var __require = ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined")
    return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});

// src/Studio.tsx
import {useLayoutEffect as useLayoutEffect2} from "react";
import {createPortal} from "react-dom";
import {Internals as Internals61} from "remotion";

// src/components/Editor.tsx
import {PlayerInternals as PlayerInternals17} from "@remotion/player";
import React164, {useCallback as useCallback121, useEffect as useEffect71, useMemo as useMemo119} from "react";
import {Internals as Internals57} from "remotion";

// src/helpers/colors.ts
var BACKGROUND = "rgb(31,36,40)";
var BACKGROUND__TRANSPARENT = "rgba(31,36,40, 0)";
var INPUT_BACKGROUND = "#2f363d";
var BORDER_COLOR = "#000";
var LIGHT_COLOR = "#ddd";
var SELECTED_BACKGROUND = "hsla(0, 0%, 100%, 0.15)";
var LIGHT_TEXT = "#A6A7A9";
var RULER_COLOR = "#808080";
var VERY_LIGHT_TEXT = "rgba(255, 255, 255, 0.3)";
var SELECTED_HOVER_BACKGROUND = "hsla(0, 0%, 100%, 0.25)";
var CLEAR_HOVER = "rgba(255, 255, 255, 0.06)";
var INPUT_BORDER_COLOR_UNHOVERED = "rgba(0, 0, 0, 0.6)";
var INPUT_BORDER_COLOR_HOVERED = "rgba(255, 255, 255, 0.05)";
var TIMELINE_BACKGROUND = "#111";
var FAIL_COLOR = "#ff3232";
var WARNING_COLOR = "#f1c40f";
var BLUE = "#0b84f3";
var BLUE_DISABLED = "#284f73";
var LIGHT_TRANSPARENT = "rgba(255, 255, 255, 0.7)";
var UNSELECTED_GUIDE = "#7e1219";
var SELECTED_GUIDE = "#d22d3a";
var LINE_COLOR = "#363A3E";
var TIMELINE_TRACK_SEPARATOR = "rgba(0, 0, 0, 0.3)";
var getBackgroundFromHoverState = ({
  selected,
  hovered
}) => {
  if (selected) {
    if (hovered) {
      return SELECTED_HOVER_BACKGROUND;
    }
    return SELECTED_BACKGROUND;
  }
  if (hovered) {
    return CLEAR_HOVER;
  }
  return "transparent";
};

// src/helpers/noop.ts
var noop = () => {
  return;
};

// src/state/canvas-ref.ts
import {createRef} from "react";
var canvasRef = createRef();
var drawRef = createRef();

// src/state/timeline-zoom.tsx
import {createContext as createContext2, useMemo as useMemo2, useState} from "react";

// src/components/Timeline/imperative-state.ts
var currentFrame = 0;
var currentZoom = 1;
var currentDuration = 1;
var currentFps = 1;
var getCurrentZoom = () => {
  return currentZoom;
};
var setCurrentZoom = (z) => {
  currentZoom = z;
};
var getCurrentFrame = () => {
  return currentFrame;
};
var setCurrentFrame = (f) => {
  currentFrame = f;
};
var getCurrentDuration = () => {
  return currentDuration;
};
var setCurrentDuration = (d) => {
  currentDuration = d;
};
var getCurrentFps = () => {
  return currentFps;
};
var setCurrentFps = (d) => {
  currentFps = d;
};

// src/components/Timeline/timeline-scroll-logic.ts
import {interpolate} from "remotion";

// src/helpers/timeline-layout.ts
var TIMELINE_PADDING = 16;
var TIMELINE_LAYER_HEIGHT = 25;
var TIMELINE_BORDER = 1;
var TIMELINE_ITEM_BORDER_BOTTOM = 1;

// src/components/Timeline/TimelineSlider.tsx
import {
createRef as createRef2,
useContext,
useEffect,
useImperativeHandle,
useMemo,
useRef
} from "react";
import {Internals, useVideoConfig} from "remotion";

// src/helpers/get-left-of-timeline-slider.ts
var getXPositionOfItemInTimelineImperatively = (frame, duration, width) => {
  const proportion = frame / (duration - 1);
  return proportion * (width - TIMELINE_PADDING * 2) + TIMELINE_PADDING;
};

// src/components/Timeline/TimelineSliderHandle.tsx
import {
jsx
} from "react/jsx-runtime";
var container = {
  width: 20,
  height: 20,
  position: "fixed",
  marginLeft: -8
};
var TimelineSliderHandle = () => {
  return jsx("div", {
    style: container,
    children: jsx("svg", {
      width: 17,
      viewBox: "0 0 159 212",
      children: jsx("path", {
        d: "M17.0234375,1.07763419 L143.355469,1.07763419 C151.63974,1.07763419 158.355469,7.79336295 158.355469,16.0776342 L158.355469,69.390507 C158.355469,73.7938677 156.420655,77.9748242 153.064021,80.8248415 L89.3980057,134.881757 C83.7986799,139.635978 75.5802263,139.635978 69.9809005,134.881757 L6.66764807,81.1243622 C3.0872392,78.0843437 1.0234375,73.6246568 1.0234375,68.9277387 L1.0234375,17.0776342 C1.0234375,8.2410782 8.1868815,1.07763419 17.0234375,1.07763419 Z",
        fill: "#f02c00"
      })
    })
  });
};

// src/components/Timeline/TimelineWidthProvider.tsx
import {PlayerInternals} from "@remotion/player";
import {createContext} from "react";

// src/components/Timeline/timeline-refs.ts
import React from "react";
var sliderAreaRef = React.createRef();
var scrollableRef = React.createRef();
var timelineVerticalScroll = React.createRef();

// src/components/Timeline/TimelineWidthProvider.tsx
import {
jsx as jsx2
} from "react/jsx-runtime";
var TimelineWidthContext = createContext(null);
var TimelineWidthProvider = ({ children }) => {
  const size = PlayerInternals.useElementSize(sliderAreaRef, {
    triggerOnWindowResize: false,
    shouldApplyCssTransforms: true
  });
  return jsx2(TimelineWidthContext.Provider, {
    value: size?.width ?? null,
    children
  });
};

// src/components/Timeline/TimelineSlider.tsx
import {
jsx as jsx3,
jsxs
} from "react/jsx-runtime";
var container2 = {
  position: "absolute",
  bottom: 0,
  top: 0,
  pointerEvents: "none"
};
var line = {
  height: "100vh",
  width: 1,
  position: "fixed",
  backgroundColor: "#f02c00"
};
var redrawTimelineSliderFast = createRef2();
var TimelineSlider = () => {
  const videoConfig = Internals.useUnsafeVideoConfig();
  const timelineWidth = useContext(TimelineWidthContext);
  if (videoConfig === null || timelineWidth === null) {
    return null;
  }
  return jsx3(Inner, {});
};
var Inner = () => {
  const videoConfig = useVideoConfig();
  const timelinePosition = Internals.Timeline.useTimelinePosition();
  const ref = useRef(null);
  const timelineWidth = useContext(TimelineWidthContext);
  if (timelineWidth === null) {
    throw new Error("Unexpectedly did not have timeline width");
  }
  const style = useMemo(() => {
    const left = getXPositionOfItemInTimelineImperatively(timelinePosition, videoConfig.durationInFrames, timelineWidth);
    return {
      ...container2,
      transform: `translateX(${left}px)`
    };
  }, [timelinePosition, videoConfig.durationInFrames, timelineWidth]);
  useImperativeHandle(redrawTimelineSliderFast, () => {
    return {
      draw: (frame, width) => {
        const { current } = ref;
        if (!current) {
          throw new Error("unexpectedly did not have ref to timelineslider");
        }
        current.style.transform = `translateX(${getXPositionOfItemInTimelineImperatively(frame, getCurrentDuration(), width ?? sliderAreaRef.current?.clientWidth ?? 0)}px)`;
      }
    };
  }, []);
  useEffect(() => {
    const currentRef = ref.current;
    if (!currentRef) {
      return;
    }
    const { current } = timelineVerticalScroll;
    if (!current) {
      return;
    }
    const onScroll = () => {
      currentRef.style.top = current.scrollTop + "px";
    };
    current.addEventListener("scroll", onScroll);
    return () => {
      current.removeEventListener("scroll", onScroll);
    };
  }, []);
  return jsxs("div", {
    ref,
    style,
    children: [
      jsx3("div", {
        style: line
      }),
      jsx3(TimelineSliderHandle, {})
    ]
  });
};

// src/components/Timeline/timeline-scroll-logic.ts
var canScrollTimelineIntoDirection = () => {
  const current = scrollableRef.current;
  const { scrollWidth, scrollLeft, clientWidth } = current;
  const canScrollRight = scrollWidth - scrollLeft - clientWidth > TIMELINE_PADDING;
  const canScrollLeft = scrollLeft > TIMELINE_PADDING;
  return { canScrollRight, canScrollLeft };
};
var SCROLL_INCREMENT = 200;
var calculateFrameWhileScrollingRight = ({
  durationInFrames,
  width,
  scrollLeft
}) => {
  return getFrameFromX({
    clientX: scrollLeft,
    durationInFrames,
    width,
    extrapolate: "clamp"
  }) + Math.ceil((scrollableRef.current?.clientWidth - TIMELINE_PADDING) / getFrameIncrement(durationInFrames));
};
var getFrameWhileScrollingLeft = ({
  durationInFrames,
  width
}) => {
  const nextFrame = getFrameFromX({
    clientX: scrollableRef.current?.scrollLeft - SCROLL_INCREMENT,
    durationInFrames,
    width,
    extrapolate: "clamp"
  });
  const currentFrame2 = getFrameFromX({
    clientX: scrollableRef.current?.scrollLeft,
    durationInFrames,
    width,
    extrapolate: "clamp"
  });
  return Math.max(0, Math.min(currentFrame2 - 1, nextFrame));
};
var isCursorInViewport = ({
  frame,
  durationInFrames
}) => {
  const width = scrollableRef.current?.scrollWidth ?? 0;
  const scrollLeft = scrollableRef.current?.scrollLeft ?? 0;
  const scrollPosOnRightEdge = getScrollPositionForCursorOnRightEdge({
    nextFrame: frame,
    durationInFrames
  });
  const scrollPosOnLeftEdge = getScrollPositionForCursorOnLeftEdge({
    nextFrame: frame,
    durationInFrames
  });
  const currentFrameRight = calculateFrameWhileScrollingRight({
    durationInFrames,
    scrollLeft,
    width
  });
  return !(scrollPosOnRightEdge >= getScrollPositionForCursorOnRightEdge({
    nextFrame: currentFrameRight,
    durationInFrames
  }) || scrollPosOnLeftEdge < scrollLeft);
};
var ensureFrameIsInViewport = ({
  direction,
  durationInFrames,
  frame
}) => {
  redrawTimelineSliderFast.current?.draw(frame);
  const width = scrollableRef.current?.scrollWidth ?? 0;
  const scrollLeft = scrollableRef.current?.scrollLeft ?? 0;
  if (direction === "fit-left") {
    const currentFrameLeft = getFrameFromX({
      clientX: scrollLeft,
      durationInFrames,
      width,
      extrapolate: "clamp"
    });
    const scrollPos = getScrollPositionForCursorOnLeftEdge({
      nextFrame: frame,
      durationInFrames
    });
    const needsToScrollLeft = scrollPos <= getScrollPositionForCursorOnLeftEdge({
      nextFrame: currentFrameLeft,
      durationInFrames
    });
    if (needsToScrollLeft) {
      scrollToTimelineXOffset(scrollPos);
    }
  }
  if (direction === "fit-right") {
    const currentFrameRight = calculateFrameWhileScrollingRight({
      durationInFrames,
      scrollLeft,
      width
    });
    const scrollPos = getScrollPositionForCursorOnRightEdge({
      nextFrame: frame,
      durationInFrames
    });
    const needsToScrollRight = scrollPos >= getScrollPositionForCursorOnRightEdge({
      nextFrame: currentFrameRight,
      durationInFrames
    });
    if (needsToScrollRight) {
      scrollToTimelineXOffset(scrollPos);
    }
  }
  if (direction === "page-right" || direction === "page-left") {
    if (!isCursorInViewport({ frame, durationInFrames })) {
      scrollToTimelineXOffset(direction === "page-left" ? getScrollPositionForCursorOnRightEdge({
        nextFrame: frame,
        durationInFrames
      }) : getScrollPositionForCursorOnLeftEdge({
        nextFrame: frame,
        durationInFrames
      }));
    }
  }
  if (direction === "center") {
    const scrollPosOnRightEdge = getScrollPositionForCursorOnRightEdge({
      nextFrame: frame,
      durationInFrames
    });
    const scrollPosOnLeftEdge = getScrollPositionForCursorOnLeftEdge({
      nextFrame: frame,
      durationInFrames
    });
    scrollToTimelineXOffset((scrollPosOnLeftEdge + scrollPosOnRightEdge) / 2);
  }
};
var scrollToTimelineXOffset = (scrollPos) => {
  scrollableRef.current?.scroll({
    left: scrollPos
  });
};
var getScrollPositionForCursorOnLeftEdge = ({
  nextFrame,
  durationInFrames
}) => {
  const frameIncrement = getFrameIncrement(durationInFrames);
  const scrollPos = frameIncrement * nextFrame;
  return scrollPos;
};
var getScrollPositionForCursorOnRightEdge = ({
  nextFrame,
  durationInFrames
}) => {
  const frameIncrement = getFrameIncrement(durationInFrames);
  const framesRemaining = durationInFrames - 1 - nextFrame;
  const fromRight = framesRemaining * frameIncrement + TIMELINE_PADDING;
  const scrollPos = scrollableRef.current?.scrollWidth - fromRight - scrollableRef.current?.clientWidth + TIMELINE_PADDING + 4;
  return scrollPos;
};
var getFrameIncrement = (durationInFrames) => {
  const width = scrollableRef.current?.scrollWidth ?? 0;
  return getFrameIncrementFromWidth(durationInFrames, width);
};
var getFrameIncrementFromWidth = (durationInFrames, width) => {
  return (width - TIMELINE_PADDING * 2) / (durationInFrames - 1);
};
var getFrameWhileScrollingRight = ({
  durationInFrames,
  width
}) => {
  const nextFrame = calculateFrameWhileScrollingRight({
    durationInFrames,
    width,
    scrollLeft: scrollableRef.current?.scrollLeft + SCROLL_INCREMENT
  });
  const currentFrame2 = calculateFrameWhileScrollingRight({
    durationInFrames,
    width,
    scrollLeft: scrollableRef.current?.scrollLeft
  });
  return Math.min(durationInFrames - 1, Math.max(nextFrame, currentFrame2 + 1));
};
var getFrameFromX = ({
  clientX,
  durationInFrames,
  width,
  extrapolate
}) => {
  const pos = clientX - TIMELINE_PADDING;
  const frame = Math.round(interpolate(pos, [0, width - TIMELINE_PADDING * 2], [0, durationInFrames - 1], {
    extrapolateLeft: extrapolate,
    extrapolateRight: extrapolate
  }));
  return frame;
};
var zoomAndPreserveCursor = ({
  oldZoom,
  newZoom,
  currentFrame: currentFrame2,
  currentDurationInFrames
}) => {
  const ratio = newZoom / oldZoom;
  if (ratio === 1) {
    return;
  }
  const { current } = scrollableRef;
  if (!current) {
    return;
  }
  const frameIncrement = getFrameIncrement(currentDurationInFrames);
  const prevCursorPosition = frameIncrement * currentFrame2 + TIMELINE_PADDING;
  const newCursorPosition = ratio * (prevCursorPosition - TIMELINE_PADDING) + TIMELINE_PADDING;
  current.scrollLeft += newCursorPosition - prevCursorPosition;
  redrawTimelineSliderFast.current?.draw(currentFrame2, (scrollableRef.current?.clientWidth ?? 0) * ratio);
};

// src/components/ZoomPersistor.tsx
import {useContext as useContext2, useEffect as useEffect2} from "react";
import {Internals as Internals2} from "remotion";

// src/helpers/url-state.ts
var getUrlHandlingType = () => {
  if (window.process.env.NODE_ENV === "production") {
    return "query-string";
  }
  return "spa";
};
var pushUrl = (url) => {
  if (getUrlHandlingType() === "query-string") {
    window.history.pushState({}, "Studio", `${window.location.pathname}?${url}`);
  } else {
    window.history.pushState({}, "Studio", url);
  }
};
var clearUrl = () => {
  window.location.href = window.location.pathname;
};
var reloadUrl = () => {
  window.location.reload();
};
var getRoute = () => {
  if (getUrlHandlingType() === "query-string") {
    return window.location.search.substring(1);
  }
  return window.location.pathname;
};

// src/components/ZoomPersistor.tsx
var makeKey = () => {
  return `remotion.zoom-map`;
};
var persistCurrentZoom = (zoom) => {
  localStorage.setItem(makeKey(), JSON.stringify(zoom));
};
var getZoomFromLocalStorage = () => {
  const zoom = localStorage.getItem(makeKey());
  return zoom ? JSON.parse(zoom) : {};
};
var deriveCanvasContentFromUrl = () => {
  const substrings = getRoute().split("/").filter(Boolean);
  const lastPart = substrings[substrings.length - 1];
  if (substrings[0] === "assets") {
    return {
      type: "asset",
      asset: decodeURIComponent(getRoute().substring("/assets/".length))
    };
  }
  if (substrings[0] === "outputs") {
    return {
      type: "output",
      path: decodeURIComponent(getRoute().substring("/outputs/".length))
    };
  }
  if (lastPart) {
    return {
      type: "composition",
      compositionId: lastPart
    };
  }
  return null;
};
var ZoomPersistor = () => {
  const [playing] = Internals2.Timeline.usePlayingState();
  const { zoom } = useContext2(TimelineZoomCtx);
  const { canvasContent } = useContext2(Internals2.CompositionManager);
  const urlState = deriveCanvasContentFromUrl();
  const isActive = urlState && urlState.type === "composition" && canvasContent && canvasContent.type === "composition" && urlState.compositionId === canvasContent.compositionId;
  useEffect2(() => {
    if (!isActive) {
      return;
    }
    persistCurrentZoom(zoom);
  }, [zoom, isActive, playing, urlState]);
  return null;
};

// src/state/timeline-zoom.tsx
import {
jsx as jsx4
} from "react/jsx-runtime";
var TIMELINE_MIN_ZOOM = 1;
var TIMELINE_MAX_ZOOM = 5;
var TimelineZoomCtx = createContext2({
  zoom: {},
  setZoom: () => {
    throw new Error("has no context");
  }
});
var TimelineZoomContext = ({ children }) => {
  const [zoom, setZoom] = useState(() => getZoomFromLocalStorage());
  const value = useMemo2(() => {
    return {
      zoom,
      setZoom: (compositionId, callback) => {
        setZoom((prevZoomMap) => {
          const newZoomWithFloatingPointErrors = Math.min(TIMELINE_MAX_ZOOM, Math.max(TIMELINE_MIN_ZOOM, callback(prevZoomMap[compositionId] ?? TIMELINE_MIN_ZOOM)));
          const newZoom = Math.round(newZoomWithFloatingPointErrors * 10) / 10;
          zoomAndPreserveCursor({
            oldZoom: prevZoomMap[compositionId] ?? TIMELINE_MIN_ZOOM,
            newZoom,
            currentDurationInFrames: getCurrentDuration(),
            currentFrame: getCurrentFrame()
          });
          return { ...prevZoomMap, [compositionId]: newZoom };
        });
      }
    };
  }, [zoom]);
  return jsx4(TimelineZoomCtx.Provider, {
    value,
    children
  });
};

// src/state/z-index.tsx
import {
createContext as createContext5,
useContext as useContext4,
useEffect as useEffect4,
useMemo as useMemo6,
useRef as useRef3
} from "react";

// src/helpers/use-keybinding.ts
import {useCallback as useCallback2, useContext as useContext3, useEffect as useEffect3, useMemo as useMemo4, useState as useState2} from "react";

// src/state/keybindings.tsx
import {createContext as createContext3, useCallback, useMemo as useMemo3, useRef as useRef2} from "react";
import {
jsx as jsx5
} from "react/jsx-runtime";
var KeybindingContext = createContext3({
  registerKeybinding: () => {
    throw new Error("Has no keybinding context");
  },
  unregisterKeybinding: () => {
    return;
  },
  unregisterPane: () => {
    return;
  }
});
var KeybindingContextProvider = ({ children }) => {
  const registered = useRef2([]);
  const registerKeybinding = useCallback((binding) => {
    registered.current = [...registered.current, binding];
    window.addEventListener(binding.event, binding.callback);
  }, []);
  const unregisterKeybinding = useCallback((binding) => {
    registered.current = registered.current.filter((r) => {
      if (r.id === binding.id) {
        window.removeEventListener(binding.event, binding.callback);
        return false;
      }
      return true;
    });
  }, []);
  const unregisterPane = useCallback((paneId) => {
    const matchedKeybindings = registered.current.filter((r) => r.registeredFromPane === paneId);
    for (const matched of matchedKeybindings) {
      unregisterKeybinding(matched);
    }
  }, [unregisterKeybinding]);
  const value = useMemo3(() => {
    return {
      registerKeybinding,
      unregisterKeybinding,
      unregisterPane
    };
  }, [registerKeybinding, unregisterKeybinding, unregisterPane]);
  return jsx5(KeybindingContext.Provider, {
    value,
    children
  });
};

// src/helpers/use-keybinding.ts
if (!process.env.KEYBOARD_SHORTCUTS_ENABLED) {
  console.warn("Keyboard shortcuts disabled either due to: a) --disable-keyboard-shortcuts being passed b) Config.setKeyboardShortcutsEnabled(false) being set or c) a Remotion version mismatch.");
}
var areKeyboardShortcutsDisabled = () => {
  return !process.env.KEYBOARD_SHORTCUTS_ENABLED;
};
var useKeybinding = () => {
  const [paneId] = useState2(() => String(Math.random()));
  const context = useContext3(KeybindingContext);
  const { isHighestContext } = useZIndex();
  const registerKeybinding = useCallback2((options) => {
    if (!process.env.KEYBOARD_SHORTCUTS_ENABLED) {
      return {
        unregister: () => {
          return;
        }
      };
    }
    if (!isHighestContext && !options.keepRegisteredWhenNotHighestContext) {
      return {
        unregister: () => {
          return;
        }
      };
    }
    const listener = (e) => {
      const commandKey = window.navigator.platform.startsWith("Mac") ? e.metaKey : e.ctrlKey;
      if (e.key.toLowerCase() === options.key.toLowerCase() && options.commandCtrlKey === commandKey) {
        if (!options.triggerIfInputFieldFocused) {
          const { activeElement } = document;
          if (activeElement instanceof HTMLInputElement) {
            return;
          }
          if (activeElement instanceof HTMLTextAreaElement) {
            return;
          }
        }
        options.callback(e);
        if (options.preventDefault) {
          e.preventDefault();
        }
      }
    };
    const toRegister = {
      registeredFromPane: paneId,
      event: options.event,
      key: options.key,
      callback: listener,
      id: String(Math.random())
    };
    context.registerKeybinding(toRegister);
    return {
      unregister: () => context.unregisterKeybinding(toRegister)
    };
  }, [context, isHighestContext, paneId]);
  useEffect3(() => {
    return () => {
      context.unregisterPane(paneId);
    };
  }, [context, paneId]);
  return useMemo4(() => ({ registerKeybinding, isHighestContext }), [registerKeybinding, isHighestContext]);
};

// src/state/highest-z-index.tsx
import {createContext as createContext4, useCallback as useCallback3, useMemo as useMemo5, useState as useState3} from "react";
import {
jsx as jsx6
} from "react/jsx-runtime";
var HighestZIndexContext = createContext4({
  highestIndex: 0,
  registerZIndex: () => {
    return;
  },
  unregisterZIndex: () => {
    return;
  }
});
var HighestZIndexProvider = ({ children }) => {
  const [zIndexes, setZIndexes] = useState3([]);
  const registerZIndex = useCallback3((newIndex) => {
    setZIndexes((prev) => [...prev, newIndex]);
  }, []);
  const unregisterZIndex = useCallback3((newIndex) => {
    setZIndexes((prev) => {
      const index = prev.indexOf(newIndex);
      if (index === -1) {
        throw new Error("did not find z-index " + newIndex);
      }
      return prev.filter((_n, i) => i !== index);
    });
  }, []);
  const highestIndex = Math.max(...zIndexes);
  const value = useMemo5(() => {
    return {
      highestIndex,
      registerZIndex,
      unregisterZIndex
    };
  }, [registerZIndex, unregisterZIndex, highestIndex]);
  return jsx6(HighestZIndexContext.Provider, {
    value,
    children
  });
};

// src/state/input-dragger-click-lock.ts
var clickLock = false;
var getClickLock = () => clickLock;
var setClickLock = (lock) => {
  clickLock = lock;
};

// src/state/z-index.tsx
import {
jsx as jsx7,
jsxs as jsxs2
} from "react/jsx-runtime";
var ZIndexContext = createContext5({
  currentIndex: 0
});
var margin = {
  margin: "auto"
};
var EscapeHook = ({ onEscape }) => {
  const keybindings2 = useKeybinding();
  useEffect4(() => {
    const escape = keybindings2.registerKeybinding({
      event: "keydown",
      key: "Escape",
      callback: onEscape,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      escape.unregister();
    };
  }, [keybindings2, onEscape]);
  return null;
};
var HigherZIndex = ({ children, onEscape, onOutsideClick }) => {
  const context = useContext4(ZIndexContext);
  const highestContext = useContext4(HighestZIndexContext);
  const containerRef = useRef3(null);
  const currentIndex = context.currentIndex + 1;
  useEffect4(() => {
    highestContext.registerZIndex(currentIndex);
    return () => highestContext.unregisterZIndex(currentIndex);
  }, [currentIndex, highestContext]);
  useEffect4(() => {
    let onUp = null;
    const listener = (downEvent) => {
      const outsideClick = !containerRef.current?.contains(downEvent.target);
      if (!outsideClick) {
        return;
      }
      onUp = (upEvent) => {
        if (highestContext.highestIndex === currentIndex && !getClickLock() && document.contains(upEvent.target)) {
          upEvent.stopPropagation();
          onOutsideClick(upEvent.target);
        }
      };
      window.addEventListener("pointerup", onUp, { once: true });
    };
    requestAnimationFrame(() => {
      window.addEventListener("pointerdown", listener);
    });
    return () => {
      if (onUp) {
        window.removeEventListener("pointerup", onUp, { once: true });
      }
      onUp = null;
      return window.removeEventListener("pointerdown", listener);
    };
  }, [currentIndex, highestContext.highestIndex, onOutsideClick]);
  const value = useMemo6(() => {
    return {
      currentIndex
    };
  }, [currentIndex]);
  return jsxs2(ZIndexContext.Provider, {
    value,
    children: [
      jsx7(EscapeHook, {
        onEscape
      }),
      jsx7("div", {
        ref: containerRef,
        style: margin,
        children
      })
    ]
  });
};
var useZIndex = () => {
  const context = useContext4(ZIndexContext);
  const highestContext = useContext4(HighestZIndexContext);
  const isHighestContext = highestContext.highestIndex === context.currentIndex;
  return useMemo6(() => ({
    currentZIndex: context.currentIndex,
    highestZIndex: highestContext.highestIndex,
    isHighestContext,
    tabIndex: isHighestContext ? 0 : -1
  }), [context.currentIndex, highestContext.highestIndex, isHighestContext]);
};

// src/components/EditorContent.tsx
import {useContext as useContext63} from "react";
import {Internals as Internals51} from "remotion";

// src/helpers/is-current-selected-still.ts
import {useContext as useContext5} from "react";
import {Internals as Internals3} from "remotion";

// src/helpers/is-composition-still.ts
var isCompositionStill = (comp) => {
  if (!comp) {
    return false;
  }
  return comp.durationInFrames === 1;
};

// src/helpers/is-current-selected-still.ts
var useIsStill = () => {
  const resolved = Internals3.useResolvedVideoConfig(null);
  if (!resolved || resolved.type !== "success") {
    return false;
  }
  return isCompositionStill(resolved.result);
};
var useIsVideoComposition = () => {
  const isStill = useIsStill();
  const { canvasContent } = useContext5(Internals3.CompositionManager);
  if (canvasContent === null) {
    return false;
  }
  if (isStill) {
    return false;
  }
  return canvasContent.type === "composition";
};

// src/components/InitialCompositionLoader.tsx
import {useContext as useContext12, useEffect as useEffect13} from "react";
import {Internals as Internals9} from "remotion";

// src/api/get-static-files.ts
var warnedServer = false;
var warnedPlayer = false;
var warnServerOnce = () => {
  if (warnedServer) {
    return;
  }
  warnedServer = true;
  console.warn("Called getStaticFiles() on the server. The API is only available in the browser. An empty array was returned.");
};
var warnPlayerOnce = () => {
  if (warnedPlayer) {
    return;
  }
  warnedPlayer = true;
  console.warn("Called getStaticFiles() while using the Remotion Player. The API is only available while using the Remotion Studio. An empty array was returned.");
};
var getStaticFiles = () => {
  if (typeof document === "undefined") {
    warnServerOnce();
    return [];
  }
  if (window.remotion_isPlayer) {
    warnPlayerOnce();
    return [];
  }
  return window.remotion_staticFiles;
};

// src/helpers/mobile-layout.ts
import {useEffect as useEffect5, useRef as useRef4, useState as useState4} from "react";
var getIsMobile = function() {
  return window.innerWidth < breakpoint;
};
var breakpoint = 900;
var useMobileLayout = () => {
  const [isMobile, setIsMobile] = useState4(getIsMobile());
  const isMobileRef = useRef4(isMobile);
  useEffect5(() => {
    function handleResize() {
      if (getIsMobile() !== isMobileRef.current) {
        setIsMobile(getIsMobile());
      }
      isMobileRef.current = getIsMobile();
    }
    window.addEventListener("resize", handleResize);
    return () => {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return isMobile;
};

// src/state/folders.tsx
import {createContext as createContext6, useMemo as useMemo7, useState as useState5} from "react";

// src/helpers/persist-open-folders.ts
var openFolderKey = ({
  folderName,
  parentName
}) => {
  return [parentName ?? "no-parent", folderName].join("/");
};
var localStorageKey = (type) => type === "compositions" ? "remotion.expandedFolders" : "remotion.expandedAssetFolders";
var persistExpandedFolders = (type, state) => {
  window.localStorage.setItem(localStorageKey(type), JSON.stringify(state));
};
var loadExpandedFolders = (type) => {
  const item = window.localStorage.getItem(localStorageKey(type));
  if (item === null) {
    return {};
  }
  return JSON.parse(item);
};

// src/state/folders.tsx
import {
jsx as jsx8
} from "react/jsx-runtime";
var FolderContext = createContext6({
  compositionFoldersExpanded: {},
  setCompositionFoldersExpanded: () => {
    throw new Error("default state");
  },
  assetFoldersExpanded: {},
  setAssetFoldersExpanded: () => {
    throw new Error("default state");
  }
});
var FolderContextProvider = ({ children }) => {
  const [compositionFoldersExpanded, setCompositionFoldersExpanded] = useState5(() => loadExpandedFolders("compositions"));
  const [assetFoldersExpanded, setAssetFoldersExpanded] = useState5(() => loadExpandedFolders("assets"));
  const value = useMemo7(() => {
    return {
      compositionFoldersExpanded,
      setCompositionFoldersExpanded,
      assetFoldersExpanded,
      setAssetFoldersExpanded
    };
  }, [assetFoldersExpanded, compositionFoldersExpanded]);
  return jsx8(FolderContext.Provider, {
    value,
    children
  });
};

// src/state/sidebar.tsx
import {createContext as createContext7, useMemo as useMemo8, useState as useState6} from "react";
import {
jsx as jsx9
} from "react/jsx-runtime";
var storageKey = (sidebar) => {
  if (sidebar === "right") {
    return "remotion.sidebarRightCollapsing";
  }
  return "remotion.sidebarCollapsing";
};
var getSavedCollapsedStateLeft = (isMobileLayout = false) => {
  const state = window.localStorage.getItem(storageKey("left"));
  if (isMobileLayout) {
    return "collapsed";
  }
  if (state === "collapsed") {
    return "collapsed";
  }
  if (state === "expanded") {
    return "expanded";
  }
  return "responsive";
};
var getSavedCollapsedStateRight = (isMobileLayout = false) => {
  const state = window.localStorage.getItem(storageKey("right"));
  if (isMobileLayout) {
    return "collapsed";
  }
  if (state === "expanded") {
    return "expanded";
  }
  return "collapsed";
};
var saveCollapsedState = (type, sidebar) => {
  window.localStorage.setItem(storageKey(sidebar), type);
};
var SidebarContext = createContext7({
  sidebarCollapsedStateLeft: "collapsed",
  setSidebarCollapsedState: () => {
    throw new Error("sidebar collapsed state");
  },
  sidebarCollapsedStateRight: "collapsed"
});
var SidebarContextProvider = ({ children }) => {
  const isMobileLayout = useMobileLayout();
  const [sidebarCollapsedState, setSidebarCollapsedState] = useState6(() => ({
    left: getSavedCollapsedStateLeft(isMobileLayout),
    right: getSavedCollapsedStateRight(isMobileLayout)
  }));
  const value = useMemo8(() => {
    return {
      sidebarCollapsedStateLeft: sidebarCollapsedState.left,
      sidebarCollapsedStateRight: sidebarCollapsedState.right,
      setSidebarCollapsedState: (options) => {
        const { left, right } = options;
        setSidebarCollapsedState((f) => {
          const copied = { ...f };
          if (left) {
            const updatedLeft = typeof left === "function" ? left(f.left) : left;
            saveCollapsedState(updatedLeft, "left");
            copied.left = updatedLeft;
          }
          if (right) {
            const updatedRight = typeof right === "function" ? right(f.right) : right;
            saveCollapsedState(updatedRight, "right");
            copied.right = updatedRight;
          }
          return copied;
        });
      }
    };
  }, [sidebarCollapsedState]);
  return jsx9(SidebarContext.Provider, {
    value,
    children
  });
};

// src/components/CompositionSelector.tsx
import {
createRef as createRef5,
useCallback as useCallback15,
useContext as useContext9,
useImperativeHandle as useImperativeHandle4,
useMemo as useMemo21,
useState as useState15
} from "react";
import {Internals as Internals7} from "remotion";

// src/helpers/create-folder-tree.ts
var buildAssetFolderStructure = (files, parentFolderName, foldersExpanded) => {
  const notInFolder = files.filter((f) => !f.name.includes("/"));
  const inFolder = files.filter((f) => f.name.includes("/"));
  const groupedByFolder = {};
  for (const item of inFolder) {
    const folderName = item.name.split("/")[0];
    if (!groupedByFolder[folderName]) {
      groupedByFolder[folderName] = [];
    }
    groupedByFolder[folderName].push(item);
  }
  return {
    files: notInFolder,
    folders: Object.keys(groupedByFolder).map((folderName) => {
      const filesInFolder = groupedByFolder[folderName];
      const filesWithoutFolderName = filesInFolder.map((f) => {
        return {
          ...f,
          name: f.name.substring(folderName.length + 1)
        };
      });
      const key = [parentFolderName, folderName].filter(Boolean).join("/");
      const isExpanded = foldersExpanded[key] ?? false;
      return {
        name: folderName,
        items: buildAssetFolderStructure(filesWithoutFolderName, [parentFolderName, folderName].filter(Boolean).join("/"), foldersExpanded),
        expanded: isExpanded
      };
    })
  };
};
var splitParentIntoNameAndParent = (name) => {
  if (name === null) {
    return {
      name: null,
      parent: null
    };
  }
  const splitted = name.split("/");
  const lastName = splitted[splitted.length - 1];
  const parentParentArray = splitted.slice(0, splitted.length - 1);
  const parentParent = parentParentArray.length === 0 ? null : parentParentArray.join("/");
  return {
    name: lastName,
    parent: parentParent
  };
};
var doesFolderExist = (items, folderName, parentName) => {
  for (const item of items) {
    if (item.type === "folder") {
      if (item.folderName === folderName && item.parentName === parentName) {
        return item.items;
      }
      const found = doesFolderExist(item.items, folderName, parentName);
      if (found !== false) {
        return found;
      }
    }
  }
  return false;
};
var findItemListToPush = (items, folderName, parentName) => {
  if (folderName === null) {
    return items;
  }
  const folder = doesFolderExist(items, folderName, parentName);
  if (!folder) {
    console.log({ items, folderName, parentName });
    throw new Error("did not find folder " + folderName);
  }
  return folder;
};
var createFolderIfDoesNotExist = (items, availableFolders, folderItem, foldersExpanded) => {
  if (doesFolderExist(items, folderItem.name, folderItem.parent)) {
    return;
  }
  const splitted = splitParentIntoNameAndParent(folderItem.parent);
  if (folderItem.parent) {
    const parent = availableFolders.find((f) => f.name === splitted.name && f.parent === splitted.parent);
    if (!parent) {
      throw new Error("unexpectedly did not have parent");
    }
    createFolderIfDoesNotExist(items, availableFolders, parent, foldersExpanded);
  }
  const itemList = findItemListToPush(items, splitted.name, splitted.parent);
  if (!itemList) {
    throw new Error("why did folder not exist? " + folderItem.name);
  }
  itemList.push({
    type: "folder",
    folderName: folderItem.name,
    items: [],
    key: folderItem.name,
    expanded: foldersExpanded[openFolderKey({
      folderName: folderItem.name,
      parentName: folderItem.parent
    })] ?? false,
    parentName: folderItem.parent
  });
};
var createFolderTree = (comps, folders, foldersExpanded) => {
  const items = [];
  const uniqueFolderKeys = [];
  for (const folder of folders) {
    const folderKey = openFolderKey({
      folderName: folder.name,
      parentName: folder.parent
    });
    if (uniqueFolderKeys.includes(folderKey)) {
      if (folder.parent) {
        throw new Error(`Multiple folders with the name ${folder.name} inside the folder ${folder.parent} exist. Folder names must be unique.`);
      }
      throw new Error("Multiple folders with the name " + folder.name + " exist. Folder names must be unique.");
    }
    uniqueFolderKeys.push(folderKey);
    createFolderIfDoesNotExist(items, folders, folder, foldersExpanded);
  }
  for (const item of comps) {
    const toPush = {
      type: "composition",
      composition: item,
      key: item.id
    };
    const list = findItemListToPush(items, item.folderName, item.parentFolderName);
    list.push(toPush);
  }
  return items;
};

// src/components/CompositionSelectorItem.tsx
import {useCallback as useCallback14, useContext as useContext8, useMemo as useMemo20, useState as useState14} from "react";

// src/icons/folder.tsx
import {
jsx as jsx10
} from "react/jsx-runtime";
var CollapsedFolderIcon = ({ color, ...props }) => {
  return jsx10("svg", {
    viewBox: "0 0 512 512",
    ...props,
    children: jsx10("path", {
      fill: color,
      d: "M447.1 96H272L226.7 50.75C214.7 38.74 198.5 32 181.5 32H63.1c-35.35 0-64 28.65-64 64v320c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V160C511.1 124.7 483.3 96 447.1 96zM480 416c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h117.5c8.549 0 16.58 3.328 22.63 9.375L258.7 128H448c17.64 0 32 14.36 32 32V416z"
    })
  });
};
var ExpandedFolderIcon = ({ color, ...props }) => {
  return jsx10("svg", {
    viewBox: "0 0 576 512",
    ...props,
    children: jsx10("path", {
      fill: color,
      d: "M566.6 211.6C557.5 199.1 543.4 192 527.1 192H134.2C114.3 192 96.2 204.5 89.23 223.1L32 375.8V96c0-17.64 14.36-32 32-32h117.5c8.549 0 16.58 3.328 22.63 9.375L258.7 128H448c17.64 0 32 14.36 32 32h32c0-35.35-28.65-64-64-64H272L226.7 50.75C214.7 38.74 198.5 32 181.5 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h403.1c21.11 0 39.53-13.53 45.81-33.69l60-192C578.4 239.6 575.8 224 566.6 211.6zM543.2 244.8l-60 192C481.1 443.5 475 448 467.1 448H64c-3.322 0-6.357-.9551-9.373-1.898c-2.184-1.17-4.109-2.832-5.596-4.977c-3.031-4.375-3.703-9.75-1.828-14.73l72-192C121.5 228.2 127.5 224 134.2 224h393.8c5.141 0 9.844 2.375 12.89 6.516C543.9 234.7 544.8 239.9 543.2 244.8z"
    })
  });
};
var ExpandedFolderIconSolid = ({ color, ...props }) => {
  return jsx10("svg", {
    viewBox: "0 0 576 512",
    ...props,
    children: jsx10("path", {
      fill: color,
      d: "M384 480h48c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224H144c-11.4 0-21.9 6-27.6 15.9L48 357.1V96c0-8.8 7.2-16 16-16H181.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H416c8.8 0 16 7.2 16 16v32h48V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H87.7 384z"
    })
  });
};

// src/icons/still.tsx
import {
jsx as jsx11
} from "react/jsx-runtime";
var StillIcon = ({ color, ...props }) => {
  return jsx11("svg", {
    ...props,
    viewBox: "0 0 512 512",
    children: jsx11("path", {
      fill: color,
      d: "M144 288C144 226.1 194.1 176 256 176C317.9 176 368 226.1 368 288C368 349.9 317.9 400 256 400C194.1 400 144 349.9 144 288zM256 208C211.8 208 176 243.8 176 288C176 332.2 211.8 368 256 368C300.2 368 336 332.2 336 288C336 243.8 300.2 208 256 208zM362.9 64.82L373.3 96H448C483.3 96 512 124.7 512 160V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V160C0 124.7 28.65 96 64 96H138.7L149.1 64.82C155.6 45.22 173.9 32 194.6 32H317.4C338.1 32 356.4 45.22 362.9 64.82H362.9zM64 128C46.33 128 32 142.3 32 160V416C32 433.7 46.33 448 64 448H448C465.7 448 480 433.7 480 416V160C480 142.3 465.7 128 448 128H350.3L332.6 74.94C330.4 68.41 324.3 64 317.4 64H194.6C187.7 64 181.6 68.41 179.4 74.94L161.7 128H64z"
    })
  });
};

// src/icons/video.tsx
import {
jsx as jsx12
} from "react/jsx-runtime";
var FilmIcon = ({ color, ...props }) => {
  return jsx12("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    children: jsx12("path", {
      fill: color,
      d: "M448 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V96C512 60.65 483.3 32 448 32zM384 64v176H128V64H384zM32 96c0-17.64 14.36-32 32-32h32v80H32V96zM32 176h64v64H32V176zM32 272h64v64H32V272zM64 448c-17.64 0-32-14.36-32-32v-48h64V448H64zM128 448V272h256V448H128zM480 416c0 17.64-14.36 32-32 32h-32v-80h64V416zM480 336h-64v-64h64V336zM480 240h-64v-64h64V240zM480 144h-64V64h32c17.64 0 32 14.36 32 32V144z"
    })
  });
};

// src/state/modals.ts
import {createContext as createContext8} from "react";
var ModalsContext = createContext8({
  selectedModal: null,
  setSelectedModal: () => {
    return;
  }
});

// src/components/CompositionContextButton.tsx
import {useCallback as useCallback11, useContext as useContext6, useMemo as useMemo17} from "react";

// src/helpers/client-id.tsx
import React12, {useCallback as useCallback5, useEffect as useEffect7, useMemo as useMemo10, useRef as useRef5} from "react";
import {Internals as Internals4} from "remotion";

// src/components/Notifications/NotificationCenter.tsx
import {
createRef as createRef3,
useCallback as useCallback4,
useImperativeHandle as useImperativeHandle2,
useState as useState7
} from "react";

// src/components/Notifications/Notification.tsx
import {useEffect as useEffect6} from "react";
import {
jsx as jsx13
} from "react/jsx-runtime";
var notification = {
  backgroundColor: "#111111",
  color: "white",
  fontFamily: "Arial, Helvetica, sans-serif",
  display: "inline-flex",
  padding: "8px 14px",
  borderRadius: 4,
  fontSize: 15,
  border: "0.25px solid rgba(255, 255, 255, 0.1)",
  boxShadow: "0 2px 3px rgba(0, 0, 0, 1)",
  marginTop: 3,
  marginBottom: 3,
  alignItems: "center"
};
var Notification = ({ children, id, duration, created, onRemove }) => {
  useEffect6(() => {
    if (duration === null) {
      return;
    }
    const timeout = setTimeout(() => {
      onRemove(id);
    }, duration - (Date.now() - created));
    return () => {
      clearTimeout(timeout);
    };
  }, [created, duration, id, onRemove]);
  return jsx13("div", {
    className: "css-reset",
    style: notification,
    children
  });
};

// src/components/Notifications/NotificationCenter.tsx
import {
jsx as jsx14
} from "react/jsx-runtime";
var container3 = {
  position: "absolute",
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  width: "100%",
  flexDirection: "column",
  paddingTop: 20,
  pointerEvents: "none",
  backgroundColor: "transparent"
};
var notificationCenter = createRef3();
var showNotification = (content, durationInMs) => {
  return notificationCenter.current.addNotification({
    content,
    duration: durationInMs,
    created: Date.now(),
    id: String(Math.random()).replace("0.", "")
  });
};
var NotificationCenter = () => {
  const [notifications, setNotifications] = useState7([]);
  const onRemove = useCallback4((id) => {
    setNotifications((not) => {
      return not.filter((n) => n.id !== id);
    });
  }, []);
  const addNotification = useCallback4((notification2) => {
    setNotifications((previousNotifications) => {
      return [...previousNotifications, notification2];
    });
    return {
      replaceContent: (newContent, durationInMs) => {
        setNotifications((oldNotifications) => {
          return oldNotifications.map((notificationToMap) => {
            if (notificationToMap.id === notification2.id) {
              return {
                ...notificationToMap,
                duration: durationInMs,
                content: newContent,
                created: Date.now()
              };
            }
            return notificationToMap;
          });
        });
      }
    };
  }, []);
  useImperativeHandle2(notificationCenter, () => {
    return {
      addNotification
    };
  }, [addNotification]);
  return jsx14("div", {
    style: container3,
    children: notifications.map((n) => {
      return jsx14(Notification, {
        created: n.created,
        duration: n.duration,
        id: n.id,
        onRemove,
        children: n.content
      }, n.id);
    })
  });
};

// src/components/PlayBeepSound.tsx
var beeped = {};
var playBeepSound = async (renderId) => {
  if (beeped[renderId]) {
    return;
  }
  beeped[renderId] = true;
  const beepAudio = new Audio("/beep.wav");
  try {
    await beepAudio.play();
  } catch (error) {
    console.error("Error playing beep sound:", error);
    throw error;
  }
};
var PlayBeepSound_default = playBeepSound;

// src/components/RenderQueue/context.tsx
import React11, {createRef as createRef4, useImperativeHandle as useImperativeHandle3, useMemo as useMemo9, useState as useState8} from "react";
import {
jsx as jsx15
} from "react/jsx-runtime";
var RenderQueueContext = React11.createContext({
  jobs: []
});
var renderJobsRef = createRef4();
var RenderQueueContextProvider = ({ children }) => {
  const [jobs, setJobs] = useState8(window.remotion_initialRenderQueue ?? []);
  const value = useMemo9(() => {
    return {
      jobs
    };
  }, [jobs]);
  useImperativeHandle3(renderJobsRef, () => {
    return {
      updateRenderJobs: (newJobs) => {
        setJobs(newJobs);
      }
    };
  }, []);
  return jsx15(RenderQueueContext.Provider, {
    value,
    children
  });
};

// src/helpers/client-id.tsx
import {
jsx as jsx16
} from "react/jsx-runtime";
var StudioServerConnectionCtx = React12.createContext({
  previewServerState: {
    type: "init"
  },
  subscribeToEvent: () => {
    throw new Error("Context not initalized");
  }
});
var PreviewServerConnection = ({ children, readOnlyStudio }) => {
  const listeners = useRef5([]);
  const subscribeToEvent = useCallback5((type, listener) => {
    listeners.current.push({ type, listener });
    return () => {
      listeners.current = listeners.current.filter((l) => l.type !== type || l.listener !== listener);
    };
  }, []);
  const openEventSource = useCallback5(() => {
    const source = new EventSource("/events");
    source.addEventListener("message", (event) => {
      const newEvent = JSON.parse(event.data);
      if (newEvent.type === "new-input-props" || newEvent.type === "new-env-variables") {
        reloadUrl();
      }
      if (newEvent.type === "init") {
        setState({
          type: "connected",
          clientId: newEvent.clientId
        });
      }
      if (newEvent.type === "render-queue-updated") {
        renderJobsRef.current?.updateRenderJobs(newEvent.queue);
        for (const job of newEvent.queue) {
          if (job.status === "done" && job.beepOnFinish) {
            PlayBeepSound_default(job.id);
          }
        }
      }
      if (newEvent.type === "render-job-failed") {
        showNotification(`Rendering "${newEvent.compositionId}" failed`, 2000);
      }
      if (newEvent.type === "new-public-folder") {
        const payload = {
          files: newEvent.files
        };
        window.remotion_staticFiles = newEvent.files;
        window.remotion_publicFolderExists = newEvent.folderExists;
        window.dispatchEvent(new CustomEvent(Internals4.WATCH_REMOTION_STATIC_FILES, {
          detail: payload
        }));
      }
      listeners.current.forEach((l) => {
        if (l.type === newEvent.type) {
          l.listener(newEvent);
        }
      });
    });
    source.addEventListener("open", () => {
      source.addEventListener("error", () => {
        setState({ type: "disconnected" });
        source?.close();
        setTimeout(() => {
          openEventSource();
        }, 1000);
      }, { once: true });
    });
    const close = () => {
      source.close();
    };
    return {
      close
    };
  }, []);
  useEffect7(() => {
    if (readOnlyStudio) {
      return;
    }
    const { close } = openEventSource();
    return () => {
      close();
    };
  }, [openEventSource, readOnlyStudio]);
  const [state, setState] = React12.useState({
    type: "init"
  });
  const context2 = useMemo10(() => {
    return {
      previewServerState: state,
      subscribeToEvent
    };
  }, [state, subscribeToEvent]);
  return jsx16(StudioServerConnectionCtx.Provider, {
    value: context2,
    children
  });
};

// src/icons/ellipsis.tsx
import {
jsx as jsx17
} from "react/jsx-runtime";
var EllipsisIcon = (props) => {
  return jsx17("svg", {
    ...props.svgProps,
    viewBox: "0 0 448 512",
    children: jsx17("path", {
      fill: props.fill,
      d: "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    })
  });
};

// src/components/InlineDropdown.tsx
import {PlayerInternals as PlayerInternals3} from "@remotion/player";
import {useCallback as useCallback10, useMemo as useMemo16, useRef as useRef8, useState as useState12} from "react";
import ReactDOM2 from "react-dom";

// src/components/InlineAction.tsx
import {useCallback as useCallback6, useMemo as useMemo11, useState as useState9} from "react";
import {
jsx as jsx18
} from "react/jsx-runtime";
var InlineAction = ({
  renderAction,
  onClick,
  disabled,
  title
}) => {
  const { tabIndex } = useZIndex();
  const [hovered, setHovered] = useState9(false);
  const onPointerEnter = useCallback6(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback6(() => {
    setHovered(false);
  }, []);
  const style = useMemo11(() => {
    return {
      border: "none",
      background: disabled ? "transparent" : getBackgroundFromHoverState({ hovered, selected: false }),
      height: 24,
      width: 24,
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 3,
      pointerEvents: disabled ? "none" : "auto"
    };
  }, [disabled, hovered]);
  return jsx18("button", {
    type: "button",
    onPointerEnter,
    onPointerLeave,
    onClick,
    style,
    tabIndex,
    title,
    children: renderAction(hovered ? "white" : LIGHT_TEXT)
  });
};

// src/components/Menu/portals.ts
var portals = [
  document.getElementById("menuportal-0"),
  document.getElementById("menuportal-1"),
  document.getElementById("menuportal-2"),
  document.getElementById("menuportal-3"),
  document.getElementById("menuportal-4"),
  document.getElementById("menuportal-5")
];
var getPortal = (i) => {
  return portals[i];
};

// src/components/Menu/styles.ts
var MENU_VERTICAL_PADDING = 4;
var SUBMENU_LEFT_INSET = -8;
var MAX_MENU_WIDTH = 400;
var MAX_MOBILE_MENU_WIDTH = 300;
var menuContainer = {
  backgroundColor: BACKGROUND,
  position: "fixed",
  color: "white",
  userSelect: "none",
  WebkitUserSelect: "none"
};
var SHADOW_TOWARDS_BOTTOM = "0 2px 8px rgba(0, 0, 0, 0.5)";
var SHADOW_TOWARDS_TOP = "0 -2px 8px rgba(0, 0, 0, 0.5)";
var menuContainerTowardsBottom = {
  ...menuContainer,
  boxShadow: SHADOW_TOWARDS_BOTTOM
};
var menuContainerTowardsTop = {
  ...menuContainer,
  boxShadow: SHADOW_TOWARDS_TOP
};
var fullScreenOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
};
var outerPortal = {
  position: "fixed"
};
var inlineCodeSnippet = {
  fontSize: 14,
  color: BLUE,
  fontFamily: "monospace"
};

// src/components/NewComposition/MenuContent.tsx
import {useCallback as useCallback9, useEffect as useEffect9, useMemo as useMemo15, useRef as useRef7, useState as useState11} from "react";

// src/components/Menu/MenuDivider.tsx
import {
jsx as jsx19
} from "react/jsx-runtime";
var menuDivider = {
  marginTop: 4,
  marginBottom: 4,
  height: 1,
  backgroundColor: INPUT_BORDER_COLOR_HOVERED
};
var MenuDivider = () => {
  return jsx19("div", {
    style: menuDivider
  });
};

// src/components/Menu/MenuSubItem.tsx
import {PlayerInternals as PlayerInternals2} from "@remotion/player";
import {useCallback as useCallback8, useEffect as useEffect8, useMemo as useMemo14, useRef as useRef6, useState as useState10} from "react";
import ReactDOM from "react-dom";

// src/icons/caret.tsx
import {useMemo as useMemo12} from "react";
import {
jsx as jsx20
} from "react/jsx-runtime";
var caret = {
  height: 12
};
var caretDown = {
  width: 10
};
var angleDown = {
  width: 10
};
var CaretRight = () => jsx20("svg", {
  viewBox: "0 0 192 512",
  style: caret,
  children: jsx20("path", {
    fill: "currentColor",
    d: "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
  })
});
var CaretDown = () => {
  return jsx20("svg", {
    viewBox: "0 0 320 512",
    style: caretDown,
    children: jsx20("path", {
      fill: "currentColor",
      d: "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    })
  });
};
var AngleDown = ({ down }) => {
  const style = useMemo12(() => {
    return {
      ...angleDown,
      transform: down ? "rotate(180deg)" : "rotate(0deg)",
      marginTop: 1
    };
  }, [down]);
  return jsx20("svg", {
    style,
    viewBox: "0 0 448 512",
    children: jsx20("path", {
      fill: LIGHT_TEXT,
      d: "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    })
  });
};

// src/components/layout.tsx
import {useMemo as useMemo13} from "react";
import {
jsx as jsx21
} from "react/jsx-runtime";
var SPACING_UNIT = 8;
var Spacing = ({ x = 0, y = 0, block = false }) => {
  const style = useMemo13(() => {
    return {
      display: block ? "block" : "inline-block",
      width: x * SPACING_UNIT,
      height: y * SPACING_UNIT,
      flexShrink: 0
    };
  }, [block, x, y]);
  return jsx21("div", {
    style
  });
};
var flexCss = { flex: 1 };
var Flex = ({ children }) => jsx21("div", {
  style: flexCss,
  children
});
var Row = ({ children, justify, className, align, flex, style = {}, ...other }) => {
  const finalStyle = useMemo13(() => {
    return {
      ...style,
      display: "flex",
      flexDirection: "row",
      justifyContent: justify ?? "flex-start",
      alignItems: align ?? "flex-start",
      flex: flex ?? undefined
    };
  }, [align, flex, justify, style]);
  return jsx21("div", {
    className,
    style: finalStyle,
    ...other,
    children
  });
};
var Column = ({ children, justify, className, align, style = {} }) => {
  const finalStyle = useMemo13(() => {
    return {
      ...style,
      display: "flex",
      flexDirection: "column",
      justifyContent: justify ?? "flex-start",
      alignItems: align ?? "flex-start"
    };
  }, [align, justify, style]);
  return jsx21("div", {
    className,
    style: finalStyle,
    children
  });
};

// src/components/Menu/SubMenu.tsx
import {useCallback as useCallback7} from "react";
import {
jsx as jsx22
} from "react/jsx-runtime";
var SubMenuComponent = ({
  portalStyle,
  subMenuActivated,
  subMenu,
  onQuitFullMenu,
  onQuitSubMenu
}) => {
  const mobileLayout = useMobileLayout();
  const onOutsideClick = useCallback7((e) => {
    if (portals.find((p) => p.contains(e)) || mobileLayout) {
      onQuitSubMenu();
    } else {
      onQuitFullMenu();
    }
  }, [mobileLayout, onQuitFullMenu, onQuitSubMenu]);
  return jsx22(HigherZIndex, {
    onEscape: onQuitFullMenu,
    onOutsideClick,
    children: jsx22("div", {
      style: portalStyle,
      className: "css-reset",
      children: jsx22(MenuContent2, {
        onNextMenu: noop,
        onPreviousMenu: onQuitSubMenu,
        values: subMenu.items,
        onHide: onQuitFullMenu,
        leaveLeftSpace: subMenu.leaveLeftSpace,
        preselectIndex: subMenuActivated === "without-mouse" && typeof subMenu.preselectIndex === "number" ? subMenu.preselectIndex : false,
        topItemCanBeUnselected: false,
        fixedHeight: null
      })
    })
  });
};

// src/components/Menu/is-menu-item.tsx
var MENU_INITIATOR_CLASSNAME = "__remotion-studio-menu-initiator";
var MENU_ITEM_CLASSNAME = "__remotion-studio-menu-item";
var HORIZONTAL_SCROLLBAR_CLASSNAME = "__remotion-horizontal-scrollbar";
var VERTICAL_SCROLLBAR_CLASSNAME = "__remotion-vertical-scrollbar";
var isMenuItem = (el) => {
  return Boolean(el.classList.contains(MENU_ITEM_CLASSNAME) || el.closest(`.${MENU_ITEM_CLASSNAME}`) || el.classList.contains(MENU_INITIATOR_CLASSNAME) || el.closest(`.${MENU_INITIATOR_CLASSNAME}`));
};

// src/components/Menu/MenuSubItem.tsx
import {
jsx as jsx23,
jsxs as jsxs3,
Fragment
} from "react/jsx-runtime";
var container4 = {
  paddingTop: 8,
  paddingBottom: 8,
  paddingLeft: 12,
  paddingRight: 8,
  cursor: "default"
};
var labelStyle = {
  fontSize: 13,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  flex: 1
};
var keyHintCss = {
  flexDirection: "row",
  color: LIGHT_TEXT,
  fontSize: 13
};
var leftSpace = {
  width: 24,
  marginLeft: -6,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center"
};
var MenuSubItem = ({
  label,
  leaveLeftSpace,
  leftItem,
  onActionChosen,
  id,
  selected,
  onItemSelected,
  keyHint,
  subMenu,
  onQuitMenu,
  subMenuActivated,
  setSubMenuActivated
}) => {
  const [hovered, setHovered] = useState10(false);
  const ref = useRef6(null);
  const size = PlayerInternals2.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const mobileLayout = useMobileLayout();
  const { currentZIndex } = useZIndex();
  const style = useMemo14(() => {
    return {
      ...container4,
      backgroundColor: selected ? CLEAR_HOVER : "transparent"
    };
  }, [selected]);
  const onPointerUp = useCallback8((e) => {
    if (subMenu) {
      setSubMenuActivated("with-mouse");
      setHovered(true);
      return;
    }
    onActionChosen(id, e);
  }, [id, onActionChosen, setSubMenuActivated, subMenu]);
  const onPointerEnter = useCallback8(() => {
    onItemSelected(id);
    setHovered(true);
  }, [id, onItemSelected]);
  const onPointerLeave = useCallback8(() => {
    setHovered(false);
  }, []);
  const onQuitSubmenu = useCallback8(() => {
    setSubMenuActivated(false);
  }, [setSubMenuActivated]);
  const portalStyle = useMemo14(() => {
    if (!selected || !size || !subMenu || !subMenuActivated) {
      return null;
    }
    const left = size.left + size.width + SUBMENU_LEFT_INSET;
    return {
      ...menuContainerTowardsBottom,
      left: mobileLayout ? left * 0.7 : left,
      top: size.top - MENU_VERTICAL_PADDING
    };
  }, [mobileLayout, selected, size, subMenu, subMenuActivated]);
  useEffect8(() => {
    if (!hovered || !subMenu) {
      return;
    }
    const hi = setTimeout(() => {
      setSubMenuActivated("with-mouse");
    }, 100);
    return () => clearTimeout(hi);
  }, [hovered, selected, setSubMenuActivated, subMenu]);
  useEffect8(() => {
    if (selected) {
      ref.current?.scrollIntoView({
        block: "nearest"
      });
    }
  }, [selected]);
  return jsx23("div", {
    ref,
    onPointerEnter,
    onPointerLeave,
    style,
    onPointerUp,
    role: "button",
    className: MENU_ITEM_CLASSNAME,
    children: jsxs3(Row, {
      align: "center",
      children: [
        leaveLeftSpace ? jsxs3(Fragment, {
          children: [
            jsx23("div", {
              style: leftSpace,
              children: leftItem
            }),
            jsx23(Spacing, {
              x: 1
            })
          ]
        }) : null,
        jsx23("div", {
          style: labelStyle,
          ...{ title: typeof label === "string" ? label : undefined },
          children: label
        }),
        " ",
        jsx23(Spacing, {
          x: 2
        }),
        subMenu ? jsx23(CaretRight, {}) : null,
        keyHint && !areKeyboardShortcutsDisabled() ? jsx23("span", {
          style: keyHintCss,
          children: keyHint
        }) : null,
        portalStyle && subMenu ? ReactDOM.createPortal(jsx23(SubMenuComponent, {
          onQuitFullMenu: onQuitMenu,
          subMenu,
          onQuitSubMenu: onQuitSubmenu,
          portalStyle,
          subMenuActivated
        }), getPortal(currentZIndex)) : null
      ]
    })
  });
};

// src/components/NewComposition/MenuContent.tsx
import {
jsx as jsx24
} from "react/jsx-runtime";
var BORDER_SIZE = 1;
var container5 = {
  paddingTop: MENU_VERTICAL_PADDING,
  paddingBottom: MENU_VERTICAL_PADDING,
  border: `${BORDER_SIZE}px solid ${INPUT_BORDER_COLOR_UNHOVERED}`,
  marginLeft: 0 - BORDER_SIZE,
  overflowY: "auto",
  overflowX: "hidden",
  minWidth: 200,
  maxWidth: MAX_MENU_WIDTH
};
var MenuContent2 = ({
  onHide,
  values,
  preselectIndex,
  onNextMenu,
  onPreviousMenu,
  leaveLeftSpace,
  topItemCanBeUnselected,
  fixedHeight
}) => {
  const keybindings2 = useKeybinding();
  const containerRef = useRef7(null);
  const isMobileLayout = useMobileLayout();
  const [subMenuActivated, setSubMenuActivated] = useState11(false);
  if (values[0].type === "divider") {
    throw new Error("first value cant be divide");
  }
  const [selectedItem, setSelectedItem] = useState11(typeof preselectIndex === "number" && preselectIndex >= 0 ? values[preselectIndex].id : null);
  const onEscape = useCallback9(() => {
    onHide();
  }, [onHide]);
  const onItemSelected = useCallback9((id) => {
    setSelectedItem(id);
  }, []);
  const onArrowUp = useCallback9(() => {
    setSelectedItem((prevItem) => {
      if (prevItem === null) {
        return null;
      }
      const index = values.findIndex((val) => val.id === prevItem);
      if (topItemCanBeUnselected && index === 0 || prevItem === null) {
        return null;
      }
      const previousItems = values.filter((v, i) => i < index && v.type !== "divider");
      if (previousItems.length > 0) {
        return previousItems[previousItems.length - 1].id;
      }
      const firstNonDivider = values.find((v) => v.type !== "divider");
      if (firstNonDivider) {
        return firstNonDivider.id;
      }
      throw new Error("could not find previous item");
    });
  }, [topItemCanBeUnselected, values]);
  const onArrowDown = useCallback9(() => {
    setSelectedItem((prevItem) => {
      const index = values.findIndex((val) => val.id === prevItem);
      const nextItem = values.find((v, i) => i > index && v.type !== "divider");
      if (nextItem) {
        return nextItem.id;
      }
      const lastNonDivider = values.slice().reverse().find((v) => v.type !== "divider");
      if (lastNonDivider) {
        return lastNonDivider.id;
      }
      throw new Error("could not find next item");
    });
  }, [values]);
  const onEnter = useCallback9(() => {
    if (selectedItem === null) {
      return onHide();
    }
    const item = values.find((i) => i.id === selectedItem);
    if (!item) {
      throw new Error("cannot find item");
    }
    if (item.type === "divider") {
      throw new Error("cannot find divider");
    }
    if (item.subMenu) {
      return setSubMenuActivated("without-mouse");
    }
    onHide();
    item.onClick(item.id, null);
  }, [onHide, selectedItem, values]);
  const onArrowRight = useCallback9(() => {
    if (selectedItem === null) {
      return onNextMenu();
    }
    const item = values.find((i) => i.id === selectedItem);
    if (!item) {
      throw new Error("cannot find item");
    }
    if (item.type === "divider") {
      throw new Error("cannot find divider");
    }
    if (!item.subMenu) {
      return onNextMenu();
    }
    setSubMenuActivated("without-mouse");
  }, [onNextMenu, selectedItem, values]);
  const containerWithHeight = useMemo15(() => {
    const containerStyles = { ...container5 };
    if (fixedHeight === null) {
      containerStyles.maxHeight = 600;
    } else {
      containerStyles.maxHeight = fixedHeight;
    }
    if (isMobileLayout) {
      containerStyles.maxWidth = MAX_MOBILE_MENU_WIDTH;
    }
    return containerStyles;
  }, [fixedHeight, isMobileLayout]);
  useEffect9(() => {
    const escapeBinding = keybindings2.registerKeybinding({
      event: "keydown",
      key: "Escape",
      callback: onEscape,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const rightBinding = keybindings2.registerKeybinding({
      event: "keydown",
      key: "ArrowRight",
      commandCtrlKey: false,
      callback: onArrowRight,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const leftBinding = keybindings2.registerKeybinding({
      event: "keydown",
      commandCtrlKey: false,
      key: "ArrowLeft",
      callback: onPreviousMenu,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const downBinding = keybindings2.registerKeybinding({
      event: "keydown",
      key: "ArrowDown",
      commandCtrlKey: false,
      callback: onArrowDown,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const upBinding = keybindings2.registerKeybinding({
      event: "keydown",
      key: "ArrowUp",
      callback: onArrowUp,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const enterBinding = keybindings2.registerKeybinding({
      event: "keydown",
      key: "Enter",
      callback: onEnter,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const spaceBinding = keybindings2.registerKeybinding({
      event: "keyup",
      key: " ",
      callback: onEnter,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      escapeBinding.unregister();
      leftBinding.unregister();
      rightBinding.unregister();
      downBinding.unregister();
      upBinding.unregister();
      enterBinding.unregister();
      spaceBinding.unregister();
    };
  }, [
    keybindings2,
    onEscape,
    onNextMenu,
    onPreviousMenu,
    onArrowDown,
    onArrowUp,
    onEnter,
    onArrowRight
  ]);
  useEffect9(() => {
    if (!subMenuActivated) {
      return;
    }
    if (selectedItem === null) {
      return setSubMenuActivated(false);
    }
    const item = values.find((i) => i.id === selectedItem);
    if (!item) {
      return;
    }
    if (item.type === "divider") {
      throw new Error("should not select divider");
    }
    if (!item.subMenu && subMenuActivated) {
      setSubMenuActivated(false);
    }
  }, [selectedItem, subMenuActivated, values]);
  useEffect9(() => {
    const { current } = containerRef;
    if (!current) {
      return;
    }
    const onPointerLeave = () => {
      if (subMenuActivated) {
        return;
      }
      setSelectedItem(null);
    };
    current.addEventListener("pointerleave", onPointerLeave);
    return () => current.removeEventListener("pointerleave", onPointerLeave);
  }, [onHide, subMenuActivated]);
  return jsx24("div", {
    ref: containerRef,
    style: containerWithHeight,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: values.map((item) => {
      if (item.type === "divider") {
        return jsx24(MenuDivider, {}, item.id);
      }
      const onClick = (id, e) => {
        item.onClick(id, e);
        if (item.subMenu) {
          return null;
        }
        onHide();
      };
      return jsx24(MenuSubItem, {
        selected: item.id === selectedItem,
        onActionChosen: onClick,
        onItemSelected,
        label: item.label,
        id: item.id,
        keyHint: item.keyHint,
        leaveLeftSpace,
        leftItem: item.leftItem,
        subMenu: item.subMenu,
        onQuitMenu: onHide,
        onNextMenu,
        subMenuActivated,
        setSubMenuActivated
      }, item.id);
    })
  });
};

// src/components/InlineDropdown.tsx
import {
jsx as jsx25,
jsxs as jsxs4,
Fragment as Fragment2
} from "react/jsx-runtime";
var InlineDropdown = ({
  values,
  ...props
}) => {
  const ref = useRef8(null);
  const [opened, setOpened] = useState12({ type: "not-open" });
  const { currentZIndex } = useZIndex();
  const size = PlayerInternals3.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const isMobileLayout = useMobileLayout();
  const onClick = useCallback10((e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpened({ type: "open", left: e.clientX, top: e.clientY });
  }, []);
  const spaceToBottom = useMemo16(() => {
    if (size && opened.type === "open") {
      return size.windowSize.height - opened.top;
    }
    return 0;
  }, [opened, size]);
  const spaceToTop = useMemo16(() => {
    if (size && opened.type === "open") {
      return opened.top;
    }
    return 0;
  }, [opened, size]);
  const portalStyle = useMemo16(() => {
    if (opened.type === "not-open") {
      return;
    }
    if (!size) {
      return;
    }
    const spaceToRight = size.windowSize.width - size.left;
    const spaceToLeft = size.left + size.width;
    const minSpaceRequired = isMobileLayout ? MAX_MOBILE_MENU_WIDTH : MAX_MENU_WIDTH;
    const verticalLayout = spaceToTop > spaceToBottom ? "bottom" : "top";
    const canOpenOnLeft = spaceToLeft >= minSpaceRequired;
    const canOpenOnRight = spaceToRight >= minSpaceRequired;
    const horizontalLayout = canOpenOnRight ? "left" : "right";
    return {
      ...menuContainerTowardsTop,
      ...verticalLayout === "top" ? {
        top: opened.top
      } : {
        bottom: size.windowSize.height - opened.top
      },
      ...horizontalLayout === "left" ? {
        left: opened.left
      } : {
        right: canOpenOnLeft ? size.windowSize.width - opened.left : 0
      }
    };
  }, [opened, size, isMobileLayout, spaceToTop, spaceToBottom]);
  const onHide = useCallback10(() => {
    setOpened({ type: "not-open" });
  }, []);
  return jsxs4(Fragment2, {
    children: [
      jsx25("div", {
        ref,
        children: jsx25(InlineAction, {
          onClick,
          ...props
        })
      }),
      portalStyle ? ReactDOM2.createPortal(jsx25("div", {
        style: fullScreenOverlay,
        children: jsx25("div", {
          style: outerPortal,
          className: "css-reset",
          children: jsx25(HigherZIndex, {
            onOutsideClick: onHide,
            onEscape: onHide,
            children: jsx25("div", {
              style: portalStyle,
              children: jsx25(MenuContent2, {
                onNextMenu: noop,
                onPreviousMenu: noop,
                values,
                onHide,
                leaveLeftSpace: true,
                preselectIndex: false,
                topItemCanBeUnselected: false,
                fixedHeight: null
              })
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/CompositionContextButton.tsx
import {
jsx as jsx26
} from "react/jsx-runtime";
var CompositionContextButton = ({ visible, values }) => {
  const iconStyle = useMemo17(() => {
    return {
      style: {
        height: 12
      }
    };
  }, []);
  const connectionStatus = useContext6(StudioServerConnectionCtx).previewServerState.type;
  const renderAction = useCallback11((color) => {
    return jsx26(EllipsisIcon, {
      fill: color,
      svgProps: iconStyle
    });
  }, [iconStyle]);
  if (!visible || connectionStatus !== "connected") {
    return null;
  }
  return jsx26(InlineDropdown, {
    renderAction,
    values
  });
};

// src/components/ContextMenu.tsx
import {PlayerInternals as PlayerInternals4} from "@remotion/player";
import {useCallback as useCallback12, useEffect as useEffect10, useMemo as useMemo18, useRef as useRef9, useState as useState13} from "react";
import ReactDOM3 from "react-dom";
import {
jsx as jsx27,
jsxs as jsxs5,
Fragment as Fragment3
} from "react/jsx-runtime";
var ContextMenu = ({ children, values }) => {
  const ref = useRef9(null);
  const [opened, setOpened] = useState13({ type: "not-open" });
  const { currentZIndex } = useZIndex();
  const style = useMemo18(() => {
    return {};
  }, []);
  const size = PlayerInternals4.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const isMobileLayout = useMobileLayout();
  useEffect10(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    const onClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setOpened({ type: "open", left: e.clientX, top: e.clientY });
      return false;
    };
    current.addEventListener("contextmenu", onClick);
    return () => {
      current.removeEventListener("contextmenu", onClick);
    };
  }, [size]);
  const spaceToBottom = useMemo18(() => {
    if (size && opened.type === "open") {
      return size.windowSize.height - opened.top;
    }
    return 0;
  }, [opened, size]);
  const spaceToTop = useMemo18(() => {
    if (size && opened.type === "open") {
      return opened.top;
    }
    return 0;
  }, [opened, size]);
  const portalStyle = useMemo18(() => {
    if (opened.type === "not-open") {
      return;
    }
    if (!size) {
      return;
    }
    const spaceToRight = size.windowSize.width - size.left;
    const spaceToLeft = size.left + size.width;
    const minSpaceRequired = isMobileLayout ? MAX_MOBILE_MENU_WIDTH : MAX_MENU_WIDTH;
    const verticalLayout = spaceToTop > spaceToBottom ? "bottom" : "top";
    const canOpenOnLeft = spaceToLeft >= minSpaceRequired;
    const canOpenOnRight = spaceToRight >= minSpaceRequired;
    const horizontalLayout = canOpenOnRight ? "left" : "right";
    return {
      ...menuContainerTowardsTop,
      ...verticalLayout === "top" ? {
        top: opened.top
      } : {
        bottom: size.windowSize.height - opened.top
      },
      ...horizontalLayout === "left" ? {
        left: opened.left
      } : {
        right: canOpenOnLeft ? size.windowSize.width - opened.left : 0
      }
    };
  }, [opened, size, isMobileLayout, spaceToTop, spaceToBottom]);
  const onHide = useCallback12(() => {
    setOpened({ type: "not-open" });
  }, []);
  return jsxs5(Fragment3, {
    children: [
      jsx27("div", {
        ref,
        onContextMenu: () => false,
        style,
        children
      }),
      portalStyle ? ReactDOM3.createPortal(jsx27("div", {
        style: fullScreenOverlay,
        children: jsx27("div", {
          style: outerPortal,
          className: "css-reset",
          children: jsx27(HigherZIndex, {
            onOutsideClick: onHide,
            onEscape: onHide,
            children: jsx27("div", {
              style: portalStyle,
              children: jsx27(MenuContent2, {
                onNextMenu: noop,
                onPreviousMenu: noop,
                values,
                onHide,
                leaveLeftSpace: true,
                preselectIndex: false,
                topItemCanBeUnselected: false,
                fixedHeight: null
              })
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/SidebarRenderButton.tsx
import {useCallback as useCallback13, useContext as useContext7, useMemo as useMemo19} from "react";
import {Internals as Internals5} from "remotion";

// src/icons/render.tsx
import {
jsx as jsx28
} from "react/jsx-runtime";
var RenderIcon = (props) => {
  return jsx28("svg", {
    ...props.svgProps,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    children: jsx28("path", {
      fill: "currentColor",
      d: "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    })
  });
};
var ThinRenderIcon = (props) => {
  return jsx28("svg", {
    ...props.svgProps,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    children: jsx28("path", {
      fill: props.fill,
      d: "M188.9 372l-50.4-50.4c18.6-42.6 61.7-137.7 95.1-187C304.6 30.1 409 24.6 475.7 36.3c11.7 66.7 6.2 171.1-98.4 242c-49.4 33.5-145.5 75.6-188.4 93.7zm-79.9-62.8c-5.2 11.9-2.5 25.7 6.7 34.9l50.7 50.7c9.1 9.1 22.7 11.9 34.5 6.9c6.5-2.7 14.3-6 23-9.8L224 496c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7l101.5-50.7c21.7-10.8 35.4-33 35.4-57.2V312.1c4-2.5 7.7-4.9 11.3-7.3C516.1 222.9 520.1 100.9 506.7 28.1c-2.1-11.6-11.2-20.6-22.8-22.8C411.1-8.1 289.1-4.1 207.2 116.7c-2.4 3.6-4.9 7.3-7.3 11.3l-90.2 0c-24.2 0-46.4 13.7-57.2 35.4L1.7 264.8c-2.5 5-2.2 10.8 .7 15.6s8.1 7.6 13.6 7.6H118.5c-3.6 8-6.8 15.2-9.4 21.2zM256 470.1l0-92.5c30.3-13.7 65.4-30.3 96-47v71.7c0 12.1-6.8 23.2-17.7 28.6L256 470.1zM109.7 160h71.5c-16.9 30.7-34 65.8-48.1 96H41.9L81 177.7c5.4-10.8 16.5-17.7 28.6-17.7zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z"
    })
  });
};

// src/components/SidebarRenderButton.tsx
import {
jsx as jsx29
} from "react/jsx-runtime";
var SidebarRenderButton = ({ composition, visible }) => {
  const { setSelectedModal } = useContext7(ModalsContext);
  const { setSidebarCollapsedState } = useContext7(SidebarContext);
  const isMobileLayout = useMobileLayout();
  const iconStyle = useMemo19(() => {
    return {
      style: {
        height: 12
      }
    };
  }, []);
  const connectionStatus = useContext7(StudioServerConnectionCtx).previewServerState.type;
  const { props } = useContext7(Internals5.EditorPropsContext);
  const onClick = useCallback13((e) => {
    const defaults = window.remotion_renderDefaults;
    if (!defaults) {
      throw new Error("expected defaults");
    }
    e.stopPropagation();
    setSelectedModal({
      type: "render",
      compositionId: composition.id,
      initialFrame: 0,
      initialVideoImageFormat: defaults.videoImageFormat,
      initialStillImageFormat: defaults.stillImageFormat,
      initialJpegQuality: defaults.jpegQuality,
      initialScale: defaults.scale,
      initialLogLevel: defaults.logLevel,
      initialConcurrency: defaults.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: defaults.muted,
      initialEnforceAudioTrack: defaults.enforceAudioTrack,
      initialProResProfile: defaults.proResProfile,
      initialx264Preset: defaults.x264Preset,
      initialPixelFormat: defaults.pixelFormat,
      initialAudioBitrate: defaults.audioBitrate,
      initialVideoBitrate: defaults.videoBitrate,
      initialEveryNthFrame: defaults.everyNthFrame,
      initialNumberOfGifLoops: defaults.numberOfGifLoops,
      initialDelayRenderTimeout: defaults.delayRenderTimeout,
      defaultConfigurationAudioCodec: defaults.audioCodec,
      initialEnvVariables: window.process.env,
      initialDisableWebSecurity: defaults.disableWebSecurity,
      initialOpenGlRenderer: defaults.openGlRenderer,
      initialHeadless: defaults.headless,
      initialOffthreadVideoCacheSizeInBytes: defaults.offthreadVideoCacheSizeInBytes,
      initialIgnoreCertificateErrors: defaults.ignoreCertificateErrors,
      defaultProps: props[composition.id] ?? composition.defaultProps,
      inFrameMark: null,
      outFrameMark: null,
      initialColorSpace: defaults.colorSpace,
      initialMultiProcessOnLinux: defaults.multiProcessOnLinux,
      defaultConfigurationVideoCodec: defaults.codec,
      initialEncodingBufferSize: defaults.encodingBufferSize,
      initialEncodingMaxRate: defaults.encodingMaxRate,
      initialUserAgent: defaults.userAgent,
      initialBeep: defaults.beepOnFinish,
      initialRepro: defaults.repro,
      initialForSeamlessAacConcatenation: defaults.forSeamlessAacConcatenation,
      renderTypeOfLastRender: null
    });
    if (isMobileLayout) {
      setSidebarCollapsedState({ left: "collapsed", right: "collapsed" });
    }
  }, [
    composition.defaultProps,
    composition.id,
    isMobileLayout,
    props,
    setSelectedModal,
    setSidebarCollapsedState
  ]);
  const renderAction = useCallback13((color) => {
    return jsx29(ThinRenderIcon, {
      fill: color,
      svgProps: iconStyle
    });
  }, [iconStyle]);
  if (!visible || connectionStatus !== "connected") {
    return null;
  }
  return jsx29(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/CompositionSelectorItem.tsx
import {
jsx as jsx30,
jsxs as jsxs6,
Fragment as Fragment4
} from "react/jsx-runtime";
var COMPOSITION_ITEM_HEIGHT = 32;
var itemStyle = {
  paddingRight: 10,
  paddingTop: 6,
  paddingBottom: 6,
  fontSize: 13,
  display: "flex",
  textDecoration: "none",
  cursor: "default",
  alignItems: "center",
  marginBottom: 1,
  appearance: "none",
  border: "none",
  width: "100%",
  textAlign: "left",
  backgroundColor: BACKGROUND,
  height: COMPOSITION_ITEM_HEIGHT
};
var labelStyle2 = {
  textAlign: "left",
  textDecoration: "none",
  fontSize: 13,
  flex: 1,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};
var iconStyle = {
  width: 18,
  height: 18,
  flexShrink: 0
};
var CompositionSelectorItem = ({
  item,
  level,
  currentComposition,
  tabIndex,
  selectComposition,
  toggleFolder
}) => {
  const selected = useMemo20(() => {
    if (item.type === "composition") {
      return currentComposition === item.composition.id;
    }
    return false;
  }, [item, currentComposition]);
  const [hovered, setHovered] = useState14(false);
  const onPointerEnter = useCallback14(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback14(() => {
    setHovered(false);
  }, []);
  const style = useMemo20(() => {
    return {
      ...itemStyle,
      backgroundColor: getBackgroundFromHoverState({ hovered, selected }),
      paddingLeft: 12 + level * 8
    };
  }, [hovered, level, selected]);
  const label = useMemo20(() => {
    return {
      ...labelStyle2,
      color: selected || hovered ? "white" : LIGHT_TEXT
    };
  }, [hovered, selected]);
  const onClick = useCallback14((evt) => {
    evt.preventDefault();
    if (item.type === "composition") {
      selectComposition(item.composition, true);
    } else {
      toggleFolder(item.folderName, item.parentName);
    }
  }, [item, selectComposition, toggleFolder]);
  const onKeyPress = useCallback14((evt) => {
    if (evt.key === "Enter") {
      onClick(evt);
    }
  }, [onClick]);
  const { setSelectedModal } = useContext8(ModalsContext);
  const contextMenu = useMemo20(() => {
    if (item.type === "composition") {
      return [
        {
          id: "duplicate",
          keyHint: null,
          label: `Duplicate...`,
          leftItem: null,
          onClick: () => {
            setSelectedModal({
              type: "duplicate-comp",
              compositionId: item.composition.id,
              compositionType: item.composition.durationInFrames === 1 ? "still" : "composition"
            });
          },
          quickSwitcherLabel: null,
          subMenu: null,
          type: "item",
          value: "duplicate"
        },
        {
          id: "rename",
          keyHint: null,
          label: `Rename...`,
          leftItem: null,
          onClick: () => {
            setSelectedModal({
              type: "rename-comp",
              compositionId: item.composition.id
            });
          },
          quickSwitcherLabel: null,
          subMenu: null,
          type: "item",
          value: "rename"
        },
        {
          id: "delete",
          keyHint: null,
          label: `Delete...`,
          leftItem: null,
          onClick: () => {
            setSelectedModal({
              type: "delete-comp",
              compositionId: item.composition.id
            });
          },
          quickSwitcherLabel: null,
          subMenu: null,
          type: "item",
          value: "delete"
        },
        {
          type: "divider",
          id: "copy-id-divider"
        },
        {
          id: "copy-id",
          keyHint: null,
          label: `Copy ID`,
          leftItem: null,
          onClick: () => {
            navigator.clipboard.writeText(item.composition.id).catch((err) => {
              showNotification(`Could not copy to clipboard: ${err.message}`, 1000);
            }).then(() => {
              showNotification("Copied to clipboard", 1000);
            });
          },
          quickSwitcherLabel: null,
          subMenu: null,
          type: "item",
          value: "remove"
        }
      ];
    }
    return [];
  }, [item, setSelectedModal]);
  if (item.type === "folder") {
    return jsxs6(Fragment4, {
      children: [
        jsxs6("button", {
          style,
          onPointerEnter,
          onPointerLeave,
          tabIndex,
          onClick,
          type: "button",
          title: item.folderName,
          children: [
            item.expanded ? jsx30(ExpandedFolderIcon, {
              style: iconStyle,
              color: hovered || selected ? "white" : LIGHT_TEXT
            }) : jsx30(CollapsedFolderIcon, {
              color: hovered || selected ? "white" : LIGHT_TEXT,
              style: iconStyle
            }),
            jsx30(Spacing, {
              x: 1
            }),
            jsx30("div", {
              style: label,
              children: item.folderName
            })
          ]
        }),
        item.expanded ? item.items.map((childItem) => {
          return jsx30(CompositionSelectorItem, {
            currentComposition,
            selectComposition,
            item: childItem,
            tabIndex,
            level: level + 1,
            toggleFolder
          }, childItem.key + childItem.type);
        }) : null
      ]
    });
  }
  return jsx30(ContextMenu, {
    values: contextMenu,
    children: jsx30(Row, {
      align: "center",
      children: jsxs6("a", {
        style,
        onPointerEnter,
        onPointerLeave,
        tabIndex,
        onClick,
        onKeyPress,
        type: "button",
        title: item.composition.id,
        className: "__remotion-composition",
        "data-compname": item.composition.id,
        children: [
          isCompositionStill(item.composition) ? jsx30(StillIcon, {
            color: hovered || selected ? "white" : LIGHT_TEXT,
            style: iconStyle
          }) : jsx30(FilmIcon, {
            color: hovered || selected ? "white" : LIGHT_TEXT,
            style: iconStyle
          }),
          jsx30(Spacing, {
            x: 1
          }),
          jsx30("div", {
            style: label,
            children: item.composition.id
          }),
          jsx30(Spacing, {
            x: 0.5
          }),
          jsx30(CompositionContextButton, {
            values: contextMenu,
            visible: hovered
          }),
          jsx30(SidebarRenderButton, {
            visible: hovered,
            composition: item.composition
          })
        ]
      })
    })
  });
};

// src/components/CurrentComposition.tsx
import {Internals as Internals6} from "remotion";

// src/state/render-frame.ts
var renderFrame = (frame, fps) => {
  const hours = Math.floor(frame / fps / 3600);
  const remainingMinutes = frame - hours * fps * 3600;
  const minutes = Math.floor(remainingMinutes / 60 / fps);
  const remainingSec = frame - hours * fps * 3600 - minutes * fps * 60;
  const seconds = Math.floor(remainingSec / fps);
  const frameAfterSec = Math.round(frame % fps);
  const hoursStr = String(hours);
  const minutesStr = String(minutes).padStart(2, "0");
  const secondsStr = String(seconds).padStart(2, "0");
  const frameStr = String(frameAfterSec).padStart(2, "0");
  if (hours > 0) {
    return `${hoursStr}:${minutesStr}:${secondsStr}.${frameStr}`;
  }
  return `${minutesStr}:${secondsStr}.${frameStr}`;
};

// src/components/CurrentComposition.tsx
import {
jsx as jsx31,
jsxs as jsxs7
} from "react/jsx-runtime";
var CURRENT_COMPOSITION_HEIGHT = 80;
var container6 = {
  height: CURRENT_COMPOSITION_HEIGHT,
  display: "block",
  borderBottom: `1px solid ${BORDER_COLOR}`,
  padding: 12,
  color: "white",
  backgroundColor: BACKGROUND
};
var title = {
  fontWeight: "bold",
  fontSize: 12,
  whiteSpace: "nowrap",
  lineHeight: "18px",
  backgroundColor: BACKGROUND
};
var subtitle = {
  fontSize: 12,
  opacity: 0.8,
  whiteSpace: "nowrap",
  lineHeight: "18px",
  backgroundColor: BACKGROUND
};
var row = {
  display: "flex",
  flexDirection: "row",
  lineHeight: "18px",
  backgroundColor: BACKGROUND
};
var CurrentComposition = () => {
  const video2 = Internals6.useVideo();
  if (!video2) {
    return jsx31("div", {
      style: container6
    });
  }
  return jsx31("div", {
    style: container6,
    children: jsx31("div", {
      style: row,
      children: jsxs7("div", {
        children: [
          jsx31("div", {
            style: title,
            children: video2.id
          }),
          jsxs7("div", {
            style: subtitle,
            children: [
              video2.width,
              "x",
              video2.height,
              isCompositionStill(video2) ? null : `, ${video2.fps} FPS`
            ]
          }),
          isCompositionStill(video2) ? jsx31("div", {
            style: subtitle,
            children: "Still"
          }) : jsxs7("div", {
            style: subtitle,
            children: [
              "Duration ",
              renderFrame(video2.durationInFrames, video2.fps)
            ]
          })
        ]
      })
    })
  });
};

// src/components/CompositionSelector.tsx
import {
jsx as jsx32,
jsxs as jsxs8
} from "react/jsx-runtime";
var container7 = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflow: "hidden",
  backgroundColor: BACKGROUND
};
var getKeysToExpand = (initialFolderName, parentFolderName, initial = []) => {
  initial.push(openFolderKey({
    folderName: initialFolderName,
    parentName: parentFolderName
  }));
  const { name, parent } = splitParentIntoNameAndParent(parentFolderName);
  if (!name) {
    return initial;
  }
  return getKeysToExpand(name, parent, initial);
};
var compositionSelectorRef = createRef5();
var CompositionSelector = () => {
  const { compositions, canvasContent, folders } = useContext9(Internals7.CompositionManager);
  const [foldersExpanded, setFoldersExpanded] = useState15(loadExpandedFolders("compositions"));
  const { tabIndex } = useZIndex();
  const selectComposition = useSelectComposition();
  const toggleFolder = useCallback15((folderName, parentName) => {
    setFoldersExpanded((p) => {
      const key = openFolderKey({ folderName, parentName });
      const prev = p[key] ?? false;
      const foldersExpandedState = {
        ...p,
        [key]: !prev
      };
      persistExpandedFolders("compositions", foldersExpandedState);
      return foldersExpandedState;
    });
  }, []);
  useImperativeHandle4(compositionSelectorRef, () => {
    return {
      expandComposition: (compName) => {
        const compositionToExpand = compositions.find((c) => c.id === compName);
        if (!compositionToExpand) {
          return;
        }
        const { folderName, parentFolderName } = compositionToExpand;
        if (folderName === null) {
          return;
        }
        setFoldersExpanded((previousState) => {
          const foldersExpandedState = {
            ...previousState
          };
          const currentFolder = folderName;
          const currentParentName = parentFolderName;
          const key = openFolderKey({
            folderName: currentFolder,
            parentName: currentParentName
          });
          const splitted = key.split("/");
          for (let i = 0;i < splitted.length - 1; i++) {
            const allExceptLast = i === 0 ? openFolderKey({
              folderName: splitted.filter((s) => s !== "no-parent")[0],
              parentName: null
            }) : splitted.slice(0, i + 1).join("/");
            foldersExpandedState[allExceptLast] = true;
          }
          persistExpandedFolders("compositions", foldersExpandedState);
          return foldersExpandedState;
        });
      }
    };
  }, [compositions]);
  const items = useMemo21(() => {
    return createFolderTree(compositions, folders, foldersExpanded);
  }, [compositions, folders, foldersExpanded]);
  const showCurrentComposition = canvasContent && canvasContent.type === "composition";
  const list = useMemo21(() => {
    return {
      height: showCurrentComposition ? `calc(100% - ${CURRENT_COMPOSITION_HEIGHT}px)` : "100%",
      overflowY: "auto"
    };
  }, [showCurrentComposition]);
  return jsxs8("div", {
    style: container7,
    children: [
      showCurrentComposition ? jsx32(CurrentComposition, {}) : null,
      jsx32("div", {
        className: "__remotion-vertical-scrollbar",
        style: list,
        children: items.map((c) => {
          return jsx32(CompositionSelectorItem, {
            level: 0,
            currentComposition: showCurrentComposition ? canvasContent.compositionId : null,
            selectComposition,
            toggleFolder,
            tabIndex,
            item: c
          }, c.key + c.type);
        })
      })
    ]
  });
};

// src/components/ExplorerPanel.tsx
import {createRef as createRef6, useCallback as useCallback20, useImperativeHandle as useImperativeHandle5, useState as useState19} from "react";

// src/components/AssetSelector.tsx
import React25, {
useCallback as useCallback18,
useContext as useContext11,
useEffect as useEffect12,
useMemo as useMemo24,
useState as useState17
} from "react";

// src/api/write-static-file.ts
var writeStaticFile = async ({
  contents,
  filePath
}) => {
  const url = new URL("/api/add-asset", window.location.origin);
  if (filePath.includes("\\")) {
    return Promise.reject(new Error("File path cannot contain backslashes"));
  }
  url.search = new URLSearchParams({
    filePath
  }).toString();
  const response = await fetch(url, {
    method: "POST",
    body: contents
  });
  if (!response.ok) {
    const jsonResponse = await response.json();
    throw new Error(jsonResponse.error);
  }
};

// src/helpers/use-asset-drag-events.ts
import {useCallback as useCallback16, useEffect as useEffect11, useMemo as useMemo22, useRef as useRef10} from "react";
import {NoReactInternals} from "remotion/no-react";
var useAssetDragEvents = function({
  name,
  parentFolder,
  dropLocation,
  setDropLocation
}) {
  const dragDepthRef = useRef10(0);
  const combinedParents = useMemo22(() => {
    return [parentFolder, name].filter(NoReactInternals.truthy).join("/");
  }, [name, parentFolder]);
  const isDropDiv = useMemo22(() => {
    return dropLocation === combinedParents;
  }, [combinedParents, dropLocation]);
  const onDragEnter = useCallback16(() => {
    if (dragDepthRef.current === 0) {
      setDropLocation((currentDropLocation) => currentDropLocation?.includes(combinedParents) ? currentDropLocation : combinedParents);
    }
    dragDepthRef.current++;
  }, [combinedParents, dragDepthRef, setDropLocation]);
  const onDragLeave = useCallback16(() => {
    dragDepthRef.current--;
    if (dragDepthRef.current === 0) {
      setDropLocation((currentPath) => currentPath === combinedParents ? parentFolder : currentPath);
    }
  }, [combinedParents, dragDepthRef, parentFolder, setDropLocation]);
  useEffect11(() => {
    if (dropLocation === null) {
      dragDepthRef.current = 0;
    }
  }, [dropLocation]);
  return {
    isDropDiv,
    onDragEnter,
    onDragLeave
  };
};
var use_asset_drag_events_default = useAssetDragEvents;

// src/components/AssetSelectorItem.tsx
import React24, {useCallback as useCallback17, useContext as useContext10, useMemo as useMemo23, useRef as useRef11, useState as useState16} from "react";
import {Internals as Internals8} from "remotion";
import {NoReactInternals as NoReactInternals3} from "remotion/no-react";

// src/helpers/copy-text.ts
var copyText = (cmd) => {
  const permissionName = "clipboard-write";
  return new Promise((resolve, reject) => {
    navigator.permissions.query({ name: permissionName }).then((result) => {
      if (result.state === "granted" || result.state === "prompt") {
        navigator.clipboard.writeText(cmd);
        resolve();
      } else {
        reject(new Error("Permission to copy not granted"));
      }
    }).catch((err) => {
      reject(err);
    });
  });
};

// src/icons/clipboard.tsx
import {
jsx as jsx33
} from "react/jsx-runtime";
var ClipboardIcon = ({ color, ...props }) => jsx33("svg", {
  viewBox: "0 0 384 512",
  ...props,
  children: jsx33("path", {
    fill: color,
    d: "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
  })
});

// src/icons/file.tsx
import {
jsx as jsx34
} from "react/jsx-runtime";
var FileIcon = ({
  color,
  ...props
}) => jsx34("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512",
  ...props,
  children: jsx34("path", {
    fill: color ?? "currentColor",
    d: "M0 64C0 28.65 28.65 0 64 0h156.1c12.7 0 25 5.057 34 14.06L369.9 129.9c9 9 14.1 21.3 14.1 34V448c0 35.3-28.7 64-64 64H64c-35.35 0-64-28.7-64-64V64zm352 128H240c-26.5 0-48-21.5-48-48V32H64c-17.67 0-32 14.33-32 32v384c0 17.7 14.33 32 32 32h256c17.7 0 32-14.3 32-32V192zm-4.7-39.4L231.4 36.69c-2-2.07-4.6-3.51-7.4-4.21V144c0 8.8 7.2 16 16 16h111.5c-.7-2.8-2.1-5.4-4.2-7.4z"
  })
});

// src/components/RenderQueue/actions.ts
import {NoReactInternals as NoReactInternals2} from "remotion/no-react";

// src/components/call-api.ts
var callApi = (endpoint, body, signal) => {
  return new Promise((resolve, reject) => {
    fetch(endpoint, {
      method: "post",
      headers: {
        "content-type": "application/json"
      },
      signal,
      body: JSON.stringify(body)
    }).then((res) => res.json()).then((data) => {
      if (data.success) {
        resolve(data.data);
      } else {
        reject(new Error(data.error));
      }
    }).catch((err) => {
      reject(err);
    });
  });
};

// src/components/RenderQueue/actions.ts
var addStillRenderJob = ({
  compositionId,
  outName,
  imageFormat,
  jpegQuality,
  frame,
  scale,
  logLevel,
  chromiumOptions,
  delayRenderTimeout,
  envVariables,
  inputProps,
  offthreadVideoCacheSizeInBytes,
  multiProcessOnLinux,
  beepOnFinish
}) => {
  return callApi("/api/render", {
    compositionId,
    type: "still",
    outName,
    imageFormat,
    jpegQuality,
    frame,
    scale,
    logLevel,
    chromiumOptions,
    delayRenderTimeout,
    envVariables,
    serializedInputPropsWithCustomSchema: NoReactInternals2.serializeJSONWithDate({
      data: inputProps,
      staticBase: window.remotion_staticBase,
      indent: undefined
    }).serializedString,
    offthreadVideoCacheSizeInBytes,
    multiProcessOnLinux,
    beepOnFinish
  });
};
var addSequenceRenderJob = ({
  compositionId,
  outName,
  imageFormat,
  startFrame,
  endFrame,
  scale,
  logLevel,
  chromiumOptions,
  delayRenderTimeout,
  envVariables,
  inputProps,
  concurrency,
  offthreadVideoCacheSizeInBytes,
  jpegQuality,
  disallowParallelEncoding,
  multiProcessOnLinux,
  beepOnFinish,
  repro
}) => {
  return callApi("/api/render", {
    compositionId,
    type: "sequence",
    outName,
    imageFormat,
    jpegQuality,
    scale,
    startFrame,
    endFrame,
    logLevel,
    chromiumOptions,
    delayRenderTimeout,
    envVariables,
    concurrency,
    serializedInputPropsWithCustomSchema: NoReactInternals2.serializeJSONWithDate({
      data: inputProps,
      staticBase: window.remotion_staticBase,
      indent: undefined
    }).serializedString,
    offthreadVideoCacheSizeInBytes,
    disallowParallelEncoding,
    multiProcessOnLinux,
    beepOnFinish,
    repro
  });
};
var addVideoRenderJob = ({
  compositionId,
  outName,
  imageFormat,
  jpegQuality,
  scale,
  logLevel,
  codec,
  concurrency,
  crf,
  startFrame,
  endFrame,
  muted,
  enforceAudioTrack,
  proResProfile,
  x264Preset,
  pixelFormat,
  audioBitrate,
  videoBitrate,
  everyNthFrame,
  numberOfGifLoops,
  delayRenderTimeout,
  audioCodec,
  disallowParallelEncoding,
  chromiumOptions,
  envVariables,
  inputProps,
  offthreadVideoCacheSizeInBytes,
  colorSpace,
  multiProcessOnLinux,
  encodingMaxRate,
  encodingBufferSize,
  beepOnFinish,
  repro,
  forSeamlessAacConcatenation,
  separateAudioTo
}) => {
  return callApi("/api/render", {
    compositionId,
    type: "video",
    outName,
    imageFormat,
    jpegQuality,
    scale,
    logLevel,
    codec,
    concurrency,
    crf,
    endFrame,
    startFrame,
    muted,
    enforceAudioTrack,
    proResProfile,
    x264Preset,
    pixelFormat,
    audioBitrate,
    videoBitrate,
    everyNthFrame,
    numberOfGifLoops,
    delayRenderTimeout,
    audioCodec,
    disallowParallelEncoding,
    chromiumOptions,
    envVariables,
    serializedInputPropsWithCustomSchema: NoReactInternals2.serializeJSONWithDate({
      data: inputProps,
      staticBase: window.remotion_staticBase,
      indent: undefined
    }).serializedString,
    offthreadVideoCacheSizeInBytes,
    colorSpace,
    multiProcessOnLinux,
    encodingBufferSize,
    encodingMaxRate,
    beepOnFinish,
    repro,
    forSeamlessAacConcatenation,
    separateAudioTo
  });
};
var unsubscribeFromFileExistenceWatcher = ({
  file,
  clientId
}) => {
  return callApi("/api/unsubscribe-from-file-existence", { file, clientId });
};
var subscribeToFileExistenceWatcher = async ({
  file,
  clientId
}) => {
  const { exists } = await callApi("/api/subscribe-to-file-existence", {
    file,
    clientId
  });
  return exists;
};
var openInFileExplorer = ({ directory }) => {
  const body = {
    directory
  };
  return callApi("/api/open-in-file-explorer", body);
};
var copyToClipboard = ({
  outName,
  binariesDirectory
}) => {
  const body = {
    outName,
    binariesDirectory
  };
  return callApi("/api/copy-still-to-clipboard", body);
};
var applyCodemod = ({
  codemod,
  dryRun,
  signal
}) => {
  const body = {
    codemod,
    dryRun
  };
  return callApi("/api/apply-codemod", body, signal);
};
var removeRenderJob = (job) => {
  return callApi("/api/remove-render", {
    jobId: job.id
  });
};
var cancelRenderJob = (job) => {
  return callApi("/api/cancel", {
    jobId: job.id
  });
};
var updateAvailable = (signal) => {
  return callApi("/api/update-available", {}, signal);
};
var getProjectInfo = (signal) => {
  return callApi("/api/project-info", {}, signal);
};
var callUpdateDefaultPropsApi = (compositionId, defaultProps, enumPaths) => {
  return callApi("/api/update-default-props", {
    compositionId,
    defaultProps: NoReactInternals2.serializeJSONWithDate({
      data: defaultProps,
      indent: undefined,
      staticBase: window.remotion_staticBase
    }).serializedString,
    enumPaths
  });
};
var canUpdateDefaultProps = (compositionId, readOnlyStudio) => {
  if (readOnlyStudio) {
    return Promise.resolve({
      canUpdate: false,
      reason: "Read-only studio"
    });
  }
  return callApi("/api/can-update-default-props", {
    compositionId
  });
};

// src/components/AssetSelectorItem.tsx
import {
jsx as jsx35,
jsxs as jsxs9,
Fragment as Fragment5
} from "react/jsx-runtime";
var ASSET_ITEM_HEIGHT = 32;
var iconStyle2 = {
  width: 18,
  height: 18,
  flexShrink: 0
};
var itemStyle2 = {
  paddingRight: 10,
  paddingTop: 6,
  paddingBottom: 6,
  fontSize: 13,
  display: "flex",
  textDecoration: "none",
  cursor: "default",
  alignItems: "center",
  marginBottom: 1,
  appearance: "none",
  border: "none",
  width: "100%",
  textAlign: "left",
  backgroundColor: BACKGROUND,
  height: ASSET_ITEM_HEIGHT,
  userSelect: "none",
  WebkitUserSelect: "none"
};
var labelStyle3 = {
  textAlign: "left",
  textDecoration: "none",
  fontSize: 13,
  flex: "1 1 0%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};
var revealIconStyle = {
  height: 12,
  color: "currentColor"
};
var AssetFolderItem = ({
  tabIndex,
  item,
  level,
  parentFolder,
  toggleFolder,
  dropLocation,
  setDropLocation
}) => {
  const [hovered, setHovered] = useState16(false);
  const openFolderTimerRef = useRef11(null);
  const { isDropDiv, onDragEnter, onDragLeave } = use_asset_drag_events_default({
    name: item.name,
    parentFolder,
    dropLocation,
    setDropLocation
  });
  const onPointerEnter = useCallback17(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback17(() => {
    setHovered(false);
  }, []);
  const folderStyle = useMemo23(() => {
    return {
      ...itemStyle2,
      paddingLeft: 4 + level * 8,
      backgroundColor: hovered ? CLEAR_HOVER : "transparent"
    };
  }, [hovered, level]);
  const label = useMemo23(() => {
    return {
      ...labelStyle3,
      color: hovered ? "white" : LIGHT_TEXT
    };
  }, [hovered]);
  const onClick = useCallback17(() => {
    toggleFolder(item.name, parentFolder);
  }, [item.name, parentFolder, toggleFolder]);
  const Icon = item.expanded ? ExpandedFolderIcon : CollapsedFolderIcon;
  return jsxs9("div", {
    onDragEnter,
    onDragLeave,
    style: {
      backgroundColor: isDropDiv ? CLEAR_HOVER : BACKGROUND
    },
    children: [
      jsx35("div", {
        style: folderStyle,
        onPointerEnter,
        onPointerLeave,
        tabIndex,
        title: item.name,
        onClick,
        onDragEnter: () => {
          if (!item.expanded) {
            openFolderTimerRef.current = window.setTimeout(() => {
              toggleFolder(item.name, parentFolder);
            }, 1000);
          }
        },
        onDragLeave: () => {
          if (openFolderTimerRef.current) {
            clearTimeout(openFolderTimerRef.current);
          }
        },
        children: jsxs9(Row, {
          children: [
            jsx35(Icon, {
              style: iconStyle2,
              color: hovered ? "white" : LIGHT_TEXT
            }),
            jsx35(Spacing, {
              x: 1
            }),
            jsx35("div", {
              style: label,
              children: item.name
            })
          ]
        })
      }),
      item.expanded ? jsx35(AssetFolderTree, {
        item: item.items,
        name: item.name,
        level,
        parentFolder,
        tabIndex,
        toggleFolder,
        dropLocation,
        setDropLocation
      }, item.name) : null
    ]
  });
};
var AssetFolderTree = ({
  item,
  level,
  name,
  parentFolder,
  toggleFolder,
  tabIndex,
  dropLocation,
  setDropLocation
}) => {
  const combinedParents = useMemo23(() => {
    return [parentFolder, name].filter(NoReactInternals3.truthy).join("/");
  }, [name, parentFolder]);
  return jsxs9("div", {
    children: [
      item.folders.map((folder3) => {
        return jsx35(AssetFolderItem, {
          item: folder3,
          tabIndex,
          level: level + 1,
          parentFolder: combinedParents,
          toggleFolder,
          dropLocation,
          setDropLocation
        }, folder3.name);
      }),
      item.files.map((file2) => {
        return jsx35(AssetSelectorItem, {
          item: file2,
          tabIndex,
          level,
          parentFolder: combinedParents
        }, file2.src);
      })
    ]
  });
};
var AssetSelectorItem = ({ item, tabIndex, level, parentFolder }) => {
  const isMobileLayout = useMobileLayout();
  const [hovered, setHovered] = useState16(false);
  const { setSidebarCollapsedState } = useContext10(SidebarContext);
  const onPointerEnter = useCallback17(() => {
    setHovered(true);
  }, []);
  const { canvasContent, setCanvasContent } = useContext10(Internals8.CompositionManager);
  const selected = useMemo23(() => {
    if (canvasContent && canvasContent.type === "asset") {
      const nameWOParent = canvasContent.asset.split("/").pop();
      return nameWOParent === item.name;
    }
    return false;
  }, [canvasContent, item.name]);
  const onPointerLeave = useCallback17(() => {
    setHovered(false);
  }, []);
  const onClick = useCallback17(() => {
    const relativePath = parentFolder ? parentFolder + "/" + item.name : item.name;
    setCanvasContent({ type: "asset", asset: relativePath });
    pushUrl(`/assets/${relativePath}`);
    if (isMobileLayout) {
      setSidebarCollapsedState({ left: "collapsed", right: "collapsed" });
    }
  }, [
    isMobileLayout,
    item.name,
    parentFolder,
    setCanvasContent,
    setSidebarCollapsedState
  ]);
  const style = useMemo23(() => {
    return {
      ...itemStyle2,
      color: hovered || selected ? "white" : LIGHT_TEXT,
      backgroundColor: hovered ? selected ? SELECTED_BACKGROUND : CLEAR_HOVER : selected ? SELECTED_BACKGROUND : "transparent",
      paddingLeft: 12 + level * 8
    };
  }, [hovered, level, selected]);
  const label = useMemo23(() => {
    return {
      ...labelStyle3,
      color: hovered || selected ? "white" : LIGHT_TEXT
    };
  }, [hovered, selected]);
  const renderFileExplorerAction = useCallback17((color) => {
    return jsx35(ExpandedFolderIcon, {
      style: revealIconStyle,
      color
    });
  }, []);
  const renderCopyAction = useCallback17((color) => {
    return jsx35(ClipboardIcon, {
      style: revealIconStyle,
      color
    });
  }, []);
  const revealInExplorer = React24.useCallback((e) => {
    e.stopPropagation();
    openInFileExplorer({
      directory: window.remotion_publicFolderExists + "/" + parentFolder + "/" + item.name
    }).catch((err) => {
      showNotification(`Could not open file: ${err.message}`, 2000);
    });
  }, [item.name, parentFolder]);
  const copyToClipboard2 = useCallback17((e) => {
    e.stopPropagation();
    const content = `staticFile("${[parentFolder, item.name].join("/")}")`;
    copyText(content).then(() => {
      showNotification(`Copied '${content}' to clipboard`, 1000);
    }).catch((err) => {
      showNotification(`Could not copy: ${err.message}`, 2000);
    });
  }, [item.name, parentFolder]);
  return jsx35(Row, {
    align: "center",
    children: jsxs9("div", {
      style,
      onPointerEnter,
      onPointerLeave,
      onClick,
      tabIndex,
      title: item.name,
      children: [
        jsx35(FileIcon, {
          style: iconStyle2,
          color: LIGHT_TEXT
        }),
        jsx35(Spacing, {
          x: 1
        }),
        jsx35("div", {
          style: label,
          children: item.name
        }),
        hovered ? jsxs9(Fragment5, {
          children: [
            jsx35(Spacing, {
              x: 0.5
            }),
            jsx35(InlineAction, {
              title: "Copy staticFile() name",
              renderAction: renderCopyAction,
              onClick: copyToClipboard2
            }),
            jsx35(Spacing, {
              x: 0.5
            }),
            jsx35(InlineAction, {
              title: "Open in Explorer",
              renderAction: renderFileExplorerAction,
              onClick: revealInExplorer
            })
          ]
        }) : null
      ]
    })
  });
};

// src/components/AssetSelector.tsx
import {
jsx as jsx36,
jsxs as jsxs10
} from "react/jsx-runtime";
var container8 = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflow: "hidden",
  backgroundColor: BACKGROUND
};
var emptyState = {
  display: "flex",
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  padding: "0 12px"
};
var label = {
  color: LIGHT_TEXT,
  lineHeight: 1.5,
  fontSize: 14
};
var list = {
  height: "100%",
  overflowY: "auto"
};
var AssetSelector = ({ readOnlyStudio }) => {
  const { tabIndex } = useZIndex();
  const { assetFoldersExpanded, setAssetFoldersExpanded } = useContext11(FolderContext);
  const [dropLocation, setDropLocation] = useState17(null);
  const { subscribeToEvent } = useContext11(StudioServerConnectionCtx);
  const connectionStatus = useContext11(StudioServerConnectionCtx).previewServerState.type;
  const shouldAllowUpload = connectionStatus === "connected" && !readOnlyStudio;
  const [{ publicFolderExists, staticFiles }, setState] = React25.useState(() => {
    return {
      staticFiles: getStaticFiles(),
      publicFolderExists: window.remotion_publicFolderExists
    };
  });
  const assetTree = useMemo24(() => {
    return buildAssetFolderStructure(staticFiles, null, assetFoldersExpanded);
  }, [assetFoldersExpanded, staticFiles]);
  useEffect12(() => {
    const onUpdate = () => {
      setState({
        staticFiles: getStaticFiles(),
        publicFolderExists: window.remotion_publicFolderExists
      });
    };
    const unsub = subscribeToEvent("new-public-folder", onUpdate);
    return () => {
      unsub();
    };
  }, [subscribeToEvent]);
  const toggleFolder = useCallback18((folderName, parentName) => {
    setAssetFoldersExpanded((p) => {
      const key = [parentName, folderName].filter(Boolean).join("/");
      const prev = p[key] ?? false;
      const foldersExpandedState = {
        ...p,
        [key]: !prev
      };
      persistExpandedFolders("assets", foldersExpandedState);
      return foldersExpandedState;
    });
  }, [setAssetFoldersExpanded]);
  const { isDropDiv, onDragEnter, onDragLeave } = use_asset_drag_events_default({
    name: null,
    parentFolder: null,
    dropLocation,
    setDropLocation
  });
  const onDragOver = useCallback18((e) => {
    e.preventDefault();
  }, []);
  const onDrop = useCallback18(async (e) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      const { files } = e.dataTransfer;
      const assetPath = dropLocation || "/";
      for (const file2 of files) {
        const body = await file2.arrayBuffer();
        await writeStaticFile({
          contents: body,
          filePath: file2.name
        });
      }
      if (files.length === 1) {
        showNotification(`Added ${files[0].name} to ${assetPath}`, 3000);
      } else {
        showNotification(`Added ${files.length} files to ${assetPath}`, 3000);
      }
    } catch (error) {
      showNotification(`Error during upload: ${error}`, 3000);
    } finally {
      setDropLocation(null);
    }
  }, [dropLocation]);
  return jsx36("div", {
    style: container8,
    onDragOver: shouldAllowUpload ? onDragOver : undefined,
    onDrop: shouldAllowUpload ? onDrop : undefined,
    children: staticFiles.length === 0 ? publicFolderExists ? jsx36("div", {
      style: emptyState,
      children: jsxs10("div", {
        style: label,
        children: [
          "To add assets, place a file in the",
          " ",
          jsx36("code", {
            style: inlineCodeSnippet,
            children: "public"
          }),
          " folder of your project or drag and drop a file here."
        ]
      })
    }) : jsx36("div", {
      style: emptyState,
      children: jsxs10("div", {
        style: label,
        children: [
          "To add assets, create a folder called",
          " ",
          jsx36("code", {
            style: inlineCodeSnippet,
            children: "public"
          }),
          " in the root of your project and place a file in it."
        ]
      })
    }) : jsx36("div", {
      className: "__remotion-vertical-scrollbar",
      style: {
        ...list,
        backgroundColor: isDropDiv ? CLEAR_HOVER : BACKGROUND
      },
      onDragEnter,
      onDragLeave,
      children: jsx36(AssetFolderTree, {
        item: assetTree,
        level: 0,
        parentFolder: null,
        name: null,
        tabIndex,
        toggleFolder,
        dropLocation,
        setDropLocation
      })
    })
  });
};

// src/components/Tabs/index.tsx
import {useCallback as useCallback19, useMemo as useMemo25, useState as useState18} from "react";
import {
jsx as jsx37
} from "react/jsx-runtime";
var tabsContainer = {
  display: "flex",
  flexDirection: "row"
};
var Tabs = ({ children, style }) => {
  const definiteStyle = useMemo25(() => {
    return {
      ...tabsContainer,
      ...style
    };
  }, [style]);
  return jsx37("div", {
    style: definiteStyle,
    children
  });
};
var selectorButton = {
  border: "none",
  flex: 1,
  padding: 8,
  paddingLeft: 16,
  display: "flex",
  flexDirection: "row",
  fontSize: 14,
  color: "inherit",
  alignItems: "center"
};
var Tab = ({ children, onClick, style, selected }) => {
  const [hovered, setHovered] = useState18(false);
  const { tabIndex } = useZIndex();
  const onPointerEnter = useCallback19(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback19(() => {
    setHovered(false);
  }, []);
  const definiteStyle = useMemo25(() => ({
    ...selectorButton,
    backgroundColor: selected ? BACKGROUND : hovered ? CLEAR_HOVER : INPUT_BACKGROUND,
    color: selected ? "white" : LIGHT_TEXT,
    borderTop: selected ? "2px solid " + BLUE : "2px solid transparent",
    boxShadow: selected ? "none" : undefined,
    ...style
  }), [hovered, selected, style]);
  return jsx37("div", {
    style: definiteStyle,
    role: "button",
    onClick,
    tabIndex,
    onPointerLeave,
    onPointerEnter,
    children
  });
};

// src/components/ExplorerPanel.tsx
import {
jsx as jsx38,
jsxs as jsxs11
} from "react/jsx-runtime";
var container9 = {
  height: "100%",
  width: "100%",
  maxWidth: "100%",
  display: "flex",
  flexDirection: "column",
  flex: 1
};
var localStorageKey2 = "remotion.sidebarPanel";
var getSelectedPanel = () => {
  const panel = localStorage.getItem(localStorageKey2);
  if (panel === "assets") {
    return "assets";
  }
  return "compositions";
};
var tabsContainer2 = {
  backgroundColor: BACKGROUND
};
var persistSelectedOptionsSidebarPanel = (panel) => {
  localStorage.setItem(localStorageKey2, panel);
};
var explorerSidebarTabs = createRef6();
var ExplorerPanel = ({ readOnlyStudio }) => {
  const [panel, setPanel] = useState19(() => getSelectedPanel());
  const onCompositionsSelected = useCallback20(() => {
    setPanel("compositions");
    persistSelectedOptionsSidebarPanel("compositions");
  }, []);
  const onAssetsSelected = useCallback20(() => {
    setPanel("assets");
    persistSelectedOptionsSidebarPanel("assets");
  }, []);
  useImperativeHandle5(explorerSidebarTabs, () => {
    return {
      selectAssetsPanel: () => {
        setPanel("assets");
        persistSelectedOptionsSidebarPanel("assets");
      },
      selectCompositionPanel: () => {
        setPanel("compositions");
        persistSelectedOptionsSidebarPanel("compositions");
      }
    };
  }, []);
  return jsxs11("div", {
    style: container9,
    className: "css-reset",
    children: [
      jsx38("div", {
        style: tabsContainer2,
        children: jsxs11(Tabs, {
          children: [
            jsx38(Tab, {
              selected: panel === "compositions",
              onClick: onCompositionsSelected,
              children: "Compositions"
            }),
            jsx38(Tab, {
              selected: panel === "assets",
              onClick: onAssetsSelected,
              children: "Assets"
            })
          ]
        })
      }),
      panel === "compositions" ? jsx38(CompositionSelector, {}) : jsx38(AssetSelector, {
        readOnlyStudio
      })
    ]
  });
};

// src/components/InitialCompositionLoader.tsx
var useSelectAsset = () => {
  const { setCanvasContent } = useContext12(Internals9.CompositionManager);
  const { setAssetFoldersExpanded } = useContext12(FolderContext);
  return (asset) => {
    setCanvasContent({ type: "asset", asset });
    explorerSidebarTabs.current?.selectAssetsPanel();
    setAssetFoldersExpanded((ex) => {
      const split = asset.split("/");
      const keysToExpand = split.map((_, i) => {
        return split.slice(0, i).join("/");
      });
      const newState = {
        ...ex
      };
      for (const key of keysToExpand) {
        newState[key] = true;
      }
      return newState;
    });
  };
};
var useSelectComposition = () => {
  const { setCompositionFoldersExpanded } = useContext12(FolderContext);
  const { setCanvasContent } = useContext12(Internals9.CompositionManager);
  const isMobileLayout = useMobileLayout();
  const { setSidebarCollapsedState } = useContext12(SidebarContext);
  return (c, push) => {
    if (push) {
      pushUrl(`/${c.id}`);
    }
    explorerSidebarTabs.current?.selectCompositionPanel();
    setCanvasContent({ type: "composition", compositionId: c.id });
    const { folderName, parentFolderName } = c;
    if (folderName !== null) {
      setCompositionFoldersExpanded((ex) => {
        const keysToExpand = getKeysToExpand(folderName, parentFolderName);
        const newState = {
          ...ex
        };
        for (const key of keysToExpand) {
          newState[key] = true;
        }
        return newState;
      });
      if (isMobileLayout) {
        setSidebarCollapsedState({ left: "collapsed", right: "collapsed" });
      }
    }
  };
};
var InitialCompositionLoader2 = () => {
  const { compositions, canvasContent, setCanvasContent } = useContext12(Internals9.CompositionManager);
  const selectComposition = useSelectComposition();
  const selectAsset = useSelectAsset();
  useEffect13(() => {
    if (canvasContent) {
      return;
    }
    const canvasContentFromUrl = deriveCanvasContentFromUrl();
    if (canvasContentFromUrl && canvasContentFromUrl.type === "composition") {
      const exists = compositions.find((c) => c.id === canvasContentFromUrl.compositionId);
      if (exists) {
        selectComposition(exists, false);
      }
      return;
    }
    if (canvasContentFromUrl && canvasContentFromUrl.type === "asset") {
      selectAsset(canvasContentFromUrl.asset);
      return;
    }
    if (canvasContentFromUrl && canvasContentFromUrl.type === "output") {
      setCanvasContent(canvasContentFromUrl);
      return;
    }
    if (compositions.length > 0) {
      selectComposition(compositions[0], true);
    }
  }, [
    compositions,
    canvasContent,
    selectComposition,
    setCanvasContent,
    selectAsset
  ]);
  useEffect13(() => {
    const onchange = () => {
      const newCanvas = deriveCanvasContentFromUrl();
      if (newCanvas && newCanvas.type === "composition") {
        const newComp = getRoute().substring(1);
        const exists = compositions.find((c) => c.id === newComp);
        if (exists) {
          selectComposition(exists, false);
        }
        return;
      }
      if (newCanvas && newCanvas.type === "asset") {
        const staticFiles = getStaticFiles();
        const exists = staticFiles.find((file2) => {
          return file2.name === newCanvas.asset;
        });
        if (exists) {
          setCanvasContent(newCanvas);
        }
        return;
      }
      setCanvasContent(newCanvas);
    };
    window.addEventListener("popstate", onchange);
    return () => window.removeEventListener("popstate", onchange);
  }, [compositions, selectComposition, setCanvasContent]);
  return null;
};

// src/components/MenuToolbar.tsx
import {useCallback as useCallback85, useMemo as useMemo89, useState as useState54} from "react";

// src/helpers/use-menu-structure.tsx
import {useContext as useContext18, useMemo as useMemo36} from "react";
import {Internals as Internals15} from "remotion";
import {NoReactInternals as NoReactInternals5} from "remotion/no-react";

// src/components/SizeSelector.tsx
import {useContext as useContext16, useMemo as useMemo32} from "react";
import {Internals as Internals11} from "remotion";

// src/icons/Checkmark.tsx
import {
jsx as jsx39
} from "react/jsx-runtime";
var style = {
  width: 14,
  height: 14
};
var Checkmark = () => jsx39("svg", {
  focusable: "false",
  role: "img",
  viewBox: "0 0 512 512",
  style,
  children: jsx39("path", {
    fill: "currentColor",
    d: "M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"
  })
});

// src/components/ControlButton.tsx
import {useMemo as useMemo26} from "react";
import {
jsx as jsx40
} from "react/jsx-runtime";
var CONTROL_BUTTON_PADDING = 6;
var ControlButton = (props) => {
  const style2 = useMemo26(() => {
    return {
      opacity: props.disabled ? 0.5 : 1,
      display: "inline-flex",
      background: "none",
      border: "none",
      padding: CONTROL_BUTTON_PADDING
    };
  }, [props.disabled]);
  const { tabIndex } = useZIndex();
  return jsx40("button", {
    type: "button",
    tabIndex,
    ...props,
    style: style2
  });
};

// src/components/NewComposition/ComboBox.tsx
import {PlayerInternals as PlayerInternals5} from "@remotion/player";
import {useCallback as useCallback21, useEffect as useEffect14, useMemo as useMemo27, useRef as useRef12, useState as useState20} from "react";
import ReactDOM4 from "react-dom";
import {
jsx as jsx41,
jsxs as jsxs12,
Fragment as Fragment6
} from "react/jsx-runtime";
var container10 = {
  padding: "8px 10px",
  display: "inline-block",
  backgroundColor: INPUT_BACKGROUND,
  borderWidth: 1,
  borderStyle: "solid",
  maxWidth: "100%"
};
var label2 = {
  flex: 1,
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontSize: 14,
  textAlign: "left"
};
var Combobox = ({ values, selectedId, style: customStyle, title: title2 }) => {
  const [hovered, setIsHovered] = useState20(false);
  const [opened, setOpened] = useState20(false);
  const ref = useRef12(null);
  const { tabIndex, currentZIndex } = useZIndex();
  const size = PlayerInternals5.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const refresh = size?.refresh;
  const onHide = useCallback21(() => {
    setOpened(false);
  }, []);
  useEffect14(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    const onPointerDown = () => {
      return setOpened((o) => {
        if (!o) {
          refresh?.();
        }
        return !o;
      });
    };
    const onClick = (e) => {
      e.stopPropagation();
      const isKeyboardInitiated = e.detail === 0;
      if (!isKeyboardInitiated) {
        return;
      }
      return setOpened((o) => {
        if (!o) {
          refresh?.();
          window.addEventListener("pointerup", (evt) => {
            if (!isMenuItem(evt.target)) {
              setOpened(false);
            }
          }, {
            once: true
          });
        }
        return !o;
      });
    };
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    current.addEventListener("pointerdown", onPointerDown);
    current.addEventListener("click", onClick);
    return () => {
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
      current.removeEventListener("pointerdown", onPointerDown);
      current.removeEventListener("click", onClick);
    };
  }, [refresh]);
  const spaceToBottom = useMemo27(() => {
    const margin2 = 10;
    if (size && opened) {
      return size.windowSize.height - (size.top + size.height) - margin2;
    }
    return 0;
  }, [opened, size]);
  const spaceToTop = useMemo27(() => {
    const margin2 = 10;
    if (size && opened) {
      return size.top - margin2;
    }
    return 0;
  }, [opened, size]);
  const derivedMaxHeight = useMemo27(() => {
    return spaceToTop > spaceToBottom ? spaceToTop : spaceToBottom;
  }, [spaceToBottom, spaceToTop]);
  const isMobileLayout = useMobileLayout();
  const portalStyle = useMemo27(() => {
    if (!opened || !size) {
      return null;
    }
    const spaceToRight = size.windowSize.width - size.left;
    const spaceToLeft = size.left + size.width;
    const minSpaceRequired = isMobileLayout ? MAX_MOBILE_MENU_WIDTH : MAX_MENU_WIDTH;
    const verticalLayout = spaceToTop > spaceToBottom ? "bottom" : "top";
    const canOpenOnLeft = spaceToLeft >= minSpaceRequired;
    const canOpenOnRight = spaceToRight >= minSpaceRequired;
    const horizontalLayout = canOpenOnRight ? "left" : "right";
    return {
      ...verticalLayout === "top" ? {
        ...menuContainerTowardsBottom,
        top: size.top + size.height
      } : {
        ...menuContainerTowardsTop,
        bottom: size.windowSize.height - size.top
      },
      ...horizontalLayout === "left" ? {
        left: size.left
      } : canOpenOnLeft ? {
        right: size.windowSize.width - size.left - size.width
      } : { left: 0 }
    };
  }, [isMobileLayout, opened, size, spaceToBottom, spaceToTop]);
  const selected = values.find((v) => v.id === selectedId);
  const style2 = useMemo27(() => {
    return {
      ...container10,
      ...customStyle ?? {},
      userSelect: "none",
      WebkitUserSelect: "none",
      color: "white",
      display: "inline-flex",
      flexDirection: "row",
      alignItems: "center",
      borderColor: opened ? SELECTED_BACKGROUND : hovered ? INPUT_BORDER_COLOR_HOVERED : INPUT_BORDER_COLOR_UNHOVERED
    };
  }, [customStyle, hovered, opened]);
  return jsxs12(Fragment6, {
    children: [
      jsxs12("button", {
        ref,
        title: title2,
        tabIndex,
        type: "button",
        style: style2,
        className: MENU_INITIATOR_CLASSNAME,
        children: [
          selected ? jsx41("div", {
            title: typeof selected.label === "string" ? selected.label : undefined,
            style: label2,
            children: selected?.label
          }) : null,
          jsx41(Spacing, {
            x: 1
          }),
          " ",
          jsx41(CaretDown, {})
        ]
      }),
      portalStyle ? ReactDOM4.createPortal(jsx41("div", {
        style: fullScreenOverlay,
        children: jsx41("div", {
          style: outerPortal,
          className: "css-reset",
          children: jsx41(HigherZIndex, {
            onOutsideClick: onHide,
            onEscape: onHide,
            children: jsx41("div", {
              style: portalStyle,
              children: jsx41(MenuContent2, {
                onNextMenu: noop,
                onPreviousMenu: noop,
                values,
                onHide,
                leaveLeftSpace: true,
                preselectIndex: values.findIndex((v) => selected && v.id === selected.id),
                topItemCanBeUnselected: false,
                fixedHeight: derivedMaxHeight
              })
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/Preview.tsx
import {PlayerInternals as PlayerInternals6} from "@remotion/player";
import {useContext as useContext15, useEffect as useEffect19, useMemo as useMemo31, useRef as useRef15} from "react";
import {Internals as Internals10} from "remotion";

// src/helpers/checkerboard-background.ts
var getCheckerboardBackgroundSize = (size) => `${size}px ${size}px`;
var getCheckerboardBackgroundPos = (size) => `0 0, ${size / 2}px 0, ${size / 2}px -${size / 2}px, 0px ${size / 2}px`;
var checkerboardBackgroundColor = (checkerboard) => {
  if (checkerboard) {
    return "white";
  }
  return "black";
};
var checkerboardBackgroundImage = (checkerboard) => {
  if (checkerboard) {
    return `
     linear-gradient(
        45deg,
        rgba(0, 0, 0, 0.1) 25%,
        transparent 25%
      ),
      linear-gradient(135deg, rgba(0, 0, 0, 0.1) 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, rgba(0, 0, 0, 0.1) 75%),
      linear-gradient(135deg, transparent 75%, rgba(0, 0, 0, 0.1) 75%)
    `;
  }
  return;
};

// src/state/checkerboard.ts
import {createContext as createContext9} from "react";
var persistCheckerboardOption = (option) => {
  localStorage.setItem("option", String(option));
};
var loadCheckerboardOption = () => {
  const item = localStorage.getItem("option");
  return item !== "false";
};
var CheckerboardContext = createContext9({
  checkerboard: loadCheckerboardOption(),
  setCheckerboard: () => {
    return;
  }
});

// src/components/RenderPreview.tsx
import {useContext as useContext13} from "react";

// src/helpers/get-asset-metadata.ts
import {getVideoMetadata} from "@remotion/media-utils";
import {staticFile} from "remotion";
var remotion_outputsBase = window.remotion_staticBase.replace("static", "outputs");
var getSrcFromCanvasContent = (canvasContent) => {
  if (canvasContent.type === "asset") {
    return staticFile(canvasContent.asset);
  }
  if (canvasContent.type === "composition") {
    throw new Error("cannot get dimensions for composition");
  }
  return remotion_outputsBase + canvasContent.path;
};
var getAssetMetadata = async (canvasContent) => {
  const src = getSrcFromCanvasContent(canvasContent);
  const file2 = await fetch(src, {
    method: "HEAD"
  });
  if (file2.status === 404) {
    return { type: "not-found" };
  }
  if (file2.status !== 200) {
    throw new Error(`Expected status code 200 or 404 for file, got ${file2.status}`);
  }
  const size = file2.headers.get("content-length");
  if (!size) {
    throw new Error("Unexpected error: content-length is null");
  }
  const fileType = getPreviewFileType(src);
  if (fileType === "video") {
    const resolution = await getVideoMetadata(src);
    return {
      type: "found",
      size: Number(size),
      dimensions: { width: resolution.width, height: resolution.height }
    };
  }
  if (fileType === "image") {
    const resolution = await new Promise((resolve, reject) => {
      const img = new Image;
      img.onload = () => {
        resolve({
          type: "found",
          size: Number(size),
          dimensions: { width: img.width, height: img.height }
        });
      };
      img.onerror = () => {
        reject(new Error("Failed to load image"));
      };
      img.src = src;
    });
    return resolution;
  }
  return {
    type: "found",
    dimensions: "none",
    size: Number(size)
  };
};

// src/components/FilePreview.tsx
import {formatBytes} from "@remotion/studio-shared";

// src/components/JSONViewer.tsx
import {useEffect as useEffect17, useState as useState23} from "react";

// src/components/NewComposition/RemTextarea.tsx
import {
forwardRef as forwardRef2,
useEffect as useEffect16,
useImperativeHandle as useImperativeHandle7,
useMemo as useMemo29,
useRef as useRef14,
useState as useState22
} from "react";

// src/components/NewComposition/RemInput.tsx
import {
forwardRef,
useEffect as useEffect15,
useImperativeHandle as useImperativeHandle6,
useMemo as useMemo28,
useRef as useRef13,
useState as useState21
} from "react";
import {
jsx as jsx42
} from "react/jsx-runtime";
var INPUT_HORIZONTAL_PADDING = 8;
var aligner = {
  marginRight: -INPUT_HORIZONTAL_PADDING
};
var RightAlignInput = ({ children }) => {
  return jsx42("div", {
    style: aligner,
    children
  });
};
var inputBaseStyle = {
  padding: `${INPUT_HORIZONTAL_PADDING}px 10px`,
  color: "white",
  borderStyle: "solid",
  borderWidth: 1,
  fontSize: 14
};
var getInputBorderColor = ({
  status,
  isFocused,
  isHovered
}) => status === "warning" ? WARNING_COLOR : status === "error" ? FAIL_COLOR : isFocused ? SELECTED_BACKGROUND : isHovered ? INPUT_BORDER_COLOR_HOVERED : INPUT_BORDER_COLOR_UNHOVERED;
var RemInputForwardRef = ({ status, rightAlign, ...props }, ref) => {
  const [isFocused, setIsFocused] = useState21(false);
  const [isHovered, setIsHovered] = useState21(false);
  const inputRef = useRef13(null);
  const { tabIndex } = useZIndex();
  const style2 = useMemo28(() => {
    return {
      backgroundColor: INPUT_BACKGROUND,
      ...inputBaseStyle,
      width: "100%",
      borderColor: getInputBorderColor({ isFocused, isHovered, status }),
      textAlign: rightAlign ? "right" : "left",
      ...props.style ?? {}
    };
  }, [isFocused, isHovered, rightAlign, props.style, status]);
  useImperativeHandle6(ref, () => {
    return inputRef.current;
  }, []);
  useEffect15(() => {
    if (!inputRef.current) {
      return;
    }
    const { current } = inputRef;
    const onFocus = () => setIsFocused(true);
    const onBlur = () => setIsFocused(false);
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    current.addEventListener("focus", onFocus);
    current.addEventListener("blur", onBlur);
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    return () => {
      current.removeEventListener("focus", onFocus);
      current.removeEventListener("blur", onBlur);
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
    };
  }, [inputRef]);
  return jsx42("input", {
    ref: inputRef,
    tabIndex,
    ...props,
    style: style2
  });
};
var RemotionInput = forwardRef(RemInputForwardRef);

// src/components/NewComposition/RemTextarea.tsx
import {
jsx as jsx43
} from "react/jsx-runtime";
var inputBaseStyle2 = {
  padding: `${INPUT_HORIZONTAL_PADDING}px 10px`,
  color: "white",
  borderStyle: "solid",
  borderWidth: 1,
  fontSize: 14,
  resize: "none",
  overflowX: "hidden"
};
var RemTextareaFRFunction = ({ status, ...props }, ref) => {
  const [isFocused, setIsFocused] = useState22(false);
  const [isHovered, setIsHovered] = useState22(false);
  const inputRef = useRef14(null);
  const { tabIndex } = useZIndex();
  useImperativeHandle7(ref, () => {
    return inputRef.current;
  }, []);
  const style2 = useMemo29(() => {
    return {
      backgroundColor: INPUT_BACKGROUND,
      ...inputBaseStyle2,
      width: "100%",
      borderColor: getInputBorderColor({ isFocused, isHovered, status }),
      ...props.style ?? {}
    };
  }, [isFocused, isHovered, props.style, status]);
  useEffect16(() => {
    if (!inputRef.current) {
      return;
    }
    const { current } = inputRef;
    const onFocus = () => setIsFocused(true);
    const onBlur = () => setIsFocused(false);
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    const onKeyDown = (e) => {
      if (!inputRef.current) {
        return;
      }
      if (inputRef.current !== document.activeElement) {
        return;
      }
      if (e.code === "Tab") {
        e.preventDefault();
        document.execCommand("insertText", false, " ".repeat(2));
      }
      if (e.code === "Enter") {
        e.preventDefault();
        const { selectionStart, selectionEnd, value } = inputRef.current;
        if (selectionStart !== selectionEnd) {
          return;
        }
        let prevNewline = selectionStart;
        for (let i = selectionStart - 1;i >= 0; i--) {
          if (value[i] === "\n") {
            break;
          }
          prevNewline = i;
        }
        const currentLine = value.substring(prevNewline, selectionStart);
        const trimmed = currentLine.trim();
        const difference = currentLine.length - trimmed.length;
        document.execCommand("insertText", false, "\n" + " ".repeat(difference));
      }
    };
    current.addEventListener("focus", onFocus);
    current.addEventListener("blur", onBlur);
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    current.addEventListener("keydown", onKeyDown);
    return () => {
      current.removeEventListener("focus", onFocus);
      current.removeEventListener("blur", onBlur);
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
      current.removeEventListener("keydown", onKeyDown);
    };
  }, [inputRef]);
  return jsx43("textarea", {
    ref: inputRef,
    tabIndex,
    ...props,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    style: style2
  });
};
var RemTextarea = forwardRef2(RemTextareaFRFunction);

// src/components/JSONViewer.tsx
import {
jsx as jsx44
} from "react/jsx-runtime";
var jsonStyle = {
  marginTop: 14,
  marginBottom: 14,
  fontFamily: "monospace",
  flex: 1
};
var JSONViewer = ({ src }) => {
  const [json, setJson] = useState23(null);
  useEffect17(() => {
    fetch(src).then((res) => res.json()).then((jsonRes) => {
      setJson(JSON.stringify(jsonRes, null, 2));
    });
  }, [src]);
  return jsx44(RemTextarea, {
    value: json ?? undefined,
    status: "ok",
    onChange: () => {
      return null;
    },
    style: jsonStyle
  });
};

// src/components/TextViewer.tsx
import {useEffect as useEffect18, useState as useState24} from "react";
import {
jsxs as jsxs13
} from "react/jsx-runtime";
var textStyle = {
  margin: 14,
  fontFamily: "monospace",
  flex: 1,
  color: "white",
  whiteSpace: "pre-wrap"
};
var TextViewer = ({ src }) => {
  const [txt, setTxt] = useState24("");
  useEffect18(() => {
    fetch(src).then(async (res) => {
      if (!res.ok || !res.body) {
        return;
      }
      const text = await res.text();
      setTxt(text);
    });
  }, [src]);
  return jsxs13("div", {
    style: textStyle,
    children: [
      txt,
      " "
    ]
  });
};

// src/components/FilePreview.tsx
import {
jsx as jsx45,
jsxs as jsxs14,
Fragment as Fragment7
} from "react/jsx-runtime";
var msgStyle = {
  fontSize: 13,
  color: "white",
  fontFamily: "sans-serif",
  display: "flex",
  justifyContent: "center"
};
var FilePreview = ({ fileType, src, currentAsset, assetMetadata }) => {
  if (!assetMetadata) {
    throw new Error("expected to have assetMetadata");
  }
  if (assetMetadata.type === "not-found") {
    throw new Error('expected to have assetMetadata, got "not-found"');
  }
  if (fileType === "audio") {
    return jsx45("audio", {
      src,
      controls: true
    });
  }
  if (fileType === "video") {
    return jsx45("video", {
      src,
      controls: true
    });
  }
  if (fileType === "image") {
    return jsx45("img", {
      src
    });
  }
  if (fileType === "json") {
    return jsx45(JSONViewer, {
      src
    });
  }
  if (fileType === "txt") {
    return jsx45(TextViewer, {
      src
    });
  }
  return jsxs14(Fragment7, {
    children: [
      jsx45("div", {
        style: msgStyle,
        children: currentAsset
      }),
      jsx45(Spacing, {
        y: 0.5
      }),
      jsxs14("div", {
        style: msgStyle,
        children: [
          "Size: ",
          formatBytes(assetMetadata.size),
          " "
        ]
      })
    ]
  });
};

// src/components/RenderPreview.tsx
import {
jsx as jsx46
} from "react/jsx-runtime";
var msgStyle2 = {
  fontSize: 13,
  color: "white",
  fontFamily: "sans-serif",
  display: "flex",
  justifyContent: "center"
};
var errMsgStyle = {
  ...msgStyle2,
  color: LIGHT_TEXT
};
var RenderPreview = ({ path, assetMetadata }) => {
  const fileType = getPreviewFileType(path);
  const src = remotion_outputsBase + path;
  const connectionStatus = useContext13(StudioServerConnectionCtx).previewServerState.type;
  if (connectionStatus === "disconnected") {
    return jsx46("div", {
      style: errMsgStyle,
      children: "Studio server disconnected"
    });
  }
  return jsx46(FilePreview, {
    assetMetadata,
    currentAsset: path,
    fileType,
    src
  });
};

// src/components/Spinner.tsx
import {useMemo as useMemo30} from "react";
import {
jsx as jsx47,
jsxs as jsxs15,
Fragment as Fragment8
} from "react/jsx-runtime";
var viewBox = 100;
var lines = 8;
var className = "__remotion_spinner_line";
var remotionSpinnerAnimation = "__remotion_spinner_animation";
var translated = "M 44 0 L 50 0 a 6 6 0 0 1 6 6 L 56 26 a 6 6 0 0 1 -6 6 L 50 32 a 6 6 0 0 1 -6 -6 L 44 6 a 6 6 0 0 1 6 -6 Z";
var Spinner = ({ size, duration }) => {
  const style2 = useMemo30(() => {
    return {
      width: size,
      height: size
    };
  }, [size]);
  return jsxs15(Fragment8, {
    children: [
      jsx47("style", {
        type: "text/css",
        children: `
				@keyframes ${remotionSpinnerAnimation} {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0.15;
          }
        }
        
        .${className} {
            animation: ${remotionSpinnerAnimation} ${duration}s linear infinite;
        }        
			`
      }),
      jsx47("svg", {
        style: style2,
        viewBox: `0 0 ${viewBox} ${viewBox}`,
        children: new Array(lines).fill(true).map((_, index) => {
          return jsx47("path", {
            className,
            style: {
              rotate: `${index * Math.PI * 2 / lines}rad`,
              transformOrigin: "center center",
              animationDelay: `${index * (duration / lines) - duration}s`
            },
            d: translated,
            fill: LIGHT_TEXT
          }, index);
        })
      })
    ]
  });
};

// src/components/StaticFilePreview.tsx
import {useContext as useContext14} from "react";
import {staticFile as staticFile2} from "remotion";
import {
jsx as jsx48,
jsxs as jsxs16
} from "react/jsx-runtime";
var msgStyle3 = {
  fontSize: 13,
  color: "white",
  fontFamily: "sans-serif",
  display: "flex",
  justifyContent: "center"
};
var errMsgStyle2 = {
  ...msgStyle3,
  color: LIGHT_TEXT
};
var StaticFilePreview = ({ currentAsset, assetMetadata }) => {
  const fileType = getPreviewFileType(currentAsset);
  const staticFileSrc = staticFile2(currentAsset);
  const staticFiles = getStaticFiles();
  const connectionStatus = useContext14(StudioServerConnectionCtx).previewServerState.type;
  const exists = staticFiles.find((file2) => file2.name === currentAsset);
  if (connectionStatus === "disconnected") {
    return jsx48("div", {
      style: errMsgStyle2,
      children: "Studio server disconnected"
    });
  }
  if (!exists) {
    return jsxs16("div", {
      style: errMsgStyle2,
      children: [
        currentAsset,
        " does not exist in your public folder."
      ]
    });
  }
  if (!currentAsset) {
    return null;
  }
  return jsx48(FilePreview, {
    currentAsset,
    fileType,
    src: staticFileSrc,
    assetMetadata
  });
};

// src/components/Preview.tsx
import {
jsx as jsx49
} from "react/jsx-runtime";
var centeredContainer = {
  display: "flex",
  flex: 1,
  justifyContent: "center",
  alignItems: "center"
};
var label3 = {
  fontFamily: "sans-serif",
  fontSize: 14,
  color: LIGHT_TEXT
};
var getPreviewFileType = (fileName) => {
  if (!fileName) {
    return "other";
  }
  const audioExtensions = ["mp3", "wav", "ogg", "aac"];
  const videoExtensions = ["mp4", "avi", "mkv", "mov", "webm"];
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
  const fileExtension = fileName.split(".").pop()?.toLowerCase();
  if (fileExtension === undefined) {
    throw new Error("File extension is undefined");
  }
  if (audioExtensions.includes(fileExtension)) {
    return "audio";
  }
  if (videoExtensions.includes(fileExtension)) {
    return "video";
  }
  if (imageExtensions.includes(fileExtension)) {
    return "image";
  }
  if (fileExtension === "json") {
    return "json";
  }
  if (fileExtension === "txt") {
    return "txt";
  }
  return "other";
};
var checkerboardSize = 49;
var containerStyle = (options) => {
  return {
    transform: `scale(${options.scale})`,
    marginLeft: options.xCorrection,
    marginTop: options.yCorrection,
    width: options.width,
    height: options.height,
    display: "flex",
    position: "absolute",
    backgroundColor: checkerboardBackgroundColor(options.checkerboard),
    backgroundImage: checkerboardBackgroundImage(options.checkerboard),
    backgroundSize: getCheckerboardBackgroundSize(checkerboardSize),
    backgroundPosition: getCheckerboardBackgroundPos(checkerboardSize)
  };
};
var VideoPreview = ({
  canvasSize,
  contentDimensions,
  canvasContent,
  assetMetadata,
  isRefreshing
}) => {
  if (assetMetadata && assetMetadata.type === "not-found") {
    return jsx49("div", {
      style: centeredContainer,
      children: jsx49("div", {
        style: label3,
        children: "File does not exist"
      })
    });
  }
  if (contentDimensions === null) {
    return jsx49("div", {
      style: centeredContainer,
      children: jsx49(Spinner, {
        duration: 0.5,
        size: 24
      })
    });
  }
  return jsx49(CompWhenItHasDimensions, {
    contentDimensions,
    canvasSize,
    canvasContent,
    assetMetadata,
    isRefreshing
  });
};
var CompWhenItHasDimensions = ({
  contentDimensions,
  canvasSize,
  canvasContent,
  assetMetadata,
  isRefreshing
}) => {
  const { size: previewSize } = useContext15(Internals10.PreviewSizeContext);
  const { centerX, centerY, yCorrection, xCorrection, scale } = useMemo31(() => {
    if (contentDimensions === "none") {
      return {
        centerX: 0,
        centerY: 0,
        yCorrection: 0,
        xCorrection: 0,
        scale: 1
      };
    }
    return PlayerInternals6.calculateCanvasTransformation({
      canvasSize,
      compositionHeight: contentDimensions.height,
      compositionWidth: contentDimensions.width,
      previewSize: previewSize.size
    });
  }, [canvasSize, contentDimensions, previewSize.size]);
  const outer = useMemo31(() => {
    return {
      width: contentDimensions === "none" ? "100%" : contentDimensions.width * scale,
      height: contentDimensions === "none" ? "100%" : contentDimensions.height * scale,
      display: "flex",
      flexDirection: "column",
      position: "absolute",
      left: centerX - previewSize.translation.x,
      top: centerY - previewSize.translation.y,
      overflow: "hidden",
      justifyContent: canvasContent.type === "asset" ? "center" : "flex-start",
      alignItems: canvasContent.type === "asset" && getPreviewFileType(canvasContent.asset) === "audio" ? "center" : "normal",
      opacity: isRefreshing ? 0.5 : 1
    };
  }, [
    contentDimensions,
    scale,
    centerX,
    previewSize.translation.x,
    previewSize.translation.y,
    centerY,
    canvasContent,
    isRefreshing
  ]);
  return jsx49("div", {
    style: outer,
    children: canvasContent.type === "asset" ? jsx49(StaticFilePreview, {
      assetMetadata,
      currentAsset: canvasContent.asset
    }) : canvasContent.type === "output" ? jsx49(RenderPreview, {
      path: canvasContent.path,
      assetMetadata
    }) : jsx49(PortalContainer, {
      contentDimensions,
      scale,
      xCorrection,
      yCorrection
    })
  });
};
var PortalContainer = ({ scale, xCorrection, yCorrection, contentDimensions }) => {
  const { checkerboard: checkerboard2 } = useContext15(CheckerboardContext);
  const style2 = useMemo31(() => {
    return containerStyle({
      checkerboard: checkerboard2,
      scale,
      xCorrection,
      yCorrection,
      width: contentDimensions.width,
      height: contentDimensions.height
    });
  }, [
    checkerboard2,
    contentDimensions.height,
    contentDimensions.width,
    scale,
    xCorrection,
    yCorrection
  ]);
  useEffect19(() => {
    const { current } = portalContainer;
    current?.appendChild(Internals10.portalNode());
    return () => {
      current?.removeChild(Internals10.portalNode());
    };
  }, []);
  const portalContainer = useRef15(null);
  return jsx49("div", {
    ref: portalContainer,
    style: style2
  });
};

// src/components/SizeSelector.tsx
import {
jsx as jsx50
} from "react/jsx-runtime";
var commonPreviewSizes = [
  {
    size: "auto",
    translation: {
      x: 0,
      y: 0
    }
  },
  {
    size: 0.25,
    translation: {
      x: 0,
      y: 0
    }
  },
  {
    size: 0.5,
    translation: {
      x: 0,
      y: 0
    }
  },
  {
    size: 1,
    translation: {
      x: 0,
      y: 0
    }
  }
];
var getPreviewSizeLabel = (previewSize) => {
  if (previewSize.size === "auto") {
    return "Fit";
  }
  return `${(previewSize.size * 100).toFixed(0)}%`;
};
var accessibilityLabel = "Preview Size";
var comboStyle = { width: 80 };
var getUniqueSizes = (size) => {
  const customPreviewSizes = [size, ...commonPreviewSizes];
  const uniqueSizes = [];
  customPreviewSizes.forEach((p) => {
    if (!uniqueSizes.find((s) => s.size === p.size)) {
      uniqueSizes.push(p);
    }
  });
  return uniqueSizes.sort((a, b) => {
    if (a.size === "auto") {
      return -1;
    }
    if (b.size === "auto") {
      return 1;
    }
    return a.size - b.size;
  });
};
var zoomableFileTypes = ["video", "image"];
var SizeSelector = () => {
  const { size, setSize } = useContext16(Internals11.PreviewSizeContext);
  const { canvasContent } = useContext16(Internals11.CompositionManager);
  const style2 = useMemo32(() => {
    return {
      padding: CONTROL_BUTTON_PADDING
    };
  }, []);
  const zoomable = useMemo32(() => {
    if (!canvasContent) {
      return null;
    }
    if (canvasContent.type === "composition") {
      return true;
    }
    if (canvasContent.type === "asset" && zoomableFileTypes.includes(getPreviewFileType(canvasContent.asset))) {
      return true;
    }
    if (canvasContent.type === "output" && zoomableFileTypes.includes(getPreviewFileType(canvasContent.path))) {
      return true;
    }
    return false;
  }, [canvasContent]);
  const items = useMemo32(() => {
    return getUniqueSizes(size).map((newSize) => {
      return {
        id: String(newSize.size),
        label: getPreviewSizeLabel(newSize),
        onClick: () => {
          return setSize(() => {
            return newSize;
          });
        },
        type: "item",
        value: newSize.size,
        keyHint: newSize.size === "auto" ? "0" : null,
        leftItem: String(size.size) === String(newSize.size) ? jsx50(Checkmark, {}) : null,
        subMenu: null,
        quickSwitcherLabel: null
      };
    });
  }, [setSize, size]);
  if (!zoomable) {
    return null;
  }
  return jsx50("div", {
    style: style2,
    "aria-label": accessibilityLabel,
    children: jsx50(Combobox, {
      title: accessibilityLabel,
      style: comboStyle,
      selectedId: String(size.size),
      values: items
    })
  });
};

// src/components/TimeValue.tsx
import {PlayerInternals as PlayerInternals7} from "@remotion/player";
import React37, {
useCallback as useCallback23,
useEffect as useEffect21,
useImperativeHandle as useImperativeHandle8,
useRef as useRef17
} from "react";
import {Internals as Internals12, useCurrentFrame} from "remotion";

// src/components/NewComposition/InputDragger.tsx
import React36, {useCallback as useCallback22, useEffect as useEffect20, useMemo as useMemo33, useRef as useRef16, useState as useState25} from "react";
import {interpolate as interpolate2} from "remotion";
import {
jsx as jsx51
} from "react/jsx-runtime";
var isInt = (num) => {
  return num % 1 === 0;
};
var InputDraggerForwardRefFn = ({
  onValueChange,
  min: _min,
  max: _max,
  step: _step,
  value,
  onTextChange,
  formatter = (q) => String(q),
  status,
  rightAlign,
  ...props
}, ref) => {
  const [inputFallback, setInputFallback] = useState25(false);
  const fallbackRef = useRef16(null);
  const style2 = useMemo33(() => {
    return {
      ...inputBaseStyle,
      backgroundColor: "transparent",
      borderColor: "transparent"
    };
  }, []);
  const span = useMemo33(() => ({
    borderBottom: "1px dotted " + BLUE,
    paddingBottom: 1,
    color: BLUE,
    cursor: "ew-resize",
    userSelect: "none",
    WebkitUserSelect: "none",
    fontSize: 13,
    fontVariantNumeric: "tabular-nums"
  }), []);
  const onClick = useCallback22((e) => {
    if (!getClickLock()) {
      e.stopPropagation();
    }
    if (getClickLock()) {
      return;
    }
    setInputFallback(true);
  }, []);
  const onEscape = useCallback22(() => {
    setInputFallback(false);
  }, []);
  const onBlur = useCallback22(() => {
    if (!fallbackRef.current) {
      return;
    }
    const newValue = fallbackRef.current.value;
    if (newValue.trim() === "") {
      onEscape();
      return;
    }
    if (fallbackRef.current.checkValidity()) {
      onTextChange?.(newValue);
      setInputFallback(false);
    } else {
      fallbackRef.current.reportValidity();
    }
  }, [onEscape, onTextChange]);
  const onKeyPress = useCallback22((e) => {
    if (e.key === "Enter") {
      fallbackRef.current?.blur();
    }
  }, []);
  const roundToStep = (val, stepSize) => {
    const factor = 1 / stepSize;
    return Math.ceil(val * factor) / factor;
  };
  const onPointerDown = useCallback22((e) => {
    const { pageX, pageY, button } = e;
    if (button !== 0) {
      return;
    }
    const moveListener = (ev) => {
      const xDistance = ev.pageX - pageX;
      const distanceFromStart = Math.sqrt(xDistance ** 2 + (ev.pageY - pageY) ** 2);
      const step = Number(_step ?? 1);
      const min = Number(_min ?? 0);
      const max = Number(_max ?? Infinity);
      if (distanceFromStart > 4) {
        setClickLock(true);
      }
      const diff = interpolate2(xDistance, [-5, -4, 0, 4, 5], [-step, 0, 0, 0, step]);
      const newValue = Math.min(max, Math.max(min, Number(value) + diff));
      const roundedToStep = roundToStep(newValue, step);
      onValueChange(roundedToStep);
    };
    window.addEventListener("mousemove", moveListener);
    window.addEventListener("pointerup", () => {
      window.removeEventListener("mousemove", moveListener);
      setTimeout(() => {
        setClickLock(false);
      }, 2);
    }, {
      once: true
    });
  }, [_step, _min, _max, value, onValueChange]);
  useEffect20(() => {
    if (inputFallback) {
      fallbackRef.current?.select();
    }
  }, [inputFallback]);
  const deriveStep = useMemo33(() => {
    if (_step !== undefined) {
      return _step;
    }
    if (typeof _min === "number" && isInt(_min)) {
      return 1;
    }
    return 0.0001;
  }, [_min, _step]);
  if (inputFallback) {
    return jsx51(HigherZIndex, {
      onEscape,
      onOutsideClick: noop,
      children: jsx51(RemotionInput, {
        ref: fallbackRef,
        autoFocus: true,
        onKeyPress,
        onBlur,
        min: _min,
        max: _max,
        step: deriveStep,
        defaultValue: value,
        status,
        pattern: "[0-9]*[.]?[0-9]*",
        rightAlign,
        ...props
      })
    });
  }
  return jsx51("button", {
    ref,
    type: "button",
    style: style2,
    onClick,
    onPointerDown,
    children: jsx51("span", {
      style: span,
      children: formatter(value)
    })
  });
};
var InputDragger = React36.forwardRef(InputDraggerForwardRefFn);

// src/components/TimeValue.tsx
import {
jsx as jsx52,
jsxs as jsxs17
} from "react/jsx-runtime";
var text = {
  color: "white",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  fontVariantNumeric: "tabular-nums",
  lineHeight: 1,
  width: "100%",
  userSelect: "none",
  WebkitUserSelect: "none"
};
var time = {
  display: "inline-block",
  fontSize: 16,
  lineHeight: 1,
  fontFamily: "monospace"
};
var frameStyle = {
  color: LIGHT_TEXT,
  fontWeight: 500,
  lineHeight: 1,
  fontSize: 16,
  fontFamily: "monospace",
  paddingRight: 10
};
var timeValueRef = React37.createRef();
var TimeValue = () => {
  const frame = useCurrentFrame();
  const config = Internals12.useUnsafeVideoConfig();
  const isStill = useIsStill();
  const { seek } = PlayerInternals7.usePlayer();
  const keybindings2 = useKeybinding();
  const ref = useRef17(null);
  const onTextChange = useCallback23((newVal) => {
    seek(parseInt(newVal, 10));
  }, [seek]);
  const onValueChange = useCallback23((val) => {
    seek(val);
  }, [seek]);
  useImperativeHandle8(timeValueRef, () => ({
    goToFrame: () => {
      ref.current?.click();
    }
  }), []);
  useEffect21(() => {
    const gKey = keybindings2.registerKeybinding({
      event: "keypress",
      key: "g",
      callback: () => {
        ref.current?.click();
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      gKey.unregister();
    };
  }, [keybindings2]);
  if (!config) {
    return null;
  }
  if (isStill) {
    return null;
  }
  return jsxs17("div", {
    style: text,
    children: [
      jsx52("div", {
        style: time,
        children: renderFrame(frame, config.fps)
      }),
      jsx52(Spacing, {
        x: 2
      }),
      jsx52(Flex, {}),
      jsx52(InputDragger, {
        ref,
        value: frame,
        onTextChange,
        onValueChange,
        rightAlign: true,
        status: "ok",
        style: frameStyle
      })
    ]
  });
};

// src/components/TimelineInOutToggle.tsx
import {
createRef as createRef7,
useCallback as useCallback24,
useEffect as useEffect22,
useImperativeHandle as useImperativeHandle9
} from "react";
import {Internals as Internals14} from "remotion";
import {NoReactInternals as NoReactInternals4} from "remotion/no-react";

// src/icons/timelineInOutPointer.tsx
import {
jsx as jsx53
} from "react/jsx-runtime";
var TimelineInPointer = (props) => {
  return jsx53("svg", {
    viewBox: "0 0 256 256",
    fill: "none",
    ...props,
    children: jsx53("path", {
      d: "M158 25H99V230.5H158",
      stroke: props.color,
      strokeWidth: "42",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
var TimelineOutPointer = (props) => {
  return jsx53("svg", {
    viewBox: "0 0 256 256",
    fill: "none",
    ...props,
    children: jsx53("path", {
      d: "M98 25H157V230.5H98",
      stroke: props.color,
      strokeWidth: "42",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

// src/state/in-out.ts
import {createContext as createContext10, useContext as useContext17} from "react";
import {Internals as Internals13} from "remotion";
var TimelineInOutContext = createContext10({});
var SetTimelineInOutContext = createContext10({
  setInAndOutFrames: () => {
    throw new Error("default");
  }
});
var useTimelineInOutFramePosition = () => {
  const videoConfig = Internals13.useUnsafeVideoConfig();
  const state = useContext17(TimelineInOutContext);
  if (!videoConfig) {
    return { inFrame: null, outFrame: null };
  }
  const maxFrame = videoConfig.durationInFrames - 1;
  const actualInFrame = state[videoConfig.id]?.inFrame ?? null;
  const actualOutFrame = state[videoConfig.id]?.outFrame ?? null;
  return {
    inFrame: actualInFrame === null ? null : actualInFrame >= maxFrame ? null : actualInFrame,
    outFrame: actualOutFrame === null ? null : actualOutFrame >= maxFrame ? null : actualOutFrame
  };
};
var useTimelineSetInOutFramePosition = () => {
  const { setInAndOutFrames } = useContext17(SetTimelineInOutContext);
  return { setInAndOutFrames };
};

// src/components/TimelineInOutToggle.tsx
import {
jsx as jsx54,
jsxs as jsxs18,
Fragment as Fragment9
} from "react/jsx-runtime";
var getTooltipText = (pointType, key) => [
  `Mark ${pointType}`,
  areKeyboardShortcutsDisabled() ? null : `(${key})`,
  "- right click to clear"
].filter(NoReactInternals4.truthy).join(" ");
var style2 = {
  width: 16,
  height: 16
};
var inOutHandles = createRef7();
var defaultInOutValue = { inFrame: null, outFrame: null };
var TimelineInOutPointToggle = () => {
  const timelinePosition = Internals14.Timeline.useTimelinePosition();
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const { setInAndOutFrames } = useTimelineSetInOutFramePosition();
  const videoConfig = Internals14.useUnsafeVideoConfig();
  const keybindings2 = useKeybinding();
  const onInOutClear = useCallback24((composition) => {
    setInAndOutFrames((prev) => {
      return {
        ...prev,
        [composition]: {
          inFrame: null,
          outFrame: null
        }
      };
    });
  }, [setInAndOutFrames]);
  const onInMark = useCallback24((e) => {
    if (!videoConfig) {
      return null;
    }
    if (e?.shiftKey) {
      setInAndOutFrames((prev) => {
        return {
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            inFrame: null
          }
        };
      });
      return null;
    }
    setInAndOutFrames((prev) => {
      const prevOut = prev[videoConfig.id]?.outFrame;
      const biggestPossible = prevOut === undefined || prevOut === null ? Infinity : prevOut - 1;
      const selected = Math.min(timelinePosition, biggestPossible);
      if (selected === 0) {
        return {
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            inFrame: null
          }
        };
      }
      const prevIn = prev[videoConfig.id]?.inFrame;
      if (prevIn !== null && prevIn !== undefined) {
        if (prevIn === selected) {
          return {
            ...prev,
            [videoConfig.id]: {
              ...prev[videoConfig.id] ?? defaultInOutValue,
              inFrame: null
            }
          };
        }
      }
      return {
        ...prev,
        [videoConfig.id]: {
          ...prev[videoConfig.id] ?? defaultInOutValue,
          inFrame: selected
        }
      };
    });
  }, [setInAndOutFrames, timelinePosition, videoConfig]);
  const clearInMark = useCallback24((e) => {
    if (!videoConfig) {
      return null;
    }
    e.preventDefault();
    setInAndOutFrames((f) => {
      return {
        ...f,
        [videoConfig.id]: {
          ...f[videoConfig.id] ?? defaultInOutValue,
          inFrame: null
        }
      };
    });
  }, [setInAndOutFrames, videoConfig]);
  const clearOutMark = useCallback24((e) => {
    if (!videoConfig) {
      return null;
    }
    e?.preventDefault();
    setInAndOutFrames((f) => {
      return {
        ...f,
        [videoConfig.id]: {
          ...f[videoConfig.id] ?? defaultInOutValue,
          outFrame: null
        }
      };
    });
  }, [setInAndOutFrames, videoConfig]);
  const onOutMark = useCallback24((e) => {
    if (!videoConfig) {
      return null;
    }
    if (e?.shiftKey) {
      setInAndOutFrames((f) => {
        return {
          ...f,
          [videoConfig.id]: {
            ...f[videoConfig.id] ?? defaultInOutValue,
            outFrame: null
          }
        };
      });
      return;
    }
    setInAndOutFrames((prev) => {
      const prevInFrame = prev[videoConfig.id]?.inFrame;
      const smallestPossible = prevInFrame === null || prevInFrame === undefined ? -Infinity : prevInFrame + 1;
      const selected = Math.max(timelinePosition, smallestPossible);
      if (selected === videoConfig.durationInFrames - 1) {
        return {
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            outFrame: null
          }
        };
      }
      const prevOut = prev[videoConfig.id]?.outFrame;
      if (prevOut !== null && prevOut !== undefined) {
        if (prevOut === selected) {
          return {
            ...prev,
            [videoConfig.id]: {
              ...prev[videoConfig.id] ?? defaultInOutValue,
              outFrame: null
            }
          };
        }
      }
      return {
        ...prev,
        [videoConfig.id]: {
          ...prev[videoConfig.id] ?? defaultInOutValue,
          outFrame: selected
        }
      };
    });
  }, [setInAndOutFrames, timelinePosition, videoConfig]);
  const confId = videoConfig?.id;
  useEffect22(() => {
    if (!confId) {
      return;
    }
    const iKey = keybindings2.registerKeybinding({
      event: "keypress",
      key: "i",
      callback: (e) => {
        onInMark(e);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const oKey = keybindings2.registerKeybinding({
      event: "keypress",
      key: "o",
      callback: (e) => {
        onOutMark(e);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const xKey = keybindings2.registerKeybinding({
      event: "keypress",
      key: "x",
      callback: () => {
        onInOutClear(confId);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      oKey.unregister();
      iKey.unregister();
      xKey.unregister();
    };
  }, [confId, keybindings2, onInMark, onInOutClear, onOutMark]);
  useImperativeHandle9(inOutHandles, () => {
    return {
      clearMarks: () => {
        if (!confId) {
          return;
        }
        onInOutClear(confId);
      },
      inMarkClick: onInMark,
      outMarkClick: onOutMark
    };
  }, [confId, onInMark, onInOutClear, onOutMark]);
  return jsxs18(Fragment9, {
    children: [
      jsx54(ControlButton, {
        title: getTooltipText("In", "I"),
        "aria-label": getTooltipText("In", "I"),
        onClick: (e) => onInMark(e),
        onContextMenu: clearInMark,
        disabled: !videoConfig || timelinePosition === 0,
        children: jsx54(TimelineInPointer, {
          color: inFrame === null ? "white" : BLUE,
          style: style2
        })
      }),
      jsx54(ControlButton, {
        title: getTooltipText("Out", "O"),
        "aria-label": getTooltipText("Out", "O"),
        onClick: onOutMark,
        onContextMenu: clearOutMark,
        disabled: !videoConfig || timelinePosition === videoConfig.durationInFrames - 1,
        children: jsx54(TimelineOutPointer, {
          color: outFrame === null ? "white" : BLUE,
          style: style2
        })
      })
    ]
  });
};

// src/error-overlay/remotion-overlay/ShortcutHint.tsx
import {useMemo as useMemo34} from "react";
import {
jsx as jsx55,
jsxs as jsxs19
} from "react/jsx-runtime";
var cmdOrCtrlCharacter = window.navigator.platform.startsWith("Mac") ? "\u2318" : "Ctrl";
var container11 = {
  display: "inline-block",
  marginLeft: 6,
  opacity: 0.6,
  verticalAlign: "middle"
};
var ShortcutHint = ({ keyToPress, cmdOrCtrl }) => {
  const style3 = useMemo34(() => {
    if (keyToPress === "\u21B5") {
      return {
        display: "inline-block",
        transform: `translateY(2px)`
      };
    }
    return {};
  }, [keyToPress]);
  if (areKeyboardShortcutsDisabled()) {
    return null;
  }
  return jsxs19("span", {
    style: container11,
    children: [
      cmdOrCtrl ? `${cmdOrCtrlCharacter}` : "",
      jsx55("span", {
        style: style3,
        children: keyToPress.toUpperCase()
      })
    ]
  });
};

// src/state/editor-guides.ts
import {createContext as createContext11} from "react";
var persistEditorShowGuidesOption = (option) => {
  localStorage.setItem("remotion.editorShowGuides", String(option));
};
var loadEditorShowGuidesOption = () => {
  const item = localStorage.getItem("remotion.editorShowGuides");
  return item === "true";
};
var persistGuidesList = (guides) => {
  localStorage.setItem("remotion.guidesList", JSON.stringify(guides));
};
var loadGuidesList = () => {
  const item = localStorage.getItem("remotion.guidesList");
  return item ? JSON.parse(item) : [];
};
var EditorShowGuidesContext = createContext11({
  editorShowGuides: false,
  setEditorShowGuides: () => {
    return;
  },
  guidesList: [],
  setGuidesList: () => {
    return;
  },
  selectedGuideId: null,
  setSelectedGuideId: () => {
    return;
  },
  shouldCreateGuideRef: { current: false },
  shouldDeleteGuideRef: { current: false },
  hoveredGuideId: null,
  setHoveredGuideId: () => {
    return;
  }
});

// src/state/editor-rulers.ts
import {createContext as createContext12} from "react";
var persistEditorShowRulersOption = (option) => {
  localStorage.setItem("remotion.editorShowRulers", String(option));
};
var loadEditorShowRulersOption = () => {
  const item = localStorage.getItem("remotion.editorShowRulers");
  return item === "true";
};
var EditorShowRulersContext = createContext12({
  editorShowRulers: loadEditorShowRulersOption(),
  setEditorShowRulers: () => {
    return;
  }
});
var RULER_WIDTH = 20;
var MINIMUM_VISIBLE_CANVAS_SIZE = 50;
var PREDEFINED_RULER_SCALE_GAPS = [
  1,
  2,
  5,
  10,
  20,
  50,
  100,
  250,
  500,
  1000,
  2000,
  5000
];
var MAXIMUM_PREDEFINED_RULER_SCALE_GAP = 5000;
var MINIMUM_RULER_MARKING_GAP_PX = 50;

// src/state/editor-zoom-gestures.ts
import {createContext as createContext13} from "react";
var persistEditorZoomGesturesOption = (option) => {
  localStorage.setItem("remotion.editorZoomGestures", String(option));
};
var loadEditorZoomGesturesOption = () => {
  const item = localStorage.getItem("remotion.editorZoomGestures");
  return item !== "false";
};
var EditorZoomGesturesContext = createContext13({
  editorZoomGestures: loadEditorZoomGesturesOption(),
  setEditorZoomGestures: () => {
    return;
  }
});

// src/helpers/get-git-menu-item.ts
var getGitSourceName = (gitSource) => {
  if (gitSource.type === "github") {
    return "GitHub";
  }
  throw new Error("Unknown git source type");
};
var getGitSourceBranchUrl = (gitSource) => {
  if (gitSource.type === "github") {
    return `https://github.com/${gitSource.org}/${gitSource.name}/tree/${gitSource.ref}${gitSource.relativeFromGitRoot ? `/${gitSource.relativeFromGitRoot}` : ""}`;
  }
  throw new Error("Unknown git source type");
};
var getGitRefUrl = (gitSource, originalLocation) => {
  if (gitSource.type === "github") {
    return `https://github.com/${gitSource.org}/${gitSource.name}/tree/${gitSource.ref}/${gitSource.relativeFromGitRoot ? `${gitSource.relativeFromGitRoot}/` : ""}${originalLocation.source}#L${originalLocation.line}`;
  }
  throw new Error("Unknown git source type");
};
var getGitMenuItem = () => {
  if (!window.remotion_gitSource) {
    return null;
  }
  return {
    id: "open-git-source",
    value: "open-git-source",
    label: `Open ${getGitSourceName(window.remotion_gitSource)} Repo`,
    onClick: () => {
      window.open(getGitSourceBranchUrl(window.remotion_gitSource), "_blank");
    },
    type: "item",
    keyHint: null,
    leftItem: null,
    subMenu: null,
    quickSwitcherLabel: `Open ${getGitSourceName(window.remotion_gitSource)} repo`
  };
};

// src/helpers/open-in-editor.ts
var openInEditor = (stack) => {
  const {
    originalFileName,
    originalLineNumber,
    originalColumnNumber,
    originalFunctionName,
    originalScriptCode
  } = stack;
  return fetch(`/api/open-in-editor`, {
    method: "post",
    headers: {
      "content-type": "application/json"
    },
    body: JSON.stringify({
      stack: {
        originalFileName,
        originalLineNumber,
        originalColumnNumber,
        originalFunctionName,
        originalScriptCode
      }
    })
  });
};

// src/components/Notifications/ColorDot.tsx
import {useMemo as useMemo35} from "react";
import {
jsx as jsx56
} from "react/jsx-runtime";
var container12 = {
  height: 16,
  width: 16,
  backgroundColor: "red",
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: 8
};
var ColorDot = ({ color }) => {
  const style3 = useMemo35(() => {
    return {
      ...container12,
      backgroundColor: color
    };
  }, [color]);
  return jsx56("div", {
    style: style3
  });
};

// src/helpers/pick-color.tsx
import {
jsx as jsx57,
jsxs as jsxs20,
Fragment as Fragment10
} from "react/jsx-runtime";
var pickColor = () => {
  const open = new EyeDropper().open();
  open.then((color) => {
    copyText(color.sRGBHex).then(() => {
      showNotification(jsxs20(Fragment10, {
        children: [
          jsx57(ColorDot, {
            color: color.sRGBHex
          }),
          " ",
          jsx57(Spacing, {
            x: 1
          }),
          " Copied",
          " ",
          color.sRGBHex
        ]
      }), 2000);
    }).catch((err) => {
      showNotification(`Could not copy: ${err.message}`, 2000);
    });
  }).catch((err) => {
    if (err.message.includes("canceled")) {
      return;
    }
    showNotification(`Could not pick color.`, 2000);
  });
};

// src/helpers/use-menu-structure.tsx
import {
jsx as jsx58
} from "react/jsx-runtime";
var openExternal = (link) => {
  window.open(link, "_blank");
};
var rotate = {
  transform: `rotate(90deg)`
};
var ICON_SIZE = 16;
var getFileMenu = ({
  readOnlyStudio,
  closeMenu,
  previewServerState
}) => {
  const items = [
    readOnlyStudio ? null : {
      id: "render",
      value: "render",
      label: "Render...",
      onClick: () => {
        closeMenu();
        if (previewServerState !== "connected") {
          showNotification("Restart the studio to render", 2000);
          return;
        }
        const renderButton = document.getElementById("render-modal-button");
        renderButton.click();
      },
      type: "item",
      keyHint: "R",
      leftItem: null,
      subMenu: null,
      quickSwitcherLabel: "Render..."
    },
    window.remotion_editorName && !readOnlyStudio ? {
      type: "divider",
      id: "open-in-editor-divider"
    } : null,
    window.remotion_editorName && !readOnlyStudio ? {
      id: "open-in-editor",
      value: "open-in-editor",
      label: `Open in ${window.remotion_editorName}`,
      onClick: async () => {
        await openInEditor({
          originalFileName: `${window.remotion_cwd}`,
          originalLineNumber: 1,
          originalColumnNumber: 1,
          originalFunctionName: null,
          originalScriptCode: null
        }).then((res) => res.json()).then(({ success }) => {
          if (!success) {
            showNotification(`Could not open ${window.remotion_editorName}`, 2000);
          }
        }).catch((err) => {
          console.error(err);
          showNotification(`Could not open ${window.remotion_editorName}`, 2000);
        });
      },
      type: "item",
      keyHint: null,
      leftItem: null,
      subMenu: null,
      quickSwitcherLabel: "Open in editor..."
    } : null,
    getGitMenuItem()
  ].filter(NoReactInternals5.truthy);
  if (items.length === 0) {
    return null;
  }
  return {
    id: "file",
    label: "File",
    leaveLeftPadding: false,
    items,
    quickSwitcherLabel: null
  };
};
var useMenuStructure = (closeMenu, readOnlyStudio) => {
  const { setSelectedModal } = useContext18(ModalsContext);
  const { checkerboard: checkerboard3, setCheckerboard } = useContext18(CheckerboardContext);
  const { editorZoomGestures, setEditorZoomGestures } = useContext18(EditorZoomGesturesContext);
  const { editorShowRulers, setEditorShowRulers } = useContext18(EditorShowRulersContext);
  const { editorShowGuides, setEditorShowGuides } = useContext18(EditorShowGuidesContext);
  const { size, setSize } = useContext18(Internals15.PreviewSizeContext);
  const { type } = useContext18(StudioServerConnectionCtx).previewServerState;
  const {
    setSidebarCollapsedState,
    sidebarCollapsedStateLeft,
    sidebarCollapsedStateRight
  } = useContext18(SidebarContext);
  const sizes = getUniqueSizes(size);
  const isFullscreenSupported = document.fullscreenEnabled || document.webkitFullscreenEnabled;
  const mobileLayout = useMobileLayout();
  const structure = useMemo36(() => {
    let struct = [
      {
        id: "remotion",
        label: jsx58(Row, {
          align: "center",
          justify: "center",
          children: jsx58("svg", {
            width: ICON_SIZE,
            height: ICON_SIZE,
            viewBox: "-100 -100 400 400",
            style: rotate,
            children: jsx58("path", {
              fill: "#fff",
              stroke: "#fff",
              strokeWidth: "100",
              strokeLinejoin: "round",
              d: "M 2 172 a 196 100 0 0 0 195 5 A 196 240 0 0 0 100 2.259 A 196 240 0 0 0 2 172 z"
            })
          })
        }),
        leaveLeftPadding: false,
        items: [
          {
            id: "about",
            value: "about",
            label: "About Remotion",
            onClick: () => {
              closeMenu();
              openExternal("https://remotion.dev");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Help: About Remotion"
          },
          {
            id: "changelog",
            value: "changelog",
            label: "Changelog",
            onClick: () => {
              closeMenu();
              openExternal("https://github.com/remotion-dev/remotion/releases");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Help: Changelog"
          },
          {
            id: "license",
            value: "license",
            label: "License",
            onClick: () => {
              closeMenu();
              openExternal("https://github.com/remotion-dev/remotion/blob/main/LICENSE.md");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Help: License"
          },
          {
            id: "acknowledgements",
            value: "acknowledgements",
            label: "Acknowledgements",
            onClick: () => {
              closeMenu();
              openExternal("https://remotion.dev/acknowledgements");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Help: Acknowledgements"
          }
        ],
        quickSwitcherLabel: null
      },
      getFileMenu({
        readOnlyStudio,
        closeMenu,
        previewServerState: type
      }),
      {
        id: "view",
        label: "View",
        leaveLeftPadding: true,
        items: [
          {
            id: "preview-size",
            keyHint: null,
            label: "Preview size",
            onClick: () => {
              return;
            },
            type: "item",
            value: "preview-size",
            leftItem: null,
            subMenu: {
              leaveLeftSpace: true,
              preselectIndex: sizes.findIndex((s) => String(size.size) === String(s.size)),
              items: sizes.map((newSize) => ({
                id: String(newSize.size),
                keyHint: newSize.size === 1 ? "0" : null,
                label: getPreviewSizeLabel(newSize),
                leftItem: String(newSize.size) === String(size.size) ? jsx58(Checkmark, {}) : null,
                onClick: () => {
                  closeMenu();
                  setSize(() => newSize);
                },
                subMenu: null,
                type: "item",
                value: newSize.size,
                quickSwitcherLabel: null
              })),
              quickSwitcherLabel: null
            },
            quickSwitcherLabel: null
          },
          {
            id: "editor-zoom-gestures",
            keyHint: null,
            label: "Zoom and Pan Gestures",
            onClick: () => {
              closeMenu();
              setEditorZoomGestures((c) => !c);
            },
            type: "item",
            value: "editor-zoom-gestures",
            leftItem: editorZoomGestures ? jsx58(Checkmark, {}) : null,
            subMenu: null,
            quickSwitcherLabel: editorZoomGestures ? "Disable Zoom and Pan Gestures" : "Enable Zoom and Pan Gestures"
          },
          {
            id: "show-rulers",
            keyHint: null,
            label: "Show Rulers",
            onClick: () => {
              closeMenu();
              setEditorShowRulers((c) => !c);
            },
            type: "item",
            value: "show-ruler",
            leftItem: editorShowRulers ? jsx58(Checkmark, {}) : null,
            subMenu: null,
            quickSwitcherLabel: editorShowRulers ? "Hide Rulers" : "Show Rulers"
          },
          {
            id: "show-guides",
            keyHint: null,
            label: "Show Guides",
            onClick: () => {
              closeMenu();
              setEditorShowGuides((c) => !c);
            },
            type: "item",
            value: "show-guides",
            leftItem: editorShowGuides ? jsx58(Checkmark, {}) : null,
            subMenu: null,
            quickSwitcherLabel: editorShowGuides ? "Hide Guides" : "Show Guides"
          },
          {
            id: "timeline-divider-1",
            type: "divider"
          },
          {
            id: "left-sidebar",
            label: "Left Sidebar",
            keyHint: null,
            type: "item",
            value: "preview-size",
            leftItem: null,
            quickSwitcherLabel: null,
            subMenu: {
              leaveLeftSpace: true,
              preselectIndex: 0,
              items: [
                {
                  id: "left-sidebar-responsive",
                  keyHint: null,
                  label: "Responsive",
                  leftItem: sidebarCollapsedStateLeft === "responsive" ? jsx58(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({
                      left: "responsive",
                      right: null
                    });
                  },
                  subMenu: null,
                  type: "item",
                  value: "responsive",
                  quickSwitcherLabel: null
                },
                {
                  id: "left-sidebar-expanded",
                  keyHint: null,
                  label: "Expanded",
                  leftItem: sidebarCollapsedStateLeft === "expanded" ? jsx58(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({ left: "expanded", right: null });
                  },
                  subMenu: null,
                  type: "item",
                  value: "expanded",
                  quickSwitcherLabel: "Expand"
                },
                {
                  id: "left-sidebar-collapsed",
                  keyHint: null,
                  label: "Collapsed",
                  leftItem: sidebarCollapsedStateLeft === "collapsed" ? jsx58(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({
                      left: "collapsed",
                      right: null
                    });
                  },
                  subMenu: null,
                  type: "item",
                  value: "collapsed",
                  quickSwitcherLabel: "Collapse"
                }
              ]
            },
            onClick: () => {
              return;
            }
          },
          {
            id: "right-sidebar",
            label: "Right Sidebar",
            keyHint: null,
            type: "item",
            value: "preview-size",
            leftItem: null,
            quickSwitcherLabel: null,
            subMenu: {
              leaveLeftSpace: true,
              preselectIndex: 0,
              items: [
                {
                  id: "sidebar-expanded",
                  keyHint: null,
                  label: "Expanded",
                  leftItem: sidebarCollapsedStateRight === "expanded" ? jsx58(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({ left: null, right: "expanded" });
                  },
                  subMenu: null,
                  type: "item",
                  value: "expanded",
                  quickSwitcherLabel: "Expand"
                },
                {
                  id: "right-sidebar-collapsed",
                  keyHint: null,
                  label: "Collapsed",
                  leftItem: sidebarCollapsedStateRight === "collapsed" ? jsx58(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({
                      left: null,
                      right: "collapsed"
                    });
                  },
                  subMenu: null,
                  type: "item",
                  value: "collapsed",
                  quickSwitcherLabel: "Collapse"
                }
              ]
            },
            onClick: () => {
              return;
            }
          },
          {
            id: "timeline-divider-2",
            type: "divider"
          },
          {
            id: "checkerboard",
            keyHint: "T",
            label: "Transparency as checkerboard",
            onClick: () => {
              closeMenu();
              setCheckerboard((c) => !c);
            },
            type: "item",
            value: "checkerboard",
            leftItem: checkerboard3 ? jsx58(Checkmark, {}) : null,
            subMenu: null,
            quickSwitcherLabel: checkerboard3 ? "Disable Checkerboard Transparency" : "Enable Checkerboard Transparency"
          },
          {
            id: "timeline-divider-3",
            type: "divider"
          },
          {
            id: "quick-switcher",
            keyHint: `${cmdOrCtrlCharacter}+K`,
            label: "Quick Switcher",
            onClick: () => {
              closeMenu();
              setSelectedModal({
                type: "quick-switcher",
                mode: "compositions",
                invocationTimestamp: Date.now()
              });
            },
            type: "item",
            value: "quick-switcher",
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Switch composition"
          },
          {
            id: "in-out-divider-5",
            type: "divider"
          },
          {
            id: "in-mark",
            keyHint: "I",
            label: "In Mark",
            leftItem: null,
            onClick: () => {
              closeMenu();
              inOutHandles.current?.inMarkClick(null);
            },
            subMenu: null,
            type: "item",
            value: "in-mark",
            quickSwitcherLabel: "Timeline: Set In Mark"
          },
          {
            id: "out-mark",
            keyHint: "O",
            label: "Out Mark",
            leftItem: null,
            onClick: () => {
              closeMenu();
              inOutHandles.current?.outMarkClick(null);
            },
            subMenu: null,
            type: "item",
            value: "out-mark",
            quickSwitcherLabel: "Timeline: Set Out Mark"
          },
          {
            id: "x-mark",
            keyHint: "X",
            label: "Clear In/Out Marks",
            leftItem: null,
            onClick: () => {
              closeMenu();
              inOutHandles.current?.clearMarks();
            },
            subMenu: null,
            type: "item",
            value: "clear-marks",
            quickSwitcherLabel: "Timeline: Clear In and Out Mark"
          },
          {
            id: "goto-time",
            keyHint: "G",
            label: "Go to frame",
            leftItem: null,
            onClick: () => {
              closeMenu();
              timeValueRef.current?.goToFrame();
            },
            subMenu: null,
            type: "item",
            value: "clear-marks",
            quickSwitcherLabel: "Timeline: Clear In and Out Mark"
          },
          {
            id: "fullscreen-divider",
            type: "divider"
          },
          isFullscreenSupported ? {
            id: "fullscreen",
            keyHint: null,
            label: "Fullscreen",
            leftItem: null,
            onClick: () => {
              closeMenu();
              drawRef.current?.requestFullscreen();
            },
            subMenu: null,
            type: "item",
            value: "fullscreen",
            quickSwitcherLabel: "Go Fullscreen"
          } : null
        ].filter(Internals15.truthy)
      },
      "EyeDropper" in window ? {
        id: "tools",
        label: "Tools",
        leaveLeftPadding: false,
        items: [
          {
            id: "color-picker",
            value: "color-picker",
            label: "Color Picker",
            onClick: () => {
              closeMenu();
              pickColor();
            },
            leftItem: null,
            keyHint: null,
            subMenu: null,
            type: "item",
            quickSwitcherLabel: "Show Color Picker"
          },
          {
            id: "spring-editor",
            value: "spring-editor",
            label: "spring() Editor",
            onClick: () => {
              closeMenu();
              window.open("https://springs.remotion.dev", "_blank");
            },
            leftItem: null,
            keyHint: null,
            subMenu: null,
            type: "item",
            quickSwitcherLabel: "Open spring() Editor"
          }
        ],
        quickSwitcherLabel: null
      } : null,
      {
        id: "help",
        label: "Help",
        leaveLeftPadding: false,
        items: [
          {
            id: "shortcuts",
            value: "shortcuts",
            label: areKeyboardShortcutsDisabled() ? "Shortcuts (disabled)" : "Shortcuts",
            onClick: () => {
              closeMenu();
              setSelectedModal({
                type: "quick-switcher",
                mode: "docs",
                invocationTimestamp: Date.now()
              });
            },
            keyHint: "?",
            leftItem: null,
            subMenu: null,
            type: "item",
            quickSwitcherLabel: areKeyboardShortcutsDisabled() ? "Show all Keyboard Shortcuts (disabled)" : "Show all Keyboard Shortcuts"
          },
          {
            id: "docs",
            value: "docs",
            label: "Docs",
            onClick: () => {
              closeMenu();
              openExternal("https://remotion.dev/docs");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Visit Documentation"
          },
          {
            id: "file-issue",
            value: "file-issue",
            label: "File an issue",
            onClick: () => {
              closeMenu();
              openExternal("https://github.com/remotion-dev/remotion/issues/new/choose");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "File GitHub issue"
          },
          {
            id: "discord",
            value: "discord",
            label: "Join Discord community",
            onClick: () => {
              closeMenu();
              openExternal("https://discord.com/invite/6VzzNDwUwV");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: null
          },
          {
            id: "help-divider-6",
            type: "divider"
          },
          {
            id: "insta",
            value: "insta",
            label: "Instagram",
            onClick: () => {
              closeMenu();
              openExternal("https://instagram.com/remotion");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Follow Remotion on Instagram"
          },
          {
            id: "x",
            value: "x",
            label: "X",
            onClick: () => {
              closeMenu();
              openExternal("https://x.com/remotion");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Follow Remotion on X"
          },
          {
            id: "youtube",
            value: "youtube",
            label: "YouTube",
            onClick: () => {
              closeMenu();
              openExternal("https://www.youtube/@remotion_dev");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Watch Remotion on YouTube"
          },
          {
            id: "linkedin",
            value: "linkedin",
            label: "LinkedIn",
            onClick: () => {
              closeMenu();
              openExternal("https://www.linkedin.com/company/remotion-dev/");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Follow Remotion on LinkedIn"
          },
          {
            id: "tiktok",
            value: "tiktok",
            label: "TikTok",
            onClick: () => {
              closeMenu();
              openExternal("https://www.tiktok.com/@remotion");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Follow Remotion on TikTok"
          }
        ]
      }
    ].filter(Internals15.truthy);
    if (mobileLayout) {
      struct = [
        {
          ...struct[0],
          items: [
            ...struct.slice(1).map((s) => {
              return {
                ...s,
                keyHint: null,
                onClick: () => {
                  return;
                },
                type: "item",
                value: s.id,
                leftItem: null,
                subMenu: {
                  items: s.items,
                  leaveLeftSpace: true,
                  preselectIndex: 0
                },
                quickSwitcherLabel: null
              };
            }),
            ...struct[0].items
          ]
        }
      ];
    }
    return struct;
  }, [
    readOnlyStudio,
    mobileLayout,
    sizes,
    editorZoomGestures,
    editorShowRulers,
    editorShowGuides,
    sidebarCollapsedStateLeft,
    sidebarCollapsedStateRight,
    checkerboard3,
    isFullscreenSupported,
    closeMenu,
    setSelectedModal,
    type,
    size.size,
    setSize,
    setEditorZoomGestures,
    setEditorShowRulers,
    setEditorShowGuides,
    setSidebarCollapsedState,
    setCheckerboard
  ]);
  return structure;
};
var getItemLabel = (item) => {
  if (item.quickSwitcherLabel !== null) {
    return item.quickSwitcherLabel;
  }
  if (typeof item.label === "string") {
    return item.label;
  }
  return item.label?.toString();
};
var itemToSearchResult = (item, setSelectedModal, prefixes) => {
  if (item.subMenu) {
    return item.subMenu.items.map((subItem) => {
      if (subItem.type === "divider") {
        return null;
      }
      return itemToSearchResult(subItem, setSelectedModal, [
        ...prefixes,
        getItemLabel(item)
      ]);
    }).flat(1).filter(NoReactInternals5.truthy);
  }
  return [
    {
      type: "menu-item",
      id: item.id,
      onSelected: () => {
        setSelectedModal(null);
        item.onClick(item.id, null);
      },
      title: [...prefixes, getItemLabel(item)].join(": ")
    }
  ];
};
var makeSearchResults = (actions2, setSelectedModal) => {
  const items = actions2.map((menu) => {
    return menu.items.map((item) => {
      if (item.type === "divider") {
        return null;
      }
      return itemToSearchResult(item, setSelectedModal, []);
    });
  }).flat(Infinity).filter(NoReactInternals5.truthy);
  return items;
};

// src/components/Menu/MenuItem.tsx
import {PlayerInternals as PlayerInternals8} from "@remotion/player";
import {useCallback as useCallback25, useMemo as useMemo37, useRef as useRef18, useState as useState26} from "react";
import ReactDOM5 from "react-dom";
import {
jsx as jsx59,
jsxs as jsxs21,
Fragment as Fragment11
} from "react/jsx-runtime";
var container13 = {
  fontSize: 13,
  color: "white",
  paddingLeft: 10,
  paddingRight: 10,
  cursor: "default",
  paddingTop: 8,
  paddingBottom: 8,
  userSelect: "none",
  WebkitUserSelect: "none",
  border: "none"
};
var MenuItem = ({
  label: itemName,
  selected,
  id,
  onItemSelected,
  onItemHovered,
  onItemQuit,
  onPreviousMenu,
  onNextMenu,
  menu
}) => {
  const [hovered, setHovered] = useState26(false);
  const ref = useRef18(null);
  const size = PlayerInternals8.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const { tabIndex, currentZIndex } = useZIndex();
  const containerStyle2 = useMemo37(() => {
    return {
      ...container13,
      backgroundColor: getBackgroundFromHoverState({
        hovered,
        selected
      })
    };
  }, [hovered, selected]);
  const portalStyle = useMemo37(() => {
    if (!selected || !size) {
      return null;
    }
    return {
      ...menuContainerTowardsBottom,
      left: size.left,
      top: size.top + size.height
    };
  }, [selected, size]);
  const onPointerEnter = useCallback25(() => {
    onItemHovered(id);
    setHovered(true);
  }, [id, onItemHovered]);
  const onPointerLeave = useCallback25(() => {
    setHovered(false);
  }, []);
  const onPointerDown = useCallback25((e) => {
    if (e.button !== 0) {
      return;
    }
    onItemSelected(id);
    window.addEventListener("pointerup", (evt) => {
      if (!isMenuItem(evt.target)) {
        onItemQuit();
      }
    }, {
      once: true
    });
  }, [id, onItemQuit, onItemSelected]);
  const onClick = useCallback25((e) => {
    e.stopPropagation();
    const isKeyboardInitiated = e.detail === 0;
    if (!isKeyboardInitiated) {
      return;
    }
    onItemSelected((p) => {
      return p === null ? id : null;
    });
  }, [id, onItemSelected]);
  const outerStyle = useMemo37(() => {
    return {
      ...outerPortal,
      top: (size?.top ?? 0) + (size?.height ?? 0)
    };
  }, [size]);
  return jsxs21(Fragment11, {
    children: [
      jsx59("button", {
        ref,
        role: "button",
        tabIndex,
        onPointerEnter,
        onPointerLeave,
        onPointerDown,
        onClick,
        style: containerStyle2,
        type: "button",
        className: MENU_INITIATOR_CLASSNAME,
        children: itemName
      }),
      portalStyle ? ReactDOM5.createPortal(jsx59("div", {
        className: "css-reset",
        style: outerStyle,
        children: jsx59(HigherZIndex, {
          onEscape: onItemQuit,
          onOutsideClick: onItemQuit,
          children: jsx59("div", {
            style: portalStyle,
            children: jsx59(MenuContent2, {
              onNextMenu: onPreviousMenu,
              onPreviousMenu: onNextMenu,
              values: menu.items,
              onHide: onItemQuit,
              leaveLeftSpace: menu.leaveLeftPadding,
              preselectIndex: false,
              topItemCanBeUnselected: true,
              fixedHeight: null
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/MenuBuildIndicator.tsx
import {useContext as useContext19, useEffect as useEffect23, useState as useState28} from "react";

// src/components/OpenEditorButton.tsx
import {useCallback as useCallback26, useMemo as useMemo38, useState as useState27} from "react";
import {
jsx as jsx60
} from "react/jsx-runtime";
var svgStyle = {
  width: 11,
  height: 11
};
var buttonStyle = {
  border: "none",
  height: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};
var OpenEditorButton = ({ type }) => {
  const [hovered, setHovered] = useState27(false);
  const svgFillColor = useMemo38(() => {
    return hovered ? "white" : LIGHT_TEXT;
  }, [hovered]);
  const handleClick = useCallback26(async () => {
    if (type === "editor") {
      await openInEditor({
        originalFileName: `${window.remotion_cwd}`,
        originalLineNumber: 1,
        originalColumnNumber: 1,
        originalFunctionName: null,
        originalScriptCode: null
      }).then((res) => res.json()).then(({ success }) => {
        if (!success) {
          showNotification(`Could not open ${window.remotion_editorName}`, 2000);
        }
      }).catch((err) => {
        console.error(err);
        showNotification(`Could not open ${window.remotion_editorName}`, 2000);
      });
    }
    if (type === "git") {
      if (!window.remotion_gitSource) {
        throw new Error("No git source");
      }
      window.open(getGitSourceBranchUrl(window.remotion_gitSource), "_blank");
    }
  }, [type]);
  const buttonTooltip = type === "git" ? `Open ${getGitSourceName(window.remotion_gitSource)} Repo` : `Open in ${window.remotion_editorName}`;
  const openInEditorSvg = jsx60("svg", {
    viewBox: "0 0 512 512",
    style: svgStyle,
    children: jsx60("path", {
      fill: svgFillColor,
      d: "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    })
  });
  const onPointerEnter = useCallback26(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback26(() => {
    setHovered(false);
  }, []);
  return jsx60("button", {
    title: buttonTooltip,
    type: "button",
    onPointerEnter,
    onPointerLeave,
    style: buttonStyle,
    onClick: handleClick,
    children: openInEditorSvg
  });
};

// src/components/MenuBuildIndicator.tsx
import {
jsx as jsx61,
jsxs as jsxs22
} from "react/jsx-runtime";
var cwd = {
  fontSize: 13,
  opacity: 0.8,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
var spinnerSize = 14;
var spinner = {
  position: "relative",
  width: spinnerSize,
  marginTop: 4
};
var noSpinner = {
  position: "relative",
  width: spinnerSize
};
var MenuBuildIndicator = () => {
  const [isBuilding, setIsBuilding] = useState28(false);
  const ctx = useContext19(StudioServerConnectionCtx).previewServerState;
  const showButton = window.remotion_editorName && ctx.type === "connected";
  useEffect23(() => {
    window.remotion_isBuilding = () => {
      setIsBuilding(true);
    };
    window.remotion_finishedBuilding = () => {
      setIsBuilding(false);
    };
    return () => {
      window.remotion_isBuilding = undefined;
      window.remotion_finishedBuilding = undefined;
    };
  }, []);
  return jsxs22("div", {
    style: cwd,
    title: window.remotion_cwd,
    children: [
      showButton ? jsx61(Spacing, {
        x: 2
      }) : null,
      isBuilding ? jsx61("div", {
        style: spinner,
        children: jsx61(Spinner, {
          duration: 0.5,
          size: spinnerSize
        })
      }) : jsx61("div", {
        style: noSpinner
      }),
      showButton ? jsx61(Spacing, {
        x: 0.5
      }) : null,
      window.remotion_projectName,
      showButton ? jsx61(Spacing, {
        x: 0.25
      }) : null,
      showButton ? jsx61(OpenEditorButton, {
        type: "editor"
      }) : window.remotion_gitSource ? jsx61(OpenEditorButton, {
        type: "git"
      }) : null
    ]
  });
};

// src/components/SidebarCollapserControls.tsx
import {useCallback as useCallback83, useContext as useContext52, useEffect as useEffect54} from "react";

// src/components/TopPanel.tsx
import {useCallback as useCallback82, useContext as useContext51, useEffect as useEffect53, useMemo as useMemo87} from "react";

// src/helpers/use-breakpoint.ts
import {useEffect as useEffect24, useState as useState29} from "react";
function useBreakpoint(breakpoint2) {
  const [compactUI, setCompactUI] = useState29(window.innerWidth < breakpoint2);
  useEffect24(() => {
    function handleResize() {
      setCompactUI(window.innerWidth < breakpoint2);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint2]);
  return compactUI;
}

// src/components/CanvasOrLoading.tsx
import {useContext as useContext27, useEffect as useEffect34} from "react";
import {Internals as Internals24} from "remotion";

// src/error-overlay/remotion-overlay/ErrorLoader.tsx
import {useEffect as useEffect29, useState as useState32} from "react";

// src/error-overlay/react-overlay/utils/parser.ts
import {getLocationFromBuildError} from "@remotion/studio-shared";

// src/error-overlay/react-overlay/effects/resolve-file-source.ts
var resolveFileSource = async (location, contextLines) => {
  const res = await fetch(`/api/file-source?f=${encodeURIComponent(location.fileName)}`);
  const text2 = await res.text();
  const lines2 = text2.split("\n").map((l, i) => {
    const oneIndexedLineNumber = i + 1;
    return [oneIndexedLineNumber, l];
  }).filter(([oneIndexedLineNumber]) => {
    return Math.abs(oneIndexedLineNumber - location.lineNumber) <= contextLines;
  });
  const scriptCode = lines2.map(([num, line2]) => {
    return {
      content: line2,
      highlight: location.lineNumber === num,
      lineNumber: num
    };
  });
  return {
    originalColumnNumber: location.columnNumber,
    originalFunctionName: null,
    originalFileName: location.fileName,
    originalLineNumber: location.lineNumber,
    originalScriptCode: scriptCode
  };
};

// src/error-overlay/react-overlay/utils/make-stack-frame.ts
var makeStackFrame = ({
  functionName,
  fileName,
  lineNumber,
  columnNumber
}) => {
  if (functionName && functionName.indexOf("Object.") === 0) {
    functionName = functionName.slice("Object.".length);
  }
  if (functionName === "friendlySyntaxErrorLabel" || functionName === "exports.__esModule" || functionName === "<anonymous>" || !functionName) {
    functionName = null;
  }
  return {
    columnNumber,
    fileName,
    functionName,
    lineNumber
  };
};

// src/error-overlay/react-overlay/utils/parser.ts
var extractLocation = function(token) {
  const execed = regexExtractLocation.exec(token);
  if (!execed) {
    throw new Error("Could not match in extractLocation");
  }
  return execed.slice(1).map((v) => {
    const p = Number(v);
    if (!isNaN(p)) {
      return p;
    }
    return v;
  });
};
function parseStack(stack) {
  const frames = stack.filter((e) => regexValidFrame_Chrome.test(e) || regexValidFrame_FireFox.test(e)).map((e) => {
    if (regexValidFrame_FireFox.test(e)) {
      let isEval = false;
      if (/ > (eval|Function)/.test(e)) {
        e = e.replace(/ line (\d+)(?: > eval line \d+)* > (eval|Function):\d+:\d+/g, ":$1");
        isEval = true;
      }
      const _data = e.split(/[@]/g);
      const _last = _data.pop();
      if (!_last) {
        throw new Error("could not get last");
      }
      const [_fileName, _lineNumber, _columnNumber] = extractLocation(_last);
      return makeStackFrame({
        functionName: _data.join("@") || (isEval ? "eval" : null),
        fileName: _fileName,
        lineNumber: _lineNumber,
        columnNumber: _columnNumber
      });
    }
    if (e.indexOf("(eval ") !== -1) {
      e = e.replace(/(\(eval at [^()]*)|(\),.*$)/g, "");
    }
    if (e.indexOf("(at ") !== -1) {
      e = e.replace(/\(at /, "(");
    }
    const data = e.trim().split(/\s+/g).slice(1);
    const last = data.pop();
    if (!last) {
      throw new Error("could not get last");
    }
    const [fileName, lineNumber, columnNumber] = extractLocation(last);
    return makeStackFrame({
      functionName: data.join(" ") || null,
      fileName,
      lineNumber,
      columnNumber
    });
  });
  return frames;
}
var regexExtractLocation = /\(?(.+?)(?::(\d+))?(?::(\d+))?\)?$/;
var regexValidFrame_Chrome = /^\s*(at|in)\s.+(:\d+)/;
var regexValidFrame_FireFox = /(^|@)\S+:\d+|.+line\s+\d+\s+>\s+(eval|Function).+/;
var parseError = async (error, contextLines) => {
  if (error === null) {
    throw new Error("You cannot pass a null object.");
  }
  if (typeof error === "string") {
    return parseStack(error.split("\n")).map((frame) => {
      return {
        type: "transpiled",
        frame
      };
    });
  }
  if (Array.isArray(error)) {
    return parseStack(error).map((frame) => {
      return {
        type: "transpiled",
        frame
      };
    });
  }
  const errorLocation = getLocationFromBuildError(error);
  if (errorLocation) {
    return [
      {
        type: "symbolicated",
        frame: await resolveFileSource(errorLocation, contextLines)
      }
    ];
  }
  if (typeof error.stack === "string") {
    return parseStack(error.stack.split("\n")).map((frame) => {
      return {
        type: "transpiled",
        frame
      };
    });
  }
  return [];
};

// src/error-overlay/react-overlay/utils/unmapper.ts
import {Internals as Internals16} from "remotion";

// src/error-overlay/react-overlay/utils/get-lines-around.ts
function getLinesAround(line2, count, lines2) {
  const result = [];
  for (let index = Math.max(0, line2 - 1 - count);index <= Math.min(lines2.length - 1, line2 - 1 + count); ++index) {
    result.push({
      lineNumber: index + 1,
      content: lines2[index],
      highlight: index === line2 - 1
    });
  }
  return result;
}

// src/error-overlay/react-overlay/utils/get-source-map.ts
import {SourceMapConsumer} from "source-map";
var extractSourceMapUrl = function(fileContents) {
  const regex = /\/\/[#@] ?sourceMappingURL=([^\s'"]+)\s*$/gm;
  let match = null;
  for (;; ) {
    const next = regex.exec(fileContents);
    if (next == null) {
      break;
    }
    match = next;
  }
  if (!match?.[1]) {
    return null;
  }
  return match[1].toString();
};
async function getSourceMap(fileUri, fileContents) {
  const sm = extractSourceMapUrl(fileContents);
  if (sm === null) {
    return null;
  }
  if (sm.indexOf("data:") === 0) {
    const base64 = /^data:application\/json;([\w=:"-]+;)*base64,/;
    const match2 = sm.match(base64);
    if (!match2) {
      throw new Error("Sorry, non-base64 inline source-map encoding is not supported.");
    }
    const converted = window.atob(sm.substring(match2[0].length));
    return new SourceMapConsumer(JSON.parse(converted));
  }
  const index = fileUri.lastIndexOf("/");
  const url = fileUri.substring(0, index + 1) + sm;
  const obj = await fetch(url).then((res) => res.json());
  return new SourceMapConsumer(obj);
}
var getOriginalPosition = (source_map, line2, column) => {
  const result = source_map.originalPositionFor({
    line: line2,
    column
  });
  return { line: result.line, column: result.column, source: result.source };
};

// src/error-overlay/react-overlay/utils/unmapper.ts
var getFileContents = async (fileName) => {
  const res = await fetch(fileName);
  const fileContents = await res.text();
  return fileContents;
};
var unmap = async (frames, contextLines) => {
  const transpiled = frames.filter((s) => s.type === "transpiled").map((s) => s.frame);
  const uniqueFileNames = [
    ...new Set(transpiled.map((f) => f.fileName).filter(Internals16.truthy))
  ];
  const maps = await Promise.all(uniqueFileNames.map(async (fileName) => {
    const fileContents = await getFileContents(fileName);
    return getSourceMap(fileName, fileContents);
  }));
  const mapValues = {};
  for (let i = 0;i < uniqueFileNames.length; i++) {
    mapValues[uniqueFileNames[i]] = maps[i];
  }
  return frames.map((frame) => {
    if (frame.type === "symbolicated") {
      return frame.frame;
    }
    const map = mapValues[frame.frame.fileName];
    if (!map) {
      return null;
    }
    const pos = getOriginalPosition(map, frame.frame.lineNumber, frame.frame.columnNumber);
    const { functionName } = frame.frame;
    let hasSource = null;
    hasSource = pos.source ? map.sourceContentFor(pos.source, false) : null;
    const scriptCode = hasSource && pos.line ? getLinesAround(pos.line, contextLines, hasSource.split("\n")) : null;
    return {
      originalColumnNumber: pos.column,
      originalFileName: pos.source,
      originalFunctionName: functionName,
      originalLineNumber: pos.line,
      originalScriptCode: scriptCode
    };
  }).filter(Internals16.truthy);
};

// src/error-overlay/react-overlay/utils/get-stack-frames.ts
var getStackFrames = async (error, contextSize) => {
  const parsedFrames = await parseError(error, contextSize);
  const enhancedFrames = await unmap(parsedFrames, contextSize);
  if (enhancedFrames.map((f) => f.originalFileName).filter((f_1) => f_1 !== null && f_1 !== undefined).length === 0) {
    return null;
  }
  return enhancedFrames;
};

// src/error-overlay/react-overlay/listen-to-runtime-errors.ts
var CONTEXT_SIZE = 3;
var getErrorRecord = async (error) => {
  const stackFrames = await getStackFrames(error, CONTEXT_SIZE);
  if (stackFrames === null || stackFrames === undefined) {
    return null;
  }
  return {
    error,
    contextSize: CONTEXT_SIZE,
    stackFrames
  };
};

// src/error-overlay/remotion-overlay/ErrorDisplay.tsx
import {getLocationFromBuildError as getLocationFromBuildError2} from "@remotion/studio-shared";
import {useMemo as useMemo42} from "react";

// src/error-overlay/remotion-overlay/AskOnDiscord.tsx
import {useCallback as useCallback27, useEffect as useEffect25} from "react";

// src/components/Button.tsx
import {forwardRef as forwardRef3, useMemo as useMemo39} from "react";
import {
jsx as jsx62
} from "react/jsx-runtime";
var button = {
  border: `1px solid ${INPUT_BORDER_COLOR_UNHOVERED}`,
  borderRadius: 4,
  backgroundColor: INPUT_BACKGROUND,
  appearance: "none",
  fontFamily: "inherit",
  fontSize: 14,
  color: "white",
  flexDirection: "row"
};
var ButtonRefForwardFunction = ({
  children,
  onClick,
  title: title2,
  disabled,
  style: style3,
  id,
  autoFocus,
  buttonContainerStyle
}, ref) => {
  const combined = useMemo39(() => {
    return {
      ...button,
      ...style3 ?? {}
    };
  }, [style3]);
  const buttonContainer = useMemo39(() => {
    return {
      padding: 10,
      cursor: disabled ? "inherit" : "pointer",
      fontSize: 14,
      opacity: disabled ? 0.7 : 1,
      ...buttonContainerStyle ?? {}
    };
  }, [buttonContainerStyle, disabled]);
  return jsx62("button", {
    ref,
    id,
    style: combined,
    type: "button",
    disabled,
    onClick,
    autoFocus,
    title: title2,
    children: jsx62("div", {
      className: "css-reset",
      style: buttonContainer,
      children
    })
  });
};
var Button = forwardRef3(ButtonRefForwardFunction);

// src/error-overlay/remotion-overlay/AskOnDiscord.tsx
import {
jsx as jsx63,
jsxs as jsxs23
} from "react/jsx-runtime";
var DISCORD_LINK = "https://remotion.dev/discord";
var AskOnDiscord = ({ canHaveKeyboardShortcuts }) => {
  const openInBrowser = useCallback27(() => {
    window.open(DISCORD_LINK, "_blank");
  }, []);
  const { registerKeybinding } = useKeybinding();
  useEffect25(() => {
    if (!canHaveKeyboardShortcuts) {
      return;
    }
    const onEditor = () => {
      openInBrowser();
    };
    const { unregister } = registerKeybinding({
      event: "keydown",
      key: "d",
      callback: onEditor,
      commandCtrlKey: true,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => unregister();
  }, [canHaveKeyboardShortcuts, openInBrowser, registerKeybinding]);
  return jsxs23(Button, {
    onClick: openInBrowser,
    children: [
      "Ask on Discord",
      " ",
      canHaveKeyboardShortcuts ? jsx63(ShortcutHint, {
        keyToPress: "d",
        cmdOrCtrl: true
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/CalculateMetadataErrorExplainer.tsx
import {
jsx as jsx64,
jsxs as jsxs24
} from "react/jsx-runtime";
var CalculateMetadataErrorExplainer = () => {
  return jsxs24("div", {
    style: style3,
    children: [
      "This error occured while calling",
      " ",
      jsx64("code", {
        style: inlineCodeSnippet,
        children: "calculateMetadata()"
      }),
      "."
    ]
  });
};
var style3 = {
  borderRadius: 3,
  color: "white",
  padding: 12,
  backgroundColor: BORDER_COLOR,
  fontSize: 14,
  fontFamily: "sans-serif"
};

// src/error-overlay/react-overlay/index.ts
import {Internals as Internals17} from "remotion";
var didUnmountReactApp = () => {
  return !Internals17.getPreviewDomElement()?.hasChildNodes();
};

// src/error-overlay/remotion-overlay/DismissButton.tsx
import {useCallback as useCallback28} from "react";
import {
jsx as jsx65
} from "react/jsx-runtime";
var size = {
  height: 20,
  width: 20
};
var style4 = {
  appearance: "none",
  WebkitAppearance: "none",
  backgroundColor: "transparent",
  border: "none",
  cursor: "pointer"
};
var DismissButton = () => {
  const dismiss = useCallback28(() => {
    clearUrl();
  }, []);
  return jsx65("button", {
    type: "button",
    style: style4,
    onClick: dismiss,
    children: jsx65("svg", {
      focusable: "false",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 352 512",
      style: size,
      children: jsx65("path", {
        fill: "white",
        d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      })
    })
  });
};

// src/error-overlay/remotion-overlay/ErrorMessage.tsx
import {PlayerInternals as PlayerInternals9} from "@remotion/player";
import {useCallback as useCallback29, useMemo as useMemo40, useRef as useRef19, useState as useState30} from "react";

// src/error-overlay/remotion-overlay/carets.tsx
import {
jsx as jsx66
} from "react/jsx-runtime";
var CaretRight2 = () => {
  return jsx66("svg", {
    style: { height: 20 },
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    viewBox: "0 0 192 512",
    children: jsx66("path", {
      fill: "currentColor",
      d: "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
    })
  });
};
var CaretDown2 = ({ invert }) => {
  return jsx66("svg", {
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    style: { height: 20, transform: invert ? `rotate(180deg)` : "" },
    children: jsx66("path", {
      fill: "currentColor",
      d: "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    })
  });
};

// src/error-overlay/remotion-overlay/ErrorMessage.tsx
import {
jsx as jsx67,
jsxs as jsxs25
} from "react/jsx-runtime";
var fontSize = 24;
var lineHeight = 1.5;
var maxLines = 2;
var buttonSize = 32;
var maskImage = "linear-gradient(to bottom, white 60%, transparent)";
var container14 = {
  position: "relative",
  marginBottom: 15
};
var messageContainer = {
  overflow: "hidden"
};
var textContainer = {
  fontSize,
  lineHeight
};
var moreLine = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  position: "absolute",
  border: `1px solid ${INPUT_BORDER_COLOR_HOVERED}`,
  height: 0,
  marginTop: 4
};
var moreButton = {
  height: buttonSize,
  width: buttonSize,
  borderRadius: buttonSize / 2,
  backgroundColor: INPUT_BACKGROUND,
  border: `1px solid ${INPUT_BORDER_COLOR_UNHOVERED}`,
  marginTop: -buttonSize / 2,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  color: "white"
};
var ErrorMessage = ({ message }) => {
  const [expanded, setExpanded] = useState30(false);
  const ref = useRef19(null);
  const size2 = PlayerInternals9.useElementSize(ref, {
    shouldApplyCssTransforms: false,
    triggerOnWindowResize: true
  });
  const errorLines = size2 ? size2.height / (lineHeight * fontSize) : null;
  const style5 = useMemo40(() => {
    const isExpanded = expanded || errorLines !== null && errorLines <= maxLines;
    return {
      ...messageContainer,
      maxHeight: isExpanded ? undefined : fontSize * lineHeight * maxLines,
      maskImage: isExpanded ? undefined : maskImage,
      WebkitMaskImage: isExpanded ? undefined : maskImage
    };
  }, [errorLines, expanded]);
  const toggle = useCallback29(() => {
    setExpanded((e) => !e);
  }, []);
  return jsxs25("div", {
    style: container14,
    children: [
      jsx67("div", {
        style: style5,
        children: jsx67("div", {
          ref,
          style: textContainer,
          children: message
        })
      }),
      errorLines !== null && errorLines > maxLines ? jsx67("div", {
        style: moreLine,
        children: jsx67("button", {
          type: "button",
          onClick: toggle,
          style: moreButton,
          children: jsx67(CaretDown2, {
            invert: expanded
          })
        })
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/Symbolicating.tsx
import {
jsx as jsx68,
jsxs as jsxs26
} from "react/jsx-runtime";
var Symbolicating = (props) => {
  return jsxs26("svg", {
    id: "loading",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "16",
    height: "16",
    fill: "white",
    ...props,
    children: [
      jsx68("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(0 16 16)",
        children: jsx68("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0"
        })
      }),
      jsx68("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(45 16 16)",
        children: jsx68("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.125s"
        })
      }),
      jsx68("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(90 16 16)",
        children: jsx68("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.25s"
        })
      }),
      jsx68("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(135 16 16)",
        children: jsx68("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.375s"
        })
      }),
      jsx68("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(180 16 16)",
        children: jsx68("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.5s"
        })
      }),
      jsx68("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(225 16 16)",
        children: jsx68("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.675s"
        })
      }),
      jsx68("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(270 16 16)",
        children: jsx68("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.75s"
        })
      }),
      jsx68("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(315 16 16)",
        children: jsx68("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.875s"
        })
      })
    ]
  });
};

// src/error-overlay/remotion-overlay/ErrorTitle.tsx
import {
jsx as jsx69,
jsxs as jsxs27,
Fragment as Fragment12
} from "react/jsx-runtime";
var title2 = {
  marginBottom: 8,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center"
};
var left = {
  flex: 1,
  paddingRight: 14,
  fontWeight: "bold",
  maxWidth: "100%"
};
var errName = {
  fontSize: 18,
  color: BLUE,
  display: "inline-block"
};
var row2 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var spacer = {
  width: 5
};
var ErrorTitle = ({ name, message, symbolicating, canHaveDismissButton }) => {
  return jsxs27("div", {
    style: title2,
    className: "css-reset",
    children: [
      jsxs27("div", {
        style: left,
        children: [
          jsx69("span", {
            style: errName,
            children: name
          }),
          jsx69("br", {}),
          jsxs27("div", {
            style: row2,
            children: [
              symbolicating ? jsxs27(Fragment12, {
                children: [
                  jsx69(Symbolicating, {}),
                  jsx69("div", {
                    style: spacer
                  })
                ]
              }) : null,
              jsx69(ErrorMessage, {
                message
              })
            ]
          })
        ]
      }),
      didUnmountReactApp() ? null : canHaveDismissButton ? jsx69(DismissButton, {}) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/HelpLink.tsx
import {useCallback as useCallback30, useEffect as useEffect26} from "react";
import {
jsx as jsx70,
jsxs as jsxs28
} from "react/jsx-runtime";
var buttonStyle2 = {
  backgroundColor: BLUE,
  color: "white"
};
var HelpLink = ({ canHaveKeyboardShortcuts, link }) => {
  const openLink = useCallback30(() => {
    window.open(link.url, "_blank");
  }, [link]);
  const { registerKeybinding } = useKeybinding();
  useEffect26(() => {
    if (!canHaveKeyboardShortcuts) {
      return;
    }
    const onEditor = () => {
      openLink();
    };
    const { unregister } = registerKeybinding({
      event: "keydown",
      key: "h",
      callback: onEditor,
      commandCtrlKey: true,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => unregister();
  }, [canHaveKeyboardShortcuts, openLink, registerKeybinding]);
  return jsxs28(Button, {
    style: buttonStyle2,
    onClick: openLink,
    children: [
      "Help: ",
      '"',
      link.title,
      '"',
      canHaveKeyboardShortcuts ? jsx70(ShortcutHint, {
        keyToPress: "h",
        cmdOrCtrl: true
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/OpenInEditor.tsx
import {
useCallback as useCallback31,
useEffect as useEffect27,
useMemo as useMemo41,
useReducer,
useRef as useRef20
} from "react";
import {
jsx as jsx71,
jsxs as jsxs29
} from "react/jsx-runtime";
var initialState = { type: "idle" };
var reducer = (state, action) => {
  if (action.type === "start") {
    return {
      type: "load"
    };
  }
  if (action.type === "fail") {
    return {
      type: "error"
    };
  }
  if (action.type === "reset") {
    return {
      type: "idle"
    };
  }
  if (action.type === "succeed") {
    return {
      type: "success"
    };
  }
  return state;
};
var OpenInEditor = ({ stack, canHaveKeyboardShortcuts }) => {
  const isMounted = useRef20(true);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { registerKeybinding } = useKeybinding();
  const dispatchIfMounted = useCallback31((payload) => {
    if (isMounted.current === false)
      return;
    dispatch(payload);
  }, []);
  const openInBrowser = useCallback31(() => {
    dispatch({ type: "start" });
    openInEditor(stack).then((res) => res.json()).then((data) => {
      if (data.success) {
        dispatchIfMounted({ type: "succeed" });
      } else {
        dispatchIfMounted({ type: "fail" });
      }
    }).catch((err) => {
      dispatchIfMounted({ type: "fail" });
      console.log("Could not open browser", err);
    }).finally(() => {
      setTimeout(() => {
        dispatchIfMounted({ type: "reset" });
      }, 2000);
    });
  }, [dispatchIfMounted, stack]);
  useEffect27(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  useEffect27(() => {
    if (!canHaveKeyboardShortcuts) {
      return;
    }
    const onEditor = () => {
      openInBrowser();
    };
    const { unregister } = registerKeybinding({
      event: "keydown",
      key: "o",
      callback: onEditor,
      commandCtrlKey: true,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => unregister();
  }, [canHaveKeyboardShortcuts, openInBrowser, registerKeybinding]);
  const label4 = useMemo41(() => {
    switch (state.type) {
      case "error":
        return "Failed to open";
      case "idle":
        return `Open in ${window.remotion_editorName}`;
      case "success":
        return `Opened in ${window.remotion_editorName}`;
      case "load":
        return `Opening...`;
      default:
        throw new Error("invalid state");
    }
  }, [state.type]);
  return jsxs29(Button, {
    onClick: openInBrowser,
    disabled: state.type !== "idle",
    children: [
      label4,
      canHaveKeyboardShortcuts ? jsx71(ShortcutHint, {
        keyToPress: "o",
        cmdOrCtrl: true
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/Retry.tsx
import {
jsx as jsx72
} from "react/jsx-runtime";
var RetryButton = ({ onClick }) => {
  return jsx72(Button, {
    onClick,
    children: "Retry calculateMetadata()"
  });
};

// src/error-overlay/remotion-overlay/SearchGitHubIssues.tsx
import {useCallback as useCallback32, useEffect as useEffect28} from "react";
import {
jsx as jsx73,
jsxs as jsxs30
} from "react/jsx-runtime";
var SearchGithubIssues = ({ message, canHaveKeyboardShortcuts }) => {
  const openInBrowser = useCallback32(() => {
    window.open(`https://github.com/remotion-dev/remotion/issues?q=${encodeURIComponent(message)}`, "_blank");
  }, [message]);
  const { registerKeybinding } = useKeybinding();
  useEffect28(() => {
    if (!canHaveKeyboardShortcuts) {
      return;
    }
    const onEditor = () => {
      openInBrowser();
    };
    const { unregister } = registerKeybinding({
      event: "keydown",
      key: "g",
      callback: onEditor,
      commandCtrlKey: true,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => unregister();
  }, [canHaveKeyboardShortcuts, openInBrowser, registerKeybinding]);
  return jsxs30(Button, {
    onClick: openInBrowser,
    children: [
      "Search GitHub Issues",
      " ",
      canHaveKeyboardShortcuts ? jsx73(ShortcutHint, {
        keyToPress: "g",
        cmdOrCtrl: true
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/StackFrame.tsx
import {useCallback as useCallback33, useState as useState31} from "react";

// src/error-overlay/remotion-overlay/CodeFrame.tsx
import {
jsx as jsx74,
jsxs as jsxs31
} from "react/jsx-runtime";
var container15 = {
  display: "flex",
  flexDirection: "row",
  width: "100%"
};
var frame = {
  backgroundColor: "#070707",
  marginBottom: 20,
  overflowY: "auto"
};
var lineNumber = {
  whiteSpace: "pre",
  paddingRight: 12,
  color: "inherit",
  fontSize: 14,
  lineHeight: 1.7,
  width: 60,
  flexShrink: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "flex-end",
  fontFamily: "monospace"
};
var CodeFrame = ({ source, lineNumberWidth }) => {
  return jsx74("div", {
    style: frame,
    className: HORIZONTAL_SCROLLBAR_CLASSNAME,
    children: source.map((s, j) => {
      return jsxs31("div", {
        style: container15,
        children: [
          jsx74("div", {
            style: {
              ...lineNumber,
              backgroundColor: s.highlight ? "white" : "#121212",
              color: s.highlight ? "black" : "rgba(255, 255, 255, 0.6)"
            },
            children: String(s.lineNumber).padStart(lineNumberWidth, " ")
          }),
          jsx74("div", {
            style: {
              fontFamily: "monospace",
              whiteSpace: "pre",
              tabSize: 2,
              color: s.highlight ? "white" : "rgba(255, 255, 255, 0.6)",
              backgroundColor: s.highlight ? BLUE : "transparent",
              lineHeight: 1.7,
              paddingRight: 12,
              paddingLeft: 12
            },
            children: s.content
          })
        ]
      }, j);
    })
  });
};

// src/error-overlay/remotion-overlay/format-location.ts
var formatLocation = (location) => {
  if (location.startsWith("webpack://")) {
    return location.replace("webpack://", "");
  }
  return location;
};

// src/error-overlay/remotion-overlay/StackFrame.tsx
import {
jsx as jsx75,
jsxs as jsxs32
} from "react/jsx-runtime";
var location = {
  color: "rgba(255, 255, 255, 0.6)",
  fontFamily: "monospace",
  fontSize: 14
};
var header = {
  paddingLeft: 14,
  paddingTop: 10,
  paddingBottom: 10,
  paddingRight: 14,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  borderBottom: "1px solid rgb(66, 144, 245)",
  backgroundColor: "black"
};
var left2 = {
  paddingRight: 14,
  flex: 1
};
var fnName = {
  fontSize: 14,
  lineHeight: 1.5,
  marginBottom: 3
};
var StackElement = ({ s, lineNumberWidth, isFirst, defaultFunctionName }) => {
  const [showCodeFrame, setShowCodeFrame] = useState31(() => !s.originalFileName?.includes("node_modules") && !s.originalFileName?.startsWith("webpack/") || isFirst);
  const toggleCodeFrame = useCallback33(() => {
    setShowCodeFrame((f) => !f);
  }, []);
  return jsxs32("div", {
    className: "css-reset",
    children: [
      jsxs32("div", {
        style: header,
        children: [
          jsxs32("div", {
            style: left2,
            children: [
              jsx75("div", {
                style: fnName,
                children: s.originalFunctionName ?? defaultFunctionName
              }),
              s.originalFileName ? jsxs32("div", {
                style: location,
                children: [
                  formatLocation(s.originalFileName),
                  ":",
                  s.originalLineNumber
                ]
              }) : null
            ]
          }),
          s.originalScriptCode && s.originalScriptCode.length > 0 ? jsx75(Button, {
            onClick: toggleCodeFrame,
            children: showCodeFrame ? jsx75(CaretDown2, {
              invert: false
            }) : jsx75(CaretRight2, {})
          }) : null
        ]
      }),
      jsx75("div", {
        children: s.originalScriptCode && s.originalScriptCode.length > 0 && showCodeFrame ? jsx75(CodeFrame, {
          lineNumberWidth,
          source: s.originalScriptCode
        }) : null
      })
    ]
  });
};

// src/error-overlay/remotion-overlay/get-help-link.ts
var getHelpLink = (message) => {
  if (message.includes("See https://www.remotion.dev/docs/the-fundamentals#defining-compositions")) {
    return {
      title: "Defining compositions",
      url: "See https://www.remotion.dev/docs/the-fundamentals#defining-compositions"
    };
  }
  if (message.includes("https://remotion.dev/docs/wrong-composition-mount")) {
    return {
      title: "Wrongly mounted <Composition>",
      url: "https://remotion.dev/docs/wrong-composition-mount"
    };
  }
  if (message.includes("https://remotion.dev/docs/staticfile-relative-paths")) {
    return {
      title: "staticFile() relative paths",
      url: "https://remotion.dev/docs/staticfile-relative-paths"
    };
  }
  if (message.includes("https://remotion.dev/docs/staticfile-remote-urls")) {
    return {
      title: "staticFile() remote URLs",
      url: "https://remotion.dev/docs/staticfile-remote-urls"
    };
  }
  if (message.includes("https://remotion.dev/docs/non-seekable-media")) {
    return {
      title: "Non-seekable media",
      url: "https://remotion.dev/docs/non-seekable-media"
    };
  }
  if (message.includes("https://remotion.dev/docs/media-playback-error")) {
    return {
      title: "Media playback error",
      url: "https://remotion.dev/docs/media-playback-error"
    };
  }
  if (message.includes("Div is not part of the THREE")) {
    return {
      title: "<Sequence> inside <ThreeCanvas>",
      url: "https://remotion.dev/docs/sequence#note-for-remotionthree"
    };
  }
  return null;
};

// src/error-overlay/remotion-overlay/ErrorDisplay.tsx
import {
jsx as jsx76,
jsxs as jsxs33,
Fragment as Fragment13
} from "react/jsx-runtime";
var stack = {
  marginTop: 17,
  overflowX: "scroll",
  marginBottom: "10vh"
};
var spacer2 = {
  width: 5,
  display: "inline-block"
};
var ErrorDisplay = ({
  display,
  keyboardShortcuts,
  onRetry,
  canHaveDismissButton,
  calculateMetadata
}) => {
  const highestLineNumber = Math.max(...display.stackFrames.map((s) => s.originalScriptCode).flat(1).map((s) => s?.lineNumber ?? 0));
  const message = useMemo42(() => {
    const location2 = getLocationFromBuildError2(display.error);
    if (!location2) {
      return display.error.message;
    }
    return location2.message.replace(/\\n/g, "\n").replace(/\\t/g, "  ").replace(/^error:/, "").trim();
  }, [display.error]);
  const lineNumberWidth = String(highestLineNumber).length;
  const helpLink = getHelpLink(message);
  return jsxs33("div", {
    children: [
      jsx76(ErrorTitle, {
        symbolicating: false,
        name: display.error.name,
        message,
        canHaveDismissButton
      }),
      helpLink ? jsxs33(Fragment13, {
        children: [
          jsx76(HelpLink, {
            link: helpLink,
            canHaveKeyboardShortcuts: keyboardShortcuts
          }),
          jsx76("div", {
            style: spacer2
          })
        ]
      }) : null,
      display.stackFrames.length > 0 && window.remotion_editorName ? jsxs33(Fragment13, {
        children: [
          jsx76(OpenInEditor, {
            canHaveKeyboardShortcuts: keyboardShortcuts,
            stack: display.stackFrames[0]
          }),
          jsx76("div", {
            style: spacer2
          })
        ]
      }) : null,
      jsx76(SearchGithubIssues, {
        canHaveKeyboardShortcuts: keyboardShortcuts,
        message: display.error.message
      }),
      jsx76("div", {
        style: spacer2
      }),
      jsx76(AskOnDiscord, {
        canHaveKeyboardShortcuts: keyboardShortcuts
      }),
      onRetry ? jsxs33(Fragment13, {
        children: [
          jsx76("div", {
            style: spacer2
          }),
          jsx76(RetryButton, {
            onClick: onRetry
          })
        ]
      }) : null,
      calculateMetadata ? jsxs33(Fragment13, {
        children: [
          jsx76("br", {}),
          jsx76(Spacing, {
            y: 0.5
          }),
          jsx76(CalculateMetadataErrorExplainer, {})
        ]
      }) : null,
      jsx76("div", {
        style: stack,
        className: HORIZONTAL_SCROLLBAR_CLASSNAME,
        children: display.stackFrames.map((s, i) => {
          return jsx76(StackElement, {
            isFirst: i === 0,
            s,
            lineNumberWidth,
            defaultFunctionName: "(anonymous function)"
          }, i);
        })
      })
    ]
  });
};

// src/error-overlay/remotion-overlay/ErrorLoader.tsx
import {
jsx as jsx77,
jsxs as jsxs34
} from "react/jsx-runtime";
var container16 = {
  width: "100%",
  maxWidth: 1000,
  paddingLeft: 14,
  paddingRight: 14,
  marginLeft: "auto",
  marginRight: "auto",
  fontFamily: "SF Pro Text, sans-serif",
  paddingTop: "5vh"
};
var errorWhileErrorStyle = {
  color: "white",
  lineHeight: 1.5,
  whiteSpace: "pre"
};
var ErrorLoader = ({
  error,
  keyboardShortcuts,
  onRetry,
  canHaveDismissButton,
  calculateMetadata
}) => {
  const [state, setState] = useState32({
    type: "loading"
  });
  useEffect29(() => {
    getErrorRecord(error).then((record) => {
      if (record) {
        setState({
          type: "symbolicated",
          record
        });
      } else {
        setState({
          type: "no-record"
        });
      }
    }).catch((err) => {
      setState({
        err,
        type: "error"
      });
    });
  }, [error]);
  if (state.type === "loading") {
    return jsx77("div", {
      style: container16,
      children: jsx77(ErrorTitle, {
        symbolicating: true,
        name: error.name,
        message: error.message,
        canHaveDismissButton
      })
    });
  }
  if (state.type === "error") {
    return jsxs34("div", {
      style: container16,
      children: [
        jsx77(ErrorTitle, {
          symbolicating: false,
          name: error.name,
          message: error.message,
          canHaveDismissButton
        }),
        jsx77("div", {
          style: errorWhileErrorStyle,
          children: "Error while getting stack trace:"
        }),
        jsx77("div", {
          style: errorWhileErrorStyle,
          children: state.err.stack
        }),
        jsx77("div", {
          style: errorWhileErrorStyle,
          children: "Report this in the Remotion repo."
        })
      ]
    });
  }
  if (state.type === "no-record") {
    return jsxs34("div", {
      style: container16,
      children: [
        jsx77(ErrorTitle, {
          symbolicating: false,
          name: error.name,
          message: error.message,
          canHaveDismissButton
        }),
        jsx77("div", {
          style: errorWhileErrorStyle,
          children: "Check the Terminal and browser console for error messages."
        })
      ]
    });
  }
  return jsx77("div", {
    style: container16,
    children: jsx77(ErrorDisplay, {
      keyboardShortcuts,
      display: state.record,
      onRetry,
      canHaveDismissButton,
      calculateMetadata
    })
  });
};

// src/components/Canvas.tsx
import {
useCallback as useCallback37,
useContext as useContext26,
useEffect as useEffect32,
useMemo as useMemo48,
useState as useState34
} from "react";
import {Internals as Internals22} from "remotion";

// src/helpers/get-effective-translation.ts
var getEffectiveXTranslation = ({
  canvasSize,
  scale,
  compositionWidth,
  translation
}) => {
  const maxTranslation = Math.abs(canvasSize.width / 2 + scale * compositionWidth / 2 - MUST_BE_INSIDE_CANVAS);
  return Math.max(-maxTranslation, Math.min(translation.x, maxTranslation));
};
var MUST_BE_INSIDE_CANVAS = 50;
var getEffectiveYTranslation = ({
  canvasSize,
  scale,
  compositionHeight,
  translation
}) => {
  const maxTranslation = Math.abs(canvasSize.height / 2 + scale * compositionHeight / 2) - MUST_BE_INSIDE_CANVAS;
  return Math.max(-maxTranslation, Math.min(translation.y, maxTranslation));
};
var getEffectiveTranslation = ({
  canvasSize,
  scale,
  compositionHeight,
  compositionWidth,
  translation
}) => {
  return {
    x: getEffectiveXTranslation({
      canvasSize,
      compositionWidth,
      scale,
      translation
    }),
    y: getEffectiveYTranslation({
      canvasSize,
      compositionHeight,
      scale,
      translation
    })
  };
};
var getCenterPointWhileScrolling = ({
  size: size2,
  clientX,
  clientY,
  compositionWidth,
  compositionHeight,
  scale,
  translation
}) => {
  const mouseLeft = clientX - size2.left;
  const mouseTop = clientY - size2.top;
  const contentLeftPoint = size2.width / 2 - compositionWidth * scale / 2 - translation.x;
  const contentTopPoint = size2.height / 2 - compositionHeight * scale / 2 - translation.y;
  const offsetFromVideoLeft = Math.min(compositionWidth, Math.max(0, (mouseLeft - contentLeftPoint) / scale));
  const offsetFromVideoTop = Math.min(compositionHeight, Math.max(0, (mouseTop - contentTopPoint) / scale));
  return {
    centerX: offsetFromVideoLeft,
    centerY: offsetFromVideoTop
  };
};

// src/helpers/smooth-zoom.ts
var logN = function(val) {
  return Math.log(val) / Math.log(BASE);
};
var BASE = Math.E / 4;
var MIN_ZOOM = 0.05;
var MAX_ZOOM = 10;
var smoothenZoom = (input) => {
  return BASE ** (input - 1);
};
var unsmoothenZoom = (input) => {
  if (input < 0) {
    return MAX_ZOOM;
  }
  return Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, logN(input) + 1));
};

// src/components/EditorGuides/index.tsx
import {useContext as useContext22, useMemo as useMemo45} from "react";
import {Internals as Internals19} from "remotion";

// src/helpers/use-studio-canvas-dimensions.ts
import {PlayerInternals as PlayerInternals10} from "@remotion/player";
import {useContext as useContext20, useMemo as useMemo43} from "react";
import {Internals as Internals18} from "remotion";
var useStudioCanvasDimensions = ({
  canvasSize,
  contentDimensions,
  assetMetadata
}) => {
  const { size: previewSize } = useContext20(Internals18.PreviewSizeContext);
  const { centerX, centerY, scale } = useMemo43(() => {
    if (contentDimensions === "none" || contentDimensions === null || assetMetadata && assetMetadata.type === "not-found" || !canvasSize) {
      return {
        centerX: previewSize.translation.x,
        centerY: previewSize.translation.y,
        scale: 1
      };
    }
    return PlayerInternals10.calculateCanvasTransformation({
      canvasSize,
      compositionHeight: contentDimensions.height,
      compositionWidth: contentDimensions.width,
      previewSize: previewSize.size
    });
  }, [
    canvasSize,
    contentDimensions,
    previewSize.size,
    previewSize.translation.y,
    previewSize.translation.x,
    assetMetadata
  ]);
  const canvasPosition = useMemo43(() => {
    return {
      left: centerX - previewSize.translation.x,
      top: centerY - previewSize.translation.y,
      width: contentDimensions === "none" || !contentDimensions ? canvasSize?.width || 0 : contentDimensions.width * scale,
      height: contentDimensions === "none" || !contentDimensions ? canvasSize?.height || 0 : contentDimensions.height * scale
    };
  }, [
    scale,
    centerX,
    previewSize.translation.x,
    previewSize.translation.y,
    centerY,
    canvasSize,
    contentDimensions
  ]);
  return {
    canvasPosition,
    scale
  };
};

// src/components/EditorGuides/Guide.tsx
import {memo, useCallback as useCallback34, useContext as useContext21, useMemo as useMemo44} from "react";
import {NoReactInternals as NoReactInternals6} from "remotion/no-react";
import {
jsx as jsx78
} from "react/jsx-runtime";
var PADDING_FOR_EASY_DRAG = 4;
var GuideComp = ({ guide, canvasDimensions, scale }) => {
  const {
    shouldCreateGuideRef,
    setGuidesList,
    setSelectedGuideId,
    selectedGuideId,
    setHoveredGuideId,
    hoveredGuideId
  } = useContext21(EditorShowGuidesContext);
  const onPointerEnter = useCallback34(() => {
    setHoveredGuideId(() => guide.id);
  }, [guide.id, setHoveredGuideId]);
  const onPointerLeave = useCallback34(() => {
    setHoveredGuideId(() => null);
  }, [setHoveredGuideId]);
  const isVerticalGuide = guide.orientation === "vertical";
  const guideStyle = useMemo44(() => {
    const canvasPosition = isVerticalGuide ? canvasDimensions.left : canvasDimensions.top;
    const guidePosition = guide.position * scale + canvasPosition;
    return {
      position: "absolute",
      width: `${isVerticalGuide ? "1px" : "100%"}`,
      height: `${isVerticalGuide ? "100%" : "1px"}`,
      left: `${isVerticalGuide ? guidePosition - PADDING_FOR_EASY_DRAG : 0}px`,
      top: `${isVerticalGuide ? 0 : guidePosition - PADDING_FOR_EASY_DRAG}px`,
      cursor: `${isVerticalGuide ? "ew-resize" : "ns-resize"}`,
      padding: isVerticalGuide ? `0 ${PADDING_FOR_EASY_DRAG}px` : `${PADDING_FOR_EASY_DRAG}px 0`
    };
  }, [guide, scale, canvasDimensions, isVerticalGuide]);
  const guideContentStyle = useMemo44(() => {
    return {
      position: "relative",
      minWidth: `${isVerticalGuide ? "1px" : `calc(100% + ${RULER_WIDTH}px`}`,
      minHeight: `${isVerticalGuide ? `calc(100% + ${RULER_WIDTH}px` : "1px"}`,
      top: `${isVerticalGuide ? `-${RULER_WIDTH}px` : "0px"}`,
      left: `${isVerticalGuide ? "0px" : `-${RULER_WIDTH}px`}`,
      display: guide.show ? "block" : "none",
      backgroundColor: selectedGuideId === guide.id || hoveredGuideId === guide.id ? SELECTED_GUIDE : UNSELECTED_GUIDE
    };
  }, [isVerticalGuide, guide.show, guide.id, selectedGuideId, hoveredGuideId]);
  const onMouseDown = useCallback34((e) => {
    e.preventDefault();
    if (e.button !== 0) {
      return;
    }
    shouldCreateGuideRef.current = true;
    document.body.style.cursor = "no-drop";
    setSelectedGuideId(() => guide.id);
  }, [shouldCreateGuideRef, setSelectedGuideId, guide.id]);
  const values = useMemo44(() => {
    return [
      {
        id: "1",
        keyHint: null,
        label: "Remove guide",
        leftItem: null,
        onClick: () => {
          setGuidesList((prevState) => {
            const newGuides = prevState.filter((selected) => {
              return selected.id !== guide.id;
            });
            persistGuidesList(newGuides);
            return newGuides;
          });
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: "remove"
      }
    ];
  }, [guide.id, setGuidesList]);
  return jsx78(ContextMenu, {
    values,
    children: jsx78("div", {
      style: guideStyle,
      onMouseDown,
      className: "__remotion_editor_guide",
      onPointerEnter,
      onPointerLeave,
      children: jsx78("div", {
        style: guideContentStyle,
        className: [
          "__remotion_editor_guide_content",
          selectedGuideId === guide.id || hoveredGuideId === guide.id ? "__remotion_editor_guide_selected" : null
        ].filter(NoReactInternals6.truthy).join(" ")
      })
    })
  });
};
var Guide_default = memo(GuideComp);

// src/components/EditorGuides/index.tsx
import {
jsx as jsx79,
Fragment as Fragment14
} from "react/jsx-runtime";
var EditorGuides = ({ canvasSize, contentDimensions, assetMetadata }) => {
  const { canvasPosition: canvasDimensions, scale } = useStudioCanvasDimensions({
    canvasSize,
    contentDimensions,
    assetMetadata
  });
  const { canvasContent } = useContext22(Internals19.CompositionManager);
  if (canvasContent === null || canvasContent.type !== "composition") {
    throw new Error("Expected to be in a composition");
  }
  const { guidesList } = useContext22(EditorShowGuidesContext);
  const guidesForThisComposition = useMemo45(() => {
    return guidesList.filter((guide) => {
      return guide.compositionId === canvasContent.compositionId;
    });
  }, [canvasContent.compositionId, guidesList]);
  return jsx79(Fragment14, {
    children: guidesForThisComposition.map((guide) => {
      return jsx79(Guide_default, {
        guide,
        canvasDimensions,
        scale
      }, guide.id);
    })
  });
};
var EditorGuides_default = EditorGuides;

// src/components/EditorRuler/index.tsx
import {
useCallback as useCallback36,
useContext as useContext24,
useEffect as useEffect31,
useMemo as useMemo47,
useRef as useRef22
} from "react";

// src/helpers/editor-ruler.ts
var drawLabel = ({
  orientation,
  context: context2,
  label: label4,
  originDistance,
  color
}) => {
  context2.fillStyle = color;
  if (orientation === "horizontal") {
    context2.fillText(label4, originDistance + 4, 16);
  } else {
    context2.rotate(-Math.PI / 2);
    context2.fillText(label4, -originDistance + 4, 16);
    context2.rotate(Math.PI / 2);
  }
};
var drawGradient = ({
  orientation,
  context: context2,
  originDistance,
  canvasHeight,
  canvasWidth
}) => {
  const size2 = 250;
  const startX = orientation === "horizontal" ? originDistance - size2 / 2 : 0;
  const startY = orientation === "horizontal" ? 0 : originDistance - size2 / 2;
  const endX = orientation === "horizontal" ? originDistance + size2 / 2 : canvasWidth;
  const endY = orientation === "horizontal" ? canvasHeight : originDistance + size2 / 2;
  const grd = context2.createLinearGradient(startX, startY, endX, endY);
  grd.addColorStop(0, BACKGROUND__TRANSPARENT);
  grd.addColorStop(0.25, BACKGROUND);
  grd.addColorStop(0.75, BACKGROUND);
  grd.addColorStop(1, BACKGROUND__TRANSPARENT);
  context2.fillStyle = grd;
  context2.fillRect(startX, startY, endX - startX, endY - startY);
};
var drawGuide = ({
  selectedGuide,
  scale,
  startMarking,
  context: context2,
  canvasHeight,
  canvasWidth,
  orientation,
  originOffset
}) => {
  const originDistance = rulerValueToPosition({
    value: selectedGuide.position,
    startMarking,
    scale
  }) + originOffset - startMarking * scale;
  drawGradient({
    canvasHeight,
    context: context2,
    orientation,
    originDistance,
    canvasWidth
  });
  context2.strokeStyle = SELECTED_GUIDE;
  context2.lineWidth = 1;
  context2.beginPath();
  if (orientation === "horizontal" && selectedGuide.orientation === "horizontal") {
    return;
  }
  if (orientation === "vertical" && selectedGuide.orientation === "vertical") {
    return;
  }
  if (orientation === "vertical" && selectedGuide.orientation === "horizontal") {
    context2.moveTo(0, originDistance);
    context2.lineTo(canvasWidth, originDistance);
    drawLabel({
      context: context2,
      label: selectedGuide.position.toString(),
      originDistance,
      orientation,
      color: SELECTED_GUIDE
    });
  } else if (orientation === "horizontal" && selectedGuide.orientation === "vertical") {
    context2.moveTo(originDistance, 0);
    context2.lineTo(originDistance, canvasHeight);
    drawLabel({
      context: context2,
      label: selectedGuide.position.toString(),
      originDistance,
      orientation,
      color: SELECTED_GUIDE
    });
  }
  context2.stroke();
};
var drawMarkingOnRulerCanvas = ({
  scale,
  points,
  startMarking,
  originOffset,
  markingGaps,
  orientation,
  rulerCanvasRef,
  selectedGuide,
  canvasHeight,
  canvasWidth
}) => {
  const canvas = rulerCanvasRef.current;
  if (!canvas)
    return;
  const context2 = canvas.getContext("2d");
  if (!context2)
    return;
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  context2.scale(window.devicePixelRatio, window.devicePixelRatio);
  context2.clearRect(0, 0, canvasWidth, canvasHeight);
  context2.strokeStyle = RULER_COLOR;
  context2.lineWidth = 1;
  context2.beginPath();
  points.forEach((point) => {
    context2.strokeStyle = RULER_COLOR;
    context2.lineWidth = 1;
    const originDistance = point.position + originOffset - startMarking * scale;
    context2.beginPath();
    if (orientation === "horizontal") {
      context2.moveTo(originDistance, 0);
      context2.lineTo(originDistance, canvasHeight);
    } else {
      context2.moveTo(0, originDistance);
      context2.lineTo(canvasWidth, originDistance);
    }
    for (let i = 1;i < 5; i++) {
      const markingOffsetXY = i * markingGaps * scale;
      if (orientation === "horizontal") {
        context2.moveTo(originDistance + markingOffsetXY / 5, 0);
        context2.lineTo(originDistance + markingOffsetXY / 5, 4);
      } else {
        context2.moveTo(0, originDistance + markingOffsetXY / 5);
        context2.lineTo(4, originDistance + markingOffsetXY / 5);
      }
    }
    context2.stroke();
    context2.font = "10px Arial, Helvetica, sans-serif";
    context2.textAlign = "left";
    context2.fillStyle = RULER_COLOR;
    drawLabel({
      orientation,
      context: context2,
      label: point.value.toString(),
      originDistance,
      color: RULER_COLOR
    });
  });
  if (selectedGuide && orientation !== selectedGuide.orientation) {
    drawGuide({
      canvasHeight,
      canvasWidth,
      context: context2,
      orientation,
      originOffset,
      scale,
      selectedGuide,
      startMarking
    });
  }
};
var getRulerPoints = ({
  rulerScaleRange,
  rulerMarkingGaps,
  scale
}) => {
  const points = [];
  const startPoint = Math.ceil(rulerScaleRange.start / rulerMarkingGaps);
  const endPoint = Math.floor(rulerScaleRange.end / rulerMarkingGaps);
  const startMarking = startPoint * rulerMarkingGaps;
  for (let i = startPoint;i <= endPoint; i++) {
    points.push({
      value: i * rulerMarkingGaps,
      position: rulerValueToPosition({
        scale,
        startMarking,
        value: i * rulerMarkingGaps
      })
    });
  }
  return {
    points,
    startMarking
  };
};
var rulerValueToPosition = ({
  value,
  startMarking,
  scale
}) => {
  return (value + startMarking) * scale;
};
var getRulerScaleRange = ({
  canvasLength,
  scale,
  canvasSize
}) => {
  const scaleRangeBeyondCanvas = (canvasSize.width || MINIMUM_VISIBLE_CANVAS_SIZE - MINIMUM_VISIBLE_CANVAS_SIZE) / scale;
  return {
    start: -scaleRangeBeyondCanvas,
    end: scaleRangeBeyondCanvas + canvasLength
  };
};

// src/components/EditorRuler/Ruler.tsx
import {
useCallback as useCallback35,
useContext as useContext23,
useEffect as useEffect30,
useMemo as useMemo46,
useRef as useRef21,
useState as useState33
} from "react";
import {Internals as Internals20} from "remotion";
import {
jsx as jsx80
} from "react/jsx-runtime";
var makeGuideId = () => {
  return Math.random().toString(36).substring(7);
};
var Ruler = ({
  scale,
  points,
  originOffset,
  startMarking,
  size: size2,
  markingGaps,
  orientation
}) => {
  const rulerCanvasRef = useRef21(null);
  const isVerticalRuler = orientation === "vertical";
  const {
    shouldCreateGuideRef,
    setGuidesList,
    selectedGuideId,
    hoveredGuideId,
    setSelectedGuideId,
    guidesList,
    setEditorShowGuides
  } = useContext23(EditorShowGuidesContext);
  const unsafeVideoConfig = Internals20.useUnsafeVideoConfig();
  if (!unsafeVideoConfig) {
    throw new Error("Video config not set");
  }
  const [cursor, setCursor] = useState33(isVerticalRuler ? "ew-resize" : "ns-resize");
  const selectedOrHoveredGuide = useMemo46(() => {
    return guidesList.find((guide) => guide.id === selectedGuideId) ?? guidesList.find((guide) => guide.id === hoveredGuideId) ?? null;
  }, [guidesList, hoveredGuideId, selectedGuideId]);
  const rulerWidth = isVerticalRuler ? RULER_WIDTH : size2.width - RULER_WIDTH;
  const rulerHeight = isVerticalRuler ? size2.height - RULER_WIDTH : RULER_WIDTH;
  useEffect30(() => {
    drawMarkingOnRulerCanvas({
      scale,
      points,
      startMarking,
      originOffset,
      markingGaps,
      orientation,
      rulerCanvasRef,
      selectedGuide: selectedOrHoveredGuide,
      canvasHeight: rulerHeight * window.devicePixelRatio,
      canvasWidth: rulerWidth * window.devicePixelRatio
    });
  }, [
    scale,
    points,
    startMarking,
    originOffset,
    markingGaps,
    orientation,
    selectedOrHoveredGuide,
    size2,
    rulerHeight,
    rulerWidth
  ]);
  const rulerStyle = useMemo46(() => ({
    position: "absolute",
    background: BACKGROUND,
    width: rulerWidth,
    height: rulerHeight,
    left: isVerticalRuler ? 0 : "unset",
    top: isVerticalRuler ? "unset" : 0,
    borderBottom: isVerticalRuler ? undefined : "1px solid " + RULER_COLOR,
    borderRight: isVerticalRuler ? "1px solid " + RULER_COLOR : undefined,
    cursor
  }), [rulerWidth, rulerHeight, cursor, isVerticalRuler]);
  const onMouseDown = useCallback35((e) => {
    if (e.button !== 0) {
      return;
    }
    e.preventDefault();
    shouldCreateGuideRef.current = true;
    document.body.style.cursor = "no-drop";
    const guideId = makeGuideId();
    setEditorShowGuides(() => true);
    setSelectedGuideId(() => guideId);
    setGuidesList((prevState) => {
      return [
        ...prevState,
        {
          orientation,
          position: -originOffset,
          show: false,
          id: guideId,
          compositionId: unsafeVideoConfig.id
        }
      ];
    });
  }, [
    shouldCreateGuideRef,
    setEditorShowGuides,
    setSelectedGuideId,
    setGuidesList,
    orientation,
    originOffset,
    unsafeVideoConfig.id
  ]);
  const changeCursor = useCallback35((e) => {
    e.preventDefault();
    if (selectedGuideId !== null) {
      setCursor("no-drop");
    }
  }, [setCursor, selectedGuideId]);
  useEffect30(() => {
    if (selectedGuideId === null) {
      setCursor(isVerticalRuler ? "ew-resize" : "ns-resize");
    }
  }, [selectedGuideId, isVerticalRuler]);
  return jsx80("canvas", {
    ref: rulerCanvasRef,
    width: rulerWidth * window.devicePixelRatio,
    height: rulerHeight * window.devicePixelRatio,
    style: rulerStyle,
    onPointerDown: onMouseDown,
    onPointerEnter: changeCursor,
    onPointerLeave: changeCursor
  });
};
var Ruler_default = Ruler;

// src/components/EditorRuler/index.tsx
import {
jsx as jsx81,
jsxs as jsxs35,
Fragment as Fragment15
} from "react/jsx-runtime";
var originBlockStyles = {
  position: "absolute",
  top: 0,
  left: 0,
  borderBottom: "1px solid " + RULER_COLOR,
  borderRight: "1px solid " + RULER_COLOR,
  width: `${RULER_WIDTH}px`,
  height: `${RULER_WIDTH}px`,
  background: BACKGROUND
};
var EditorRulers = ({ contentDimensions, canvasSize, assetMetadata, containerRef }) => {
  const { scale, canvasPosition } = useStudioCanvasDimensions({
    canvasSize,
    contentDimensions,
    assetMetadata
  });
  const {
    shouldCreateGuideRef,
    shouldDeleteGuideRef,
    setGuidesList,
    selectedGuideId,
    setSelectedGuideId
  } = useContext24(EditorShowGuidesContext);
  const rulerMarkingGaps = useMemo47(() => {
    const minimumGap = MINIMUM_RULER_MARKING_GAP_PX;
    const predefinedGap = PREDEFINED_RULER_SCALE_GAPS.find((gap) => gap * scale > minimumGap);
    return predefinedGap || MAXIMUM_PREDEFINED_RULER_SCALE_GAP;
  }, [scale]);
  const horizontalRulerScaleRange = useMemo47(() => getRulerScaleRange({
    canvasLength: canvasPosition.width,
    scale,
    canvasSize
  }), [canvasPosition.width, canvasSize, scale]);
  const verticalRulerScaleRange = useMemo47(() => getRulerScaleRange({
    canvasLength: canvasPosition.height,
    scale,
    canvasSize
  }), [canvasPosition.height, canvasSize, scale]);
  const {
    points: horizontalRulerPoints,
    startMarking: horizontalRulerStartMarking
  } = useMemo47(() => getRulerPoints({
    rulerScaleRange: horizontalRulerScaleRange,
    rulerMarkingGaps,
    scale
  }), [horizontalRulerScaleRange, rulerMarkingGaps, scale]);
  const { points: verticalRulerPoints, startMarking: verticalRulerStartMarking } = useMemo47(() => getRulerPoints({
    rulerScaleRange: verticalRulerScaleRange,
    rulerMarkingGaps,
    scale
  }), [verticalRulerScaleRange, rulerMarkingGaps, scale]);
  const requestAnimationFrameRef = useRef22(null);
  const onMouseMove = useCallback36((e) => {
    if (requestAnimationFrameRef.current) {
      cancelAnimationFrame(requestAnimationFrameRef.current);
    }
    requestAnimationFrameRef.current = requestAnimationFrame(() => {
      const { clientX: mouseX, clientY: mouseY } = e;
      const {
        left: containerLeft = 0,
        top: containerTop = 0,
        right: containerRight = 0,
        bottom: containerBottom = 0
      } = containerRef.current?.getBoundingClientRect() || {};
      if (mouseX < containerLeft || mouseX > containerRight || mouseY < containerTop || mouseY > containerBottom) {
        if (!shouldDeleteGuideRef.current) {
          shouldDeleteGuideRef.current = true;
        }
        if (document.body.style.cursor !== "no-drop") {
          document.body.style.cursor = "no-drop";
        }
        setGuidesList((prevState) => {
          const newGuides = prevState.map((guide) => {
            if (guide.id !== selectedGuideId) {
              return guide;
            }
            return {
              ...guide,
              show: false
            };
          });
          persistGuidesList(newGuides);
          return newGuides;
        });
      } else {
        if (shouldDeleteGuideRef.current) {
          shouldDeleteGuideRef.current = false;
        }
        setGuidesList((prevState) => {
          return prevState.map((guide) => {
            if (guide.id !== selectedGuideId) {
              return guide;
            }
            const position = guide.orientation === "vertical" ? (mouseX - containerLeft) / scale - canvasPosition.left / scale : (mouseY - containerTop) / scale - canvasPosition.top / scale;
            const desiredCursor = guide.orientation === "vertical" ? "ew-resize" : "ns-resize";
            if (document.body.style.cursor !== desiredCursor) {
              document.body.style.cursor = desiredCursor;
            }
            return {
              ...guide,
              position: Math.floor(position / 1),
              show: true
            };
          });
        });
      }
    });
  }, [
    containerRef,
    shouldDeleteGuideRef,
    setGuidesList,
    selectedGuideId,
    scale,
    canvasPosition.left,
    canvasPosition.top
  ]);
  const onMouseUp = useCallback36(() => {
    setGuidesList((prevState) => {
      const newGuides = prevState.filter((selected) => {
        if (!shouldDeleteGuideRef.current) {
          return true;
        }
        return selected.id !== selectedGuideId;
      });
      persistGuidesList(newGuides);
      return newGuides;
    });
    shouldDeleteGuideRef.current = false;
    document.body.style.cursor = "auto";
    shouldCreateGuideRef.current = false;
    setSelectedGuideId(() => null);
    document.removeEventListener("pointerup", onMouseUp);
    document.removeEventListener("pointermove", onMouseMove);
  }, [
    selectedGuideId,
    shouldCreateGuideRef,
    shouldDeleteGuideRef,
    setSelectedGuideId,
    setGuidesList,
    onMouseMove
  ]);
  useEffect31(() => {
    if (selectedGuideId !== null) {
      document.addEventListener("pointermove", onMouseMove);
      document.addEventListener("pointerup", onMouseUp);
    }
    return () => {
      document.removeEventListener("pointermove", onMouseMove);
      document.removeEventListener("pointerup", onMouseUp);
      if (requestAnimationFrameRef.current) {
        cancelAnimationFrame(requestAnimationFrameRef.current);
      }
    };
  }, [selectedGuideId, onMouseMove, onMouseUp]);
  return jsxs35(Fragment15, {
    children: [
      jsx81("div", {
        style: originBlockStyles
      }),
      jsx81(Ruler_default, {
        orientation: "horizontal",
        scale,
        points: horizontalRulerPoints,
        startMarking: horizontalRulerStartMarking,
        markingGaps: rulerMarkingGaps,
        originOffset: canvasPosition.left,
        size: canvasSize
      }),
      jsx81(Ruler_default, {
        orientation: "vertical",
        scale,
        points: verticalRulerPoints,
        startMarking: verticalRulerStartMarking,
        markingGaps: rulerMarkingGaps,
        originOffset: canvasPosition.top,
        size: canvasSize
      })
    ]
  });
};

// src/components/EditorRuler/use-is-ruler-visible.ts
import {useContext as useContext25} from "react";
import {Internals as Internals21} from "remotion";
var useIsRulerVisible = () => {
  const { canvasContent } = useContext25(Internals21.CompositionManager);
  const { editorShowRulers } = useContext25(EditorShowRulersContext);
  return editorShowRulers && canvasContent && canvasContent.type === "composition";
};

// src/components/ResetZoomButton.tsx
import {
jsx as jsx82
} from "react/jsx-runtime";
var ResetZoomButton = ({ onClick }) => {
  return jsx82(Button, {
    onClick,
    children: "Reset zoom"
  });
};

// src/components/Canvas.tsx
import {
jsx as jsx83,
jsxs as jsxs36,
Fragment as Fragment16
} from "react/jsx-runtime";
var container17 = {
  flex: 1,
  display: "flex",
  overflow: "hidden",
  position: "relative",
  backgroundColor: BACKGROUND
};
var resetZoom = {
  position: "absolute",
  top: SPACING_UNIT * 2,
  right: SPACING_UNIT * 2
};
var ZOOM_PX_FACTOR = 0.003;
var Canvas = ({ canvasContent, size: size2, isRefreshing }) => {
  const { setSize, size: previewSize } = useContext26(Internals22.PreviewSizeContext);
  const { editorZoomGestures } = useContext26(EditorZoomGesturesContext);
  const keybindings2 = useKeybinding();
  const config = Internals22.useUnsafeVideoConfig();
  const areRulersVisible = useIsRulerVisible();
  const { editorShowGuides } = useContext26(EditorShowGuidesContext);
  const [assetResolution, setAssetResolution] = useState34(null);
  const contentDimensions = useMemo48(() => {
    if ((canvasContent.type === "asset" || canvasContent.type === "output") && assetResolution && assetResolution.type === "found") {
      return assetResolution.dimensions;
    }
    if (config) {
      return { width: config.width, height: config.height };
    }
    return null;
  }, [assetResolution, config, canvasContent]);
  const isFit = previewSize.size === "auto";
  const onWheel = useCallback37((e) => {
    if (!editorZoomGestures) {
      return;
    }
    if (!size2) {
      return;
    }
    if (!contentDimensions || contentDimensions === "none") {
      return;
    }
    const wantsToZoom = e.ctrlKey || e.metaKey;
    if (!wantsToZoom && isFit) {
      return;
    }
    e.preventDefault();
    setSize((prevSize) => {
      const scale = Internals22.calculateScale({
        canvasSize: size2,
        compositionHeight: contentDimensions.height,
        compositionWidth: contentDimensions.width,
        previewSize: prevSize.size
      });
      if (wantsToZoom) {
        const oldSize = prevSize.size === "auto" ? scale : prevSize.size;
        const smoothened = smoothenZoom(oldSize);
        const added = smoothened + e.deltaY * ZOOM_PX_FACTOR;
        const unsmoothened = unsmoothenZoom(added);
        const { centerX, centerY } = getCenterPointWhileScrolling({
          size: size2,
          clientX: e.clientX,
          clientY: e.clientY,
          compositionWidth: contentDimensions.width,
          compositionHeight: contentDimensions.height,
          scale,
          translation: prevSize.translation
        });
        const zoomDifference = unsmoothened - oldSize;
        const uvCoordinatesX = centerX / contentDimensions.width;
        const uvCoordinatesY = centerY / contentDimensions.height;
        const correctionLeft = -uvCoordinatesX * (zoomDifference * contentDimensions.width) + (1 - uvCoordinatesX) * zoomDifference * contentDimensions.width;
        const correctionTop = -uvCoordinatesY * (zoomDifference * contentDimensions.height) + (1 - uvCoordinatesY) * zoomDifference * contentDimensions.height;
        return {
          translation: getEffectiveTranslation({
            translation: {
              x: prevSize.translation.x - correctionLeft / 2,
              y: prevSize.translation.y - correctionTop / 2
            },
            canvasSize: size2,
            compositionHeight: contentDimensions.height,
            compositionWidth: contentDimensions.width,
            scale
          }),
          size: unsmoothened
        };
      }
      const effectiveTranslation = getEffectiveTranslation({
        translation: prevSize.translation,
        canvasSize: size2,
        compositionHeight: contentDimensions.height,
        compositionWidth: contentDimensions.width,
        scale
      });
      return {
        ...prevSize,
        translation: getEffectiveTranslation({
          translation: {
            x: effectiveTranslation.x + e.deltaX,
            y: effectiveTranslation.y + e.deltaY
          },
          canvasSize: size2,
          compositionHeight: contentDimensions.height,
          compositionWidth: contentDimensions.width,
          scale
        })
      };
    });
  }, [editorZoomGestures, contentDimensions, isFit, setSize, size2]);
  useEffect32(() => {
    const { current } = canvasRef;
    if (!current) {
      return;
    }
    current.addEventListener("wheel", onWheel, { passive: false });
    return () => current.removeEventListener("wheel", onWheel, {
      passive: false
    });
  }, [onWheel]);
  const onReset = useCallback37(() => {
    setSize(() => {
      return {
        translation: {
          x: 0,
          y: 0
        },
        size: "auto"
      };
    });
  }, [setSize]);
  const onZoomIn = useCallback37(() => {
    if (!contentDimensions || contentDimensions === "none") {
      return;
    }
    if (!size2) {
      return;
    }
    setSize((prevSize) => {
      const scale = Internals22.calculateScale({
        canvasSize: size2,
        compositionHeight: contentDimensions.height,
        compositionWidth: contentDimensions.width,
        previewSize: prevSize.size
      });
      return {
        translation: {
          x: 0,
          y: 0
        },
        size: Math.min(MAX_ZOOM, scale * 2)
      };
    });
  }, [contentDimensions, setSize, size2]);
  const onZoomOut = useCallback37(() => {
    if (!contentDimensions || contentDimensions === "none") {
      return;
    }
    if (!size2) {
      return;
    }
    setSize((prevSize) => {
      const scale = Internals22.calculateScale({
        canvasSize: size2,
        compositionHeight: contentDimensions.height,
        compositionWidth: contentDimensions.width,
        previewSize: prevSize.size
      });
      return {
        translation: {
          x: 0,
          y: 0
        },
        size: Math.max(MIN_ZOOM, scale / 2)
      };
    });
  }, [contentDimensions, setSize, size2]);
  useEffect32(() => {
    const resetBinding = keybindings2.registerKeybinding({
      event: "keydown",
      key: "0",
      commandCtrlKey: false,
      callback: onReset,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const zoomIn = keybindings2.registerKeybinding({
      event: "keydown",
      key: "+",
      commandCtrlKey: false,
      callback: onZoomIn,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const zoomOut = keybindings2.registerKeybinding({
      event: "keydown",
      key: "-",
      commandCtrlKey: false,
      callback: onZoomOut,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      resetBinding.unregister();
      zoomIn.unregister();
      zoomOut.unregister();
    };
  }, [keybindings2, onReset, onZoomIn, onZoomOut]);
  const fetchMetadata = useCallback37(async () => {
    setAssetResolution(null);
    if (canvasContent.type === "composition") {
      return;
    }
    const metadata = await getAssetMetadata(canvasContent);
    setAssetResolution(metadata);
  }, [canvasContent]);
  useEffect32(() => {
    fetchMetadata();
  }, [fetchMetadata]);
  return jsxs36(Fragment16, {
    children: [
      jsxs36("div", {
        ref: canvasRef,
        style: container17,
        children: [
          size2 ? jsx83(VideoPreview, {
            canvasContent,
            contentDimensions,
            canvasSize: size2,
            assetMetadata: assetResolution,
            isRefreshing
          }) : null,
          isFit ? null : jsx83("div", {
            style: resetZoom,
            className: "css-reset",
            children: jsx83(ResetZoomButton, {
              onClick: onReset
            })
          }),
          editorShowGuides && canvasContent.type === "composition" && jsx83(EditorGuides_default, {
            canvasSize: size2,
            contentDimensions,
            assetMetadata: assetResolution
          })
        ]
      }),
      areRulersVisible && jsx83(EditorRulers, {
        contentDimensions,
        canvasSize: size2,
        assetMetadata: assetResolution,
        containerRef: canvasRef
      })
    ]
  });
};

// src/components/FramePersistor.tsx
import {useEffect as useEffect33} from "react";
import {Internals as Internals23, useVideoConfig as useVideoConfig2} from "remotion";
var FramePersistor = () => {
  const [playing] = Internals23.Timeline.usePlayingState();
  const config = useVideoConfig2();
  const frame2 = Internals23.Timeline.useTimelinePosition();
  const setFrame = Internals23.useTimelineSetFrame();
  useEffect33(() => {
    if (!playing) {
      setFrame((f) => {
        const newObj = { ...f, [config.id]: frame2 };
        Internals23.persistCurrentFrame(newObj);
        return newObj;
      });
    }
  }, [config.id, frame2, playing, setFrame]);
  return null;
};

// src/components/RefreshCompositionOverlay.tsx
import {AbsoluteFill} from "remotion";

// src/components/RunningCalculateMetadata.tsx
import {
jsx as jsx84,
jsxs as jsxs37
} from "react/jsx-runtime";
var loaderLabel = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var container18 = {
  backgroundColor: BACKGROUND,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row",
  padding: 20
};
var RunningCalculateMetadata = () => {
  return jsxs37("div", {
    style: container18,
    children: [
      jsx84(Spinner, {
        size: 24,
        duration: 1
      }),
      jsx84(Spacing, {
        x: 2
      }),
      jsxs37("div", {
        style: loaderLabel,
        children: [
          "Running ",
          jsx84("code", {
            style: inlineCodeSnippet,
            children: "calculateMetadata()"
          }),
          "..."
        ]
      })
    ]
  });
};

// src/components/RefreshCompositionOverlay.tsx
import {
jsx as jsx85
} from "react/jsx-runtime";
var container19 = {
  justifyContent: "flex-end",
  alignItems: "flex-start",
  padding: 20,
  pointerEvents: "none"
};
var shadow = {
  boxShadow: "0 0 4px black"
};
var RefreshCompositionOverlay = () => {
  return jsx85(AbsoluteFill, {
    style: container19,
    children: jsx85("div", {
      style: shadow,
      children: jsx85(RunningCalculateMetadata, {})
    })
  });
};

// src/components/CanvasOrLoading.tsx
import {
jsx as jsx86,
jsxs as jsxs38,
Fragment as Fragment17
} from "react/jsx-runtime";
var container20 = {
  color: "white",
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  backgroundColor: BACKGROUND,
  flexDirection: "column"
};
var CanvasOrLoading = ({ size: size2 }) => {
  const resolved = Internals24.useResolvedVideoConfig(null);
  const { setZoom } = useContext27(TimelineZoomCtx);
  const { canvasContent } = useContext27(Internals24.CompositionManager);
  useEffect34(() => {
    if (resolved?.type !== "success" && resolved?.type !== "success-and-refreshing") {
      return;
    }
    const c = resolved.result;
    setTimeout(() => {
      ensureFrameIsInViewport({
        direction: "center",
        frame: getCurrentFrame(),
        durationInFrames: c.durationInFrames
      });
    });
  }, [resolved, setZoom]);
  if (!canvasContent) {
    const compname = window.location.pathname.replace("/", "");
    return jsx86("div", {
      style: container20,
      className: "css-reset",
      children: jsxs38("div", {
        style: loaderLabel,
        children: [
          "Composition with ID ",
          compname,
          " not found."
        ]
      })
    });
  }
  const content = jsxs38(Fragment17, {
    children: [
      jsx86(ZoomPersistor, {}),
      jsx86(Canvas, {
        isRefreshing: resolved?.type === "success-and-refreshing",
        size: size2,
        canvasContent
      }),
      resolved?.type === "success-and-refreshing" ? jsx86(RefreshCompositionOverlay, {}) : null
    ]
  });
  if (canvasContent.type === "asset" || canvasContent.type === "output") {
    return content;
  }
  if (!resolved) {
    return null;
  }
  if (resolved.type === "loading") {
    return jsx86("div", {
      style: container20,
      className: "css-reset",
      children: jsx86(RunningCalculateMetadata, {})
    });
  }
  if (resolved.type === "error") {
    return jsx86(ErrorLoading, {
      error: resolved.error
    });
  }
  return jsxs38(Fragment17, {
    children: [
      jsx86(FramePersistor, {}),
      " ",
      content
    ]
  });
};
var loaderContainer = {
  marginLeft: "auto",
  marginRight: "auto",
  width: "100%",
  position: "absolute",
  height: "100%",
  overflowY: "auto"
};
var ErrorLoading = ({ error }) => {
  return jsx86("div", {
    style: loaderContainer,
    children: jsx86(ErrorLoader, {
      canHaveDismissButton: false,
      keyboardShortcuts: false,
      error,
      onRetry: () => Internals24.resolveCompositionsRef.current?.reloadCurrentlySelectedComposition(),
      calculateMetadata: true
    }, error.stack)
  });
};

// src/components/CurrentCompositionSideEffects.tsx
import {useCallback as useCallback38, useContext as useContext28, useEffect as useEffect35} from "react";
import {Internals as Internals25} from "remotion";

// src/helpers/document-title.ts
import {NoReactInternals as NoReactInternals7} from "remotion/no-react";
var currentItemName = null;
var unsavedProps = false;
var tabInactive = false;
var renderJobs = [];
var setCurrentCanvasContentId = (id) => {
  if (!id) {
    currentItemName = id;
    updateTitle();
    return;
  }
  const idWithoutFolder = id.split("/").pop();
  currentItemName = idWithoutFolder;
  updateTitle();
};
var setUnsavedProps = (unsaved) => {
  window.remotion_unsavedProps = unsaved;
  unsavedProps = unsaved;
};
var setRenderJobs = (jobs) => {
  renderJobs = jobs;
  updateTitle();
};
document.addEventListener("visibilitychange", () => {
  tabInactive = document.visibilityState === "hidden";
  updateTitle();
});
var productName = "Remotion Studio";
var suffix = `- ${productName}`;
var updateTitle = () => {
  if (!currentItemName) {
    document.title = productName;
    return;
  }
  const currentCompTitle = `${currentItemName} / ${window.remotion_projectName}`;
  document.title = [
    getProgressInBrackets(currentItemName, renderJobs),
    unsavedProps && tabInactive ? "\u270F\uFE0F" : null,
    `${currentCompTitle} ${suffix}`
  ].filter(NoReactInternals7.truthy).join(" ");
};
var getProgressInBrackets = (selectedCompositionId, jobs) => {
  const currentRender = jobs.find((job) => job.status === "running");
  if (!currentRender) {
    return null;
  }
  if (currentRender.status !== "running") {
    throw new Error("expected running job");
  }
  const progInPercent = Math.ceil(currentRender.progress.value * 100);
  const progressInBrackets = currentRender.compositionId === selectedCompositionId ? `[${progInPercent}%]` : `[${progInPercent}% ${currentRender.compositionId}]`;
  return progressInBrackets;
};
document.addEventListener("visibilitychange", () => {
  tabInactive = document.visibilityState === "hidden";
  updateTitle();
});

// src/components/CurrentCompositionSideEffects.tsx
var TitleUpdater = () => {
  const renderQueue = useContext28(RenderQueueContext);
  const { canvasContent } = useContext28(Internals25.CompositionManager);
  const { jobs } = renderQueue;
  useEffect35(() => {
    if (!canvasContent) {
      setCurrentCanvasContentId(null);
      return;
    }
    if (canvasContent.type === "composition") {
      setCurrentCanvasContentId(canvasContent.compositionId);
      return;
    }
    if (canvasContent.type === "output") {
      setCurrentCanvasContentId(canvasContent.path);
      return;
    }
    setCurrentCanvasContentId(canvasContent.asset);
  }, [canvasContent]);
  useEffect35(() => {
    setRenderJobs(jobs);
  }, [jobs]);
  return null;
};
var CurrentCompositionKeybindings = ({ readOnlyStudio }) => {
  const keybindings2 = useKeybinding();
  const video2 = Internals25.useVideo();
  const { type } = useContext28(StudioServerConnectionCtx).previewServerState;
  const openRenderModal = useCallback38(() => {
    if (!video2) {
      return;
    }
    if (readOnlyStudio) {
      return showNotification("Studio is read-only", 2000);
    }
    if (type !== "connected") {
      showNotification("Studio server is offline", 2000);
      return;
    }
    const renderButton = document.getElementById("render-modal-button");
    renderButton.click();
  }, [readOnlyStudio, type, video2]);
  useEffect35(() => {
    const binding = keybindings2.registerKeybinding({
      event: "keydown",
      key: "r",
      commandCtrlKey: false,
      callback: openRenderModal,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      binding.unregister();
    };
  }, [keybindings2, openRenderModal]);
  return null;
};

// src/components/MobilePanel.tsx
import ReactDOM6 from "react-dom";

// src/components/NewComposition/CancelButton.tsx
import {
jsx as jsx87
} from "react/jsx-runtime";
var style5 = {
  appearance: "none",
  border: "none",
  backgroundColor: "transparent",
  color: "white",
  cursor: "pointer",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center"
};
var CancelButton = ({ onPress, ...props }) => {
  const { tabIndex } = useZIndex();
  return jsx87("button", {
    tabIndex,
    style: style5,
    type: "button",
    onClick: onPress,
    children: jsx87("svg", {
      viewBox: "0 0 320 512",
      ...props,
      children: jsx87("path", {
        fill: "currentColor",
        d: "M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"
      })
    })
  });
};

// src/components/MobilePanel.tsx
import {
jsx as jsx88,
jsxs as jsxs39
} from "react/jsx-runtime";
var container21 = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  padding: "0 0px 50px 0px",
  background: BACKGROUND
};
var buttonContainer = {
  height: "40px",
  width: "100%",
  alignItems: "center",
  display: "flex",
  justifyContent: "flex-end"
};
var button2 = {
  height: 20,
  width: 20
};
function MobilePanel({
  children,
  onClose
}) {
  const { currentZIndex } = useZIndex();
  return ReactDOM6.createPortal(jsxs39("div", {
    style: container21,
    children: [
      jsx88("div", {
        style: buttonContainer,
        children: jsx88(CancelButton, {
          style: button2,
          onPress: onClose
        })
      }),
      children
    ]
  }), getPortal(currentZIndex));
}

// src/components/OptionsPanel.tsx
import {
createRef as createRef8,
useCallback as useCallback73,
useContext as useContext41,
useEffect as useEffect45,
useImperativeHandle as useImperativeHandle11,
useMemo as useMemo81,
useState as useState47
} from "react";
import {Internals as Internals34} from "remotion";

// src/components/GlobalPropsEditorUpdateButton.tsx
import React59, {useCallback as useCallback41, useContext as useContext29} from "react";
import {Internals as Internals27} from "remotion";

// src/components/RenderModal/SchemaEditor/extract-enum-json-paths.ts
var extractEnumJsonPaths = (schema, zodRuntime, currentPath) => {
  const def = schema._def;
  const typeName = def.typeName;
  switch (typeName) {
    case zodRuntime.ZodFirstPartyTypeKind.ZodObject: {
      const shape = def.shape();
      const keys = Object.keys(shape);
      return keys.map((key) => {
        return extractEnumJsonPaths(shape[key], zodRuntime, [
          ...currentPath,
          key
        ]);
      }).flat(1);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodArray: {
      return extractEnumJsonPaths(def.type, zodRuntime, [
        ...currentPath,
        "[]"
      ]);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodUnion: {
      return def.options.map((option) => {
        return extractEnumJsonPaths(option, zodRuntime, currentPath);
      }).flat(1);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodDiscriminatedUnion: {
      return def.options.map((op) => {
        return extractEnumJsonPaths(op, zodRuntime, currentPath);
      }).flat(1);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodLiteral: {
      return [currentPath];
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodEffects: {
      return extractEnumJsonPaths(def.schema, zodRuntime, currentPath);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodIntersection: {
      const { left: left3, right } = def;
      const leftValue = extractEnumJsonPaths(left3, zodRuntime, currentPath);
      const rightValue = extractEnumJsonPaths(right, zodRuntime, currentPath);
      return [...leftValue, ...rightValue];
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodTuple: {
      return def.items.map((item, i) => extractEnumJsonPaths(item, zodRuntime, [...currentPath, i])).flat(1);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodRecord: {
      const values = extractEnumJsonPaths(def.valueType, zodRuntime, [...currentPath, "{}"]);
      return values;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodFunction: {
      throw new Error("Cannot create a value for type function");
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodEnum: {
      return [currentPath];
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodNativeEnum: {
      return [];
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodOptional: {
      const defType = def;
      const value = extractEnumJsonPaths(defType.innerType, zodRuntime, currentPath);
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodNullable: {
      const defType = def;
      const value = extractEnumJsonPaths(defType.innerType, zodRuntime, currentPath);
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodDefault: {
      const defType = def;
      return extractEnumJsonPaths(defType.innerType, zodRuntime, currentPath);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodCatch: {
      const defType = def;
      return extractEnumJsonPaths(defType.innerType, zodRuntime, currentPath);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodPromise: {
      return [];
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodBranded: {
      const defType = def;
      const value = extractEnumJsonPaths(defType.type, zodRuntime, currentPath);
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodPipeline: {
      const defType = def;
      const value = extractEnumJsonPaths(defType.out, zodRuntime, currentPath);
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodString:
    case zodRuntime.ZodFirstPartyTypeKind.ZodNumber:
    case zodRuntime.ZodFirstPartyTypeKind.ZodBigInt:
    case zodRuntime.ZodFirstPartyTypeKind.ZodBoolean:
    case zodRuntime.ZodFirstPartyTypeKind.ZodNaN:
    case zodRuntime.ZodFirstPartyTypeKind.ZodDate:
    case zodRuntime.ZodFirstPartyTypeKind.ZodSymbol:
    case zodRuntime.ZodFirstPartyTypeKind.ZodUndefined:
    case zodRuntime.ZodFirstPartyTypeKind.ZodNull:
    case zodRuntime.ZodFirstPartyTypeKind.ZodAny:
    case zodRuntime.ZodFirstPartyTypeKind.ZodUnknown:
    case zodRuntime.ZodFirstPartyTypeKind.ZodNever:
    case zodRuntime.ZodFirstPartyTypeKind.ZodVoid:
    case zodRuntime.ZodFirstPartyTypeKind.ZodMap:
    case zodRuntime.ZodFirstPartyTypeKind.ZodLazy:
    case zodRuntime.ZodFirstPartyTypeKind.ZodSet: {
      return [];
    }
    default:
      throw new Error("Not implemented: " + typeName);
  }
};

// src/api/helpers/calc-new-props.ts
import {Internals as Internals26, getRemotionEnvironment} from "remotion";
var calcNewProps = (compositionId, defaultProps) => {
  if (!getRemotionEnvironment().isStudio) {
    throw new Error("saveDefaultProps can only be called in the Remotion Studio.");
  }
  const { compositionsRef, editorPropsProviderRef } = Internals26;
  const compositionsStore = compositionsRef.current;
  if (!compositionsStore) {
    throw new Error("No compositions ref found. Are you in the Remotion Studio and are the Remotion versions aligned?");
  }
  const compositions = compositionsStore.getCompositions();
  const composition = compositions.find((c) => c.id === compositionId);
  if (!composition) {
    throw new Error(`No composition with the ID ${compositionId} found. Available compositions: ${compositions.map((c) => c.id).join(", ")}`);
  }
  const propsStore = editorPropsProviderRef.current;
  if (!propsStore) {
    throw new Error("No props store found. Are you in the Remotion Studio and are the Remotion versions aligned?");
  }
  const savedDefaultProps = composition.defaultProps ?? {};
  const unsavedDefaultProps = propsStore.getProps()[compositionId] ?? savedDefaultProps;
  const generatedDefaultProps = defaultProps({
    schema: composition.schema,
    savedDefaultProps,
    unsavedDefaultProps
  });
  return {
    composition,
    generatedDefaultProps
  };
};

// src/api/save-default-props.ts
var saveDefaultProps = async ({
  compositionId,
  defaultProps
}) => {
  try {
    await import("zod");
  } catch {
    throw new Error('"zod" is required to use saveDefaultProps(), but is not installed.');
  }
  const z = await import("zod");
  const { generatedDefaultProps, composition } = calcNewProps(compositionId, defaultProps);
  const res = await callUpdateDefaultPropsApi(compositionId, generatedDefaultProps, composition.schema ? extractEnumJsonPaths(composition.schema, z, []) : []);
  if (res.success) {
    return Promise.resolve();
  }
  const err = new Error(res.reason);
  err.stack = res.stack;
  return Promise.reject(err);
};

// src/components/RenderModal/SchemaEditor/SchemaResetButton.tsx
import {useCallback as useCallback39} from "react";
import {
jsx as jsx89
} from "react/jsx-runtime";
var icon = {
  height: 14,
  color: "currentColor"
};
var SchemaResetButton = ({ onClick }) => {
  const renderAction = useCallback39((color) => {
    return jsx89("svg", {
      style: icon,
      viewBox: "0 0 512 512",
      children: jsx89("path", {
        fill: color,
        d: "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"
      })
    });
  }, []);
  return jsx89(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderModal/SchemaEditor/SchemaSaveButton.tsx
import {useCallback as useCallback40} from "react";
import {
jsx as jsx90
} from "react/jsx-runtime";
var icon2 = {
  height: 14,
  color: "currentColor"
};
var SchemaSaveButton = ({ onClick, disabled }) => {
  const renderAction = useCallback40((color) => {
    return jsx90("svg", {
      style: icon2,
      viewBox: "0 0 448 512",
      children: jsx90("path", {
        fill: disabled ? LIGHT_TEXT : color,
        d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
      })
    });
  }, [disabled]);
  return jsx90(InlineAction, {
    renderAction,
    onClick,
    disabled
  });
};

// src/components/GlobalPropsEditorUpdateButton.tsx
import {
jsx as jsx91,
jsxs as jsxs40
} from "react/jsx-runtime";
var container22 = {
  display: "inline-block",
  flexDirection: "row"
};
var GlobalPropsEditorUpdateButton = ({ compositionId, currentDefaultProps }) => {
  const { fastRefreshes } = useContext29(Internals27.NonceContext);
  const [disabled, setDisabled] = React59.useState(false);
  const onClicked = useCallback41(() => {
    setDisabled(true);
    window.remotion_ignoreFastRefreshUpdate = fastRefreshes + 1;
    saveDefaultProps({
      compositionId,
      defaultProps: () => currentDefaultProps
    }).catch((err) => {
      showNotification(`Cannot update default props: ${err.stack}`, 2000);
    }).finally(() => {
      setDisabled(true);
    });
  }, [compositionId, currentDefaultProps, fastRefreshes]);
  const onReset = useCallback41(() => {
    window.remotion_ignoreFastRefreshUpdate = null;
    window.dispatchEvent(new CustomEvent(Internals27.PROPS_UPDATED_EXTERNALLY));
  }, []);
  return jsxs40("div", {
    style: container22,
    children: [
      jsx91(SchemaResetButton, {
        onClick: onReset
      }),
      jsx91(SchemaSaveButton, {
        disabled,
        onClick: onClicked
      })
    ]
  });
};

// src/components/RenderModal/DataEditor.tsx
import React88, {
useCallback as useCallback63,
useContext as useContext33,
useEffect as useEffect42,
useMemo as useMemo72,
useState as useState45
} from "react";
import {Internals as Internals30, getInputProps} from "remotion";
import {NoReactInternals as NoReactInternals10} from "remotion/no-react";

// src/components/NewComposition/ValidationMessage.tsx
import {useMemo as useMemo49} from "react";
import {
jsx as jsx92,
jsxs as jsxs41
} from "react/jsx-runtime";
var WarningTriangle = (props) => {
  return jsx92("svg", {
    viewBox: "0 0 576 512",
    ...props,
    children: jsx92("path", {
      d: "M248.747 204.705l6.588 112c.373 6.343 5.626 11.295 11.979 11.295h41.37a12 12 0 0 0 11.979-11.295l6.588-112c.405-6.893-5.075-12.705-11.979-12.705h-54.547c-6.903 0-12.383 5.812-11.978 12.705zM330 384c0 23.196-18.804 42-42 42s-42-18.804-42-42 18.804-42 42-42 42 18.804 42 42zm-.423-360.015c-18.433-31.951-64.687-32.009-83.154 0L6.477 440.013C-11.945 471.946 11.118 512 48.054 512H527.94c36.865 0 60.035-39.993 41.577-71.987L329.577 23.985zM53.191 455.002L282.803 57.008c2.309-4.002 8.085-4.002 10.394 0l229.612 397.993c2.308 4-.579 8.998-5.197 8.998H58.388c-4.617.001-7.504-4.997-5.197-8.997z"
    })
  });
};
var style6 = {
  width: 12,
  height: 12,
  flexShrink: 0
};
var container23 = {
  maxWidth: 500
};
var label4 = {
  fontSize: 13,
  color: "white",
  fontFamily: "sans-serif"
};
var ValidationMessage = ({ message, align, type }) => {
  const finalStyle = useMemo49(() => {
    return {
      ...style6,
      fill: type === "warning" ? WARNING_COLOR : FAIL_COLOR
    };
  }, [type]);
  return jsx92("div", {
    style: container23,
    children: jsxs41(Row, {
      align: "center",
      justify: align,
      children: [
        jsx92(WarningTriangle, {
          style: finalStyle
        }),
        jsx92(Spacing, {
          x: 1
        }),
        jsx92("div", {
          style: label4,
          children: message
        })
      ]
    })
  });
};

// src/components/SegmentedControl.tsx
import {useCallback as useCallback42, useMemo as useMemo50, useState as useState35} from "react";
import {
jsx as jsx93
} from "react/jsx-runtime";
var container24 = {
  display: "flex",
  flexDirection: "row",
  overflow: "hidden",
  border: "1px solid " + INPUT_BORDER_COLOR_UNHOVERED,
  flexWrap: "wrap",
  maxWidth: 350,
  justifyContent: "flex-end"
};
var item = {
  display: "flex",
  fontSize: 15,
  padding: "4px 12px",
  cursor: "pointer",
  appearance: "none",
  border: "none",
  flex: 1,
  justifyContent: "center",
  whiteSpace: "nowrap"
};
var SegmentedControl = ({ items, needsWrapping }) => {
  const controlStyle = useMemo50(() => {
    if (needsWrapping) {
      return {
        ...container24,
        flexWrap: "wrap",
        maxWidth: "248px",
        justifyContent: "flex-end",
        marginBottom: "8px"
      };
    }
    return {
      ...container24
    };
  }, [needsWrapping]);
  return jsx93("div", {
    style: controlStyle,
    children: items.map((i) => {
      return jsx93(Item, {
        onClick: i.onClick,
        selected: i.selected,
        children: i.label
      }, i.key);
    })
  });
};
var Item = ({ selected, onClick, children }) => {
  const [hovered, setHovered] = useState35(false);
  const { tabIndex } = useZIndex();
  const onPointerEnter = useCallback42(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback42(() => {
    setHovered(false);
  }, []);
  const itemStyle3 = useMemo50(() => {
    return {
      ...item,
      backgroundColor: selected ? INPUT_BACKGROUND : "transparent",
      color: selected ? "white" : hovered ? "white" : LIGHT_TEXT
    };
  }, [hovered, selected]);
  return jsx93("button", {
    type: "button",
    onPointerEnter,
    onPointerLeave,
    style: itemStyle3,
    tabIndex,
    onClick,
    children
  });
};

// src/components/get-zod-if-possible.tsx
import {
createContext as createContext14,
useContext as useContext30,
useEffect as useEffect36,
useMemo as useMemo51,
useState as useState36
} from "react";
import {
jsx as jsx94
} from "react/jsx-runtime";
var getZodIfPossible = async () => {
  try {
    const { z } = await import("zod");
    return z;
  } catch (err) {
    return null;
  }
};
var getZTypesIfPossible = async () => {
  try {
    const mod = await import("@remotion/zod-types");
    return mod;
  } catch (err) {
    return null;
  }
};
var useZodIfPossible = () => {
  const context3 = useContext30(ZodContext);
  return context3?.zod ?? null;
};
var useZodTypesIfPossible = () => {
  const context3 = useContext30(ZodContext);
  return context3?.zodTypes ?? null;
};
var ZodContext = createContext14(null);
var ZodProvider = ({ children }) => {
  const [zod, setZod] = useState36(null);
  const [zodTypes, setZodTypes] = useState36(null);
  useEffect36(() => {
    getZodIfPossible().then((z) => setZod(z));
  }, []);
  useEffect36(() => {
    getZTypesIfPossible().then((z) => setZodTypes(z));
  }, []);
  const contextValue = useMemo51(() => {
    return {
      zod,
      zodTypes
    };
  }, [zod, zodTypes]);
  return jsx94(ZodContext.Provider, {
    value: contextValue,
    children
  });
};

// src/components/RenderModal/RenderModalJSONPropsEditor.tsx
import React64, {useCallback as useCallback43, useEffect as useEffect37, useMemo as useMemo53} from "react";
import {NoReactInternals as NoReactInternals8} from "remotion/no-react";

// src/components/RenderModal/SchemaEditor/ZodErrorMessages.tsx
import {useMemo as useMemo52} from "react";
import {
jsx as jsx95,
jsxs as jsxs42
} from "react/jsx-runtime";
var schemaLabel = {
  fontSize: 14,
  color: LIGHT_TEXT
};
var jsonLabel = {
  color: "white",
  fontSize: 13,
  fontFamily: "sans-serif",
  display: "flex",
  alignItems: "center"
};
var triangleStyle = {
  width: 12,
  height: 12,
  flexShrink: 0,
  fill: FAIL_COLOR
};
var ZodErrorMessages = ({ zodValidationResult, viewTab }) => {
  if (zodValidationResult.success) {
    throw new Error("Expected error");
  }
  const style7 = useMemo52(() => {
    return viewTab === "json" ? jsonLabel : schemaLabel;
  }, [viewTab]);
  const code = useMemo52(() => {
    return {
      ...schemaLabel,
      fontFamily: "monospace"
    };
  }, []);
  if (viewTab === "json") {
    return jsx95("div", {
      children: zodValidationResult.error.errors.map((error) => {
        return jsxs42("div", {
          style: style7,
          children: [
            jsx95(WarningTriangle, {
              style: triangleStyle
            }),
            jsx95(Spacing, {
              x: 1
            }),
            error.path.length === 0 ? "Root" : error.path.join("."),
            ":",
            " ",
            error.message
          ]
        }, error.path.join("."));
      })
    });
  }
  return jsx95("div", {
    children: zodValidationResult.error.errors.map((error) => {
      return jsxs42("div", {
        style: style7,
        children: [
          "-",
          " ",
          jsx95("code", {
            style: code,
            children: error.path.length === 0 ? "Root" : error.path.join(".")
          }),
          ": ",
          error.message
        ]
      }, error.path.join("."));
    })
  });
};

// src/components/RenderModal/SchemaEditor/deep-equal.ts
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }
  if (typeof a !== "object" || a === null || typeof b !== "object" || b === null) {
    return false;
  }
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) {
    return false;
  }
  for (const key of keysA) {
    if (!keysB.includes(key) || !deepEqual(a[key], b[key])) {
      return false;
    }
  }
  return true;
}

// src/components/RenderModal/RenderModalJSONPropsEditor.tsx
import {
jsx as jsx96,
jsxs as jsxs43
} from "react/jsx-runtime";
var style7 = {
  fontFamily: "monospace",
  flex: 1
};
var scrollable = {
  padding: "8px 12px",
  display: "flex",
  flexDirection: "column",
  flex: 1
};
var parseJSON = (str, schema) => {
  try {
    const value = NoReactInternals8.deserializeJSONWithCustomFields(str);
    const zodValidation = schema.safeParse(value);
    return { str, value, validJSON: true, zodValidation };
  } catch (e) {
    return { str, validJSON: false, error: e.message };
  }
};
var RenderModalJSONPropsEditor = ({
  setValue,
  value,
  defaultProps,
  onSave,
  showSaveButton,
  serializedJSON,
  schema
}) => {
  if (serializedJSON === null) {
    throw new Error("expecting serializedJSON to be defined");
  }
  const keybindings2 = useKeybinding();
  const [localValue, setLocalValue] = React64.useState(() => {
    return parseJSON(serializedJSON.serializedString, schema);
  });
  const onPretty = useCallback43(() => {
    if (!localValue.validJSON) {
      return;
    }
    const parsed = JSON.parse(localValue.str);
    setLocalValue({ ...localValue, str: JSON.stringify(parsed, null, 2) });
  }, [localValue, setLocalValue]);
  const onChange = useCallback43((e) => {
    const parsed = parseJSON(e.target.value, schema);
    if (parsed.validJSON) {
      const validationResult = schema.safeParse(parsed.value);
      setLocalValue({
        str: e.target.value,
        value: parsed.value,
        validJSON: parsed.validJSON,
        zodValidation: validationResult
      });
      if (validationResult.success) {
        setValue(parsed.value);
      }
    } else {
      setLocalValue({
        str: e.target.value,
        validJSON: parsed.validJSON,
        error: parsed.error
      });
    }
  }, [schema, setValue]);
  const hasChanged = useMemo53(() => {
    return !deepEqual(value, defaultProps);
  }, [defaultProps, value]);
  useEffect37(() => {
    setUnsavedProps(hasChanged);
  }, [hasChanged]);
  const onQuickSave = useCallback43(() => {
    if (hasChanged) {
      onSave();
    }
  }, [hasChanged, onSave]);
  useEffect37(() => {
    setLocalValue(parseJSON(localValue.str, schema));
  }, [localValue.str, schema]);
  useEffect37(() => {
    const save = keybindings2.registerKeybinding({
      event: "keydown",
      key: "s",
      commandCtrlKey: true,
      callback: onQuickSave,
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      save.unregister();
    };
  }, [keybindings2, onQuickSave, onSave]);
  const reset = useCallback43(() => {
    setValue(defaultProps);
    setLocalValue(parseJSON(JSON.stringify(defaultProps, null, 2), schema));
  }, [defaultProps, schema, setValue]);
  const textAreaStyle = useMemo53(() => {
    const fail = !localValue.validJSON || !localValue.zodValidation.success;
    if (!fail) {
      return style7;
    }
    return {
      ...style7,
      borderColor: FAIL_COLOR
    };
  }, [localValue]);
  return jsxs43("div", {
    style: scrollable,
    children: [
      jsx96(RemTextarea, {
        onChange,
        value: localValue.str,
        status: localValue.validJSON ? "ok" : "error",
        style: textAreaStyle
      }),
      jsx96(Spacing, {
        y: 1
      }),
      localValue.validJSON === false ? jsx96(ValidationMessage, {
        align: "flex-start",
        message: localValue.error,
        type: "error"
      }) : localValue.zodValidation.success === false ? jsx96(ZodErrorMessages, {
        zodValidationResult: localValue.zodValidation,
        viewTab: "json"
      }) : null,
      jsx96(Spacing, {
        y: 1
      }),
      jsxs43(Row, {
        children: [
          jsx96(Button, {
            disabled: !(hasChanged || !localValue.validJSON),
            onClick: reset,
            children: "Reset"
          }),
          jsx96(Flex, {}),
          jsx96(Button, {
            disabled: !localValue.validJSON,
            onClick: onPretty,
            children: "Format"
          }),
          jsx96(Spacing, {
            x: 1
          }),
          showSaveButton ? jsx96(Button, {
            onClick: onSave,
            disabled: !(localValue.validJSON && localValue.zodValidation.success) || !localValue.validJSON || !hasChanged,
            children: "Save"
          }) : null
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/SchemaEditor.tsx
import {useCallback as useCallback61, useEffect as useEffect41, useMemo as useMemo70, useState as useState44} from "react";
import {Internals as Internals29} from "remotion";

// src/components/RenderModal/SchemaEditor/SchemaErrorMessages.tsx
import {
jsx as jsx97,
jsxs as jsxs44
} from "react/jsx-runtime";
var explainer = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  padding: "0 12px",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center"
};
var errorExplanation = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var codeSnippet = {
  fontSize: 14,
  color: BLUE,
  fontFamily: "monospace"
};
var errorContainer = {
  padding: "8px 12px",
  overflowY: "auto"
};
var openDocs = () => {
  window.open("https://www.remotion.dev/docs/schemas");
};
var ZodNotInstalled = () => {
  return jsxs44("div", {
    style: explainer,
    children: [
      jsxs44("div", {
        style: errorExplanation,
        children: [
          "Install ",
          jsx97("code", {
            style: inlineCodeSnippet,
            children: "zod"
          }),
          " as a dependency to interactively control the props of the composition."
        ]
      }),
      jsx97(Spacing, {
        y: 2,
        block: true
      }),
      jsx97(Button, {
        onClick: openDocs,
        children: "Learn how"
      })
    ]
  });
};
var NoSchemaDefined = () => {
  return jsxs44("div", {
    style: explainer,
    children: [
      jsxs44("div", {
        style: errorExplanation,
        children: [
          "Make the props of this composition interactively editable by adding a",
          " ",
          jsx97("code", {
            style: inlineCodeSnippet,
            children: "schema"
          }),
          " prop to the",
          " ",
          jsx97("code", {
            style: inlineCodeSnippet,
            children: "<Composition>"
          }),
          " component."
        ]
      }),
      jsx97(Spacing, {
        y: 2,
        block: true
      }),
      jsx97(Button, {
        onClick: openDocs,
        children: "Learn how"
      })
    ]
  });
};
var NoDefaultProps = () => {
  return jsxs44("div", {
    style: explainer,
    children: [
      jsxs44("div", {
        style: errorExplanation,
        children: [
          "The schema can not be edited because the",
          " ",
          jsx97("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " prop in the",
          " ",
          jsx97("code", {
            style: inlineCodeSnippet,
            children: "<Composition>"
          }),
          " does not exist."
        ]
      }),
      jsx97(Spacing, {
        y: 1
      }),
      jsxs44("div", {
        style: errorExplanation,
        children: [
          "Fix the schema by adding a",
          " ",
          jsx97("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " prop to your composition."
        ]
      }),
      jsx97(Spacing, {
        y: 2,
        block: true
      }),
      jsx97(Button, {
        onClick: openDocs,
        children: "Learn more"
      })
    ]
  });
};
var InvalidDefaultProps = ({ zodValidationResult }) => {
  return jsxs44("div", {
    style: errorContainer,
    children: [
      jsxs44("div", {
        style: errorExplanation,
        children: [
          "The schema can not be edited because the",
          " ",
          jsx97("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " prop in the",
          " ",
          jsx97("code", {
            style: inlineCodeSnippet,
            children: "<Composition>"
          }),
          " is not valid:"
        ]
      }),
      jsx97(Spacing, {
        y: 1,
        block: true
      }),
      jsx97(ZodErrorMessages, {
        zodValidationResult,
        viewTab: "schema"
      }),
      jsx97(Spacing, {
        y: 1,
        block: true
      }),
      jsxs44("div", {
        style: errorExplanation,
        children: [
          "Fix the schema by changing the",
          " ",
          jsx97("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " prop in your composition so it does not give a type error."
        ]
      })
    ]
  });
};
var InvalidSchema = ({ zodValidationResult, reset }) => {
  return jsxs44("div", {
    style: errorContainer,
    children: [
      jsx97("div", {
        style: errorExplanation,
        children: "The data does not satisfy the schema:"
      }),
      jsx97(Spacing, {
        y: 1,
        block: true
      }),
      jsx97(ZodErrorMessages, {
        zodValidationResult,
        viewTab: "schema"
      }),
      jsx97(Spacing, {
        y: 1,
        block: true
      }),
      jsx97("div", {
        style: errorExplanation,
        children: "Fix the schema using the JSON editor."
      }),
      jsx97(Spacing, {
        y: 1,
        block: true
      }),
      jsxs44("div", {
        style: errorExplanation,
        children: [
          "Alternatively, reset the data to the",
          " ",
          jsx97("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " that you have defined."
        ]
      }),
      jsx97(Spacing, {
        y: 1,
        block: true
      }),
      jsx97(Button, {
        onClick: reset,
        children: "Reset props"
      })
    ]
  });
};
var TopLevelZodValue = ({ typeReceived }) => {
  return jsxs44("div", {
    style: explainer,
    children: [
      jsxs44("div", {
        style: errorExplanation,
        children: [
          "The top-level type of the schema must be a pure",
          " ",
          jsx97("code", {
            style: codeSnippet,
            children: "z.object"
          }),
          ". Instead got a schema of type",
          " ",
          jsx97("code", {
            style: codeSnippet,
            children: typeReceived
          })
        ]
      }),
      jsx97(Spacing, {
        y: 1
      }),
      jsx97("div", {
        style: errorExplanation,
        children: "Fix the schema by changing the top-level Zod type to an object."
      }),
      jsx97(Spacing, {
        y: 2,
        block: true
      }),
      jsx97(Button, {
        onClick: openDocs,
        children: "Learn more"
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodObjectEditor.tsx
import React85, {useMemo as useMemo69, useState as useState43} from "react";

// src/components/RenderModal/layout.ts
var optionRow = {
  display: "flex",
  flexDirection: "row",
  minHeight: 40,
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 8,
  paddingBottom: 8
};
var label5 = {
  width: 220,
  fontSize: 15,
  lineHeight: "40px",
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var rightRow = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  alignSelf: "center",
  flex: 1
};
var input = {
  minWidth: 250
};
var fieldSetText = {
  color: LIGHT_TEXT,
  fontSize: 14,
  fontFamily: "monospace"
};
var fieldsetLabel = {
  ...fieldSetText,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%"
};

// src/components/RenderModal/SchemaEditor/Fieldset.tsx
import {createContext as createContext15, useContext as useContext31, useMemo as useMemo54} from "react";
import {
jsx as jsx98
} from "react/jsx-runtime";
var SCHEMA_EDITOR_FIELDSET_PADDING = 10;
var AlreadyPaddedRightContext = createContext15(false);
var Fieldset = ({ children, shouldPad }) => {
  const alreadyPadded = useContext31(AlreadyPaddedRightContext);
  const style8 = useMemo54(() => {
    if (shouldPad) {
      return {
        padding: SCHEMA_EDITOR_FIELDSET_PADDING,
        paddingTop: SCHEMA_EDITOR_FIELDSET_PADDING / 2,
        paddingRight: alreadyPadded ? 0 : SCHEMA_EDITOR_FIELDSET_PADDING
      };
    }
    return {};
  }, [alreadyPadded, shouldPad]);
  const content = jsx98("div", {
    style: style8,
    children
  });
  if (shouldPad) {
    return jsx98(AlreadyPaddedRightContext.Provider, {
      value: true,
      children: content
    });
  }
  return content;
};

// src/components/RenderModal/SchemaEditor/SchemaLabel.tsx
import {useCallback as useCallback45, useMemo as useMemo55, useState as useState37} from "react";

// src/components/RenderModal/InlineRemoveButton.tsx
import {useCallback as useCallback44} from "react";
import {
jsx as jsx99
} from "react/jsx-runtime";
var clearIcon = {
  height: 14,
  color: "currentColor"
};
var InlineRemoveButton = ({ onClick }) => {
  const renderAction = useCallback44((color) => {
    return jsx99("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 320 512",
      style: clearIcon,
      children: jsx99("path", {
        d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z",
        fill: color
      })
    });
  }, []);
  return jsx99(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderModal/SchemaEditor/get-schema-label.ts
var getSchemaLabel = (jsonPath) => {
  const lastKey = jsonPath[jsonPath.length - 1];
  if (typeof lastKey === "number") {
    const secondLastKey = jsonPath[jsonPath.length - 2];
    if (typeof secondLastKey === "undefined") {
      return `[${lastKey}]:`;
    }
    return `${lastKey}:`;
  }
  return `${lastKey}:`;
};

// src/components/RenderModal/SchemaEditor/scroll-to-default-props-path.ts
import React66 from "react";
var DEFAULT_PROPS_PATH_CLASSNAME = "__remotion-default-props-editor-label";
var DEFAULT_PROPS_PATH_ACTIVE_CLASSNAME = "__remotion-default-props-editor-label-active";
var defaultPropsEditorScrollableAreaRef = React66.createRef();

// src/components/RenderModal/SchemaEditor/SchemaLabel.tsx
import {
jsx as jsx100,
jsxs as jsxs45
} from "react/jsx-runtime";
var compactStyles = {
  fontSize: 15,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  flex: 1
};
var SchemaLabel = ({
  jsonPath,
  isDefaultValue,
  onReset,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  valid,
  saveDisabledByParent,
  suffix: suffix2,
  handleClick
}) => {
  const [clickableButtonHovered, setClickableButtonHovered] = useState37(false);
  const disableSave = saving || !valid || saveDisabledByParent;
  const labelStyle4 = useMemo55(() => {
    return {
      fontFamily: "monospace",
      fontSize: 14,
      color: valid ? clickableButtonHovered ? "white" : LIGHT_TEXT : FAIL_COLOR,
      lineHeight: "24px"
    };
  }, [clickableButtonHovered, valid]);
  const onClickablePointerEnter = useCallback45(() => {
    setClickableButtonHovered(true);
  }, []);
  const onClickablePointerLeave = useCallback45(() => {
    setClickableButtonHovered(false);
  }, []);
  const labelContent = jsxs45("span", {
    style: labelStyle4,
    children: [
      getSchemaLabel(jsonPath),
      " ",
      suffix2 ? suffix2 : null
    ]
  });
  return jsxs45("div", {
    style: compactStyles,
    className: DEFAULT_PROPS_PATH_CLASSNAME,
    "data-json-path": jsonPath.join("."),
    children: [
      handleClick ? jsx100("button", {
        onPointerEnter: onClickablePointerEnter,
        onPointerLeave: onClickablePointerLeave,
        type: "button",
        onClick: handleClick,
        style: { border: "none", marginLeft: -6 },
        children: labelContent
      }) : labelContent,
      jsx100(Flex, {}),
      isDefaultValue ? null : jsx100(SchemaResetButton, {
        onClick: onReset
      }),
      isDefaultValue ? null : showSaveButton ? jsx100(SchemaSaveButton, {
        onClick: onSave,
        disabled: disableSave
      }) : null,
      onRemove ? jsx100(InlineRemoveButton, {
        onClick: onRemove
      }) : null
    ]
  });
};

// src/components/RenderModal/SchemaEditor/SchemaSeparationLine.tsx
import {useCallback as useCallback46, useMemo as useMemo56, useState as useState38} from "react";

// src/icons/plus.tsx
import {
jsx as jsx101
} from "react/jsx-runtime";
var Plus = ({ color, ...props }) => {
  return jsx101("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: jsx101("path", {
      fill: color,
      d: "M432 256c0 17.69-14.33 32.01-32 32.01H256v144c0 17.69-14.33 31.99-32 31.99s-32-14.3-32-31.99v-144H48c-17.67 0-32-14.32-32-32.01s14.33-31.99 32-31.99H192v-144c0-17.69 14.33-32.01 32-32.01s32 14.32 32 32.01v144h144C417.7 224 432 238.3 432 256z"
    })
  });
};

// src/components/RenderModal/SchemaEditor/create-zod-values.ts
var createZodValues = (schema, zodRuntime, zodTypes) => {
  if (!schema) {
    throw new Error("Invalid zod schema");
  }
  const def = schema._def;
  const typeName = def.typeName;
  switch (typeName) {
    case zodRuntime.ZodFirstPartyTypeKind.ZodString:
      return "";
    case zodRuntime.ZodFirstPartyTypeKind.ZodNumber:
      return 0;
    case zodRuntime.ZodFirstPartyTypeKind.ZodBigInt:
      return BigInt(0);
    case zodRuntime.ZodFirstPartyTypeKind.ZodBoolean:
      return false;
    case zodRuntime.ZodFirstPartyTypeKind.ZodNaN:
      return NaN;
    case zodRuntime.ZodFirstPartyTypeKind.ZodDate:
      return new Date;
    case zodRuntime.ZodFirstPartyTypeKind.ZodSymbol:
      return Symbol("remotion");
    case zodRuntime.ZodFirstPartyTypeKind.ZodUndefined:
      return;
    case zodRuntime.ZodFirstPartyTypeKind.ZodNull:
      return null;
    case zodRuntime.ZodFirstPartyTypeKind.ZodAny:
      throw new Error("Cannot create a value for type z.any()");
    case zodRuntime.ZodFirstPartyTypeKind.ZodUnknown:
      throw new Error("Cannot create a value for type z.unknown()");
    case zodRuntime.ZodFirstPartyTypeKind.ZodNever:
      throw new Error("Cannot create a value for type z.never()");
    case zodRuntime.ZodFirstPartyTypeKind.ZodVoid:
      return;
    case zodRuntime.ZodFirstPartyTypeKind.ZodObject: {
      const shape = def.shape();
      const keys = Object.keys(shape);
      const returnValue = keys.reduce((existing, key) => {
        existing[key] = createZodValues(shape[key], zodRuntime, zodTypes);
        return existing;
      }, {});
      return returnValue;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodArray: {
      return [
        createZodValues(def.type, zodRuntime, zodTypes)
      ];
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodUnion: {
      const firstOptions = def.options[0];
      return firstOptions ? createZodValues(firstOptions, zodRuntime, zodTypes) : undefined;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodDiscriminatedUnion: {
      const options = def.options[0];
      return createZodValues(options, zodRuntime, zodTypes);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodLiteral: {
      return def.value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodEffects: {
      if (zodTypes && schema._def.description === zodTypes.ZodZypesInternals.REMOTION_COLOR_BRAND) {
        return "#ffffff";
      }
      if (zodTypes && schema._def.description === zodTypes.ZodZypesInternals.REMOTION_TEXTAREA_BRAND) {
        return "";
      }
      return createZodValues(def.schema, zodRuntime, zodTypes);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodIntersection: {
      const { left: left3, right } = def;
      const leftValue = createZodValues(left3, zodRuntime, zodTypes);
      if (typeof leftValue !== "object") {
        throw new Error("Cannot create value for type z.intersection: Left side is not an object");
      }
      const rightValue = createZodValues(right, zodRuntime, zodTypes);
      if (typeof rightValue !== "object") {
        throw new Error("Cannot create value for type z.intersection: Right side is not an object");
      }
      return { ...leftValue, ...rightValue };
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodTuple: {
      const items = def.items.map((item2) => createZodValues(item2, zodRuntime, zodTypes));
      return items;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodRecord: {
      const values = createZodValues(def.valueType, zodRuntime, zodTypes);
      return { key: values };
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodMap: {
      const defType = def;
      const values = createZodValues(defType.valueType, zodRuntime, zodTypes);
      const key = createZodValues(defType.keyType, zodRuntime, zodTypes);
      return new Map([[key, values]]);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodLazy: {
      const defType = def;
      const type = defType.getter();
      return createZodValues(type, zodRuntime, zodTypes);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodSet: {
      const defType = def;
      const values = createZodValues(defType.valueType, zodRuntime, zodTypes);
      return new Set([values]);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodFunction: {
      throw new Error("Cannot create a value for type function");
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodEnum: {
      const { values } = def;
      return values[0];
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodNativeEnum: {
      return 0;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodOptional: {
      const defType = def;
      const value = createZodValues(defType.innerType, zodRuntime, zodTypes);
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodNullable: {
      const defType = def;
      const value = createZodValues(defType.innerType, zodRuntime, zodTypes);
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodDefault: {
      const defType = def;
      return defType.defaultValue();
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodCatch: {
      const defType = def;
      const value = createZodValues(defType.innerType, zodRuntime, zodTypes);
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodPromise: {
      const defType = def;
      const value = createZodValues(defType.type, zodRuntime, zodTypes);
      return Promise.resolve(value);
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodBranded: {
      const defType = def;
      const value = createZodValues(defType.type, zodRuntime, zodTypes);
      return value;
    }
    case zodRuntime.ZodFirstPartyTypeKind.ZodPipeline: {
      const defType = def;
      const value = createZodValues(defType.out, zodRuntime, zodTypes);
      return value;
    }
    default:
      throw new Error("Not implemented: " + typeName);
  }
};

// src/components/RenderModal/SchemaEditor/SchemaSeparationLine.tsx
import {
jsx as jsx102,
jsxs as jsxs46,
Fragment as Fragment18
} from "react/jsx-runtime";
var VERTICAL_GUIDE_HEIGHT = 24;
var line2 = {
  borderBottom: "1px solid " + LINE_COLOR
};
var SchemaSeparationLine = () => {
  return jsx102("div", {
    style: line2
  });
};
var arraySeparationLine = {
  borderBottom: "1px solid " + LINE_COLOR,
  marginTop: -VERTICAL_GUIDE_HEIGHT / 2,
  pointerEvents: "none",
  width: "100%"
};
var SchemaArrayItemSeparationLine = ({ onChange, index, schema, isLast }) => {
  const [outerHovered, setOuterHovered] = useState38(false);
  const [innerHovered, setInnerHovered] = useState38(false);
  const zodTypes = useZodTypesIfPossible();
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const def = schema._def;
  const onAdd = useCallback46(() => {
    onChange((oldV) => {
      return [
        ...oldV.slice(0, index + 1),
        createZodValues(def.type, z, zodTypes),
        ...oldV.slice(index + 1)
      ];
    }, false, true);
  }, [def.type, index, onChange, z, zodTypes]);
  const dynamicAddButtonStyle = useMemo56(() => {
    return {
      display: "flex",
      justifyContent: "center",
      height: VERTICAL_GUIDE_HEIGHT,
      opacity: outerHovered || isLast ? 1 : 0,
      position: "relative",
      marginTop: -4
    };
  }, [isLast, outerHovered]);
  const inner = useMemo56(() => {
    return {
      background: BACKGROUND,
      paddingLeft: 10,
      paddingRight: 10
    };
  }, []);
  const onOuterMouseEnter = useCallback46(() => {
    setOuterHovered(true);
  }, []);
  const onOuterMouseLeave = useCallback46(() => {
    setOuterHovered(false);
  }, []);
  const onInnerMouseEnter = useCallback46(() => {
    setInnerHovered(true);
  }, []);
  const onInnerMouseLeave = useCallback46(() => {
    setInnerHovered(false);
  }, []);
  return jsxs46("div", {
    style: { display: "flex", flexDirection: "row" },
    children: [
      jsxs46("div", {
        style: { flex: 1 },
        children: [
          jsx102("div", {
            style: dynamicAddButtonStyle,
            onMouseEnter: onOuterMouseEnter,
            onMouseLeave: onOuterMouseLeave,
            children: jsx102("div", {
              onClick: onAdd,
              style: inner,
              onMouseEnter: onInnerMouseEnter,
              onMouseLeave: onInnerMouseLeave,
              children: jsx102(Plus, {
                color: innerHovered ? "white" : LIGHT_TEXT,
                style: { height: VERTICAL_GUIDE_HEIGHT / 2 }
              })
            })
          }),
          jsx102("div", {
            style: arraySeparationLine
          })
        ]
      }),
      isLast ? jsxs46(Fragment18, {
        children: [
          jsx102(Spacing, {
            x: 1
          }),
          jsx102("div", {
            style: {
              ...fieldSetText,
              alignItems: "center",
              display: "flex"
            },
            children: "]"
          })
        ]
      }) : null
    ]
  });
};

// src/components/RenderModal/SchemaEditor/SchemaVerticalGuide.tsx
import {useMemo as useMemo57} from "react";
import {
jsx as jsx103,
jsxs as jsxs47
} from "react/jsx-runtime";
var flex = {
  flex: 1
};
var SchemaVerticalGuide = ({ isRoot, children }) => {
  const outer = useMemo57(() => {
    return {
      display: "flex",
      flexDirection: "row",
      position: "relative",
      marginLeft: isRoot ? 0 : 4
    };
  }, [isRoot]);
  const inner = useMemo57(() => {
    return isRoot ? {} : {
      height: `calc(100% - ${VERTICAL_GUIDE_HEIGHT / 2}px)`,
      width: 1,
      background: "#363A3E",
      position: "absolute"
    };
  }, [isRoot]);
  return jsxs47("div", {
    style: outer,
    children: [
      jsx103("div", {
        style: inner
      }),
      jsx103("div", {
        style: flex,
        children
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodArrayEditor.tsx
import React73, {useMemo as useMemo62, useState as useState41} from "react";

// src/components/RenderModal/SchemaEditor/ZodArrayItemEditor.tsx
import {useCallback as useCallback47, useMemo as useMemo58} from "react";
import {
jsx as jsx104
} from "react/jsx-runtime";
var ZodArrayItemEditor = ({
  def,
  onChange,
  jsonPath,
  index,
  value,
  defaultValue,
  onSave: onSaveObject,
  showSaveButton,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const onRemove = useCallback47(() => {
    onChange((oldV) => [...oldV.slice(0, index), ...oldV.slice(index + 1)], false, true);
  }, [index, onChange]);
  const setValue = useCallback47((val) => {
    onChange((oldV) => [
      ...oldV.slice(0, index),
      typeof val === "function" ? val(oldV[index]) : val,
      ...oldV.slice(index + 1)
    ], false, false);
  }, [index, onChange]);
  const newJsonPath = useMemo58(() => [...jsonPath, index], [index, jsonPath]);
  const onSave = useCallback47((updater) => {
    onSaveObject((oldV) => [
      ...oldV.slice(0, index),
      updater(oldV[index]),
      ...oldV.slice(index + 1)
    ], false, false);
  }, [index, onSaveObject]);
  return jsx104("div", {
    children: jsx104(ZodSwitch2, {
      jsonPath: newJsonPath,
      schema: def.type,
      value,
      setValue,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    })
  });
};

// src/components/RenderModal/InfoBubble.tsx
import {PlayerInternals as PlayerInternals11} from "@remotion/player";
import {useCallback as useCallback48, useEffect as useEffect38, useMemo as useMemo60, useRef as useRef23, useState as useState39} from "react";
import ReactDOM7 from "react-dom";

// src/components/RenderModal/InfoTooltip.tsx
import {useMemo as useMemo59} from "react";
import {
jsx as jsx105,
jsxs as jsxs48
} from "react/jsx-runtime";
var arrow = {
  height: 7,
  display: "block",
  overflow: "visible",
  marginLeft: 7
};
var arrowUp = {
  ...arrow,
  transform: `translateY(1px)`
};
var arrowDown = {
  ...arrow,
  marginTop: -1
};
var InfoTooltip = ({ children, arrowDirection, backgroundColor }) => {
  const container25 = useMemo59(() => {
    return {
      boxShadow: arrowDirection === "down" ? SHADOW_TOWARDS_TOP : SHADOW_TOWARDS_BOTTOM,
      background: backgroundColor,
      color: "white",
      border: "0.5px solid " + BORDER_COLOR,
      maxHeight: 200,
      overflow: "auto",
      borderRadius: "4px"
    };
  }, [arrowDirection, backgroundColor]);
  return jsxs48("div", {
    style: {
      display: "flex",
      flexDirection: arrowDirection === "up" ? "column-reverse" : "column",
      alignItems: "flex-start"
    },
    children: [
      jsx105("div", {
        style: container25,
        className: VERTICAL_SCROLLBAR_CLASSNAME,
        children
      }),
      arrowDirection === "down" ? jsx105("svg", {
        viewBox: "0 0 14 7",
        style: arrowDown,
        children: jsx105("path", {
          d: `M 14 0 L 7 7 L 0 0`,
          fill: backgroundColor,
          strokeLinecap: "butt",
          stroke: BORDER_COLOR,
          strokeWidth: 0.5
        })
      }) : null,
      arrowDirection === "up" ? jsx105("svg", {
        viewBox: "0 0 14 7",
        style: arrowUp,
        children: jsx105("path", {
          d: `M 0 7 L 7 0 L 14 7`,
          fill: backgroundColor,
          strokeLinecap: "butt",
          stroke: BORDER_COLOR,
          strokeWidth: 0.5
        })
      }) : null
    ]
  });
};

// src/components/RenderModal/InfoBubble.tsx
import {
jsx as jsx106,
jsxs as jsxs49,
Fragment as Fragment19
} from "react/jsx-runtime";
var icon3 = {
  color: LIGHT_TEXT,
  height: 15
};
var container25 = {
  display: "inline-block",
  border: "none",
  fontSize: 14,
  verticalAlign: "text-bottom"
};
var InfoBubble = ({ title: title3, children }) => {
  const [hovered, setIsHovered] = useState39(false);
  const [opened, setOpened] = useState39(false);
  const ref = useRef23(null);
  const { tabIndex, currentZIndex } = useZIndex();
  const size2 = PlayerInternals11.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const refresh = size2?.refresh;
  const onHide = useCallback48(() => {
    setOpened(false);
  }, []);
  useEffect38(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    const onPointerUp = () => {
      return setOpened((o) => {
        if (!o) {
          refresh?.();
        }
        return !o;
      });
    };
    const onClick = (e) => {
      e.stopPropagation();
      const isKeyboardInitiated = e.detail === 0;
      if (!isKeyboardInitiated) {
        return;
      }
      return setOpened((o) => {
        return !o;
      });
    };
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    current.addEventListener("pointerup", onPointerUp);
    current.addEventListener("click", onClick);
    return () => {
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
      current.removeEventListener("pointerup", onPointerUp);
      current.removeEventListener("click", onClick);
    };
  }, [refresh]);
  const layout20 = useMemo60(() => {
    if (!size2) {
      return "down";
    }
    const spaceToBottom = size2.windowSize.height - (size2.top + size2.height);
    const spaceToTop = size2.top;
    const l = spaceToTop > spaceToBottom ? "down" : "up";
    return l;
  }, [size2]);
  const portalStyle = useMemo60(() => {
    if (!size2 || !opened) {
      return null;
    }
    return {
      ...layout20 === "up" ? {
        position: "fixed",
        top: size2.top + size2.height
      } : {
        position: "fixed",
        bottom: size2.windowSize.height - size2.top
      },
      left: size2.left
    };
  }, [layout20, opened, size2]);
  const style8 = useMemo60(() => {
    return {
      ...container25,
      userSelect: "none",
      WebkitUserSelect: "none",
      color: "white",
      display: "inline-flex",
      flexDirection: "row",
      alignItems: "center",
      padding: 6
    };
  }, []);
  return jsxs49(Fragment19, {
    children: [
      jsx106("button", {
        ref,
        tabIndex,
        style: style8,
        title: title3,
        type: "button",
        children: jsx106("svg", {
          style: icon3,
          viewBox: "0 0 512 512",
          children: jsx106("path", {
            fill: hovered ? "white" : LIGHT_TEXT,
            d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
          })
        })
      }),
      portalStyle ? ReactDOM7.createPortal(jsx106("div", {
        style: outerPortal,
        className: "css-reset",
        children: jsx106(HigherZIndex, {
          onOutsideClick: onHide,
          onEscape: onHide,
          children: jsx106("div", {
            style: portalStyle,
            children: jsx106(InfoTooltip, {
              backgroundColor: INPUT_BACKGROUND,
              arrowDirection: layout20,
              children
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodFieldValidation.tsx
import {
jsx as jsx107,
jsxs as jsxs50
} from "react/jsx-runtime";
var legend = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var stackTrace = {
  padding: 10
};
var stackTraceLabel = {
  fontSize: 14
};
var ZodFieldValidation = ({ localValue, path }) => {
  if (localValue.zodValidation.success) {
    return null;
  }
  return jsxs50("div", {
    style: legend,
    children: [
      jsx107(ValidationMessage, {
        align: "flex-start",
        message: localValue.zodValidation.error.format()._errors[0],
        type: "error"
      }),
      jsx107(Spacing, {
        x: 0.5
      }),
      jsx107(InfoBubble, {
        title: "Zod validation failure",
        children: jsxs50("div", {
          style: stackTrace,
          children: [
            jsx107("div", {
              style: stackTraceLabel,
              children: "Zod Validation has failed:"
            }),
            localValue.zodValidation.error.errors.map((error, index) => jsxs50("div", {
              style: stackTraceLabel,
              children: [
                "Type: ",
                error.code,
                " ",
                jsx107("br", {}),
                "Message: ",
                error.message,
                jsx107("br", {}),
                "Path: ",
                path.join(".")
              ]
            }, index))
          ]
        })
      }),
      jsx107(Spacing, {
        x: 0.5
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/local-state.tsx
import {
createContext as createContext16,
useCallback as useCallback49,
useContext as useContext32,
useEffect as useEffect39,
useMemo as useMemo61,
useRef as useRef24,
useState as useState40
} from "react";
import {Internals as Internals28} from "remotion";
import {
jsx as jsx108
} from "react/jsx-runtime";
var RevisionContext = createContext16({
  childResetRevision: 0
});
var useLocalState = ({
  unsavedValue,
  schema,
  setValue,
  savedValue
}) => {
  const parentRevision = useContext32(RevisionContext).childResetRevision;
  const [resetRevision, setResetRevision] = useState40(0);
  const [localValueOrNull, setLocalValue] = useState40(() => {
    return {
      [parentRevision]: {
        value: unsavedValue,
        keyStabilityRevision: 0,
        zodValidation: schema.safeParse(unsavedValue)
      }
    };
  });
  const localUnsavedValue = useMemo61(() => {
    if (localValueOrNull[parentRevision] === null) {
      return {
        value: unsavedValue,
        keyStabilityRevision: 0,
        zodValidation: schema.safeParse(unsavedValue)
      };
    }
    return localValueOrNull[parentRevision];
  }, [localValueOrNull, parentRevision, schema, unsavedValue]);
  useEffect39(() => {
    const checkFile = () => {
      setResetRevision((old) => old + 1);
      setLocalValue({});
    };
    window.addEventListener(Internals28.PROPS_UPDATED_EXTERNALLY, checkFile);
    return () => {
      window.removeEventListener(Internals28.PROPS_UPDATED_EXTERNALLY, checkFile);
    };
  }, []);
  const currentLocalValue = useMemo61(() => {
    return localUnsavedValue ?? {
      value: savedValue,
      keyStabilityRevision: 0,
      zodValidation: schema.safeParse(savedValue)
    };
  }, [localUnsavedValue, savedValue, schema]);
  const stateRef = useRef24(currentLocalValue);
  stateRef.current = currentLocalValue;
  const onChange = useCallback49((updater, forceApply, increment) => {
    const newValue = updater(stateRef.current.value);
    const isSame = deepEqual(newValue, stateRef.current.value);
    if (isSame) {
      return;
    }
    const safeParse = schema.safeParse(newValue);
    if (safeParse.success || forceApply) {
      setValue(updater, forceApply, increment);
    }
    setLocalValue(() => {
      const newState = {
        keyStabilityRevision: currentLocalValue.keyStabilityRevision + (increment ? 1 : 0),
        value: newValue,
        zodValidation: safeParse
      };
      stateRef.current = newState;
      return {
        ...localUnsavedValue,
        [parentRevision]: newState
      };
    });
  }, [
    currentLocalValue.keyStabilityRevision,
    localUnsavedValue,
    parentRevision,
    schema,
    setValue
  ]);
  const contextValue = useMemo61(() => {
    return {
      childResetRevision: resetRevision
    };
  }, [resetRevision]);
  const reset = useCallback49(() => {
    onChange(() => savedValue, true, true);
    setResetRevision((old) => old + 1);
  }, [savedValue, onChange]);
  const RevisionContextProvider = useCallback49(({ children }) => {
    return jsx108(RevisionContext.Provider, {
      value: contextValue,
      children
    });
  }, [contextValue]);
  return useMemo61(() => ({
    localValue: currentLocalValue,
    onChange,
    reset,
    RevisionContextProvider
  }), [RevisionContextProvider, currentLocalValue, onChange, reset]);
};

// src/components/RenderModal/SchemaEditor/ZodArrayEditor.tsx
import {
jsx as jsx109,
jsxs as jsxs51
} from "react/jsx-runtime";
var ZodArrayEditor = ({
  schema,
  jsonPath,
  setValue,
  defaultValue,
  value,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { localValue, onChange, RevisionContextProvider, reset } = useLocalState({
    unsavedValue: value,
    schema,
    setValue,
    savedValue: defaultValue
  });
  const [expanded, setExpanded] = useState41(true);
  const def = schema._def;
  const suffix2 = useMemo62(() => {
    return expanded ? " [" : " [...] ";
  }, [expanded]);
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const typeName = def.typeName;
  if (typeName !== z.ZodFirstPartyTypeKind.ZodArray) {
    throw new Error("expected object");
  }
  const isDefaultValue = useMemo62(() => {
    return deepEqual(localValue.value, defaultValue);
  }, [defaultValue, localValue]);
  return jsxs51(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      jsx109("div", {
        style: {
          display: "flex",
          flexDirection: "row"
        },
        children: jsx109(SchemaLabel, {
          onReset: reset,
          isDefaultValue,
          jsonPath,
          onRemove,
          suffix: suffix2,
          onSave: () => {
            onSave(() => localValue.value, false, false);
          },
          saveDisabledByParent,
          saving,
          showSaveButton,
          valid: localValue.zodValidation.success,
          handleClick: () => setExpanded(!expanded)
        })
      }),
      expanded ? jsx109(RevisionContextProvider, {
        children: jsxs51(SchemaVerticalGuide, {
          isRoot: false,
          children: [
            localValue.value.map((child, i) => {
              return jsxs51(React73.Fragment, {
                children: [
                  jsx109(ZodArrayItemEditor, {
                    onChange,
                    value: child,
                    def,
                    index: i,
                    jsonPath,
                    defaultValue: defaultValue?.[i] ?? createZodValues(def.type, z, zodTypes),
                    onSave,
                    showSaveButton,
                    saving,
                    saveDisabledByParent,
                    mayPad
                  }),
                  jsx109(SchemaArrayItemSeparationLine, {
                    schema,
                    index: i,
                    onChange,
                    isLast: i === localValue.value.length - 1
                  })
                ]
              }, `${i}${localValue.keyStabilityRevision}`);
            }),
            value.length === 0 ? jsx109(SchemaArrayItemSeparationLine, {
              schema,
              index: 0,
              onChange,
              isLast: true
            }) : null
          ]
        })
      }) : null,
      jsx109(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodBooleanEditor.tsx
import {useCallback as useCallback50} from "react";

// src/components/Checkbox.tsx
import {useMemo as useMemo63} from "react";
import {
jsx as jsx110,
jsxs as jsxs52
} from "react/jsx-runtime";
var size2 = 20;
var background = {
  height: size2,
  width: size2,
  position: "relative"
};
var box = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  height: size2,
  width: size2,
  top: 0,
  left: 0,
  pointerEvents: "none",
  color: "white"
};
var Checkbox = ({ checked, onChange, disabled, name }) => {
  const input2 = useMemo63(() => {
    return {
      appearance: "none",
      background: disabled ? "transparent" : INPUT_BACKGROUND,
      border: "1px solid " + INPUT_BORDER_COLOR_UNHOVERED,
      height: size2,
      width: size2,
      top: 0,
      left: 0,
      position: "absolute",
      margin: 0
    };
  }, [disabled]);
  return jsxs52("div", {
    style: background,
    children: [
      jsx110("input", {
        style: input2,
        type: "checkbox",
        checked,
        onChange,
        disabled,
        name
      }),
      jsx110("div", {
        style: box,
        children: checked ? jsx110(Checkmark, {}) : null
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodBooleanEditor.tsx
import {
jsx as jsx111,
jsxs as jsxs53
} from "react/jsx-runtime";
var fullWidth = {
  width: "100%"
};
var ZodBooleanEditor = ({
  schema,
  jsonPath,
  value,
  setValue,
  onSave,
  defaultValue,
  onRemove,
  showSaveButton,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { localValue, onChange, reset } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onToggle = useCallback50((e) => {
    onChange(() => e.target.checked, false, false);
  }, [onChange]);
  const save = useCallback50(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return jsxs53(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      jsx111(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: true,
        saveDisabledByParent,
        suffix: null
      }),
      jsx111("div", {
        style: fullWidth,
        children: jsx111(Checkbox, {
          name: jsonPath.join("."),
          checked: localValue.value,
          onChange: onToggle,
          disabled: false
        })
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodColorEditor.tsx
import {useCallback as useCallback51, useMemo as useMemo65} from "react";

// src/helpers/color-math.ts
var colorWithNewOpacity = (color, opacity, zodTypes) => {
  const { r, g, b } = zodTypes.ZodZypesInternals.parseColor(color);
  if (opacity >= 255) {
    return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
  }
  return `rgba(${r}, ${g}, ${b}, ${(opacity / 255).toFixed(2)})`;
};

// src/components/NewComposition/RemInputTypeColor.tsx
import {
forwardRef as forwardRef4,
useEffect as useEffect40,
useImperativeHandle as useImperativeHandle10,
useMemo as useMemo64,
useRef as useRef25,
useState as useState42
} from "react";
import {
jsx as jsx112
} from "react/jsx-runtime";
var inputBaseStyle3 = {
  padding: 0,
  borderStyle: "solid",
  borderWidth: 1
};
var RemInputTypeColorForwardRef = ({ status, ...props }, ref) => {
  const [isFocused, setIsFocused] = useState42(false);
  const [isHovered, setIsHovered] = useState42(false);
  const inputRef = useRef25(null);
  const { tabIndex } = useZIndex();
  const style8 = useMemo64(() => {
    return {
      backgroundColor: INPUT_BACKGROUND,
      ...inputBaseStyle3,
      borderColor: getInputBorderColor({ isFocused, isHovered, status }),
      ...props.style ?? {}
    };
  }, [isFocused, isHovered, props.style, status]);
  useImperativeHandle10(ref, () => {
    return inputRef.current;
  }, []);
  useEffect40(() => {
    if (!inputRef.current) {
      return;
    }
    const { current } = inputRef;
    const onFocus = () => setIsFocused(true);
    const onBlur = () => setIsFocused(false);
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    current.addEventListener("focus", onFocus);
    current.addEventListener("blur", onBlur);
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    return () => {
      current.removeEventListener("focus", onFocus);
      current.removeEventListener("blur", onBlur);
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
    };
  }, [inputRef]);
  return jsx112("input", {
    ref: inputRef,
    type: "color",
    tabIndex,
    ...props,
    name: props.name,
    style: style8
  });
};
var RemInputTypeColor = forwardRef4(RemInputTypeColorForwardRef);

// src/components/RenderModal/SchemaEditor/ZodColorEditor.tsx
import {
jsx as jsx113,
jsxs as jsxs54
} from "react/jsx-runtime";
var fullWidth2 = {
  width: "100%"
};
var ZodColorEditor = ({
  jsonPath,
  value,
  setValue,
  showSaveButton,
  defaultValue,
  schema,
  onSave,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  if (!zodTypes) {
    throw new Error("expected zod color");
  }
  const {
    localValue,
    onChange: onValueChange,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const { a, b, g, r } = localValue.zodValidation.success ? zodTypes.ZodZypesInternals.parseColor(localValue.value) : { a: 1, b: 0, g: 0, r: 0 };
  const onChange = useCallback51((e) => {
    const newColor = colorWithNewOpacity(e.target.value, Math.round(a), zodTypes);
    onValueChange(() => newColor, false, false);
  }, [a, onValueChange, zodTypes]);
  const onTextChange = useCallback51((e) => {
    const newValue = e.target.value;
    onValueChange(() => newValue, false, false);
  }, [onValueChange]);
  const save = useCallback51(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  const rgb = `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
  const status = localValue.zodValidation.success ? "ok" : "error";
  const colorPicker = useMemo65(() => {
    return {
      height: 39,
      width: 45,
      display: "inline-block"
    };
  }, []);
  const onOpacityChange = useCallback51((newValue) => {
    const newColor = colorWithNewOpacity(localValue.value, Math.round(Number(newValue) / 100 * 255), zodTypes);
    onValueChange(() => newColor, false, false);
  }, [localValue.value, onValueChange, zodTypes]);
  const onOpacityValueChange = useCallback51((newValue) => {
    const newColor = colorWithNewOpacity(localValue.value, Math.round(Number(newValue) / 100 * 255), zodTypes);
    onValueChange(() => newColor, false, false);
  }, [localValue.value, onValueChange, zodTypes]);
  return jsxs54(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      jsx113(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      jsxs54("div", {
        style: fullWidth2,
        children: [
          jsxs54(Row, {
            align: "center",
            children: [
              jsx113("div", {
                style: colorPicker,
                children: jsx113(RemInputTypeColor, {
                  type: "color",
                  style: {
                    height: 39
                  },
                  value: rgb,
                  onChange,
                  className: "__remotion_color_picker",
                  status,
                  name: jsonPath.join(".")
                })
              }),
              jsx113(Spacing, {
                x: 1,
                block: true
              }),
              jsx113(RemotionInput, {
                value: localValue.value,
                status,
                placeholder: jsonPath.join("."),
                onChange: onTextChange,
                rightAlign: false
              }),
              jsx113(Spacing, {
                x: 1
              }),
              jsx113(InputDragger, {
                onTextChange: onOpacityChange,
                onValueChange: onOpacityValueChange,
                status,
                value: a / 255 * 100,
                min: 0,
                max: 100,
                step: 1,
                formatter: (v) => `${Math.round(Number(v))}%`,
                rightAlign: false
              })
            ]
          }),
          jsx113(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodDateEditor.tsx
import {useCallback as useCallback52} from "react";
import {
jsx as jsx114,
jsxs as jsxs55
} from "react/jsx-runtime";
var fullWidth3 = {
  width: "100%"
};
var explainer2 = {
  fontFamily: "sans-serif",
  fontSize: 12,
  color: VERY_LIGHT_TEXT
};
var inputStyle = {
  colorScheme: "dark"
};
var formatDate = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const milliseconds = date.getMilliseconds();
  const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}T${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}.${milliseconds.toString().padStart(3, "0")}`;
  return formattedDate;
};
var ZodDateEditor = ({
  jsonPath,
  value,
  setValue,
  showSaveButton,
  defaultValue,
  schema,
  onSave,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onChange = useCallback52((e) => {
    setLocalValue(() => new Date(e.target.value), false, false);
  }, [setLocalValue]);
  const save = useCallback52(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return jsxs55(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      jsx114(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value.getTime() === defaultValue.getTime(),
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      jsxs55("div", {
        style: fullWidth3,
        children: [
          jsx114(RemotionInput, {
            value: formatDate(localValue.value),
            type: "datetime-local",
            status: localValue.zodValidation.success ? "ok" : "error",
            placeholder: jsonPath.join("."),
            onChange,
            style: inputStyle,
            rightAlign: false
          }),
          jsx114(Spacing, {
            y: 1,
            block: true
          }),
          jsx114("div", {
            style: explainer2,
            children: "Date is in local format"
          }),
          jsx114(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodDefaultEditor.tsx
import {
jsx as jsx115
} from "react/jsx-runtime";
var ZodDefaultEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { innerType } = schema._def;
  return jsx115(ZodSwitch2, {
    defaultValue,
    jsonPath,
    onRemove,
    onSave,
    schema: innerType,
    setValue,
    showSaveButton,
    value,
    saving,
    saveDisabledByParent,
    mayPad
  });
};

// src/components/RenderModal/SchemaEditor/ZodDiscriminatedUnionEditor.tsx
import {useCallback as useCallback53, useMemo as useMemo66} from "react";
import {
jsx as jsx116,
jsxs as jsxs56
} from "react/jsx-runtime";
var ZodDiscriminatedUnionEditor = ({
  schema,
  setValue,
  showSaveButton,
  saving,
  value,
  defaultValue,
  saveDisabledByParent,
  onSave,
  mayPad,
  jsonPath,
  onRemove
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const typedSchema = schema._def;
  const options = useMemo66(() => [...typedSchema.optionsMap.keys()], [typedSchema.optionsMap]);
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const comboBoxValues = useMemo66(() => {
    return options.map((option) => {
      return {
        value: option,
        label: option,
        id: option,
        keyHint: null,
        leftItem: option === value[typedSchema.discriminator] ? jsx116(Checkmark, {}) : null,
        onClick: () => {
          const val = createZodValues(typedSchema.optionsMap.get(option), z, zodTypes);
          setLocalValue(() => val, false, false);
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item"
      };
    });
  }, [
    options,
    setLocalValue,
    typedSchema.discriminator,
    typedSchema.optionsMap,
    value,
    z,
    zodTypes
  ]);
  const save = useCallback53(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  const discriminatedUnionReplacement = useMemo66(() => {
    return {
      discriminator: typedSchema.discriminator,
      markup: jsxs56(Fieldset, {
        shouldPad: mayPad,
        success: true,
        children: [
          jsx116(SchemaLabel, {
            handleClick: null,
            isDefaultValue: localValue.value[typedSchema.discriminator] === defaultValue[typedSchema.discriminator],
            jsonPath: [...jsonPath, typedSchema.discriminator],
            onRemove,
            onReset: reset,
            onSave: save,
            saveDisabledByParent,
            saving,
            showSaveButton,
            suffix: null,
            valid: localValue.zodValidation.success
          }),
          jsx116(Combobox, {
            title: "Select type",
            values: comboBoxValues,
            selectedId: value[typedSchema.discriminator]
          })
        ]
      }, "replacement")
    };
  }, [
    comboBoxValues,
    defaultValue,
    jsonPath,
    localValue.value,
    localValue.zodValidation.success,
    mayPad,
    onRemove,
    reset,
    save,
    saveDisabledByParent,
    saving,
    showSaveButton,
    typedSchema.discriminator,
    value
  ]);
  return jsx116(ZodObjectEditor2, {
    jsonPath,
    mayPad,
    savedValue: defaultValue,
    onRemove,
    onSave,
    saveDisabledByParent,
    saving,
    schema: typedSchema.optionsMap.get(value[typedSchema.discriminator]),
    setValue: setLocalValue,
    showSaveButton,
    unsavedValue: value,
    discriminatedUnionReplacement
  }, value[typedSchema.discriminator]);
};

// src/components/RenderModal/SchemaEditor/ZodEffectEditor.tsx
import {
jsx as jsx117,
jsxs as jsxs57
} from "react/jsx-runtime";
var fullWidth4 = {
  width: "100%"
};
var ZodEffectEditor = ({
  schema,
  jsonPath,
  value,
  setValue: updateValue,
  defaultValue,
  onSave,
  onRemove,
  showSaveButton,
  saving,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const { localValue, onChange } = useLocalState({
    unsavedValue: value,
    schema,
    setValue: updateValue,
    savedValue: defaultValue
  });
  const def = schema._def;
  const typeName = def.typeName;
  if (typeName !== z.ZodFirstPartyTypeKind.ZodEffects) {
    throw new Error("expected effect");
  }
  return jsxs57(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      jsx117("div", {
        style: fullWidth4,
        children: jsx117(ZodSwitch2, {
          value,
          setValue: onChange,
          jsonPath,
          schema: def.schema,
          defaultValue,
          onSave,
          showSaveButton,
          onRemove,
          saving,
          saveDisabledByParent: !localValue.zodValidation.success,
          mayPad: false
        })
      }),
      jsx117(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodEnumEditor.tsx
import {useCallback as useCallback54, useMemo as useMemo67} from "react";
import {
jsx as jsx118,
jsxs as jsxs58
} from "react/jsx-runtime";
var container26 = {
  width: "100%"
};
var ZodEnumEditor = ({
  schema,
  jsonPath,
  setValue,
  defaultValue,
  value,
  onSave,
  showSaveButton,
  onRemove,
  saving
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const def = schema._def;
  const typeName = def.typeName;
  if (typeName !== z.ZodFirstPartyTypeKind.ZodEnum) {
    throw new Error("expected enum");
  }
  const isRoot = jsonPath.length === 0;
  const comboBoxValues = useMemo67(() => {
    return def.values.map((option) => {
      return {
        value: option,
        label: option,
        id: option,
        keyHint: null,
        leftItem: option === value ? jsx118(Checkmark, {}) : null,
        onClick: (id) => {
          setLocalValue(() => id, false, false);
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item"
      };
    });
  }, [def.values, setLocalValue, value]);
  const save = useCallback54(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return jsxs58(Fieldset, {
    shouldPad: true,
    success: localValue.zodValidation.success,
    children: [
      jsx118(SchemaLabel, {
        handleClick: null,
        onSave: save,
        showSaveButton,
        isDefaultValue: localValue.value === defaultValue,
        onReset: reset,
        jsonPath,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent: !localValue.zodValidation.success,
        suffix: null
      }),
      jsx118("div", {
        style: isRoot ? undefined : container26,
        children: jsx118(Combobox, {
          values: comboBoxValues,
          selectedId: value,
          title: value
        })
      }),
      jsx118(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodNonEditableValue.tsx
import {useCallback as useCallback55} from "react";
import {
jsx as jsx119,
jsxs as jsxs59
} from "react/jsx-runtime";
var fullWidth5 = {
  width: "100%"
};
var emptyLabel = {
  width: "100%",
  color: VERY_LIGHT_TEXT,
  fontFamily: "sans-serif",
  fontSize: 14
};
var wideEmptyLabel = {
  ...emptyLabel,
  lineHeight: "37px"
};
var ZonNonEditableValue = ({ jsonPath, label: label6, showSaveButton, saving, mayPad }) => {
  const save = useCallback55(() => {
    return;
  }, []);
  const reset = useCallback55(() => {
    return;
  }, []);
  return jsxs59(Fieldset, {
    shouldPad: mayPad,
    success: true,
    children: [
      jsx119(SchemaLabel, {
        handleClick: null,
        isDefaultValue: true,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove: null,
        saving,
        valid: true,
        saveDisabledByParent: true,
        suffix: null
      }),
      jsx119("div", {
        style: fullWidth5,
        children: jsx119("em", {
          style: wideEmptyLabel,
          children: label6
        })
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodOrNullishEditor.tsx
import {useCallback as useCallback56} from "react";
import {
jsx as jsx120,
jsxs as jsxs60
} from "react/jsx-runtime";
var labelStyle4 = {
  fontFamily: "sans-serif",
  fontSize: 14,
  color: LIGHT_TEXT
};
var checkBoxWrapper = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  marginTop: "5px"
};
var ZodOrNullishEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  nullishValue,
  saving,
  saveDisabledByParent,
  mayPad,
  innerSchema
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const isChecked = value === nullishValue;
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onCheckBoxChange = useCallback56((e) => {
    const val = e.target.checked ? nullishValue : createZodValues(innerSchema, z, zodTypes);
    setLocalValue(() => val, false, false);
  }, [innerSchema, nullishValue, setLocalValue, z, zodTypes]);
  const save = useCallback56(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return jsxs60(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      localValue.value === nullishValue ? jsx120(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }) : jsx120(ZodSwitch2, {
        value: localValue.value,
        setValue: setLocalValue,
        jsonPath,
        schema: innerSchema,
        defaultValue,
        onSave,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad: false
      }),
      jsxs60("div", {
        style: checkBoxWrapper,
        children: [
          jsx120(Checkbox, {
            checked: isChecked,
            onChange: onCheckBoxChange,
            disabled: false,
            name: jsonPath.join(".")
          }),
          jsx120(Spacing, {
            x: 1
          }),
          jsx120("div", {
            style: labelStyle4,
            children: String(nullishValue)
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodNullableEditor.tsx
import {
jsx as jsx121
} from "react/jsx-runtime";
var ZodNullableEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { innerType } = schema._def;
  return jsx121(ZodOrNullishEditor, {
    defaultValue,
    jsonPath,
    onRemove,
    onSave,
    schema,
    innerSchema: innerType,
    setValue,
    showSaveButton,
    value,
    nullishValue: null,
    saving,
    saveDisabledByParent,
    mayPad
  });
};

// src/components/RenderModal/SchemaEditor/ZodNumberEditor.tsx
import {useCallback as useCallback57} from "react";
import {
jsx as jsx122,
jsxs as jsxs61
} from "react/jsx-runtime";
var fullWidth6 = {
  width: "100%"
};
var getMinValue = (schema) => {
  const minCheck = schema._def.checks.find((c) => c.kind === "min");
  if (!minCheck) {
    return -Infinity;
  }
  if (minCheck.kind !== "min") {
    throw new Error("Expected min check");
  }
  if (!minCheck.inclusive) {
    return -Infinity;
  }
  return minCheck.value;
};
var getMaxValue = (schema) => {
  const maxCheck = schema._def.checks.find((c) => c.kind === "max");
  if (!maxCheck) {
    return Infinity;
  }
  if (maxCheck.kind !== "max") {
    throw new Error("Expected max check");
  }
  if (!maxCheck.inclusive) {
    return Infinity;
  }
  return maxCheck.value;
};
var getStep = (schema) => {
  const multipleStep = schema._def.checks.find((c) => c.kind === "multipleOf");
  if (!multipleStep) {
    return;
  }
  if (multipleStep.kind !== "multipleOf") {
    throw new Error("Expected multipleOf check");
  }
  return multipleStep.value;
};
var ZodNumberEditor = ({
  jsonPath,
  value,
  schema,
  setValue,
  onSave,
  defaultValue,
  onRemove,
  showSaveButton,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    unsavedValue: value,
    schema,
    setValue,
    savedValue: defaultValue
  });
  const onNumberChange = useCallback57((newValue) => {
    setLocalValue(() => newValue, false, false);
  }, [setLocalValue]);
  const isDefault = localValue.value === defaultValue;
  const onTextChange = useCallback57((newValue) => {
    setLocalValue(() => Number(newValue), false, false);
  }, [setLocalValue]);
  const save = useCallback57(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return jsxs61(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      jsx122(SchemaLabel, {
        handleClick: null,
        isDefaultValue: isDefault,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      jsxs61("div", {
        style: fullWidth6,
        children: [
          jsx122(InputDragger, {
            type: "number",
            value: localValue.value,
            style: fullWidth6,
            status: localValue.zodValidation.success ? "ok" : "error",
            placeholder: jsonPath.join("."),
            onTextChange,
            onValueChange: onNumberChange,
            min: getMinValue(schema),
            max: getMaxValue(schema),
            step: getStep(schema),
            rightAlign: false
          }),
          jsx122(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodOptionalEditor.tsx
import {
jsx as jsx123
} from "react/jsx-runtime";
var ZodOptionalEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { innerType } = schema._def;
  return jsx123(ZodOrNullishEditor, {
    defaultValue,
    jsonPath,
    onRemove,
    onSave,
    schema,
    setValue,
    showSaveButton,
    value,
    nullishValue: undefined,
    saving,
    saveDisabledByParent,
    mayPad,
    innerSchema: innerType
  });
};

// src/components/RenderModal/SchemaEditor/ZodStaticFileEditor.tsx
import {useCallback as useCallback58, useMemo as useMemo68} from "react";
import {
jsx as jsx124,
jsxs as jsxs62
} from "react/jsx-runtime";
var container27 = {
  width: "100%"
};
var ZodStaticFileEditor = ({
  schema,
  jsonPath,
  setValue,
  defaultValue,
  value,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const def = schema._def;
  const typeName = def.typeName;
  if (typeName !== z.ZodFirstPartyTypeKind.ZodString) {
    throw new Error("expected enum");
  }
  const isRoot = jsonPath.length === 0;
  const comboBoxValues = useMemo68(() => {
    return getStaticFiles().map((option) => {
      return {
        value: option.src,
        label: option.name,
        id: option.src,
        keyHint: null,
        leftItem: option.src === value ? jsx124(Checkmark, {}) : null,
        onClick: (id) => {
          setLocalValue(() => id, false, false);
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item"
      };
    });
  }, [setLocalValue, value]);
  const save = useCallback58(() => {
    onSave(() => value);
  }, [onSave, value]);
  return jsxs62(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      jsx124(SchemaLabel, {
        handleClick: null,
        onSave: save,
        showSaveButton,
        isDefaultValue: localValue.value === defaultValue,
        onReset: reset,
        jsonPath,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      jsx124("div", {
        style: isRoot ? undefined : container27,
        children: jsx124(Combobox, {
          values: comboBoxValues,
          selectedId: localValue.value,
          title: value
        })
      }),
      jsx124(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodStringEditor.tsx
import {useCallback as useCallback59} from "react";
import {
jsx as jsx125,
jsxs as jsxs63
} from "react/jsx-runtime";
var fullWidth7 = {
  width: "100%"
};
var ZodStringEditor = ({
  jsonPath,
  value,
  setValue,
  showSaveButton,
  defaultValue,
  schema,
  onSave,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onChange = useCallback59((e) => {
    setLocalValue(() => e.target.value, false, false);
  }, [setLocalValue]);
  const save = useCallback59(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return jsxs63(Fieldset, {
    shouldPad: mayPad,
    success: false,
    children: [
      jsx125(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      jsxs63("div", {
        style: fullWidth7,
        children: [
          jsx125(RemotionInput, {
            value: localValue.value,
            status: localValue.zodValidation ? "ok" : "error",
            placeholder: jsonPath.join("."),
            onChange,
            rightAlign: false,
            name: jsonPath.join(".")
          }),
          jsx125(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodTextareaEditor.tsx
import {useCallback as useCallback60} from "react";
import {
jsx as jsx126,
jsxs as jsxs64
} from "react/jsx-runtime";
var fullWidth8 = {
  width: "100%"
};
var textareaStyle = {
  resize: "vertical",
  minHeight: 100
};
var ZodTextareaEditor = ({
  jsonPath,
  value,
  setValue,
  showSaveButton,
  defaultValue,
  schema,
  onSave,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  if (!zodTypes) {
    throw new Error("expected zod textarea");
  }
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onChange = useCallback60((e) => {
    setLocalValue(() => e.target.value, false, false);
  }, [setLocalValue]);
  const save = useCallback60(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return jsxs64(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      jsx126(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      jsxs64("div", {
        style: fullWidth8,
        children: [
          jsx126(RemTextarea, {
            onChange,
            value: localValue.value,
            status: localValue.zodValidation ? "ok" : "error",
            placeholder: jsonPath.join("."),
            name: jsonPath.join("."),
            style: textareaStyle
          }),
          jsx126(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodUnionEditor.tsx
import {
jsx as jsx127
} from "react/jsx-runtime";
var findNull = (value, zodType) => {
  const nullIndex = value.findIndex((v) => v._def.typeName === zodType.ZodFirstPartyTypeKind.ZodNull || v._def.typeName === zodType.ZodFirstPartyTypeKind.ZodUndefined);
  if (nullIndex === -1) {
    return null;
  }
  const nullishValue = value[nullIndex]._def.typeName === zodType.ZodFirstPartyTypeKind.ZodNull ? null : undefined;
  const otherSchema = value[nullIndex === 0 ? 1 : 0];
  const otherSchemaIsAlsoNullish = otherSchema._def.typeName === zodType.ZodFirstPartyTypeKind.ZodNull || otherSchema._def.typeName === zodType.ZodFirstPartyTypeKind.ZodUndefined;
  return {
    nullIndex,
    nullishValue,
    otherSchema,
    otherSchemaIsAlsoNullish
  };
};
var ZodUnionEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { options } = schema._def;
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  if (options.length > 2) {
    return jsx127(ZonNonEditableValue, {
      jsonPath,
      label: "Union with more than 2 options not editable",
      showSaveButton,
      saving,
      mayPad
    });
  }
  if (options.length < 2) {
    return jsx127(ZonNonEditableValue, {
      jsonPath,
      label: "Union with less than 2 options not editable",
      showSaveButton,
      saving,
      mayPad
    });
  }
  const nullResult = findNull(options, z);
  if (!nullResult) {
    return jsx127(ZonNonEditableValue, {
      jsonPath,
      label: "Union only editable with 1 value being null",
      showSaveButton,
      saving,
      mayPad
    });
  }
  const { otherSchema, nullishValue, otherSchemaIsAlsoNullish } = nullResult;
  if (otherSchemaIsAlsoNullish) {
    return jsx127(ZonNonEditableValue, {
      jsonPath,
      label: "Not editable - both union values are nullish",
      showSaveButton,
      saving,
      mayPad
    });
  }
  return jsx127(ZodOrNullishEditor, {
    defaultValue,
    jsonPath,
    onRemove,
    onSave,
    schema,
    innerSchema: otherSchema,
    setValue,
    showSaveButton,
    value,
    nullishValue,
    saving,
    saveDisabledByParent,
    mayPad
  });
};

// src/components/RenderModal/SchemaEditor/ZodSwitch.tsx
import {
jsx as jsx128
} from "react/jsx-runtime";
var ZodSwitch2 = ({
  schema,
  jsonPath,
  value,
  setValue,
  defaultValue,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const def = schema._def;
  const typeName = def.typeName;
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  if (typeName === z.ZodFirstPartyTypeKind.ZodObject) {
    return jsx128(ZodObjectEditor2, {
      setValue,
      unsavedValue: value,
      savedValue: defaultValue,
      jsonPath,
      schema,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad,
      discriminatedUnionReplacement: null
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodString) {
    if (value.startsWith(window.remotion_staticBase)) {
      return jsx128(ZodStaticFileEditor, {
        setValue,
        value,
        jsonPath,
        schema,
        defaultValue,
        onSave,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad
      });
    }
    if (zodTypes && schema._def.description === zodTypes.ZodZypesInternals.REMOTION_TEXTAREA_BRAND) {
      return jsx128(ZodTextareaEditor, {
        value,
        setValue,
        jsonPath,
        schema,
        onSave,
        defaultValue,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad
      });
    }
    return jsx128(ZodStringEditor, {
      value,
      setValue,
      jsonPath,
      schema,
      onSave,
      defaultValue,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodDate) {
    return jsx128(ZodDateEditor, {
      value,
      setValue,
      jsonPath,
      schema,
      onSave,
      defaultValue,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodNumber) {
    return jsx128(ZodNumberEditor, {
      value,
      setValue,
      jsonPath,
      schema,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodBoolean) {
    return jsx128(ZodBooleanEditor, {
      value,
      setValue,
      jsonPath,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad,
      schema
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodUndefined) {
    return jsx128(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "undefined",
      saving,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodNull) {
    return jsx128(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "null",
      saving,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodAny) {
    return jsx128(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "any (not editable)",
      saving,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodBigInt) {
    return jsx128(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "BigInt (not editable)",
      saving,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodUnknown) {
    return jsx128(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "unknown (not editable)",
      saving,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodArray) {
    return jsx128(ZodArrayEditor, {
      setValue,
      value,
      jsonPath,
      schema,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodEnum) {
    return jsx128(ZodEnumEditor, {
      setValue,
      value,
      jsonPath,
      schema,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodEffects) {
    if (zodTypes && schema._def.description === zodTypes.ZodZypesInternals.REMOTION_COLOR_BRAND) {
      return jsx128(ZodColorEditor, {
        value,
        setValue,
        jsonPath,
        schema,
        onSave,
        defaultValue,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad
      });
    }
    return jsx128(ZodEffectEditor, {
      value,
      setValue,
      jsonPath,
      schema,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodUnion) {
    return jsx128(ZodUnionEditor, {
      schema,
      showSaveButton,
      jsonPath,
      value,
      defaultValue,
      setValue,
      onSave,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodOptional) {
    return jsx128(ZodOptionalEditor, {
      jsonPath,
      showSaveButton,
      defaultValue,
      value,
      setValue,
      onSave,
      onRemove,
      schema,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodNullable) {
    return jsx128(ZodNullableEditor, {
      jsonPath,
      showSaveButton,
      defaultValue,
      value,
      setValue,
      onSave,
      onRemove,
      schema,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodDefault) {
    return jsx128(ZodDefaultEditor, {
      jsonPath,
      showSaveButton,
      defaultValue,
      value,
      setValue,
      onSave,
      onRemove,
      schema,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === z.ZodFirstPartyTypeKind.ZodDiscriminatedUnion) {
    return jsx128(ZodDiscriminatedUnionEditor, {
      defaultValue,
      mayPad,
      schema,
      setValue,
      value,
      jsonPath,
      onRemove,
      onSave,
      saving,
      saveDisabledByParent,
      showSaveButton
    });
  }
  return jsx128(ZonNonEditableValue, {
    jsonPath,
    showSaveButton,
    label: `${typeName} (not editable)`,
    saving,
    mayPad
  });
};

// src/components/RenderModal/SchemaEditor/ZodObjectEditor.tsx
import {
jsx as jsx129,
jsxs as jsxs65
} from "react/jsx-runtime";
var ZodObjectEditor2 = ({
  schema,
  jsonPath,
  setValue,
  unsavedValue,
  savedValue,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad,
  discriminatedUnionReplacement
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const [expanded, setExpanded] = useState43(true);
  const { localValue, onChange, RevisionContextProvider, reset } = useLocalState({
    schema,
    setValue,
    unsavedValue,
    savedValue
  });
  const def = schema._def;
  const typeName = def.typeName;
  if (typeName !== z.ZodFirstPartyTypeKind.ZodObject) {
    throw new Error("expected object");
  }
  const shape = def.shape();
  const keys = Object.keys(shape);
  const isRoot = jsonPath.length === 0;
  const isDefaultValue = useMemo69(() => {
    return deepEqual(localValue.value, savedValue);
  }, [savedValue, localValue]);
  const suffix2 = useMemo69(() => {
    return expanded ? " {" : " {...}";
  }, [expanded]);
  return jsxs65(Fieldset, {
    shouldPad: !isRoot && mayPad,
    success: localValue.zodValidation.success,
    children: [
      isRoot ? null : jsx129(SchemaLabel, {
        isDefaultValue,
        onReset: reset,
        jsonPath,
        onRemove,
        suffix: suffix2,
        onSave: () => {
          onSave(() => {
            return localValue.value;
          }, false, false);
        },
        saveDisabledByParent,
        saving,
        showSaveButton,
        valid: localValue.zodValidation.success,
        handleClick: () => setExpanded(!expanded)
      }),
      expanded ? jsx129(RevisionContextProvider, {
        children: jsx129(SchemaVerticalGuide, {
          isRoot,
          children: keys.map((key, i) => {
            if (discriminatedUnionReplacement && key === discriminatedUnionReplacement.discriminator) {
              return discriminatedUnionReplacement.markup;
            }
            return jsxs65(React85.Fragment, {
              children: [
                jsx129(ZodSwitch2, {
                  mayPad: true,
                  jsonPath: [...jsonPath, key],
                  schema: shape[key],
                  value: localValue.value[key],
                  defaultValue: (savedValue ?? unsavedValue)[key],
                  setValue: (val, forceApply) => {
                    onChange((oldVal) => {
                      return {
                        ...oldVal,
                        [key]: typeof val === "function" ? val(oldVal[key]) : val
                      };
                    }, forceApply, false);
                  },
                  onSave: (val, forceApply) => {
                    onSave((oldVal) => {
                      return {
                        ...oldVal,
                        [key]: typeof val === "function" ? val(oldVal[key]) : val
                      };
                    }, forceApply, false);
                  },
                  onRemove: null,
                  showSaveButton,
                  saving,
                  saveDisabledByParent
                }),
                i === keys.length - 1 ? null : jsx129(SchemaSeparationLine, {})
              ]
            }, key);
          })
        })
      }) : null,
      isRoot || !expanded ? null : jsx129("div", {
        style: fieldsetLabel,
        children: "}"
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/SchemaEditor.tsx
import {
jsx as jsx130
} from "react/jsx-runtime";
var scrollable2 = {
  display: "flex",
  flexDirection: "column",
  overflowY: "auto"
};
var SchemaEditor = ({
  schema,
  unsavedDefaultProps,
  setValue,
  zodValidationResult,
  savedDefaultProps,
  onSave,
  showSaveButton,
  saving,
  saveDisabledByParent
}) => {
  const keybindings2 = useKeybinding();
  const [revision, setRevision] = useState44(0);
  const revisionState = useMemo70(() => {
    return {
      childResetRevision: revision
    };
  }, [revision]);
  useEffect41(() => {
    const bumpRevision = () => {
      setRevision((old) => old + 1);
    };
    window.addEventListener(Internals29.PROPS_UPDATED_EXTERNALLY, bumpRevision);
    return () => {
      window.removeEventListener(Internals29.PROPS_UPDATED_EXTERNALLY, bumpRevision);
    };
  }, []);
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const hasChanged = useMemo70(() => {
    return !deepEqual(savedDefaultProps, unsavedDefaultProps);
  }, [savedDefaultProps, unsavedDefaultProps]);
  useEffect41(() => {
    setUnsavedProps(hasChanged);
  }, [hasChanged]);
  const onQuickSave = useCallback61(() => {
    if (hasChanged && showSaveButton) {
      onSave(() => {
        return unsavedDefaultProps;
      });
    }
  }, [hasChanged, onSave, showSaveButton, unsavedDefaultProps]);
  useEffect41(() => {
    const save = keybindings2.registerKeybinding({
      event: "keydown",
      key: "s",
      commandCtrlKey: true,
      callback: onQuickSave,
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: true
    });
    return () => {
      save.unregister();
    };
  }, [keybindings2, onQuickSave, onSave]);
  const def = schema._def;
  const typeName = def.typeName;
  const reset = useCallback61(() => {
    setValue(savedDefaultProps);
  }, [savedDefaultProps, setValue]);
  if (!zodValidationResult.success) {
    const defaultPropsValid = schema.safeParse(savedDefaultProps);
    if (!defaultPropsValid.success) {
      return jsx130(InvalidDefaultProps, {
        zodValidationResult
      });
    }
    return jsx130(InvalidSchema, {
      reset,
      zodValidationResult
    });
  }
  if (typeName !== z.ZodFirstPartyTypeKind.ZodObject) {
    return jsx130(TopLevelZodValue, {
      typeReceived: typeName
    });
  }
  return jsx130("div", {
    ref: defaultPropsEditorScrollableAreaRef,
    style: scrollable2,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: jsx130(RevisionContext.Provider, {
      value: revisionState,
      children: jsx130(ZodObjectEditor2, {
        discriminatedUnionReplacement: null,
        unsavedValue: unsavedDefaultProps,
        setValue,
        jsonPath: [],
        schema,
        savedValue: savedDefaultProps,
        onSave,
        showSaveButton,
        onRemove: null,
        saving,
        saveDisabledByParent,
        mayPad: true
      })
    })
  });
};

// src/components/RenderModal/WarningIndicatorButton.tsx
import {useCallback as useCallback62, useMemo as useMemo71} from "react";
import {
jsx as jsx131,
jsxs as jsxs66
} from "react/jsx-runtime";
var style8 = {
  fontSize: 12,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "transparent",
  color: LIGHT_TEXT,
  borderStyle: "solid",
  borderWidth: 1,
  cursor: "pointer",
  paddingLeft: 8,
  paddingRight: 8,
  paddingTop: 4,
  paddingBottom: 4
};
var triangleStyle2 = {
  width: 12,
  height: 12,
  flexShrink: 0,
  fill: WARNING_COLOR
};
var WarningTriangle2 = (props) => {
  return jsx131("svg", {
    viewBox: "0 0 576 512",
    ...props,
    children: jsx131("path", {
      d: "M248.747 204.705l6.588 112c.373 6.343 5.626 11.295 11.979 11.295h41.37a12 12 0 0 0 11.979-11.295l6.588-112c.405-6.893-5.075-12.705-11.979-12.705h-54.547c-6.903 0-12.383 5.812-11.978 12.705zM330 384c0 23.196-18.804 42-42 42s-42-18.804-42-42 18.804-42 42-42 42 18.804 42 42zm-.423-360.015c-18.433-31.951-64.687-32.009-83.154 0L6.477 440.013C-11.945 471.946 11.118 512 48.054 512H527.94c36.865 0 60.035-39.993 41.577-71.987L329.577 23.985zM53.191 455.002L282.803 57.008c2.309-4.002 8.085-4.002 10.394 0l229.612 397.993c2.308 4-.579 8.998-5.197 8.998H58.388c-4.617.001-7.504-4.997-5.197-8.997z"
    })
  });
};
var WarningIndicatorButton = ({ setShowWarning, showWarning, warningCount }) => {
  const onClick = useCallback62(() => {
    setShowWarning((s) => !s);
  }, [setShowWarning]);
  const buttonStyle3 = useMemo71(() => {
    return {
      ...style8,
      backgroundColor: showWarning ? INPUT_BACKGROUND : "transparent",
      borderColor: showWarning ? INPUT_BORDER_COLOR_HOVERED : INPUT_BORDER_COLOR_UNHOVERED,
      color: showWarning ? "white" : LIGHT_TEXT
    };
  }, [showWarning]);
  return jsxs66("button", {
    type: "button",
    style: buttonStyle3,
    onClick,
    children: [
      jsx131(WarningTriangle2, {
        style: triangleStyle2
      }),
      jsx131(Spacing, {
        x: 0.5
      }),
      warningCount,
      jsx131(Spacing, {
        x: 1
      }),
      jsx131(AngleDown, {
        down: showWarning
      })
    ]
  });
};

// src/components/RenderModal/get-render-modal-warnings.ts
import {NoReactInternals as NoReactInternals9} from "remotion/no-react";
var defaultTypeCanSaveState = {
  canUpdate: false,
  reason: "Loading...",
  determined: false
};
var getInputPropsWarning = ({
  cliProps,
  propsEditType
}) => {
  if (Object.keys(cliProps).length > 0 && propsEditType === "default-props") {
    return "The data that was passed using --props takes priority over the data you enter here.";
  }
  return null;
};
var getCannotSaveDefaultProps = (canSaveDefaultProps) => {
  if (canSaveDefaultProps.canUpdate) {
    return null;
  }
  if (!canSaveDefaultProps.determined) {
    return null;
  }
  return `Can't save default props: ${canSaveDefaultProps.reason}.`;
};
var customDateUsed = (used, inJSONEditor) => {
  if (used && inJSONEditor) {
    return "There is a Date in the schema which was serialized. Note the custom syntax.";
  }
  return null;
};
var staticFileUsed = (used, inJSONEditor) => {
  if (used && inJSONEditor) {
    return "There is a staticFile() in the schema which was serialized. Note the custom syntax.";
  }
  return null;
};
var mapUsed = (used, inJSONEditor) => {
  if (used && inJSONEditor) {
    return "A `Map` was used in the schema which can not be serialized to JSON.";
  }
  return null;
};
var setUsed = (used, inJSONEditor) => {
  if (used && inJSONEditor) {
    return "A `Set` was used in the schema which can not be serialized to JSON.";
  }
  return null;
};
var getRenderModalWarnings = ({
  cliProps,
  canSaveDefaultProps,
  isCustomDateUsed,
  customFileUsed,
  jsMapUsed,
  jsSetUsed,
  inJSONEditor,
  propsEditType
}) => {
  return [
    getInputPropsWarning({ cliProps, propsEditType }),
    getCannotSaveDefaultProps(canSaveDefaultProps),
    customDateUsed(isCustomDateUsed, inJSONEditor),
    staticFileUsed(customFileUsed, inJSONEditor),
    mapUsed(jsMapUsed, inJSONEditor),
    setUsed(jsSetUsed, inJSONEditor)
  ].filter(NoReactInternals9.truthy);
};

// src/components/RenderModal/DataEditor.tsx
import {
jsx as jsx132,
jsxs as jsxs67
} from "react/jsx-runtime";
var errorExplanation2 = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var explainer3 = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  padding: "0 12px",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center"
};
var outer = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflow: "hidden",
  backgroundColor: BACKGROUND
};
var controlContainer = {
  flexDirection: "column",
  display: "flex",
  padding: 12,
  borderBottom: `1px solid ${BORDER_COLOR}`
};
var tabWrapper = {
  display: "flex",
  marginBottom: "4px",
  flexDirection: "row",
  alignItems: "center"
};
var persistanceKey = "remotion.show-render-modalwarning";
var getPersistedShowWarningState = () => {
  const val = localStorage.getItem(persistanceKey);
  if (!val) {
    return true;
  }
  return val === "true";
};
var setPersistedShowWarningState = (val) => {
  localStorage.setItem(persistanceKey, String(Boolean(val)));
};
var DataEditor = ({
  unresolvedComposition,
  defaultProps,
  setDefaultProps,
  mayShowSaveButton,
  propsEditType,
  saving,
  setSaving,
  readOnlyStudio
}) => {
  const [mode, setMode] = useState45("schema");
  const [showWarning, setShowWarningWithoutPersistance] = useState45(() => getPersistedShowWarningState());
  const { updateCompositionDefaultProps } = useContext33(Internals30.CompositionManager);
  const inJSONEditor = mode === "json";
  const serializedJSON = useMemo72(() => {
    if (!inJSONEditor) {
      return null;
    }
    const value = defaultProps;
    return NoReactInternals10.serializeJSONWithDate({
      data: value,
      indent: 2,
      staticBase: window.remotion_staticBase
    });
  }, [inJSONEditor, defaultProps]);
  const cliProps = getInputProps();
  const [canSaveDefaultPropsObjectState, setCanSaveDefaultProps] = useState45({
    [unresolvedComposition.id]: defaultTypeCanSaveState
  });
  const z = useZodIfPossible();
  const schema = useMemo72(() => {
    if (!z) {
      return "no-zod";
    }
    if (!unresolvedComposition.schema) {
      return "no-schema";
    }
    if (!(typeof unresolvedComposition.schema.safeParse === "function")) {
      throw new Error("A value which is not a Zod schema was passed to `schema`");
    }
    return unresolvedComposition.schema;
  }, [unresolvedComposition.schema, z]);
  const zodValidationResult = useMemo72(() => {
    if (schema === "no-zod") {
      return "no-zod";
    }
    if (schema === "no-schema") {
      return "no-schema";
    }
    return schema.safeParse(defaultProps);
  }, [defaultProps, schema]);
  const setShowWarning = useCallback63((val) => {
    setShowWarningWithoutPersistance((prevVal) => {
      if (typeof val === "boolean") {
        setPersistedShowWarningState(val);
        return val;
      }
      setPersistedShowWarningState(val(prevVal));
      return val(prevVal);
    });
  }, []);
  const canSaveDefaultProps = useMemo72(() => {
    return canSaveDefaultPropsObjectState[unresolvedComposition.id] ? canSaveDefaultPropsObjectState[unresolvedComposition.id] : defaultTypeCanSaveState;
  }, [canSaveDefaultPropsObjectState, unresolvedComposition.id]);
  const showSaveButton = mayShowSaveButton && canSaveDefaultProps.canUpdate;
  const { fastRefreshes } = useContext33(Internals30.NonceContext);
  const checkIfCanSaveDefaultProps = useCallback63(async () => {
    try {
      const can = await canUpdateDefaultProps(unresolvedComposition.id, readOnlyStudio);
      if (can.canUpdate) {
        setCanSaveDefaultProps((prevState) => ({
          ...prevState,
          [unresolvedComposition.id]: {
            canUpdate: true
          }
        }));
      } else {
        setCanSaveDefaultProps((prevState) => ({
          ...prevState,
          [unresolvedComposition.id]: {
            canUpdate: false,
            reason: can.reason,
            determined: true
          }
        }));
      }
    } catch (err) {
      setCanSaveDefaultProps((prevState) => ({
        ...prevState,
        [unresolvedComposition.id]: {
          canUpdate: false,
          reason: err.message,
          determined: true
        }
      }));
    }
  }, [readOnlyStudio, unresolvedComposition.id]);
  useEffect42(() => {
    checkIfCanSaveDefaultProps();
  }, [checkIfCanSaveDefaultProps]);
  const { previewServerState, subscribeToEvent } = useContext33(StudioServerConnectionCtx);
  useEffect42(() => {
    const unsub = subscribeToEvent("root-file-changed", checkIfCanSaveDefaultProps);
    return () => {
      unsub();
    };
  }, [checkIfCanSaveDefaultProps, subscribeToEvent]);
  const modeItems = useMemo72(() => {
    return [
      {
        key: "schema",
        label: "Schema",
        onClick: () => {
          setMode("schema");
        },
        selected: mode === "schema"
      },
      {
        key: "json",
        label: "JSON",
        onClick: () => {
          setMode("json");
        },
        selected: mode === "json"
      }
    ];
  }, [mode]);
  const onUpdate = useCallback63(() => {
    if (schema === "no-zod" || schema === "no-schema" || z === null) {
      showNotification("Cannot update default props: No Zod schema", 2000);
      return;
    }
    callUpdateDefaultPropsApi(unresolvedComposition.id, defaultProps, extractEnumJsonPaths(schema, z, [])).then((response) => {
      if (!response.success) {
        showNotification(`Cannot update default props: ${response.reason}`, 2000);
      }
    });
  }, [unresolvedComposition.id, defaultProps, schema, z]);
  const onSave = useCallback63((updater) => {
    if (schema === "no-zod" || schema === "no-schema" || z === null) {
      showNotification("Cannot update default props: No Zod schema", 2000);
      return;
    }
    window.remotion_ignoreFastRefreshUpdate = fastRefreshes + 1;
    setSaving(true);
    const newDefaultProps = updater(unresolvedComposition.defaultProps ?? {});
    callUpdateDefaultPropsApi(unresolvedComposition.id, newDefaultProps, extractEnumJsonPaths(schema, z, [])).then((response) => {
      if (!response.success) {
        console.log(response.stack);
        showNotification(`Cannot update default props: ${response.reason}. See console for more information.`, 2000);
      }
      updateCompositionDefaultProps(unresolvedComposition.id, newDefaultProps);
    }).catch((err) => {
      showNotification(`Cannot update default props: ${err.message}`, 2000);
    }).finally(() => {
      setSaving(false);
    });
  }, [
    schema,
    z,
    fastRefreshes,
    setSaving,
    unresolvedComposition.defaultProps,
    unresolvedComposition.id,
    updateCompositionDefaultProps
  ]);
  const connectionStatus = previewServerState.type;
  const warnings = useMemo72(() => {
    return getRenderModalWarnings({
      canSaveDefaultProps,
      cliProps,
      isCustomDateUsed: serializedJSON ? serializedJSON.customDateUsed : false,
      customFileUsed: serializedJSON ? serializedJSON.customFileUsed : false,
      inJSONEditor,
      propsEditType,
      jsMapUsed: serializedJSON ? serializedJSON.mapUsed : false,
      jsSetUsed: serializedJSON ? serializedJSON.setUsed : false
    });
  }, [
    cliProps,
    canSaveDefaultProps,
    inJSONEditor,
    propsEditType,
    serializedJSON
  ]);
  if (connectionStatus === "disconnected") {
    return jsxs67("div", {
      style: explainer3,
      children: [
        jsx132(Spacing, {
          y: 5
        }),
        jsx132("div", {
          style: errorExplanation2,
          children: "The studio server has disconnected. Reconnect to edit the schema."
        }),
        jsx132(Spacing, {
          y: 2,
          block: true
        })
      ]
    });
  }
  if (schema === "no-zod") {
    return jsx132(ZodNotInstalled, {});
  }
  if (schema === "no-schema") {
    return jsx132(NoSchemaDefined, {});
  }
  if (!z) {
    throw new Error("expected zod");
  }
  if (zodValidationResult === "no-zod") {
    throw new Error("expected zod");
  }
  if (zodValidationResult === "no-schema") {
    throw new Error("expected schema");
  }
  const def = schema._def;
  const typeName = def.typeName;
  if (typeName === z.ZodFirstPartyTypeKind.ZodAny) {
    return jsx132(NoSchemaDefined, {});
  }
  if (!unresolvedComposition.defaultProps) {
    return jsx132(NoDefaultProps, {});
  }
  return jsxs67("div", {
    style: outer,
    children: [
      jsxs67("div", {
        style: controlContainer,
        children: [
          jsxs67("div", {
            style: tabWrapper,
            children: [
              jsx132(SegmentedControl, {
                items: modeItems,
                needsWrapping: false
              }),
              jsx132(Flex, {}),
              warnings.length > 0 ? jsx132(WarningIndicatorButton, {
                setShowWarning,
                showWarning,
                warningCount: warnings.length
              }) : null
            ]
          }),
          showWarning && warnings.length > 0 ? warnings.map((warning) => jsxs67(React88.Fragment, {
            children: [
              jsx132(Spacing, {
                y: 1
              }),
              jsx132(ValidationMessage, {
                message: warning,
                align: "flex-start",
                type: "warning"
              })
            ]
          }, warning)) : null
        ]
      }),
      mode === "schema" ? jsx132(SchemaEditor, {
        unsavedDefaultProps: defaultProps,
        setValue: setDefaultProps,
        schema,
        zodValidationResult,
        savedDefaultProps: unresolvedComposition.defaultProps,
        onSave,
        showSaveButton,
        saving,
        saveDisabledByParent: !zodValidationResult.success
      }) : jsx132(RenderModalJSONPropsEditor, {
        value: defaultProps ?? {},
        setValue: setDefaultProps,
        onSave: onUpdate,
        showSaveButton,
        serializedJSON,
        defaultProps: unresolvedComposition.defaultProps,
        schema
      })
    ]
  });
};

// src/components/RenderQueue/index.tsx
import React98, {useContext as useContext39, useEffect as useEffect44, useMemo as useMemo79} from "react";
import {Internals as Internals32} from "remotion";

// src/components/RenderQueue/RenderQueueItem.tsx
import {
useCallback as useCallback72,
useContext as useContext38,
useEffect as useEffect43,
useMemo as useMemo78,
useState as useState46
} from "react";
import {Internals as Internals31} from "remotion";

// src/components/RenderQueue/RenderQueueCopyToClipboard.tsx
import {useCallback as useCallback64} from "react";
import {
jsx as jsx133
} from "react/jsx-runtime";
var revealIconStyle2 = {
  height: 12,
  color: "currentColor"
};
var supportsCopyingToClipboard = (job) => {
  if (job.status !== "done") {
    return false;
  }
  if (job.type !== "still") {
    return false;
  }
  if (job.imageFormat === "png") {
    return true;
  }
  if (job.imageFormat === "jpeg") {
    return true;
  }
  return false;
};
var RenderQueueCopyToClipboard = ({ job }) => {
  const renderCopyAction = useCallback64((color) => {
    return jsx133(ClipboardIcon, {
      style: revealIconStyle2,
      color
    });
  }, []);
  const onClick = useCallback64((e) => {
    e.stopPropagation();
    copyToClipboard({
      outName: job.outName,
      binariesDirectory: job.binariesDirectory
    }).catch((err) => {
      showNotification(`Could not copy to clipboard: ${err.message}`, 2000);
    }).then(() => {
      showNotification("Copied to clipboard", 1000);
    });
  }, [job.binariesDirectory, job.outName]);
  return jsx133(InlineAction, {
    title: "Copy to clipboard",
    renderAction: renderCopyAction,
    onClick
  });
};

// src/components/RenderQueue/RenderQueueError.tsx
import {useCallback as useCallback65, useContext as useContext34} from "react";

// src/components/RenderQueue/item-style.ts
var renderQueueItemSubtitleStyle = {
  fontSize: 13,
  color: LIGHT_TEXT,
  appearance: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
  lineHeight: 1.2,
  textAlign: "left",
  whiteSpace: "nowrap",
  marginRight: SPACING_UNIT,
  overflowX: "hidden",
  maxWidth: 500,
  textOverflow: "ellipsis"
};

// src/components/RenderQueue/RenderQueueError.tsx
import {
jsx as jsx134
} from "react/jsx-runtime";
var outputLocation = {
  ...renderQueueItemSubtitleStyle
};
var RenderQueueError = ({ job }) => {
  const { setSelectedModal } = useContext34(ModalsContext);
  const { tabIndex } = useZIndex();
  const onClick = useCallback65(() => {
    setSelectedModal({
      type: "render-progress",
      jobId: job.id
    });
  }, [job.id, setSelectedModal]);
  if (job.status !== "failed") {
    throw new Error("should not have rendered this component");
  }
  return jsx134("button", {
    onClick,
    type: "button",
    style: outputLocation,
    tabIndex,
    title: job.error.message,
    children: job.error.message
  });
};

// src/components/RenderQueue/RenderQueueItemCancelButton.tsx
import {useCallback as useCallback66, useMemo as useMemo73} from "react";
import {
jsx as jsx135
} from "react/jsx-runtime";
var RenderQueueCancelButton = ({ job }) => {
  const onClick = useCallback66((e) => {
    e.stopPropagation();
    cancelRenderJob(job).catch((err) => {
      showNotification(`Could not cancel job: ${err.message}`, 2000);
    });
  }, [job]);
  const icon4 = useMemo73(() => {
    return {
      height: 14,
      color: "currentColor"
    };
  }, []);
  const renderAction = useCallback66((color) => {
    return jsx135("svg", {
      style: icon4,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: jsx135("path", {
        fill: color,
        d: "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
      })
    });
  }, [icon4]);
  return jsx135(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderQueue/RenderQueueItemStatus.tsx
import React91, {useCallback as useCallback67, useContext as useContext35} from "react";

// src/components/RenderQueue/CircularProgress.tsx
import {
jsx as jsx136
} from "react/jsx-runtime";
var RENDER_STATUS_INDICATOR_SIZE = 16;
var STROKE_WIDTH = 3;
var container28 = {
  height: RENDER_STATUS_INDICATOR_SIZE,
  width: RENDER_STATUS_INDICATOR_SIZE,
  transform: `rotate(-90deg)`
};
var CircularProgress = ({ progress }) => {
  const r = RENDER_STATUS_INDICATOR_SIZE / 2 - STROKE_WIDTH;
  const circumference = r * Math.PI * 2;
  return jsx136("svg", {
    style: container28,
    viewBox: `0 0 ${RENDER_STATUS_INDICATOR_SIZE} ${RENDER_STATUS_INDICATOR_SIZE}`,
    children: jsx136("circle", {
      r: RENDER_STATUS_INDICATOR_SIZE / 2 - STROKE_WIDTH,
      stroke: LIGHT_TEXT,
      fill: "none",
      strokeWidth: STROKE_WIDTH,
      cx: RENDER_STATUS_INDICATOR_SIZE / 2,
      cy: RENDER_STATUS_INDICATOR_SIZE / 2,
      strokeDasharray: `${circumference} ${circumference}`,
      strokeMiterlimit: 0,
      strokeDashoffset: (1 - progress) * circumference
    })
  });
};

// src/components/RenderQueue/RenderQueueItemStatus.tsx
import {
jsx as jsx137
} from "react/jsx-runtime";
var iconStyle3 = {
  height: RENDER_STATUS_INDICATOR_SIZE,
  width: RENDER_STATUS_INDICATOR_SIZE
};
var invisibleStyle = {
  appearance: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
  display: "flex"
};
var RenderQueueItemStatus = ({ job }) => {
  const { setSelectedModal } = useContext35(ModalsContext);
  const [hovered, setHovered] = React91.useState(false);
  const onPointerEnter = useCallback67(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback67(() => {
    setHovered(false);
  }, []);
  const onClick = useCallback67((e) => {
    e.stopPropagation();
    setSelectedModal({
      type: "render-progress",
      jobId: job.id
    });
  }, [job.id, setSelectedModal]);
  if (job.status === "failed") {
    return jsx137("div", {
      children: jsx137("svg", {
        style: iconStyle3,
        viewBox: "0 0 512 512",
        children: jsx137("path", {
          fill: FAIL_COLOR,
          d: "M0 160V352L160 512H352L512 352V160L352 0H160L0 160zm353.9 32l-17 17-47 47 47 47 17 17L320 353.9l-17-17-47-47-47 47-17 17L158.1 320l17-17 47-47-47-47-17-17L192 158.1l17 17 47 47 47-47 17-17L353.9 192z"
        })
      })
    });
  }
  if (job.status === "idle") {
    return jsx137("svg", {
      style: iconStyle3,
      viewBox: "0 0 512 512",
      children: jsx137("path", {
        fill: LIGHT_TEXT,
        d: "M256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
      })
    });
  }
  if (job.status === "done") {
    return jsx137("button", {
      type: "button",
      style: invisibleStyle,
      onPointerEnter,
      onPointerLeave,
      onClick,
      children: jsx137("svg", {
        style: iconStyle3,
        viewBox: "0 0 512 512",
        children: jsx137("path", {
          fill: hovered ? "white" : LIGHT_TEXT,
          d: "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM369 209L241 337l-17 17-17-17-64-64-17-17L160 222.1l17 17 47 47L335 175l17-17L385.9 192l-17 17z"
        })
      })
    });
  }
  if (job.status === "running") {
    return jsx137("button", {
      type: "button",
      style: invisibleStyle,
      onClick,
      children: jsx137(CircularProgress, {
        progress: Math.max(0.07, job.progress.value)
      })
    });
  }
  throw new Error("Unknown job status");
};

// src/components/RenderQueue/RenderQueueOpenInFolder.tsx
import {useCallback as useCallback68, useMemo as useMemo74} from "react";
import {
jsx as jsx138
} from "react/jsx-runtime";
var RenderQueueOpenInFinderItem = ({ job }) => {
  const onClick = useCallback68((e) => {
    e.stopPropagation();
    openInFileExplorer({ directory: job.outName }).catch((err) => {
      showNotification(`Could not open file: ${err.message}`, 2000);
    });
  }, [job.outName]);
  const icon4 = useMemo74(() => {
    return {
      height: 12,
      color: "currentColor"
    };
  }, []);
  const renderAction = useCallback68((color) => {
    return jsx138(ExpandedFolderIconSolid, {
      style: icon4,
      color
    });
  }, [icon4]);
  return jsx138(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderQueue/RenderQueueOutputName.tsx
import {useMemo as useMemo75} from "react";
import {
jsx as jsx139
} from "react/jsx-runtime";
var RenderQueueOutputName = ({ job }) => {
  const style9 = useMemo75(() => {
    return {
      ...renderQueueItemSubtitleStyle,
      textDecoration: job.deletedOutputLocation ? "line-through" : "none",
      color: renderQueueItemSubtitleStyle.color,
      cursor: "inherit"
    };
  }, [job.deletedOutputLocation]);
  return jsx139("span", {
    style: style9,
    title: job.deletedOutputLocation ? "File was deleted" : job.outName,
    children: job.outName
  });
};

// src/components/RenderQueue/RenderQueueProgressMessage.tsx
import {useCallback as useCallback69, useContext as useContext36} from "react";
import {
jsx as jsx140
} from "react/jsx-runtime";
var outputLocation2 = {
  ...renderQueueItemSubtitleStyle
};
var RenderQueueProgressMessage = ({ job }) => {
  if (job.status !== "running") {
    throw new Error("should not have rendered this component");
  }
  const { setSelectedModal } = useContext36(ModalsContext);
  const { tabIndex } = useZIndex();
  const onClick = useCallback69(() => {
    setSelectedModal({
      type: "render-progress",
      jobId: job.id
    });
  }, [job, setSelectedModal]);
  return jsx140("button", {
    onClick,
    type: "button",
    style: outputLocation2,
    tabIndex,
    title: job.progress.message,
    children: job.progress.message
  });
};

// src/components/RenderQueue/RenderQueueRemoveItem.tsx
import {useCallback as useCallback70, useMemo as useMemo76} from "react";
import {
jsx as jsx141
} from "react/jsx-runtime";
var RenderQueueRemoveItem = ({ job }) => {
  const onClick = useCallback70((e) => {
    e.stopPropagation();
    removeRenderJob(job).then(() => {
      showNotification("Removed job", 2000);
    }).catch((err) => {
      showNotification(`Could not remove item: ${err.message}`, 2000);
    });
  }, [job]);
  const icon4 = useMemo76(() => {
    return {
      height: 16,
      color: "currentColor"
    };
  }, []);
  const renderAction = useCallback70((color) => {
    return jsx141("svg", {
      style: icon4,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 320 512",
      children: jsx141("path", {
        fill: color,
        d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
      })
    });
  }, [icon4]);
  return jsx141(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderQueue/RenderQueueRepeat.tsx
import {useCallback as useCallback71, useContext as useContext37, useMemo as useMemo77} from "react";

// src/helpers/retry-payload.ts
import {NoReactInternals as NoReactInternals11} from "remotion/no-react";
var makeRetryPayload = (job) => {
  const defaults = window.remotion_renderDefaults;
  if (!defaults) {
    throw new Error("defaults not set");
  }
  if (job.type === "still") {
    return {
      type: "render",
      compositionId: job.compositionId,
      initialFrame: job.frame,
      initialStillImageFormat: job.imageFormat,
      initialVideoImageFormat: defaults.videoImageFormat,
      initialJpegQuality: job.jpegQuality ?? defaults.jpegQuality,
      initialScale: job.scale,
      initialLogLevel: job.logLevel,
      initialConcurrency: defaults.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: defaults.muted,
      initialEnforceAudioTrack: defaults.enforceAudioTrack,
      initialProResProfile: defaults.proResProfile,
      initialx264Preset: defaults.x264Preset,
      initialPixelFormat: defaults.pixelFormat,
      initialAudioBitrate: defaults.audioBitrate,
      initialVideoBitrate: defaults.videoBitrate,
      initialEveryNthFrame: defaults.everyNthFrame,
      initialNumberOfGifLoops: defaults.numberOfGifLoops,
      initialDelayRenderTimeout: job.delayRenderTimeout,
      defaultConfigurationAudioCodec: defaults.audioCodec,
      initialEnvVariables: job.envVariables,
      initialDisableWebSecurity: job.chromiumOptions.disableWebSecurity,
      initialOpenGlRenderer: job.chromiumOptions.gl,
      initialHeadless: job.chromiumOptions.headless,
      initialIgnoreCertificateErrors: job.chromiumOptions.ignoreCertificateErrors,
      defaultProps: NoReactInternals11.deserializeJSONWithCustomFields(job.serializedInputPropsWithCustomSchema),
      inFrameMark: null,
      outFrameMark: null,
      initialOffthreadVideoCacheSizeInBytes: job.offthreadVideoCacheSizeInBytes,
      initialColorSpace: defaults.colorSpace,
      initialMultiProcessOnLinux: job.multiProcessOnLinux,
      defaultConfigurationVideoCodec: defaults.codec,
      initialEncodingBufferSize: defaults.encodingBufferSize,
      initialEncodingMaxRate: defaults.encodingMaxRate,
      initialUserAgent: job.chromiumOptions.userAgent,
      initialBeep: job.beepOnFinish,
      initialRepro: job.repro,
      initialForSeamlessAacConcatenation: defaults.forSeamlessAacConcatenation,
      renderTypeOfLastRender: "still"
    };
  }
  if (job.type === "sequence") {
    return {
      type: "render",
      initialFrame: 0,
      compositionId: job.compositionId,
      initialVideoImageFormat: defaults.videoImageFormat,
      initialJpegQuality: job.jpegQuality ?? defaults.jpegQuality,
      initialScale: job.scale,
      initialLogLevel: job.logLevel,
      initialConcurrency: defaults.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: defaults.muted,
      initialEnforceAudioTrack: defaults.enforceAudioTrack,
      initialProResProfile: defaults.proResProfile,
      initialx264Preset: defaults.x264Preset,
      initialPixelFormat: defaults.pixelFormat,
      initialAudioBitrate: defaults.audioBitrate,
      initialVideoBitrate: defaults.videoBitrate,
      initialEveryNthFrame: defaults.everyNthFrame,
      initialNumberOfGifLoops: defaults.numberOfGifLoops,
      initialDelayRenderTimeout: job.delayRenderTimeout,
      initialEnvVariables: job.envVariables,
      initialDisableWebSecurity: job.chromiumOptions.disableWebSecurity,
      initialOpenGlRenderer: job.chromiumOptions.gl,
      initialHeadless: job.chromiumOptions.headless,
      initialIgnoreCertificateErrors: job.chromiumOptions.ignoreCertificateErrors,
      defaultProps: NoReactInternals11.deserializeJSONWithCustomFields(job.serializedInputPropsWithCustomSchema),
      initialStillImageFormat: defaults.stillImageFormat,
      inFrameMark: job.startFrame,
      outFrameMark: job.endFrame,
      initialOffthreadVideoCacheSizeInBytes: job.offthreadVideoCacheSizeInBytes,
      initialColorSpace: defaults.colorSpace,
      initialMultiProcessOnLinux: job.multiProcessOnLinux,
      defaultConfigurationVideoCodec: defaults.codec,
      defaultConfigurationAudioCodec: defaults.audioCodec,
      initialEncodingBufferSize: defaults.encodingBufferSize,
      initialEncodingMaxRate: defaults.encodingMaxRate,
      initialUserAgent: job.chromiumOptions.userAgent,
      initialBeep: job.beepOnFinish,
      initialRepro: job.repro,
      initialForSeamlessAacConcatenation: defaults.forSeamlessAacConcatenation,
      renderTypeOfLastRender: "sequence"
    };
  }
  if (job.type === "video") {
    return {
      type: "render",
      compositionId: job.compositionId,
      initialStillImageFormat: defaults.stillImageFormat,
      initialVideoImageFormat: job.imageFormat,
      initialJpegQuality: job.jpegQuality ?? defaults.jpegQuality,
      initialScale: job.scale,
      initialLogLevel: job.logLevel,
      initialFrame: 0,
      initialConcurrency: job.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: job.muted,
      initialEnforceAudioTrack: job.enforceAudioTrack,
      initialProResProfile: job.proResProfile ?? defaults.proResProfile,
      initialx264Preset: job.x264Preset ?? defaults.x264Preset,
      initialPixelFormat: job.pixelFormat,
      initialAudioBitrate: job.audioBitrate,
      initialVideoBitrate: job.videoBitrate,
      initialEveryNthFrame: job.everyNthFrame,
      initialNumberOfGifLoops: job.numberOfGifLoops,
      initialDelayRenderTimeout: job.delayRenderTimeout,
      initialEnvVariables: job.envVariables,
      initialDisableWebSecurity: job.chromiumOptions.disableWebSecurity,
      initialOpenGlRenderer: job.chromiumOptions.gl,
      initialHeadless: job.chromiumOptions.headless,
      initialIgnoreCertificateErrors: job.chromiumOptions.ignoreCertificateErrors,
      defaultProps: NoReactInternals11.deserializeJSONWithCustomFields(job.serializedInputPropsWithCustomSchema),
      inFrameMark: job.startFrame,
      outFrameMark: job.endFrame,
      initialOffthreadVideoCacheSizeInBytes: job.offthreadVideoCacheSizeInBytes,
      initialColorSpace: job.colorSpace,
      initialMultiProcessOnLinux: job.multiProcessOnLinux,
      defaultConfigurationVideoCodec: job.codec,
      defaultConfigurationAudioCodec: job.audioCodec,
      initialEncodingBufferSize: job.encodingBufferSize,
      initialEncodingMaxRate: job.encodingMaxRate,
      initialUserAgent: job.chromiumOptions.userAgent,
      initialBeep: job.beepOnFinish,
      initialRepro: job.repro,
      initialForSeamlessAacConcatenation: job.forSeamlessAacConcatenation,
      renderTypeOfLastRender: "video"
    };
  }
  throw new Error(`Job ${JSON.stringify(job)} Not implemented`);
};

// src/components/RenderQueue/RenderQueueRepeat.tsx
import {
jsx as jsx142
} from "react/jsx-runtime";
var RenderQueueRepeatItem = ({ job }) => {
  const { setSelectedModal } = useContext37(ModalsContext);
  const isMobileLayout = useMobileLayout();
  const { setSidebarCollapsedState } = useContext37(SidebarContext);
  const onClick = useCallback71((e) => {
    e.stopPropagation();
    const retryPayload = makeRetryPayload(job);
    setSelectedModal(retryPayload);
    if (isMobileLayout) {
      setSidebarCollapsedState({ left: "collapsed", right: "collapsed" });
    }
  }, [isMobileLayout, job, setSelectedModal, setSidebarCollapsedState]);
  const icon4 = useMemo77(() => {
    return {
      height: 12,
      color: "currentColor"
    };
  }, []);
  const renderAction = useCallback71((color) => {
    return jsx142("svg", {
      style: icon4,
      viewBox: "0 0 512 512",
      children: jsx142("path", {
        fill: color,
        d: "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
      })
    });
  }, [icon4]);
  return jsx142(InlineAction, {
    onClick,
    renderAction
  });
};

// src/components/RenderQueue/RenderQueueItem.tsx
import {
jsx as jsx143,
jsxs as jsxs68
} from "react/jsx-runtime";
var container29 = {
  padding: 12,
  display: "flex",
  flexDirection: "row",
  paddingBottom: 10,
  paddingRight: 4
};
var title3 = {
  fontSize: 13,
  lineHeight: 1
};
var right = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden"
};
var subtitle2 = {
  maxWidth: "100%",
  flex: 1,
  display: "flex",
  overflow: "hidden"
};
var SELECTED_CLASSNAME = "__remotion_selected_classname";
var RenderQueueItem = ({ job, selected }) => {
  const [hovered, setHovered] = useState46(false);
  const { setCanvasContent } = useContext38(Internals31.CompositionManager);
  const onPointerEnter = useCallback72(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback72(() => {
    setHovered(false);
  }, []);
  const isHoverable = job.status === "done";
  const containerStyle2 = useMemo78(() => {
    return {
      ...container29,
      backgroundColor: getBackgroundFromHoverState({
        hovered: isHoverable && hovered,
        selected
      }),
      userSelect: "none",
      WebkitUserSelect: "none"
    };
  }, [hovered, isHoverable, selected]);
  const scrollCurrentIntoView = useCallback72(() => {
    document.querySelector(`.${SELECTED_CLASSNAME}`)?.scrollIntoView({ behavior: "smooth" });
  }, []);
  const onClick = useCallback72(() => {
    if (job.status !== "done") {
      return;
    }
    setCanvasContent((c) => {
      const isAlreadySelected = c && c.type === "output" && c.path === `/${job.outName}`;
      if (isAlreadySelected && !selected) {
        scrollCurrentIntoView();
        return c;
      }
      return { type: "output", path: `/${job.outName}` };
    });
    pushUrl(`/outputs/${job.outName}`);
  }, [
    job.outName,
    job.status,
    scrollCurrentIntoView,
    selected,
    setCanvasContent
  ]);
  useEffect43(() => {
    if (selected) {
      scrollCurrentIntoView();
    }
  }, [scrollCurrentIntoView, selected]);
  return jsxs68(Row, {
    onPointerEnter,
    onPointerLeave,
    style: containerStyle2,
    align: "center",
    onClick,
    className: selected ? SELECTED_CLASSNAME : undefined,
    children: [
      jsx143(RenderQueueItemStatus, {
        job
      }),
      jsx143(Spacing, {
        x: 1
      }),
      jsxs68("div", {
        style: right,
        children: [
          jsx143("div", {
            style: title3,
            children: job.compositionId
          }),
          jsx143("div", {
            style: subtitle2,
            children: job.status === "done" ? jsx143(RenderQueueOutputName, {
              job
            }) : job.status === "failed" ? jsx143(RenderQueueError, {
              job
            }) : job.status === "running" ? jsx143(RenderQueueProgressMessage, {
              job
            }) : null
          })
        ]
      }),
      jsx143(Spacing, {
        x: 1
      }),
      supportsCopyingToClipboard(job) ? jsx143(RenderQueueCopyToClipboard, {
        job
      }) : null,
      job.status === "done" || job.status === "failed" ? jsx143(RenderQueueRepeatItem, {
        job
      }) : null,
      job.status === "running" ? jsx143(RenderQueueCancelButton, {
        job
      }) : jsx143(RenderQueueRemoveItem, {
        job
      }),
      job.status === "done" ? jsx143(RenderQueueOpenInFinderItem, {
        job
      }) : null
    ]
  });
};

// src/components/RenderQueue/index.tsx
import {
jsx as jsx144,
jsxs as jsxs69
} from "react/jsx-runtime";
var separatorStyle = {
  borderBottom: `1px solid ${BORDER_COLOR}`
};
var errorExplanation3 = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var explainer4 = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  padding: "0 12px",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  background: BACKGROUND
};
var renderQueue = {
  background: BACKGROUND,
  flex: 1,
  overflowY: "auto"
};
var RenderQueue = () => {
  const connectionStatus = useContext39(StudioServerConnectionCtx).previewServerState.type;
  const { jobs } = useContext39(RenderQueueContext);
  const { canvasContent } = useContext39(Internals32.CompositionManager);
  const previousJobCount = React98.useRef(jobs.length);
  const jobCount = jobs.length;
  const divRef = React98.useRef(null);
  useEffect44(() => {
    if (!divRef.current) {
      return;
    }
    if (jobCount > previousJobCount.current) {
      divRef.current.scrollTo({
        top: divRef.current.scrollHeight,
        behavior: "smooth"
      });
    }
    previousJobCount.current = jobCount;
  }, [jobCount]);
  const selectedJob = useMemo79(() => {
    let selectedIndex = -1;
    for (let i = 0;i < jobs.length; i++) {
      const job = jobs[i];
      if (canvasContent && canvasContent.type === "output" && canvasContent.path === `/${job.outName}` && job.status === "done") {
        selectedIndex = i;
      }
    }
    return selectedIndex;
  }, [canvasContent, jobs]);
  if (connectionStatus === "disconnected") {
    return jsxs69("div", {
      style: explainer4,
      children: [
        jsx144(Spacing, {
          y: 5
        }),
        jsx144("div", {
          style: errorExplanation3,
          children: "The studio server has disconnected."
        }),
        jsx144(Spacing, {
          y: 2,
          block: true
        })
      ]
    });
  }
  if (jobCount === 0) {
    return jsxs69("div", {
      style: explainer4,
      children: [
        jsx144(Spacing, {
          y: 5
        }),
        jsx144("div", {
          style: errorExplanation3,
          children: "No renders in the queue."
        }),
        jsx144(Spacing, {
          y: 2,
          block: true
        })
      ]
    });
  }
  return jsx144("div", {
    ref: divRef,
    style: renderQueue,
    className: ["css-reset", VERTICAL_SCROLLBAR_CLASSNAME].join(" "),
    children: jobs.map((j, index) => {
      return jsx144("div", {
        style: index === jobs.length - 1 ? undefined : separatorStyle,
        children: jsx144(RenderQueueItem, {
          selected: selectedJob === index,
          job: j
        })
      }, j.id);
    })
  });
};

// src/components/RendersTab.tsx
import {useContext as useContext40, useMemo as useMemo80} from "react";
import {Internals as Internals33} from "remotion";
import {
jsx as jsx145,
jsxs as jsxs70,
Fragment as Fragment20
} from "react/jsx-runtime";
var row3 = {
  display: "flex",
  flexDirection: "row",
  fontSize: 14,
  color: "inherit",
  alignItems: "center",
  flex: 1
};
var badge = {
  height: 16,
  width: 16,
  borderRadius: 3,
  fontSize: 10,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center"
};
var RendersTab = ({ selected, onClick }) => {
  const { jobs } = useContext40(RenderQueueContext);
  const { canvasContent } = useContext40(Internals33.CompositionManager);
  const failedJobs = jobs.filter((j) => j.status === "failed").length;
  const jobCount = jobs.length;
  const isActuallySelected = useMemo80(() => {
    if (!canvasContent || canvasContent.type !== "composition") {
      return true;
    }
    return selected;
  }, [canvasContent, selected]);
  const badgeStyle = useMemo80(() => {
    return {
      ...badge,
      backgroundColor: failedJobs > 0 ? FAIL_COLOR : "transparent",
      color: failedJobs > 0 ? "white" : LIGHT_TEXT,
      borderWidth: failedJobs > 0 ? 0 : 1,
      borderStyle: "solid",
      borderColor: LIGHT_TEXT
    };
  }, [failedJobs]);
  return jsx145(Tab, {
    selected: isActuallySelected,
    onClick,
    children: jsxs70("div", {
      style: row3,
      children: [
        "Renders",
        jobCount > 0 ? jsxs70(Fragment20, {
          children: [
            jsx145(Flex, {}),
            jsx145("div", {
              style: badgeStyle,
              children: jobCount
            })
          ]
        }) : null
      ]
    })
  });
};

// src/components/OptionsPanel.tsx
import {
jsx as jsx146,
jsxs as jsxs71
} from "react/jsx-runtime";
var localStorageKey3 = "remotion.sidebarPanel";
var getSelectedPanel2 = (readOnlyStudio) => {
  if (readOnlyStudio) {
    return "input-props";
  }
  const panel = localStorage.getItem(localStorageKey3);
  if (panel === "renders") {
    return "renders";
  }
  return "input-props";
};
var tabsContainer3 = {
  backgroundColor: BACKGROUND
};
var persistSelectedOptionsSidebarPanel2 = (panel) => {
  localStorage.setItem(localStorageKey3, panel);
};
var optionsSidebarTabs = createRef8();
var OptionsPanel = ({ readOnlyStudio }) => {
  const { props, updateProps, resetUnsaved } = useContext41(Internals34.EditorPropsContext);
  const [saving, setSaving] = useState47(false);
  const isMobileLayout = useMobileLayout();
  const container30 = useMemo81(() => ({
    height: "100%",
    width: "100%",
    display: "flex",
    position: isMobileLayout ? "relative" : "absolute",
    flexDirection: "column",
    flex: 1
  }), [isMobileLayout]);
  const [panel, setPanel] = useState47(() => getSelectedPanel2(readOnlyStudio));
  const onPropsSelected = useCallback73(() => {
    setPanel("input-props");
    persistSelectedOptionsSidebarPanel2("input-props");
  }, []);
  const onRendersSelected = useCallback73(() => {
    setPanel("renders");
    persistSelectedOptionsSidebarPanel2("renders");
  }, []);
  useImperativeHandle11(optionsSidebarTabs, () => {
    return {
      selectRendersPanel: () => {
        setPanel("renders");
        persistSelectedOptionsSidebarPanel2("renders");
      }
    };
  }, []);
  const { compositions, canvasContent } = useContext41(Internals34.CompositionManager);
  const composition = useMemo81(() => {
    if (canvasContent === null || canvasContent.type !== "composition") {
      return null;
    }
    for (const comp of compositions) {
      if (comp.id === canvasContent.compositionId) {
        return comp;
      }
    }
    return null;
  }, [canvasContent, compositions]);
  const setDefaultProps = useCallback73((newProps) => {
    if (composition === null) {
      return;
    }
    window.remotion_ignoreFastRefreshUpdate = null;
    updateProps({
      id: composition.id,
      defaultProps: composition.defaultProps,
      newProps
    });
  }, [composition, updateProps]);
  const currentDefaultProps = useMemo81(() => {
    if (composition === null) {
      return {};
    }
    return props[composition.id] ?? composition.defaultProps ?? {};
  }, [composition, props]);
  const unsavedChangesExist = useMemo81(() => {
    if (composition === null || composition.defaultProps === undefined) {
      return false;
    }
    return !deepEqual(composition.defaultProps, currentDefaultProps);
  }, [currentDefaultProps, composition]);
  const reset = useCallback73(() => {
    resetUnsaved();
  }, [resetUnsaved]);
  useEffect45(() => {
    window.addEventListener(Internals34.PROPS_UPDATED_EXTERNALLY, reset);
    return () => {
      window.removeEventListener(Internals34.PROPS_UPDATED_EXTERNALLY, reset);
    };
  }, [reset]);
  return jsxs71("div", {
    style: container30,
    className: "css-reset",
    children: [
      jsx146("div", {
        style: tabsContainer3,
        children: jsxs71(Tabs, {
          children: [
            composition ? jsxs71(Tab, {
              selected: panel === "input-props",
              onClick: onPropsSelected,
              style: { justifyContent: "space-between" },
              children: [
                "Props",
                unsavedChangesExist ? jsx146(GlobalPropsEditorUpdateButton, {
                  compositionId: composition.id,
                  currentDefaultProps
                }) : null
              ]
            }) : null,
            readOnlyStudio ? null : jsx146(RendersTab, {
              onClick: onRendersSelected,
              selected: panel === "renders"
            })
          ]
        })
      }),
      panel === `input-props` && composition ? jsx146(DataEditor, {
        unresolvedComposition: composition,
        defaultProps: currentDefaultProps,
        setDefaultProps,
        mayShowSaveButton: true,
        propsEditType: "default-props",
        saving,
        setSaving,
        readOnlyStudio
      }, composition.id) : readOnlyStudio ? null : jsx146(RenderQueue, {})
    ]
  });
};

// src/components/PreviewToolbar.tsx
import {useContext as useContext48, useState as useState50} from "react";
import {Internals as Internals42} from "remotion";

// src/state/loop.ts
var key = "remotion.loop";
var persistLoopOption = (option) => {
  localStorage.setItem(key, String(option));
};
var loadLoopOption = () => {
  const item2 = localStorage.getItem(key);
  return item2 !== "false";
};

// src/components/CheckboardToggle.tsx
import {useCallback as useCallback74, useContext as useContext42} from "react";
import {NoReactInternals as NoReactInternals12} from "remotion/no-react";
import {
jsx as jsx147
} from "react/jsx-runtime";
var accessibilityLabel2 = [
  "Show transparency as checkerboard",
  areKeyboardShortcutsDisabled() ? null : "(T)"
].filter(NoReactInternals12.truthy).join(" ");
var CheckboardToggle = () => {
  const { checkerboard: checkerboard4, setCheckerboard } = useContext42(CheckerboardContext);
  const onClick = useCallback74(() => {
    setCheckerboard((c) => {
      return !c;
    });
  }, [setCheckerboard]);
  return jsx147(ControlButton, {
    title: accessibilityLabel2,
    "aria-label": accessibilityLabel2,
    onClick,
    children: jsx147("svg", {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "fas",
      "data-icon": "game-board-alt",
      className: "svg-inline--fa fa-game-board-alt fa-w-16",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      style: { width: 16, height: 16 },
      children: jsx147("path", {
        fill: checkerboard4 ? BLUE : "white",
        d: "M480 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm-32 256H256v192H64V256h192V64h192z"
      })
    })
  });
};

// src/components/FpsCounter.tsx
import {
useEffect as useEffect46,
useLayoutEffect,
useMemo as useMemo82,
useRef as useRef26,
useState as useState48
} from "react";
import {Internals as Internals35} from "remotion";
import {
jsxs as jsxs72
} from "react/jsx-runtime";
var label6 = {
  color: "white",
  fontSize: 15,
  fontFamily: "Arial, Helvetica, sans-serif"
};
var pushWithMaxSize = (arr, value, maxSize) => {
  arr.push(value);
  return arr.slice(-maxSize);
};
var FpsCounter = ({ playbackSpeed }) => {
  const videoConfig = Internals35.useUnsafeVideoConfig();
  const [playing] = Internals35.Timeline.usePlayingState();
  const frame2 = Internals35.Timeline.useTimelinePosition();
  const [marker, rerender] = useState48({});
  const [fps, setFps] = useState48(0);
  const previousUpdates = useRef26([]);
  const fpsRef = useRef26(0);
  const playingRef = useRef26(playing);
  useLayoutEffect(() => {
    fpsRef.current = 0;
    previousUpdates.current = [];
    playingRef.current = playing;
  }, [playing]);
  useLayoutEffect(() => {
    if (playingRef.current === false)
      return;
    previousUpdates.current = pushWithMaxSize(previousUpdates.current, performance.now(), 15);
    if (previousUpdates.current.length < 2)
      return;
    const diff = Math.max(...previousUpdates.current) - Math.min(...previousUpdates.current);
    const averageDistanceBetween = diff / (previousUpdates.current.length - 1);
    fpsRef.current = 1000 / averageDistanceBetween;
    if (previousUpdates.current.length === 2)
      setFps(fpsRef.current);
  }, [frame2]);
  useEffect46(() => {
    if (playing) {
      const t = setTimeout(() => {
        rerender({});
        setFps(fpsRef.current);
      }, 1000);
      return () => clearTimeout(t);
    }
  }, [marker, playing]);
  const style9 = useMemo82(() => {
    if (!videoConfig) {
      return {};
    }
    const expectedFps = Math.abs(playbackSpeed) * videoConfig.fps;
    return {
      ...label6,
      color: fps < expectedFps * 0.9 ? "red" : "white"
    };
  }, [fps, playbackSpeed, videoConfig]);
  if (fps === 0) {
    return null;
  }
  if (playing === false) {
    return null;
  }
  if (videoConfig === null) {
    return null;
  }
  return jsxs72("div", {
    style: style9,
    children: [
      fps.toFixed(1),
      " FPS"
    ]
  });
};

// src/components/FullscreenToggle.tsx
import {useCallback as useCallback75, useContext as useContext43, useEffect as useEffect47} from "react";
import {Internals as Internals36} from "remotion";
import {NoReactInternals as NoReactInternals13} from "remotion/no-react";
import {
jsx as jsx148
} from "react/jsx-runtime";
var accessibilityLabel3 = [
  "Enter fullscreen preview",
  areKeyboardShortcutsDisabled() ? null : "(F)"
].filter(NoReactInternals13.truthy).join(" ");
var FullScreenToggle = () => {
  const keybindings2 = useKeybinding();
  const { setSize } = useContext43(Internals36.PreviewSizeContext);
  const onClick = useCallback75(() => {
    drawRef.current?.requestFullscreen();
    if (document.fullscreenElement)
      setSize(() => ({
        size: "auto",
        translation: {
          x: 0,
          y: 0
        }
      }));
  }, [setSize]);
  useEffect47(() => {
    const f = keybindings2.registerKeybinding({
      event: "keydown",
      key: "f",
      callback: onClick,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      f.unregister();
    };
  }, [keybindings2, onClick]);
  return jsx148(ControlButton, {
    title: accessibilityLabel3,
    "aria-label": accessibilityLabel3,
    onClick,
    children: jsx148("svg", {
      style: { width: 18, height: 18 },
      viewBox: "0 0 448 512",
      fill: "#fff",
      children: jsx148("path", {
        d: "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
      })
    })
  });
};

// src/components/LoopToggle.tsx
import {useCallback as useCallback76} from "react";
import {
jsx as jsx149
} from "react/jsx-runtime";
var accessibilityLabel4 = "Loop video";
var LoopToggle = ({ loop: loop2, setLoop }) => {
  const onClick = useCallback76(() => {
    setLoop((c) => {
      persistLoopOption(!c);
      return !c;
    });
  }, [setLoop]);
  return jsx149(ControlButton, {
    title: accessibilityLabel4,
    "aria-label": accessibilityLabel4,
    onClick,
    children: jsx149("svg", {
      viewBox: "0 0 512 512",
      style: { width: 18, height: 18 },
      children: jsx149("path", {
        fill: loop2 ? BLUE : "white",
        d: "M493.544 181.463c11.956 22.605 18.655 48.4 18.452 75.75C511.339 345.365 438.56 416 350.404 416H192v47.495c0 22.475-26.177 32.268-40.971 17.475l-80-80c-9.372-9.373-9.372-24.569 0-33.941l80-80C166.138 271.92 192 282.686 192 304v48h158.875c52.812 0 96.575-42.182 97.12-94.992.155-15.045-3.17-29.312-9.218-42.046-4.362-9.185-2.421-20.124 4.8-27.284 4.745-4.706 8.641-8.555 11.876-11.786 11.368-11.352 30.579-8.631 38.091 5.571zM64.005 254.992c.545-52.81 44.308-94.992 97.12-94.992H320v47.505c0 22.374 26.121 32.312 40.971 17.465l80-80c9.372-9.373 9.372-24.569 0-33.941l-80-80C346.014 16.077 320 26.256 320 48.545V96H161.596C73.44 96 .661 166.635.005 254.788c-.204 27.35 6.495 53.145 18.452 75.75 7.512 14.202 26.723 16.923 38.091 5.57 3.235-3.231 7.13-7.08 11.876-11.786 7.22-7.16 9.162-18.098 4.8-27.284-6.049-12.735-9.374-27.001-9.219-42.046z"
      })
    })
  });
};

// src/components/MuteToggle.tsx
import {useCallback as useCallback77} from "react";

// src/icons/media-volume.tsx
import {
jsx as jsx150
} from "react/jsx-runtime";
var size3 = 22;
var VolumeOffIcon = () => {
  return jsx150("svg", {
    width: size3,
    height: size3,
    viewBox: "0 0 24 24",
    children: jsx150("path", {
      d: "M3.63 3.63a.996.996 0 000 1.41L7.29 8.7 7 9H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71v-4.17l4.18 4.18c-.49.37-1.02.68-1.6.91-.36.15-.58.53-.58.92 0 .72.73 1.18 1.39.91.8-.33 1.55-.77 2.22-1.31l1.34 1.34a.996.996 0 101.41-1.41L5.05 3.63c-.39-.39-1.02-.39-1.42 0zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-3.83-2.4-7.11-5.78-8.4-.59-.23-1.22.23-1.22.86v.19c0 .38.25.71.61.85C17.18 6.54 19 9.06 19 12zm-8.71-6.29l-.17.17L12 7.76V6.41c0-.89-1.08-1.33-1.71-.7zM16.5 12A4.5 4.5 0 0014 7.97v1.79l2.48 2.48c.01-.08.02-.16.02-.24z",
      fill: BLUE
    })
  });
};
var VolumeOnIcon = () => {
  return jsx150("svg", {
    width: size3,
    height: size3,
    viewBox: "0 0 24 24",
    children: jsx150("path", {
      d: "M3 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L7 9H4c-.55 0-1 .45-1 1zm13.5 2A4.5 4.5 0 0014 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 4.45v.2c0 .38.25.71.6.85C17.18 6.53 19 9.06 19 12s-1.82 5.47-4.4 6.5c-.36.14-.6.47-.6.85v.2c0 .63.63 1.07 1.21.85C18.6 19.11 21 15.84 21 12s-2.4-7.11-5.79-8.4c-.58-.23-1.21.22-1.21.85z",
      fill: "#fff"
    })
  });
};

// src/state/mute.ts
var key2 = "remotion.mute";
var persistMuteOption = (option) => {
  localStorage.setItem(key2, String(option));
};
var loadMuteOption = () => {
  const item2 = localStorage.getItem(key2);
  return item2 === "true";
};

// src/components/MuteToggle.tsx
import {
jsx as jsx151
} from "react/jsx-runtime";
var MuteToggle = ({ muted, setMuted }) => {
  const onClick = useCallback77(() => {
    setMuted((m) => {
      persistMuteOption(!m);
      return !m;
    });
  }, [setMuted]);
  const accessibilityLabel5 = muted ? "Unmute video" : "Mute video";
  return jsx151(ControlButton, {
    title: accessibilityLabel5,
    "aria-label": accessibilityLabel5,
    onClick,
    children: muted ? jsx151(VolumeOffIcon, {}) : jsx151(VolumeOnIcon, {})
  });
};

// src/components/PlayPause.tsx
import {PlayerInternals as PlayerInternals12} from "@remotion/player";
import {useCallback as useCallback78, useEffect as useEffect48, useState as useState49} from "react";
import {Internals as Internals37} from "remotion";

// src/icons/jump-to-start.tsx
import {
jsx as jsx152
} from "react/jsx-runtime";
var JumpToStart = (props) => {
  return jsx152("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ...props,
    children: jsx152("path", {
      fill: "currentColor",
      d: "M0 415.1V96.03c0-17.67 14.33-31.1 31.1-31.1C49.67 64.03 64 78.36 64 96.03v131.8l171.5-156.5C256.1 54.28 288 68.66 288 96.03v131.9l171.5-156.5C480.1 54.28 512 68.66 512 96.03v319.9c0 27.37-31.88 41.74-52.5 24.62L288 285.2v130.7c0 27.37-31.88 41.74-52.5 24.62L64 285.2v130.7c0 17.67-14.33 31.1-31.1 31.1C14.33 447.1 0 433.6 0 415.1z"
    })
  });
};

// src/icons/pause.tsx
import {
jsx as jsx153
} from "react/jsx-runtime";
var Pause = (props) => jsx153("svg", {
  ...props,
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "pause",
  className: "svg-inline--fa fa-pause fa-w-14",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  children: jsx153("path", {
    fill: "currentColor",
    d: "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
  })
});

// src/icons/play.tsx
import {
jsx as jsx154
} from "react/jsx-runtime";
var Play = (props) => jsx154("svg", {
  ...props,
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "play",
  className: "svg-inline--fa fa-play fa-w-14",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  children: jsx154("path", {
    fill: "currentColor",
    d: "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
  })
});

// src/icons/step-back.tsx
import {
jsx as jsx155
} from "react/jsx-runtime";
var StepBack = (props) => {
  return jsx155("svg", {
    viewBox: "0 0 448 512",
    ...props,
    children: jsx155("path", {
      fill: "currentColor",
      d: "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
    })
  });
};

// src/icons/step-forward.tsx
import {
jsx as jsx156
} from "react/jsx-runtime";
var StepForward = (props) => {
  return jsx156("svg", {
    viewBox: "0 0 448 512",
    ...props,
    children: jsx156("path", {
      fill: "currentColor",
      d: "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
    })
  });
};

// src/components/PlayPause.tsx
import {
jsx as jsx157,
jsxs as jsxs73,
Fragment as Fragment21
} from "react/jsx-runtime";
var backStyle = {
  height: 18,
  color: "white"
};
var forwardBackStyle = {
  height: 16,
  color: "white"
};
var iconButton = {
  height: 14,
  width: 14,
  color: "white"
};
var PlayPause = ({ playbackRate, loop: loop2, bufferStateDelayInMilliseconds }) => {
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const videoConfig = Internals37.useUnsafeVideoConfig();
  const [showBufferIndicator, setShowBufferState] = useState49(false);
  const {
    playing,
    play: play2,
    pause: pause2,
    pauseAndReturnToPlayStart,
    frameBack,
    seek,
    frameForward,
    isLastFrame,
    isFirstFrame,
    remotionInternal_currentFrameRef,
    emitter
  } = PlayerInternals12.usePlayer();
  PlayerInternals12.usePlayback({
    loop: loop2,
    playbackRate,
    moveToBeginningWhenEnded: true,
    inFrame,
    outFrame,
    frameRef: remotionInternal_currentFrameRef
  });
  const isStill = useIsStill();
  useEffect48(() => {
    if (isStill) {
      pause2();
    }
  }, [isStill, pause2]);
  const onSpace = useCallback78((e) => {
    if (playing) {
      pause2();
    } else {
      play2();
    }
    e.preventDefault();
  }, [pause2, play2, playing]);
  const onEnter = useCallback78((e) => {
    if (playing) {
      e.preventDefault();
      pauseAndReturnToPlayStart();
    }
  }, [pauseAndReturnToPlayStart, playing]);
  const onArrowLeft = useCallback78((e) => {
    e.preventDefault();
    if (e.altKey) {
      seek(0);
      ensureFrameIsInViewport({
        direction: "fit-left",
        durationInFrames: getCurrentDuration(),
        frame: 0
      });
    } else if (e.shiftKey) {
      frameBack(getCurrentFps());
      ensureFrameIsInViewport({
        direction: "fit-left",
        durationInFrames: getCurrentDuration(),
        frame: Math.max(0, getCurrentFrame() - getCurrentFps())
      });
    } else {
      frameBack(1);
      ensureFrameIsInViewport({
        direction: "fit-left",
        durationInFrames: getCurrentDuration(),
        frame: Math.max(0, getCurrentFrame() - 1)
      });
    }
  }, [frameBack, seek]);
  const onArrowRight = useCallback78((e) => {
    if (e.altKey) {
      seek(getCurrentDuration() - 1);
      ensureFrameIsInViewport({
        direction: "fit-right",
        durationInFrames: getCurrentDuration() - 1,
        frame: getCurrentDuration() - 1
      });
    } else if (e.shiftKey) {
      frameForward(getCurrentFps());
      ensureFrameIsInViewport({
        direction: "fit-right",
        durationInFrames: getCurrentDuration(),
        frame: Math.min(getCurrentDuration() - 1, getCurrentFrame() + getCurrentFps())
      });
    } else {
      frameForward(1);
      ensureFrameIsInViewport({
        direction: "fit-right",
        durationInFrames: getCurrentDuration(),
        frame: Math.min(getCurrentDuration() - 1, getCurrentFrame() + 1)
      });
    }
    e.preventDefault();
  }, [frameForward, seek]);
  const oneFrameBack = useCallback78(() => {
    frameBack(1);
  }, [frameBack]);
  const oneFrameForward = useCallback78(() => {
    frameForward(1);
  }, [frameForward]);
  const jumpToStart = useCallback78(() => {
    seek(inFrame ?? 0);
  }, [seek, inFrame]);
  const jumpToEnd = useCallback78(() => {
    seek(outFrame ?? getCurrentDuration() - 1);
  }, [seek, outFrame]);
  const keybindings2 = useKeybinding();
  useEffect48(() => {
    const arrowLeft = keybindings2.registerKeybinding({
      event: "keydown",
      key: "ArrowLeft",
      callback: onArrowLeft,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const arrowRight = keybindings2.registerKeybinding({
      event: "keydown",
      key: "ArrowRight",
      callback: onArrowRight,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const space = keybindings2.registerKeybinding({
      event: "keydown",
      key: " ",
      callback: onSpace,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const enter = keybindings2.registerKeybinding({
      event: "keydown",
      key: "enter",
      callback: onEnter,
      commandCtrlKey: false,
      preventDefault: false,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const a = keybindings2.registerKeybinding({
      event: "keydown",
      key: "a",
      callback: jumpToStart,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const e = keybindings2.registerKeybinding({
      event: "keydown",
      key: "e",
      callback: jumpToEnd,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      arrowLeft.unregister();
      arrowRight.unregister();
      space.unregister();
      enter.unregister();
      a.unregister();
      e.unregister();
    };
  }, [
    jumpToEnd,
    jumpToStart,
    keybindings2,
    onArrowLeft,
    onArrowRight,
    onEnter,
    onSpace
  ]);
  useEffect48(() => {
    let timeout = null;
    let stopped = false;
    const onBuffer = () => {
      requestAnimationFrame(() => {
        stopped = false;
        timeout = setTimeout(() => {
          if (!stopped) {
            setShowBufferState(true);
          }
        }, bufferStateDelayInMilliseconds);
      });
    };
    const onResume = () => {
      requestAnimationFrame(() => {
        setShowBufferState(false);
        stopped = true;
        if (timeout) {
          clearTimeout(timeout);
        }
      });
    };
    emitter.addEventListener("waiting", onBuffer);
    emitter.addEventListener("resume", onResume);
    return () => {
      emitter.removeEventListener("waiting", onBuffer);
      emitter.removeEventListener("resume", onResume);
      setShowBufferState(false);
      if (timeout) {
        clearTimeout(timeout);
      }
      stopped = true;
    };
  }, [bufferStateDelayInMilliseconds, emitter]);
  return jsxs73(Fragment21, {
    children: [
      jsx157(ControlButton, {
        "aria-label": "Jump to beginning",
        title: "Jump to beginning",
        disabled: !videoConfig || isFirstFrame,
        onClick: jumpToStart,
        children: jsx157(JumpToStart, {
          style: backStyle
        })
      }),
      jsx157(ControlButton, {
        "aria-label": "Step back one frame",
        title: "Step back one frame",
        disabled: !videoConfig || isFirstFrame,
        onClick: oneFrameBack,
        children: jsx157(StepBack, {
          style: forwardBackStyle
        })
      }),
      jsx157(ControlButton, {
        "aria-label": playing ? "Pause" : "Play",
        title: playing ? "Pause" : "Play",
        onClick: playing ? pause2 : play2,
        disabled: !videoConfig,
        children: playing ? showBufferIndicator ? jsx157(PlayerInternals12.BufferingIndicator, {
          type: "studio"
        }) : jsx157(Pause, {
          style: iconButton
        }) : jsx157(Play, {
          style: iconButton
        })
      }),
      jsx157(ControlButton, {
        "aria-label": "Step forward one frame",
        title: "Step forward one frame",
        disabled: !videoConfig || isLastFrame,
        onClick: oneFrameForward,
        children: jsx157(StepForward, {
          style: forwardBackStyle
        })
      })
    ]
  });
};

// src/components/PlaybackKeyboardShortcutsManager.tsx
import {PlayerInternals as PlayerInternals13} from "@remotion/player";
import {useCallback as useCallback79, useEffect as useEffect49} from "react";
var PlaybackKeyboardShortcutsManager = ({ setPlaybackRate }) => {
  const keybindings2 = useKeybinding();
  const { play: play2, pause: pause2, playing } = PlayerInternals13.usePlayer();
  const onJKey = useCallback79(() => {
    setPlaybackRate((prevPlaybackRate) => {
      if (!playing) {
        return -1;
      }
      if (prevPlaybackRate > -1) {
        return -1;
      }
      if (prevPlaybackRate > -2) {
        return -2;
      }
      return -4;
    });
    play2();
  }, [play2, playing, setPlaybackRate]);
  const onKKey = useCallback79(() => {
    setPlaybackRate(1);
    pause2();
  }, [pause2, setPlaybackRate]);
  const onLKey = useCallback79(() => {
    setPlaybackRate((prevPlaybackRate) => {
      if (!playing) {
        return 1;
      }
      if (prevPlaybackRate < 1) {
        return 1;
      }
      if (prevPlaybackRate < 2) {
        return 2;
      }
      return 4;
    });
    play2();
  }, [play2, playing, setPlaybackRate]);
  useEffect49(() => {
    const jKey = keybindings2.registerKeybinding({
      event: "keydown",
      key: "j",
      callback: onJKey,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const kKey = keybindings2.registerKeybinding({
      event: "keydown",
      key: "k",
      callback: onKKey,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const lKey = keybindings2.registerKeybinding({
      event: "keydown",
      key: "l",
      callback: onLKey,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      jKey.unregister();
      kKey.unregister();
      lKey.unregister();
    };
  }, [keybindings2, onJKey, onKKey, onLKey]);
  return null;
};

// src/components/PlaybackRatePersistor.tsx
import {useContext as useContext44, useEffect as useEffect50} from "react";
import {Internals as Internals38} from "remotion";

// src/state/playbackrate.ts
var key3 = "remotion.playbackrate";
var persistPlaybackRate = (option) => {
  localStorage.setItem(key3, String(option));
};
var loadPlaybackRate = () => {
  if (typeof window !== "undefined") {
    return 1;
  }
  const item2 = localStorage.getItem(key3);
  if (item2 === null) {
    return 1;
  }
  return Number(item2);
};

// src/components/PlaybackRatePersistor.tsx
var PlaybackRatePersistor = () => {
  const { setPlaybackRate, playbackRate } = useContext44(Internals38.Timeline.TimelineContext);
  useEffect50(() => {
    setPlaybackRate(loadPlaybackRate());
  }, [setPlaybackRate]);
  useEffect50(() => {
    persistPlaybackRate(playbackRate);
  }, [playbackRate]);
  return null;
};

// src/components/PlaybackRateSelector.tsx
import {useContext as useContext45, useMemo as useMemo83} from "react";
import {Internals as Internals39} from "remotion";
import {
jsx as jsx158
} from "react/jsx-runtime";
var commonPlaybackRates = [
  -4,
  -2,
  -1,
  -0.5,
  -0.25,
  0.25,
  0.5,
  1,
  1.5,
  2,
  4
];
var getPlaybackRateLabel = (playbackRate) => {
  return `${playbackRate}x`;
};
var accessibilityLabel5 = "Change the playback rate";
var comboStyle2 = { width: 80 };
var PlaybackRateSelector = ({ playbackRate, setPlaybackRate }) => {
  const { canvasContent } = useContext45(Internals39.CompositionManager);
  const isStill = useIsStill();
  const style9 = useMemo83(() => {
    return {
      padding: CONTROL_BUTTON_PADDING
    };
  }, []);
  const items = useMemo83(() => {
    const divider = {
      type: "divider",
      id: "divider"
    };
    const values = commonPlaybackRates.map((newPlaybackRate) => {
      return {
        id: String(newPlaybackRate),
        label: getPlaybackRateLabel(newPlaybackRate),
        onClick: () => {
          return setPlaybackRate(() => {
            persistPlaybackRate(newPlaybackRate);
            return newPlaybackRate;
          });
        },
        type: "item",
        value: newPlaybackRate,
        keyHint: null,
        leftItem: String(playbackRate) === String(newPlaybackRate) ? jsx158(Checkmark, {}) : null,
        subMenu: null,
        quickSwitcherLabel: null
      };
    });
    const middle = Math.floor(commonPlaybackRates.length / 2);
    return [...values.slice(0, middle), divider, ...values.slice(middle)];
  }, [playbackRate, setPlaybackRate]);
  if (isStill || canvasContent === null || canvasContent.type === "asset") {
    return null;
  }
  return jsx158("div", {
    style: style9,
    "aria-label": accessibilityLabel5,
    children: jsx158(Combobox, {
      title: accessibilityLabel5,
      style: comboStyle2,
      selectedId: String(playbackRate),
      values: items
    })
  });
};

// src/components/RenderButton.tsx
import {useCallback as useCallback80, useContext as useContext46, useMemo as useMemo84} from "react";
import {Internals as Internals40, useCurrentFrame as useCurrentFrame2} from "remotion";
import {
jsx as jsx159,
jsxs as jsxs74
} from "react/jsx-runtime";
var button3 = {
  paddingLeft: 7,
  paddingRight: 7,
  paddingTop: 7,
  paddingBottom: 7
};
var label7 = {
  fontSize: 14
};
var RenderButton = () => {
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const { setSelectedModal } = useContext46(ModalsContext);
  const connectionStatus = useContext46(StudioServerConnectionCtx).previewServerState.type;
  const shortcut = areKeyboardShortcutsDisabled() ? "" : "(R)";
  const tooltip = connectionStatus === "connected" ? "Export the current composition " + shortcut : "Connect to the Studio server to render";
  const iconStyle4 = useMemo84(() => {
    return {
      style: {
        height: 16,
        color: "currentColor"
      }
    };
  }, []);
  const video2 = Internals40.useVideo();
  const frame2 = useCurrentFrame2();
  const { props } = useContext46(Internals40.EditorPropsContext);
  const onClick = useCallback80(() => {
    if (!video2) {
      return null;
    }
    const defaults = window.remotion_renderDefaults;
    if (!defaults) {
      throw new TypeError("Expected defaults");
    }
    setSelectedModal({
      type: "render",
      compositionId: video2.id,
      initialFrame: frame2,
      initialStillImageFormat: defaults.stillImageFormat,
      initialVideoImageFormat: defaults.videoImageFormat,
      initialJpegQuality: defaults.jpegQuality,
      initialScale: window.remotion_renderDefaults?.scale ?? 1,
      initialLogLevel: defaults.logLevel,
      initialConcurrency: defaults.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: defaults.muted,
      initialEnforceAudioTrack: defaults.enforceAudioTrack,
      initialProResProfile: defaults.proResProfile,
      initialx264Preset: defaults.x264Preset,
      initialPixelFormat: defaults.pixelFormat,
      initialAudioBitrate: defaults.audioBitrate,
      initialVideoBitrate: defaults.videoBitrate,
      initialEveryNthFrame: defaults.everyNthFrame,
      initialNumberOfGifLoops: defaults.numberOfGifLoops,
      initialDelayRenderTimeout: defaults.delayRenderTimeout,
      defaultConfigurationAudioCodec: defaults.audioCodec,
      initialEnvVariables: window.process.env,
      initialDisableWebSecurity: defaults.disableWebSecurity,
      initialOpenGlRenderer: defaults.openGlRenderer,
      initialHeadless: defaults.headless,
      initialIgnoreCertificateErrors: defaults.ignoreCertificateErrors,
      initialOffthreadVideoCacheSizeInBytes: defaults.offthreadVideoCacheSizeInBytes,
      defaultProps: props[video2.id] ?? video2.defaultProps,
      inFrameMark: inFrame,
      outFrameMark: outFrame,
      initialColorSpace: defaults.colorSpace,
      initialMultiProcessOnLinux: defaults.multiProcessOnLinux,
      defaultConfigurationVideoCodec: defaults.codec,
      initialEncodingBufferSize: defaults.encodingBufferSize,
      initialEncodingMaxRate: defaults.encodingMaxRate,
      initialUserAgent: defaults.userAgent,
      initialBeep: defaults.beepOnFinish,
      initialRepro: defaults.repro,
      initialForSeamlessAacConcatenation: defaults.forSeamlessAacConcatenation,
      renderTypeOfLastRender: null
    });
  }, [video2, setSelectedModal, frame2, props, inFrame, outFrame]);
  if (!video2) {
    return null;
  }
  return jsx159(Button, {
    id: "render-modal-button",
    title: tooltip,
    onClick,
    buttonContainerStyle: button3,
    disabled: connectionStatus !== "connected",
    children: jsxs74(Row, {
      align: "center",
      children: [
        jsx159(RenderIcon, {
          svgProps: iconStyle4
        }),
        jsx159(Spacing, {
          x: 1
        }),
        jsx159("span", {
          style: label7,
          children: "Render"
        })
      ]
    })
  });
};

// src/components/Timeline/TimelineZoomControls.tsx
import {useCallback as useCallback81, useContext as useContext47} from "react";
import {Internals as Internals41} from "remotion";

// src/icons/minus.tsx
import {
jsx as jsx160
} from "react/jsx-runtime";
var Minus = (props) => {
  return jsx160("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: jsx160("path", {
      fill: "currentColor",
      d: "M400 288h-352c-17.69 0-32-14.32-32-32.01s14.31-31.99 32-31.99h352c17.69 0 32 14.3 32 31.99S417.7 288 400 288z"
    })
  });
};

// src/components/Timeline/TimelineZoomControls.tsx
import {
jsx as jsx161,
jsxs as jsxs75
} from "react/jsx-runtime";
var container30 = {
  color: "black",
  flexDirection: "row",
  display: "flex",
  alignItems: "center"
};
var buttonStyle3 = {
  fontSize: 24
};
var iconStyle4 = {
  color: "white",
  width: 14
};
var TimelineZoomControls = () => {
  const { canvasContent } = useContext47(Internals41.CompositionManager);
  const { setZoom, zoom: zoomMap } = useContext47(TimelineZoomCtx);
  const { tabIndex } = useZIndex();
  const onMinusClicked = useCallback81(() => {
    if (canvasContent === null || canvasContent.type !== "composition") {
      return;
    }
    setZoom(canvasContent.compositionId, (z) => Math.max(TIMELINE_MIN_ZOOM, z - 0.2));
  }, [canvasContent, setZoom]);
  const onPlusClicked = useCallback81(() => {
    if (canvasContent === null || canvasContent.type !== "composition") {
      return;
    }
    setZoom(canvasContent.compositionId, (z) => Math.min(TIMELINE_MAX_ZOOM, z + 0.2));
  }, [canvasContent, setZoom]);
  const onChange = useCallback81((e) => {
    if (canvasContent === null || canvasContent.type !== "composition") {
      return;
    }
    setZoom(canvasContent.compositionId, () => Number(e.target.value));
  }, [canvasContent, setZoom]);
  const isStill = useIsStill();
  if (isStill || canvasContent === null || canvasContent.type !== "composition") {
    return null;
  }
  const zoom = zoomMap[canvasContent.compositionId] ?? TIMELINE_MIN_ZOOM;
  return jsxs75("div", {
    style: container30,
    children: [
      jsx161(ControlButton, {
        onClick: onMinusClicked,
        style: buttonStyle3,
        title: "Zoom out timeline",
        role: "ControlButton",
        type: "button",
        disabled: TIMELINE_MIN_ZOOM === zoom,
        children: jsx161(Minus, {
          style: iconStyle4
        })
      }),
      jsx161(Spacing, {
        x: 0.5
      }),
      jsx161("input", {
        title: `Timeline zoom (${zoom}x)`,
        alt: `Timeline zoom (${zoom}x)`,
        type: "range",
        min: TIMELINE_MIN_ZOOM,
        step: 0.1,
        value: zoom,
        max: TIMELINE_MAX_ZOOM,
        onChange,
        className: "__remotion-timeline-slider",
        tabIndex
      }),
      jsx161(Spacing, {
        x: 0.5
      }),
      jsx161(ControlButton, {
        onClick: onPlusClicked,
        style: buttonStyle3,
        title: "Zoom in timeline",
        role: "button",
        type: "button",
        disabled: TIMELINE_MAX_ZOOM === zoom,
        children: jsx161(Plus, {
          color: "currentcolor",
          style: iconStyle4
        })
      })
    ]
  });
};

// src/components/PreviewToolbar.tsx
import {
jsx as jsx162,
jsxs as jsxs76,
Fragment as Fragment22
} from "react/jsx-runtime";
var container31 = {
  display: "flex",
  justifyContent: "center",
  borderTop: "1px solid rgba(0, 0, 0, 0.5)",
  paddingTop: 2,
  paddingBottom: 2,
  alignItems: "center",
  flexDirection: "row",
  background: BACKGROUND
};
var sideContainer = {
  width: 300,
  height: 38,
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var padding = {
  width: TIMELINE_PADDING
};
var PreviewToolbar = ({ readOnlyStudio, bufferStateDelayInMilliseconds }) => {
  const { playbackRate, setPlaybackRate } = useContext48(Internals42.Timeline.TimelineContext);
  const { mediaMuted } = useContext48(Internals42.MediaVolumeContext);
  const { setMediaMuted } = useContext48(Internals42.SetMediaVolumeContext);
  const isVideoComposition = useIsVideoComposition();
  const isStill = useIsStill();
  const [loop3, setLoop] = useState50(loadLoopOption());
  const isFullscreenSupported = document.fullscreenEnabled || document.webkitFullscreenEnabled;
  return jsxs76("div", {
    style: container31,
    className: "css-reset",
    children: [
      jsxs76("div", {
        style: sideContainer,
        children: [
          jsx162("div", {
            style: padding
          }),
          jsx162(TimelineZoomControls, {})
        ]
      }),
      jsx162(Flex, {}),
      jsx162(SizeSelector, {}),
      isStill || isVideoComposition ? jsx162(PlaybackRateSelector, {
        setPlaybackRate,
        playbackRate
      }) : null,
      isVideoComposition ? jsxs76(Fragment22, {
        children: [
          jsx162(Spacing, {
            x: 2
          }),
          jsx162(PlayPause, {
            bufferStateDelayInMilliseconds,
            loop: loop3,
            playbackRate
          }),
          jsx162(Spacing, {
            x: 2
          }),
          jsx162(LoopToggle, {
            loop: loop3,
            setLoop
          }),
          jsx162(MuteToggle, {
            muted: mediaMuted,
            setMuted: setMediaMuted
          }),
          jsx162(Spacing, {
            x: 2
          }),
          jsx162(TimelineInOutPointToggle, {}),
          jsx162(Spacing, {
            x: 2
          })
        ]
      }) : null,
      jsx162(CheckboardToggle, {}),
      jsx162(Spacing, {
        x: 1
      }),
      isFullscreenSupported && jsx162(FullScreenToggle, {}),
      jsx162(Flex, {}),
      jsxs76("div", {
        style: sideContainer,
        children: [
          jsx162(Flex, {}),
          jsx162(FpsCounter, {
            playbackSpeed: playbackRate
          }),
          jsx162(Spacing, {
            x: 2
          }),
          readOnlyStudio ? null : jsx162(RenderButton, {}),
          jsx162(Spacing, {
            x: 1.5
          })
        ]
      }),
      jsx162(PlaybackKeyboardShortcutsManager, {
        setPlaybackRate
      }),
      jsx162(PlaybackRatePersistor, {})
    ]
  });
};

// src/components/Splitter/SplitterContainer.tsx
import {useEffect as useEffect51, useMemo as useMemo85, useRef as useRef27, useState as useState51} from "react";

// src/state/timeline.ts
var localStorageKey4 = (id) => `remotion.editor.timelineFlex.${id}`;
var persistTimelineFlex = (value, id) => {
  localStorage.setItem(localStorageKey4(id), String(value));
};
var loadTimelineFlex = (id) => {
  const item2 = localStorage.getItem(localStorageKey4(id));
  return item2 ? parseFloat(item2) : null;
};
var useTimelineFlex = (id) => {
  return [
    loadTimelineFlex(id),
    (value) => persistTimelineFlex(value, id)
  ];
};

// src/components/Splitter/SplitterContext.tsx
import React109 from "react";
var SplitterContext = React109.createContext({
  flexValue: 1,
  domRect: null,
  setFlexValue: () => {
    return;
  },
  isDragging: { current: false },
  orientation: "horizontal",
  maxFlex: 1,
  minFlex: 1,
  defaultFlex: 1,
  id: "--",
  persistFlex: () => {
    return;
  }
});

// src/components/Splitter/SplitterContainer.tsx
import {
jsx as jsx163
} from "react/jsx-runtime";
var containerRow = {
  display: "flex",
  flexDirection: "row",
  flex: 1,
  height: "100%",
  width: "100%"
};
var containerColumn = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  height: 0
};
var SplitterContainer = ({ orientation, children, defaultFlex, maxFlex, minFlex, id }) => {
  const [initialTimelineFlex, persistFlex] = useTimelineFlex(id);
  const [flexValue, setFlexValue] = useState51(initialTimelineFlex ?? defaultFlex);
  const [domRect, setDomRect] = useState51(null);
  const ref = useRef27(null);
  const isDragging = useRef27(false);
  const [resizeObserver] = useState51(() => {
    return new ResizeObserver((entries) => {
      setDomRect(entries[0].contentRect);
    });
  });
  useEffect51(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    resizeObserver.observe(current);
    return () => resizeObserver.unobserve(current);
  }, [resizeObserver]);
  useEffect51(() => {
    setDomRect(ref.current?.getBoundingClientRect() ?? null);
  }, []);
  const value = useMemo85(() => {
    return {
      flexValue,
      domRect,
      setFlexValue,
      isDragging,
      orientation,
      id,
      maxFlex,
      minFlex,
      defaultFlex,
      persistFlex
    };
  }, [
    defaultFlex,
    domRect,
    flexValue,
    id,
    maxFlex,
    minFlex,
    orientation,
    persistFlex
  ]);
  return jsx163(SplitterContext.Provider, {
    value,
    children: jsx163("div", {
      ref,
      style: orientation === "horizontal" ? containerColumn : containerRow,
      children
    })
  });
};

// src/components/Splitter/SplitterElement.tsx
import {useContext as useContext49, useMemo as useMemo86} from "react";
import {interpolateColors, random} from "remotion";
import {
jsx as jsx164,
jsxs as jsxs77,
Fragment as Fragment23
} from "react/jsx-runtime";
var SplitterElement = ({ children, type, sticky }) => {
  const context5 = useContext49(SplitterContext);
  const style9 = useMemo86(() => {
    return {
      flex: (type === "flexer" ? context5.flexValue : 1 - context5.flexValue) * 1000,
      display: "flex",
      position: "relative",
      overflow: "hidden",
      flexDirection: "column"
    };
  }, [context5.flexValue, type]);
  const stickStyle = useMemo86(() => {
    return {
      position: "absolute",
      left: (type === "flexer" ? 0 : context5.flexValue) * 100 + "%",
      width: (type === "flexer" ? context5.flexValue : 1 - context5.flexValue) * 100 + "%",
      backgroundColor: interpolateColors(random(context5.flexValue), [0, 1], ["red", "blue"])
    };
  }, [context5.flexValue, type]);
  return jsxs77(Fragment23, {
    children: [
      jsx164("div", {
        style: style9,
        children
      }),
      jsx164("div", {
        style: stickStyle,
        children: sticky ?? null
      })
    ]
  });
};

// src/components/Splitter/SplitterHandle.tsx
import {PlayerInternals as PlayerInternals14} from "@remotion/player";
import {useContext as useContext50, useEffect as useEffect52, useRef as useRef28, useState as useState52} from "react";
import {
jsx as jsx165
} from "react/jsx-runtime";
var SPLITTER_HANDLE_SIZE = 3;
var containerRow2 = {
  height: SPLITTER_HANDLE_SIZE,
  cursor: "row-resize"
};
var containerColumn2 = {
  width: SPLITTER_HANDLE_SIZE,
  cursor: "col-resize"
};
var SplitterHandle = ({ allowToCollapse, onCollapse }) => {
  const context5 = useContext50(SplitterContext);
  if (!context5) {
    throw new Error("Cannot find splitter context");
  }
  const [lastPointerUp, setLastPointerUp] = useState52(() => Date.now());
  const ref = useRef28(null);
  useEffect52(() => {
    if (context5.isDragging.current) {
      return;
    }
    if (!context5.domRect) {
      return;
    }
    const { current } = ref;
    if (!current) {
      return;
    }
    const getNewValue = (e, clamp) => {
      if (!context5.isDragging.current) {
        throw new Error("cannot get value if not dragging");
      }
      if (!context5.domRect) {
        throw new Error("domRect is not mounted");
      }
      const { width, height } = context5.domRect;
      const change = (() => {
        if (context5.orientation === "vertical") {
          return (e.clientX - context5.isDragging.current.x) / (width - SPLITTER_HANDLE_SIZE);
        }
        return (e.clientY - context5.isDragging.current.y) / (height - SPLITTER_HANDLE_SIZE);
      })();
      const newFlex = context5.flexValue + change;
      if (clamp) {
        return Math.min(context5.maxFlex, Math.max(context5.minFlex, newFlex));
      }
      return newFlex;
    };
    const onPointerDown = (e) => {
      if (e.button !== 0) {
        return;
      }
      context5.isDragging.current = {
        x: e.clientX,
        y: e.clientY
      };
      ref.current?.classList.add("remotion-splitter-active");
      window.addEventListener("pointerup", (ev) => {
        if (!context5.isDragging.current) {
          return;
        }
        context5.persistFlex(getNewValue(ev, true));
        cleanup();
        setLastPointerUp(Date.now());
      }, { once: true });
      window.addEventListener("pointermove", onPointerMove);
    };
    const onPointerMove = (e) => {
      if (context5.isDragging.current) {
        const val = getNewValue(e, true);
        context5.setFlexValue(val);
        if (allowToCollapse === "left") {
          const unclamped = getNewValue(e, false);
          if (unclamped < context5.minFlex / 2) {
            cleanup();
            onCollapse();
            setLastPointerUp(Date.now());
          }
        }
        if (allowToCollapse === "right") {
          const unclamped = 1 - getNewValue(e, false);
          if (unclamped < (1 - context5.maxFlex) / 2) {
            cleanup();
            onCollapse();
            setLastPointerUp(Date.now());
          }
        }
      }
    };
    const cleanup = () => {
      context5.isDragging.current = false;
      ref.current?.classList.remove("remotion-splitter-active");
      current.removeEventListener("pointerdown", onPointerDown);
      window.removeEventListener("pointermove", onPointerMove);
      PlayerInternals14.updateAllElementsSizes();
    };
    current.addEventListener("pointerdown", onPointerDown);
    return () => {
      if (!context5.isDragging.current) {
        cleanup();
      }
    };
  }, [
    allowToCollapse,
    context5,
    context5.domRect,
    context5.flexValue,
    lastPointerUp,
    onCollapse
  ]);
  return jsx165("div", {
    ref,
    className: [
      "remotion-splitter",
      context5.orientation === "horizontal" ? "remotion-splitter-horizontal" : "remotion-splitter-vertical"
    ].join(" "),
    style: context5.orientation === "horizontal" ? containerRow2 : containerColumn2
  });
};

// src/components/TopPanel.tsx
import {
jsx as jsx166,
jsxs as jsxs78
} from "react/jsx-runtime";
var container32 = {
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  flex: 1
};
var row4 = {
  display: "flex",
  flexDirection: "row",
  flex: 1,
  minHeight: 0
};
var useResponsiveSidebarStatus = () => {
  const { sidebarCollapsedStateLeft } = useContext51(SidebarContext);
  const responsiveLeftStatus = useBreakpoint(1200) ? "collapsed" : "expanded";
  const actualStateLeft = useMemo87(() => {
    if (sidebarCollapsedStateLeft === "collapsed") {
      return "collapsed";
    }
    if (sidebarCollapsedStateLeft === "expanded") {
      return "expanded";
    }
    return responsiveLeftStatus;
  }, [sidebarCollapsedStateLeft, responsiveLeftStatus]);
  return actualStateLeft;
};
var TopPanel = ({
  readOnlyStudio,
  onMounted,
  size: size4,
  drawRef: drawRef2,
  bufferStateDelayInMilliseconds
}) => {
  const { setSidebarCollapsedState, sidebarCollapsedStateRight } = useContext51(SidebarContext);
  const rulersAreVisible = useIsRulerVisible();
  const actualStateLeft = useResponsiveSidebarStatus();
  const actualStateRight = useMemo87(() => {
    if (sidebarCollapsedStateRight === "collapsed") {
      return "collapsed";
    }
    return "expanded";
  }, [sidebarCollapsedStateRight]);
  const hasSize = size4 !== null;
  useEffect53(() => {
    onMounted();
  }, [hasSize, onMounted]);
  const canvasContainerStyle = useMemo87(() => ({
    flex: 1,
    display: "flex",
    paddingTop: rulersAreVisible ? RULER_WIDTH : 0,
    paddingLeft: rulersAreVisible ? RULER_WIDTH : 0
  }), [rulersAreVisible]);
  const onCollapseLeft = useCallback82(() => {
    setSidebarCollapsedState({ left: "collapsed", right: null });
  }, [setSidebarCollapsedState]);
  const onCollapseRight = useCallback82(() => {
    setSidebarCollapsedState({ left: null, right: "collapsed" });
  }, [setSidebarCollapsedState]);
  const isMobileLayout = useMobileLayout();
  return jsxs78("div", {
    style: container32,
    children: [
      jsx166("div", {
        style: row4,
        children: jsxs78(SplitterContainer, {
          minFlex: 0.15,
          maxFlex: 0.4,
          defaultFlex: 0.2,
          id: "sidebar-to-preview",
          orientation: "vertical",
          children: [
            actualStateLeft === "expanded" ? isMobileLayout ? jsx166(MobilePanel, {
              onClose: onCollapseLeft,
              children: jsx166(ExplorerPanel, {
                readOnlyStudio
              })
            }) : jsx166(SplitterElement, {
              sticky: null,
              type: "flexer",
              children: jsx166(ExplorerPanel, {
                readOnlyStudio
              })
            }) : null,
            actualStateLeft === "expanded" ? jsx166(SplitterHandle, {
              allowToCollapse: "left",
              onCollapse: onCollapseLeft
            }) : null,
            jsx166(SplitterElement, {
              sticky: null,
              type: "anti-flexer",
              children: jsxs78(SplitterContainer, {
                minFlex: 0.5,
                maxFlex: 0.8,
                defaultFlex: 0.7,
                id: "canvas-to-right-sidebar",
                orientation: "vertical",
                children: [
                  jsx166(SplitterElement, {
                    sticky: null,
                    type: "flexer",
                    children: jsx166("div", {
                      ref: drawRef2,
                      style: canvasContainerStyle,
                      children: size4 ? jsx166(CanvasOrLoading, {
                        size: size4
                      }) : null
                    })
                  }),
                  actualStateRight === "expanded" ? jsx166(SplitterHandle, {
                    allowToCollapse: "right",
                    onCollapse: onCollapseRight
                  }) : null,
                  actualStateRight === "expanded" ? isMobileLayout ? jsx166(MobilePanel, {
                    onClose: onCollapseRight,
                    children: jsx166(OptionsPanel, {
                      readOnlyStudio
                    })
                  }) : jsx166(SplitterElement, {
                    sticky: null,
                    type: "anti-flexer",
                    children: jsx166(OptionsPanel, {
                      readOnlyStudio
                    })
                  }) : null
                ]
              })
            })
          ]
        })
      }),
      jsx166(PreviewToolbar, {
        bufferStateDelayInMilliseconds,
        readOnlyStudio
      }),
      jsx166(CurrentCompositionKeybindings, {
        readOnlyStudio
      }),
      jsx166(TitleUpdater, {})
    ]
  });
};

// src/components/SidebarCollapserControls.tsx
import {
jsx as jsx167,
jsxs as jsxs79,
Fragment as Fragment24
} from "react/jsx-runtime";
var style9 = {
  width: 16,
  height: 16,
  minWidth: 16,
  border: "1px solid currentColor",
  borderRadius: 3,
  color: "currentColor",
  position: "relative"
};
var SidebarCollapserControls = () => {
  const { setSidebarCollapsedState, sidebarCollapsedStateRight } = useContext52(SidebarContext);
  const keybindings2 = useKeybinding();
  const leftSidebarStatus = useResponsiveSidebarStatus();
  const leftIcon = useCallback83((color) => {
    return {
      width: "35%",
      height: "100%",
      borderRight: "1px solid " + color,
      background: leftSidebarStatus === "expanded" ? color : "transparent"
    };
  }, [leftSidebarStatus]);
  const rightIcon = useCallback83((color) => {
    return {
      width: "35%",
      height: "100%",
      right: 0,
      position: "absolute",
      borderLeft: "1px solid " + color,
      background: sidebarCollapsedStateRight === "expanded" ? color : "transparent"
    };
  }, [sidebarCollapsedStateRight]);
  const toggleLeft = useCallback83(() => {
    setSidebarCollapsedState({
      left: (s) => {
        if (s === "responsive") {
          return leftSidebarStatus === "collapsed" ? "expanded" : "collapsed";
        }
        return s === "collapsed" ? "expanded" : "collapsed";
      },
      right: null
    });
  }, [leftSidebarStatus, setSidebarCollapsedState]);
  const toggleRight = useCallback83(() => {
    setSidebarCollapsedState({
      right: (s) => s === "collapsed" ? "expanded" : "collapsed",
      left: null
    });
  }, [setSidebarCollapsedState]);
  const toggleBoth = useCallback83(() => {
    if (sidebarCollapsedStateRight === leftSidebarStatus) {
      setSidebarCollapsedState({
        left: (s) => {
          if (s === "responsive") {
            return leftSidebarStatus === "collapsed" ? "expanded" : "collapsed";
          }
          return s === "collapsed" ? "expanded" : "collapsed";
        },
        right: (s) => s === "collapsed" ? "expanded" : "collapsed"
      });
    } else if (sidebarCollapsedStateRight === "expanded") {
      toggleRight();
    } else if (leftSidebarStatus === "expanded") {
      toggleLeft();
    }
  }, [
    leftSidebarStatus,
    setSidebarCollapsedState,
    sidebarCollapsedStateRight,
    toggleLeft,
    toggleRight
  ]);
  useEffect54(() => {
    const left3 = keybindings2.registerKeybinding({
      event: "keydown",
      key: "b",
      commandCtrlKey: true,
      callback: toggleLeft,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const right2 = keybindings2.registerKeybinding({
      event: "keydown",
      key: "j",
      commandCtrlKey: true,
      callback: toggleRight,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const zen = keybindings2.registerKeybinding({
      event: "keydown",
      key: "g",
      commandCtrlKey: true,
      callback: toggleBoth,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      left3.unregister();
      right2.unregister();
      zen.unregister();
    };
  }, [keybindings2, toggleBoth, toggleLeft, toggleRight]);
  const toggleLeftTooltip = areKeyboardShortcutsDisabled() ? "Toggle Left Sidebar" : `Toggle Left Sidebar (${cmdOrCtrlCharacter}+B)`;
  const toggleRightTooltip = areKeyboardShortcutsDisabled() ? "Toggle Right Sidebar" : `Toggle Right Sidebar (${cmdOrCtrlCharacter}+J)`;
  const colorStyle = useCallback83((color) => {
    return {
      ...style9,
      color
    };
  }, []);
  const toggleLeftAction = useCallback83((color) => {
    return jsx167("div", {
      style: colorStyle(color),
      title: toggleLeftTooltip,
      children: jsx167("div", {
        style: leftIcon(color)
      })
    });
  }, [colorStyle, leftIcon, toggleLeftTooltip]);
  const toggleRightAction = useCallback83((color) => {
    return jsx167("div", {
      style: colorStyle(color),
      title: toggleRightTooltip,
      children: jsx167("div", {
        style: rightIcon(color)
      })
    });
  }, [colorStyle, rightIcon, toggleRightTooltip]);
  return jsxs79(Fragment24, {
    children: [
      jsx167(InlineAction, {
        onClick: toggleLeft,
        renderAction: toggleLeftAction
      }),
      jsx167(InlineAction, {
        onClick: toggleRight,
        renderAction: toggleRightAction
      })
    ]
  });
};

// src/components/UpdateCheck.tsx
import {
useCallback as useCallback84,
useContext as useContext53,
useEffect as useEffect55,
useMemo as useMemo88,
useState as useState53
} from "react";
import {VERSION} from "remotion";
import {
jsx as jsx168
} from "react/jsx-runtime";
var buttonStyle4 = {
  appearance: "none",
  color: BLUE,
  border: "none",
  fontWeight: "bold",
  backgroundColor: "transparent",
  cursor: "pointer",
  fontSize: 14,
  display: "inline-flex",
  justifyContent: "center"
};
var UpdateCheck = () => {
  const [info, setInfo] = useState53(null);
  const { setSelectedModal } = useContext53(ModalsContext);
  const { tabIndex } = useZIndex();
  const [knownBugs, setKnownBugs] = useState53(null);
  const hasKnownBugs = useMemo88(() => {
    return knownBugs && knownBugs.length > 0;
  }, [knownBugs]);
  const checkForUpdates = useCallback84(() => {
    const controller = new AbortController;
    updateAvailable(controller.signal).then((d) => {
      setInfo(d);
    }).catch((err) => {
      if (err.message.includes("aborted")) {
        return;
      }
      console.log("Could not check for updates", err);
    });
    return controller;
  }, []);
  const checkForBugs = useCallback84(() => {
    const controller = new AbortController;
    fetch(`https://bugs.remotion.dev/api/${VERSION}`, {
      signal: controller.signal
    }).then(async (res) => {
      const body = await res.json();
      setKnownBugs(body.bugs);
    }).catch((err) => {
      if (err.message.includes("aborted")) {
        return;
      }
      console.log("Could not check for bugs in this version", err);
    });
    return controller;
  }, []);
  useEffect55(() => {
    const abortUpdate = checkForUpdates();
    const abortBugs = checkForBugs();
    return () => {
      abortUpdate.abort();
      abortBugs.abort();
    };
  }, [checkForBugs, checkForUpdates]);
  const openModal = useCallback84(() => {
    setSelectedModal({
      type: "update",
      info,
      knownBugs
    });
  }, [info, knownBugs, setSelectedModal]);
  const dynButtonStyle = useMemo88(() => {
    return {
      ...buttonStyle4,
      color: hasKnownBugs ? WARNING_COLOR : LIGHT_TEXT
    };
  }, [hasKnownBugs]);
  if (!info) {
    return null;
  }
  if (!info.updateAvailable) {
    return null;
  }
  return jsx168("button", {
    tabIndex,
    style: dynButtonStyle,
    onClick: openModal,
    type: "button",
    title: hasKnownBugs ? "Bugfixes available" : "Update available",
    children: hasKnownBugs ? "Bugfixes available" : jsx168("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        height: 16,
        width: 16
      },
      viewBox: "0 0 512 512",
      children: jsx168("path", {
        fill: "currentcolor",
        d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4c-4.5 4.2-7.1 10.1-7.1 16.3c0 12.3 10 22.3 22.3 22.3H208v96c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h57.7c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.1-16.3L269.8 117.5c-3.8-3.5-8.7-5.5-13.8-5.5s-10.1 2-13.8 5.5L135.1 217.4z"
      })
    })
  });
};

// src/components/MenuToolbar.tsx
import {
jsx as jsx169,
jsxs as jsxs80
} from "react/jsx-runtime";
var row5 = {
  alignItems: "center",
  flexDirection: "row",
  display: "flex",
  color: "white",
  borderBottom: "1px solid black",
  fontSize: 13,
  paddingLeft: 6,
  paddingRight: 10,
  backgroundColor: BACKGROUND
};
var flex2 = {
  flex: 1
};
var MenuToolbar = ({ readOnlyStudio }) => {
  const [selected, setSelected] = useState54(null);
  const mobileLayout = useMobileLayout();
  const fixedWidthRight = useMemo89(() => {
    return {
      ...mobileLayout ? { width: "fit-content" } : {
        width: "330px"
      },
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end"
    };
  }, [mobileLayout]);
  const fixedWidthLeft = useMemo89(() => {
    return {
      ...mobileLayout ? { minWidth: "0px" } : {
        minWidth: "330px"
      },
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start"
    };
  }, [mobileLayout]);
  const itemClicked = useCallback85((itemId) => {
    setSelected(itemId);
  }, [setSelected]);
  const itemHovered = useCallback85((itemId) => {
    if (selected) {
      setSelected(itemId);
    }
  }, [selected, setSelected]);
  const closeMenu = useCallback85(() => {
    setSelected(null);
  }, []);
  const structure = useMenuStructure(closeMenu, readOnlyStudio);
  const menus = useMemo89(() => {
    return structure.map((s) => s.id);
  }, [structure]);
  const onPreviousMenu = useCallback85(() => {
    setSelected((s) => {
      if (s === null) {
        return null;
      }
      return menus[(menus.indexOf(s) + 1) % menus.length];
    });
  }, [menus]);
  const onNextMenu = useCallback85(() => {
    setSelected((s) => {
      if (s === null) {
        return null;
      }
      if (menus.indexOf(s) === 0) {
        return menus[menus.length - 1];
      }
      return menus[(menus.indexOf(s) - 1) % menus.length];
    });
  }, [menus]);
  const onItemQuit = useCallback85(() => {
    setSelected(null);
  }, [setSelected]);
  return jsxs80(Row, {
    align: "center",
    className: "css-reset",
    style: row5,
    children: [
      jsxs80("div", {
        style: fixedWidthLeft,
        children: [
          structure.map((s) => {
            return jsx169(MenuItem, {
              selected: selected === s.id,
              onItemSelected: itemClicked,
              onItemHovered: itemHovered,
              id: s.id,
              label: s.label,
              onItemQuit,
              menu: s,
              onPreviousMenu,
              onNextMenu,
              leaveLeftPadding: s.leaveLeftPadding
            }, s.id);
          }),
          readOnlyStudio ? null : jsx169(UpdateCheck, {})
        ]
      }),
      jsx169("div", {
        style: flex2
      }),
      jsx169(MenuBuildIndicator, {}),
      jsx169("div", {
        style: flex2
      }),
      jsx169("div", {
        style: fixedWidthRight,
        children: jsx169(SidebarCollapserControls, {})
      }),
      jsx169(Spacing, {
        x: 1
      })
    ]
  });
};

// src/components/Timeline/Timeline.tsx
import {useContext as useContext62, useMemo as useMemo100} from "react";
import {Internals as Internals50} from "remotion";

// src/helpers/get-sequence-visible-range.ts
var getCascadedStart = (sequence, sequences) => {
  if (!sequence.parent) {
    return sequence.from;
  }
  const parent = sequences.find((s) => s.id === sequence.parent);
  if (!parent) {
    throw new TypeError("Parent not found for sequence " + sequence.id);
  }
  return getCascadedStart(parent, sequences) + sequence.from;
};
var getTimelineVisibleStart = (sequence, sequences) => {
  const cascadedStart = Math.max(0, getCascadedStart(sequence, sequences));
  if (!sequence.parent) {
    return cascadedStart;
  }
  const parent = sequences.find((s) => s.id === sequence.parent);
  if (!parent) {
    throw new TypeError("Parent not found for sequence " + sequence.id);
  }
  const timelineVisibleStart = getTimelineVisibleStart(parent, sequences);
  return Math.max(timelineVisibleStart, cascadedStart);
};
var getTimelineVisibleDuration = (sequence, sequences) => {
  const visibleDuration = sequence.duration + Math.min(sequence.from, 0);
  if (!sequence.parent) {
    return visibleDuration;
  }
  const parent = sequences.find((s) => s.id === sequence.parent);
  if (!parent) {
    throw new TypeError("Parent not found for sequence " + sequence.id);
  }
  return Math.min(visibleDuration, getTimelineVisibleDuration(parent, sequences));
};

// src/helpers/get-timeline-nestedness.ts
var getTimelineNestedLevel = (sequence, allSequences, depth) => {
  if (!sequence.parent) {
    return depth;
  }
  const parentSequence = allSequences.find((s) => s.id === sequence.parent);
  if (!parentSequence) {
    throw new Error("has parentId but no parent");
  }
  return getTimelineNestedLevel(parentSequence, allSequences, depth + 1);
};

// src/helpers/get-timeline-sequence-hash.ts
var getTimelineSequenceHash = (sequence, allSequences, hashesUsedInRoot, cache) => {
  if (cache[sequence.id]) {
    return cache[sequence.id];
  }
  const parent = allSequences.find((a) => a.id === sequence.parent);
  const baseHash = [
    parent ? getTimelineSequenceHash(parent, allSequences, hashesUsedInRoot, cache) : null,
    sequence.displayName,
    sequence.duration,
    sequence.from,
    sequence.type,
    sequence.type === "audio" ? sequence.src : null,
    sequence.type === "audio" ? sequence.volume : null,
    sequence.type === "video" ? sequence.src : null,
    sequence.type === "video" ? sequence.volume : null
  ].join("-");
  const actualHash = baseHash + hashesUsedInRoot[sequence.rootId].filter((h) => h === baseHash).length;
  hashesUsedInRoot[sequence.rootId].push(baseHash);
  cache[sequence.id] = actualHash;
  return actualHash;
};

// src/helpers/get-timeline-sequence-sort-key.ts
var getTimelineSequenceSequenceSortKey = (track, tracks, sameHashes = {}) => {
  const firstSequenceWithSameHash = tracks.find((t) => sameHashes[track.hash].includes(t.sequence.id));
  const id = String(firstSequenceWithSameHash.sequence.nonce).padStart(6, "0");
  if (!track.sequence.parent) {
    return id;
  }
  const parent = tracks.find((t) => t.sequence.id === track.sequence.parent);
  if (!parent) {
    return id;
  }
  const firstParentWithSameHash = tracks.find((a) => {
    return sameHashes[parent.hash].includes(a.sequence.id);
  });
  if (!firstParentWithSameHash) {
    throw new Error("could not find parent: " + track.sequence.parent);
  }
  return `${getTimelineSequenceSequenceSortKey(firstParentWithSameHash, tracks, sameHashes)}-${id}`;
};

// src/helpers/calculate-timeline.ts
var calculateTimeline = ({
  sequences,
  sequenceDuration
}) => {
  const tracks = [];
  if (sequences.length === 0) {
    return [
      {
        sequence: {
          displayName: "",
          duration: sequenceDuration,
          from: 0,
          id: "seq",
          parent: null,
          type: "sequence",
          rootId: "-",
          showInTimeline: true,
          nonce: 0,
          loopDisplay: undefined,
          stack: null,
          premountDisplay: null
        },
        depth: 0,
        hash: "-"
      }
    ];
  }
  const sameHashes = {};
  const hashesUsedInRoot = {};
  const cache = {};
  for (let i = 0;i < sequences.length; i++) {
    const sequence = sequences[i];
    if (!hashesUsedInRoot[sequence.rootId]) {
      hashesUsedInRoot[sequence.rootId] = [];
    }
    const actualHash = getTimelineSequenceHash(sequence, sequences, hashesUsedInRoot, cache);
    if (!sameHashes[actualHash]) {
      sameHashes[actualHash] = [];
    }
    sameHashes[actualHash].push(sequence.id);
    const cascadedStart = getCascadedStart(sequence, sequences);
    const visibleStart = getTimelineVisibleStart(sequence, sequences);
    const visibleDuration = getTimelineVisibleDuration(sequence, sequences);
    tracks.push({
      sequence: {
        ...sequence,
        from: visibleStart,
        duration: visibleDuration
      },
      depth: getTimelineNestedLevel(sequence, sequences, 0),
      hash: actualHash,
      cascadedStart,
      cascadedDuration: sequence.duration
    });
  }
  const uniqueTracks = [];
  for (const track of tracks) {
    if (!uniqueTracks.find((t) => t.hash === track.hash)) {
      const { cascadedDuration, cascadedStart, ...cleanTrack } = track;
      uniqueTracks.push(cleanTrack);
    }
  }
  return uniqueTracks.sort((a, b) => {
    const sortKeyA = getTimelineSequenceSequenceSortKey(a, tracks, sameHashes);
    const sortKeyB = getTimelineSequenceSequenceSortKey(b, tracks, sameHashes);
    return sortKeyA.localeCompare(sortKeyB);
  });
};

// src/components/Timeline/MaxTimelineTracks.tsx
import {DEFAULT_TIMELINE_TRACKS} from "@remotion/studio-shared";
import {
jsxs as jsxs81
} from "react/jsx-runtime";
var MAX_TIMELINE_TRACKS = typeof process.env.MAX_TIMELINE_TRACKS === "undefined" || process.env.MAX_TIMELINE_TRACKS === null ? DEFAULT_TIMELINE_TRACKS : Number(process.env.MAX_TIMELINE_TRACKS);
var MAX_TIMELINE_TRACKS_NOTICE_HEIGHT = 24;
var container33 = {
  height: MAX_TIMELINE_TRACKS_NOTICE_HEIGHT,
  display: "flex",
  alignItems: "center",
  color: "rgba(255, 255, 255, 0.6)",
  fontFamily: "sans-serif",
  fontSize: 12,
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  paddingLeft: TIMELINE_PADDING + 5
};
var MaxTimelineTracksReached = () => {
  return jsxs81("div", {
    style: container33,
    children: [
      "Limited display to ",
      MAX_TIMELINE_TRACKS,
      " tracks to sustain performance.",
      "",
      "You can change this by setting Config.setMaxTimelineTracks() in your remotion.config.ts file."
    ]
  });
};

// src/components/Timeline/TimelineDragHandler.tsx
import {PlayerInternals as PlayerInternals15} from "@remotion/player";
import {
useCallback as useCallback86,
useContext as useContext56,
useEffect as useEffect56,
useMemo as useMemo91,
useRef as useRef29,
useState as useState55
} from "react";
import {Internals as Internals44, useVideoConfig as useVideoConfig4} from "remotion";

// src/components/Timeline/TimelineInOutPointer.tsx
import {createRef as createRef9, useContext as useContext54} from "react";
import {Internals as Internals43} from "remotion";
import {
jsx as jsx170,
jsxs as jsxs82,
Fragment as Fragment25
} from "react/jsx-runtime";
var areaHighlight = {
  position: "absolute",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  height: "100%",
  bottom: 0,
  top: 0
};
var inMarkerAreaRef = createRef9();
var outMarkerAreaRef = createRef9();
var TimelineInOutPointer = () => {
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const videoConfig = Internals43.useUnsafeVideoConfig();
  const timelineWidth = useContext54(TimelineWidthContext);
  if (!videoConfig || timelineWidth === null) {
    return null;
  }
  return jsxs82(Fragment25, {
    children: [
      inFrame !== null && jsx170("div", {
        ref: inMarkerAreaRef,
        style: {
          ...areaHighlight,
          left: 0,
          width: getXPositionOfItemInTimelineImperatively(inFrame, videoConfig.durationInFrames, timelineWidth)
        }
      }),
      outFrame !== null && jsx170("div", {
        ref: outMarkerAreaRef,
        style: {
          ...areaHighlight,
          left: getXPositionOfItemInTimelineImperatively(outFrame, videoConfig.durationInFrames, timelineWidth),
          width: timelineWidth - getXPositionOfItemInTimelineImperatively(outFrame, videoConfig.durationInFrames, timelineWidth)
        }
      })
    ]
  });
};

// src/components/Timeline/TimelineInOutPointerHandle.tsx
import {createRef as createRef10, useContext as useContext55, useMemo as useMemo90} from "react";
import {useVideoConfig as useVideoConfig3} from "remotion";
import {
jsx as jsx171
} from "react/jsx-runtime";
var line3 = {
  height: "100%",
  width: 1,
  position: "absolute",
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  cursor: "ew-resize",
  paddingLeft: 1,
  paddingRight: 1
};
var inPointerHandle = createRef10();
var outPointerHandle = createRef10();
var InnerTimelineInOutPointerHandle = ({ atFrame, dragging, timelineWidth, type }) => {
  const videoConfig = useVideoConfig3();
  const style10 = useMemo90(() => {
    return {
      ...line3,
      backgroundColor: dragging ? LIGHT_TRANSPARENT : "rgba(255, 255, 255, 0.1)",
      transform: `translateX(${getXPositionOfItemInTimelineImperatively(atFrame, videoConfig.durationInFrames, timelineWidth)}px)`
    };
  }, [atFrame, dragging, timelineWidth, videoConfig.durationInFrames]);
  return jsx171("div", {
    ref: type === "in" ? inPointerHandle : outPointerHandle,
    style: style10
  });
};
var TimelineInOutPointerHandle = ({
  dragging,
  type,
  atFrame
}) => {
  const timelineWidth = useContext55(TimelineWidthContext);
  if (timelineWidth === null) {
    return null;
  }
  return jsx171(InnerTimelineInOutPointerHandle, {
    atFrame,
    dragging,
    timelineWidth,
    type
  });
};

// src/components/Timeline/TimelineDragHandler.tsx
import {
jsx as jsx172,
jsxs as jsxs83
} from "react/jsx-runtime";
var inner = {
  overflowY: "auto",
  overflowX: "hidden"
};
var container34 = {
  userSelect: "none",
  WebkitUserSelect: "none",
  position: "absolute",
  height: "100%",
  top: 0
};
var style10 = {
  width: "100%",
  height: "100%"
};
var getClientXWithScroll = (x) => {
  return x + scrollableRef.current?.scrollLeft;
};
var TimelineDragHandler = () => {
  const video2 = Internals44.useUnsafeVideoConfig();
  const { zoom: zoomMap } = useContext56(TimelineZoomCtx);
  const { canvasContent } = useContext56(Internals44.CompositionManager);
  const containerStyle2 = useMemo91(() => {
    if (!canvasContent || canvasContent.type !== "composition") {
      return {};
    }
    const zoom = zoomMap[canvasContent.compositionId] ?? TIMELINE_MIN_ZOOM;
    return {
      ...container34,
      width: 100 * zoom + "%"
    };
  }, [canvasContent, zoomMap]);
  if (!canvasContent || canvasContent.type !== "composition") {
    return null;
  }
  return jsx172("div", {
    ref: sliderAreaRef,
    style: containerStyle2,
    children: video2 ? jsx172(Inner2, {}) : null
  });
};
var Inner2 = () => {
  const videoConfig = useVideoConfig4();
  const size4 = PlayerInternals15.useElementSize(scrollableRef, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const { isHighestContext } = useZIndex();
  const setFrame = Internals44.useTimelineSetFrame();
  const [inOutDragging, setInOutDragging] = useState55({
    dragging: false
  });
  const timelineWidth = useContext56(TimelineWidthContext);
  const get = useCallback86((frame2) => {
    if (timelineWidth === null) {
      throw new Error("timeline width is not yet determined");
    }
    return getXPositionOfItemInTimelineImperatively(frame2, videoConfig.durationInFrames, timelineWidth);
  }, [timelineWidth, videoConfig.durationInFrames]);
  const width = scrollableRef.current?.scrollWidth ?? 0;
  const left3 = size4?.left ?? 0;
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const { setInAndOutFrames } = useTimelineSetInOutFramePosition();
  const [dragging, setDragging] = useState55({
    dragging: false
  });
  const { playing, play: play2, pause: pause2, seek } = PlayerInternals15.usePlayer();
  const scroller = useRef29(null);
  const stopInterval = () => {
    if (scroller.current) {
      clearInterval(scroller.current);
      scroller.current = null;
    }
  };
  const onPointerDown = useCallback86((e) => {
    if (e.button !== 0) {
      return;
    }
    if (!isHighestContext) {
      return;
    }
    stopInterval();
    if (!videoConfig) {
      return;
    }
    if (e.target === inPointerHandle.current) {
      if (inFrame === null) {
        throw new Error("expected outframe");
      }
      const inMarker = get(inFrame);
      const outMarker = outFrame === null ? Infinity : get(outFrame - 1);
      setInOutDragging({
        dragging: "in",
        initialOffset: getClientXWithScroll(e.clientX),
        boundaries: [-Infinity, outMarker - inMarker]
      });
      return;
    }
    if (e.target === outPointerHandle.current) {
      if (outFrame === null) {
        throw new Error("expected outframe");
      }
      const outMarker = get(outFrame);
      const inMarker = inFrame === null ? -Infinity : get(inFrame + 1);
      setInOutDragging({
        dragging: "out",
        initialOffset: getClientXWithScroll(e.clientX),
        boundaries: [inMarker - outMarker, Infinity]
      });
      return;
    }
    if (e.button !== 0) {
      return;
    }
    const frame2 = getFrameFromX({
      clientX: getClientXWithScroll(e.clientX) - left3,
      durationInFrames: videoConfig.durationInFrames,
      width,
      extrapolate: "clamp"
    });
    seek(frame2);
    setDragging({
      dragging: true,
      wasPlaying: playing
    });
    pause2();
  }, [
    isHighestContext,
    videoConfig,
    left3,
    width,
    seek,
    playing,
    pause2,
    inFrame,
    get,
    outFrame
  ]);
  const onPointerMoveScrubbing = useCallback86((e) => {
    if (!videoConfig) {
      return;
    }
    if (!dragging.dragging) {
      return;
    }
    const isRightOfArea = e.clientX >= scrollableRef.current?.clientWidth + left3 - TIMELINE_PADDING;
    const isLeftOfArea = e.clientX <= left3;
    const frame2 = getFrameFromX({
      clientX: getClientXWithScroll(e.clientX) - left3,
      durationInFrames: videoConfig.durationInFrames,
      width,
      extrapolate: "clamp"
    });
    if (isLeftOfArea && canScrollTimelineIntoDirection().canScrollLeft) {
      if (scroller.current) {
        return;
      }
      const scrollEvery = () => {
        if (!canScrollTimelineIntoDirection().canScrollLeft) {
          stopInterval();
          return;
        }
        const nextFrame = getFrameWhileScrollingLeft({
          durationInFrames: videoConfig.durationInFrames,
          width
        });
        const scrollPos = getScrollPositionForCursorOnLeftEdge({
          nextFrame,
          durationInFrames: videoConfig.durationInFrames
        });
        redrawTimelineSliderFast.current?.draw(nextFrame);
        seek(nextFrame);
        scrollToTimelineXOffset(scrollPos);
      };
      scrollEvery();
      scroller.current = setInterval(() => {
        scrollEvery();
      }, 100);
    } else if (isRightOfArea && canScrollTimelineIntoDirection().canScrollRight) {
      if (scroller.current) {
        return;
      }
      const scrollEvery = () => {
        if (!canScrollTimelineIntoDirection().canScrollRight) {
          stopInterval();
          return;
        }
        const nextFrame = getFrameWhileScrollingRight({
          durationInFrames: videoConfig.durationInFrames,
          width
        });
        const scrollPos = getScrollPositionForCursorOnRightEdge({
          nextFrame,
          durationInFrames: videoConfig.durationInFrames
        });
        redrawTimelineSliderFast.current?.draw(nextFrame);
        seek(nextFrame);
        scrollToTimelineXOffset(scrollPos);
      };
      scrollEvery();
      scroller.current = setInterval(() => {
        scrollEvery();
      }, 100);
    } else {
      stopInterval();
      seek(frame2);
    }
  }, [videoConfig, dragging.dragging, left3, width, seek]);
  const onPointerMoveInOut = useCallback86((e) => {
    if (!videoConfig) {
      return;
    }
    if (!inOutDragging.dragging) {
      return;
    }
    const offset = Math.max(inOutDragging.boundaries[0], Math.min(inOutDragging.boundaries[1], getClientXWithScroll(e.clientX) - inOutDragging.initialOffset));
    if (inOutDragging.dragging === "in") {
      if (!inPointerHandle.current) {
        throw new Error("in pointer handle");
      }
      if (!inMarkerAreaRef.current) {
        throw new Error("expected inMarkerAreaRef");
      }
      if (!inFrame) {
        throw new Error("expected inframes");
      }
      inPointerHandle.current.style.transform = `translateX(${get(inFrame) + offset}px)`;
      inMarkerAreaRef.current.style.width = String(get(inFrame) + offset) + "px";
    }
    if (inOutDragging.dragging === "out") {
      if (!outPointerHandle.current) {
        throw new Error("in pointer handle");
      }
      if (!outMarkerAreaRef.current) {
        throw new Error("in outMarkerAreaRef");
      }
      if (!outFrame) {
        throw new Error("expected outframes");
      }
      outPointerHandle.current.style.transform = `translateX(${get(outFrame) + offset}px)`;
      outMarkerAreaRef.current.style.left = String(get(outFrame) + offset) + "px";
      outMarkerAreaRef.current.style.width = String(width - get(outFrame) - offset) + "px";
    }
  }, [get, inFrame, inOutDragging, outFrame, videoConfig, width]);
  const onPointerUpScrubbing = useCallback86((e) => {
    stopInterval();
    if (!videoConfig) {
      return;
    }
    if (!dragging.dragging) {
      return;
    }
    setDragging({
      dragging: false
    });
    const frame2 = getFrameFromX({
      clientX: getClientXWithScroll(e.clientX) - left3,
      durationInFrames: videoConfig.durationInFrames,
      width,
      extrapolate: "clamp"
    });
    setFrame((c) => {
      const newObj = { ...c, [videoConfig.id]: frame2 };
      Internals44.persistCurrentFrame(newObj);
      return newObj;
    });
    if (dragging.wasPlaying) {
      play2();
    }
  }, [dragging, left3, play2, videoConfig, setFrame, width]);
  const onPointerUpInOut = useCallback86((e) => {
    if (!videoConfig) {
      return;
    }
    if (!inOutDragging.dragging) {
      return;
    }
    setInOutDragging({
      dragging: false
    });
    const frame2 = getFrameFromX({
      clientX: getClientXWithScroll(e.clientX) - left3,
      durationInFrames: videoConfig.durationInFrames,
      width,
      extrapolate: "extend"
    });
    if (inOutDragging.dragging === "in") {
      if (frame2 < 1) {
        return setInAndOutFrames((prev) => ({
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            inFrame: null
          }
        }));
      }
      const maxFrame = outFrame === null ? Infinity : outFrame - 1;
      setInAndOutFrames((prev) => ({
        ...prev,
        [videoConfig.id]: {
          ...prev[videoConfig.id] ?? defaultInOutValue,
          inFrame: Math.min(maxFrame, frame2)
        }
      }));
    } else {
      if (frame2 > videoConfig.durationInFrames - 2) {
        return setInAndOutFrames((prev) => ({
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            outFrame: null
          }
        }));
      }
      const minFrame = inFrame === null ? -Infinity : inFrame + 1;
      setInAndOutFrames((prev) => ({
        ...prev,
        [videoConfig.id]: {
          ...prev[videoConfig.id] ?? defaultInOutValue,
          outFrame: Math.max(minFrame, frame2)
        }
      }));
    }
  }, [
    inFrame,
    inOutDragging.dragging,
    left3,
    outFrame,
    setInAndOutFrames,
    videoConfig,
    width
  ]);
  useEffect56(() => {
    if (!dragging.dragging) {
      return;
    }
    window.addEventListener("pointermove", onPointerMoveScrubbing);
    window.addEventListener("pointerup", onPointerUpScrubbing);
    return () => {
      window.removeEventListener("pointermove", onPointerMoveScrubbing);
      window.removeEventListener("pointerup", onPointerUpScrubbing);
    };
  }, [dragging.dragging, onPointerMoveScrubbing, onPointerUpScrubbing]);
  useEffect56(() => {
    if (inOutDragging.dragging === false) {
      return;
    }
    window.addEventListener("pointermove", onPointerMoveInOut);
    window.addEventListener("pointerup", onPointerUpInOut);
    return () => {
      window.removeEventListener("pointermove", onPointerMoveInOut);
      window.removeEventListener("pointerup", onPointerUpInOut);
    };
  }, [inOutDragging.dragging, onPointerMoveInOut, onPointerUpInOut]);
  const inContextMenu = useMemo91(() => {
    return [
      {
        id: "hide-in",
        keyHint: null,
        label: "Clear In marker",
        leftItem: null,
        onClick: (_, e) => {
          e?.stopPropagation();
          e?.preventDefault();
          setInAndOutFrames((prev) => ({
            ...prev,
            [videoConfig.id]: {
              ...prev[videoConfig.id] ?? defaultInOutValue,
              inFrame: null
            }
          }));
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: "hide-in"
      }
    ];
  }, [setInAndOutFrames, videoConfig.id]);
  const outContextMenu = useMemo91(() => {
    return [
      {
        id: "hide-out",
        keyHint: null,
        label: "Clear Out marker",
        leftItem: null,
        onClick: (_, e) => {
          e?.stopPropagation();
          e?.preventDefault();
          setInAndOutFrames((prev) => ({
            ...prev,
            [videoConfig.id]: {
              ...prev[videoConfig.id] ?? defaultInOutValue,
              outFrame: null
            }
          }));
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: "hide-out"
      }
    ];
  }, [setInAndOutFrames, videoConfig.id]);
  return jsxs83("div", {
    style: style10,
    onPointerDown,
    children: [
      jsx172("div", {
        style: inner,
        className: VERTICAL_SCROLLBAR_CLASSNAME
      }),
      inFrame !== null && jsx172(ContextMenu, {
        values: inContextMenu,
        children: jsx172(TimelineInOutPointerHandle, {
          type: "in",
          atFrame: inFrame,
          dragging: inOutDragging.dragging === "in"
        })
      }),
      outFrame !== null && jsx172(ContextMenu, {
        values: outContextMenu,
        children: jsx172(TimelineInOutPointerHandle, {
          type: "out",
          dragging: inOutDragging.dragging === "out",
          atFrame: outFrame
        })
      })
    ]
  });
};

// src/components/Timeline/TimelineList.tsx
import {PlayerInternals as PlayerInternals16} from "@remotion/player";
import {useRef as useRef31} from "react";

// src/components/Timeline/TimelineListItem.tsx
import {useCallback as useCallback89, useContext as useContext58, useMemo as useMemo93} from "react";
import {Internals as Internals45} from "remotion";

// src/components/Timeline/TimelineLayerEye.tsx
import {useCallback as useCallback87} from "react";
import {
jsx as jsx173
} from "react/jsx-runtime";
var eyeIcon = {
  width: 12,
  color: "currentColor",
  pointerEvents: "none"
};
var speakerIcon = {
  ...eyeIcon,
  height: 10,
  marginLeft: -1
};
var container35 = {
  height: 16,
  width: 16,
  borderRadius: 2,
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  marginRight: 6
};
var layerPointedDown = null;
var TimelineLayerEye = ({ onInvoked, hidden, type }) => {
  const renderAction = useCallback87((color) => {
    if (hidden) {
      return null;
    }
    if (type === "speaker") {
      return jsx173("svg", {
        viewBox: "0 0 10 14",
        fill: "none",
        style: speakerIcon,
        children: jsx173("path", {
          d: "M9.40938 0.0869018C9.76875 0.249402 10 0.605652 10 0.999402V12.9994C10 13.3932 9.76875 13.7494 9.40938 13.9119C9.05 14.0744 8.62813 14.0088 8.33438 13.7463L4.11875 9.9994H2C0.896875 9.9994 0 9.10253 0 7.9994V5.9994C0 4.89628 0.896875 3.9994 2 3.9994H4.11875L8.33438 0.252527C8.62813 -0.0099732 9.05 -0.0724732 9.40938 0.0869018Z",
          fill: color
        })
      });
    }
    return jsx173("svg", {
      style: eyeIcon,
      viewBox: "0 0 24 16",
      fill: "none",
      children: jsx173("path", {
        d: "M24 7.551C24 7.551 19.748 16 12.015 16C4.835 16 0 7.551 0 7.551C0 7.551 4.446 0 12.015 0C19.709 0 24 7.551 24 7.551ZM17 8C17 5.243 14.757 3 12 3C9.243 3 7 5.243 7 8C7 10.757 9.243 13 12 13C14.757 13 17 10.757 17 8Z",
        fill: color
      })
    });
  }, [hidden, type]);
  const onPointerDown = useCallback87((e) => {
    if (e.button !== 0) {
      return;
    }
    layerPointedDown = hidden ? "enable" : "disable";
    onInvoked(layerPointedDown);
    window.addEventListener("pointerup", () => {
      layerPointedDown = null;
    }, { once: true });
  }, [hidden, onInvoked]);
  const onPointerEnter = useCallback87(() => {
    if (layerPointedDown) {
      onInvoked(layerPointedDown);
    }
  }, [onInvoked]);
  return jsx173("div", {
    style: container35,
    onPointerEnter,
    onPointerDown,
    children: renderAction(LIGHT_COLOR)
  });
};

// src/components/Timeline/TimelineStack/index.tsx
import {SOURCE_MAP_ENDPOINT} from "@remotion/studio-shared";
import {
useCallback as useCallback88,
useContext as useContext57,
useEffect as useEffect57,
useMemo as useMemo92,
useState as useState56
} from "react";
import {SourceMapConsumer as SourceMapConsumer3} from "source-map";

// src/components/Timeline/TimelineStack/get-stack.ts
import {SourceMapConsumer as SourceMapConsumer2} from "source-map";

// src/helpers/get-location-of-sequence.ts
var getLocationOfSequence = (stack2) => {
  if (!stack2) {
    return null;
  }
  const parsed = parseStack(stack2.split("\n"));
  let i = 0;
  while (i < parsed.length) {
    const frame2 = parsed[i];
    if (frame2.functionName === "apply") {
      i++;
      continue;
    }
    return frame2;
  }
  return null;
};

// src/components/Timeline/TimelineStack/get-stack.ts
var waiters = [];
var sourceMapConsumerCache = {};
var isCreating = {};
var getSourceMapCache = async (fileName) => {
  if (sourceMapConsumerCache[fileName]) {
    return sourceMapConsumerCache[fileName];
  }
  if (isCreating[fileName]) {
    return new Promise((resolve) => {
      waiters.push({
        id: String(Math.random()),
        forFileName: fileName,
        resolve
      });
    });
  }
  isCreating[fileName] = true;
  const res = await fetch(`${fileName}.map`);
  const json = await res.json();
  const map = await new Promise((resolve) => {
    SourceMapConsumer2.with(json, null, (consumer) => {
      resolve(consumer);
    });
  });
  waiters.filter((w) => {
    if (w.forFileName === fileName) {
      w.resolve(map);
      return false;
    }
    return true;
  });
  sourceMapConsumerCache[fileName] = map;
  isCreating[fileName] = false;
  return map;
};
var getOriginalLocationFromStack = async (stack2) => {
  const location2 = getLocationOfSequence(stack2);
  if (!location2) {
    return null;
  }
  const map = await getSourceMapCache(location2.fileName);
  const originalPosition = getOriginalPosition(map, location2.lineNumber, location2.columnNumber);
  return originalPosition;
};

// src/components/Timeline/TimelineStack/source-attribution.ts
var getOriginalSourceAttribution = (originalLocation) => {
  if (!originalLocation.source) {
    return "";
  }
  const split = originalLocation.source.split("/");
  const last = split[split.length - 1];
  if (last.startsWith("index")) {
    const lastTwo = split[split.length - 2];
    return `${lastTwo}/${last}:${originalLocation.line}`;
  }
  return `${last}:${originalLocation.line}`;
};

// src/components/Timeline/TimelineStack/index.tsx
import {
jsx as jsx174,
jsxs as jsxs84,
Fragment as Fragment26
} from "react/jsx-runtime";
SourceMapConsumer3.initialize({
  "lib/mappings.wasm": (window.remotion_publicPath === "/" ? "" : window.remotion_publicPath) + SOURCE_MAP_ENDPOINT
});
var TimelineStack = ({ isCompact, sequence }) => {
  const [originalLocation, setOriginalLocation] = useState56(null);
  const [stackHovered, setStackHovered] = useState56(false);
  const [titleHovered, setTitleHovered] = useState56(false);
  const [opening, setOpening] = useState56(false);
  const selectAsset = useSelectAsset();
  const connectionStatus = useContext57(StudioServerConnectionCtx).previewServerState.type;
  const assetPath = useMemo92(() => {
    if (sequence.type !== "video" && sequence.type !== "audio") {
      return null;
    }
    const isStatic = sequence.src.startsWith(window.remotion_staticBase);
    if (!isStatic) {
      return null;
    }
    const relativePath = sequence.src.replace(window.remotion_staticBase + "/", "");
    return relativePath;
  }, [sequence]);
  const navigateToAsset = useCallback88((asset) => {
    selectAsset(asset);
    pushUrl(`/assets/${asset}`);
  }, [selectAsset]);
  const openEditor = useCallback88(async (location2) => {
    if (!window.remotion_editorName) {
      return;
    }
    setOpening(true);
    try {
      await openInEditor({
        originalColumnNumber: location2.column,
        originalFileName: location2.source,
        originalFunctionName: null,
        originalLineNumber: location2.line,
        originalScriptCode: null
      });
    } catch (err) {
      showNotification(err.message, 2000);
    } finally {
      setOpening(false);
    }
  }, []);
  const canOpenInEditor = window.remotion_editorName && connectionStatus === "connected" && originalLocation;
  const canOpenInGitHub = window.remotion_gitSource && originalLocation;
  const titleHoverable = isCompact && (canOpenInEditor || canOpenInGitHub) || assetPath;
  const stackHoverable = !isCompact && (canOpenInEditor || canOpenInGitHub);
  const onClickTitle = useCallback88(() => {
    if (!titleHoverable) {
      return null;
    }
    if (assetPath) {
      navigateToAsset(assetPath);
      return;
    }
    if (!originalLocation) {
      return;
    }
    if (canOpenInEditor) {
      openEditor(originalLocation);
      return;
    }
    if (canOpenInGitHub) {
      window.open(getGitRefUrl(window.remotion_gitSource, originalLocation), "_blank");
    }
  }, [
    assetPath,
    canOpenInEditor,
    canOpenInGitHub,
    navigateToAsset,
    openEditor,
    originalLocation,
    titleHoverable
  ]);
  const onClickStack = useCallback88(() => {
    if (!originalLocation) {
      return;
    }
    if (canOpenInEditor) {
      openEditor(originalLocation);
      return;
    }
    if (canOpenInGitHub) {
      window.open(getGitRefUrl(window.remotion_gitSource, originalLocation), "_blank");
    }
  }, [canOpenInEditor, canOpenInGitHub, openEditor, originalLocation]);
  useEffect57(() => {
    if (!sequence.stack) {
      return;
    }
    getOriginalLocationFromStack(sequence.stack).then((frame2) => {
      setOriginalLocation(frame2);
    }).catch((err) => {
      console.error("Could not get original location of Sequence", err);
    });
  }, [sequence.stack]);
  const onStackPointerEnter = useCallback88(() => {
    setStackHovered(true);
  }, []);
  const onStackPointerLeave = useCallback88(() => {
    setStackHovered(false);
  }, []);
  const onTitlePointerEnter = useCallback88(() => {
    setTitleHovered(true);
  }, []);
  const onTitlePointerLeave = useCallback88(() => {
    setTitleHovered(false);
  }, []);
  const style11 = useMemo92(() => {
    return {
      fontSize: 12,
      color: opening ? VERY_LIGHT_TEXT : stackHovered && stackHoverable ? LIGHT_TEXT : VERY_LIGHT_TEXT,
      marginLeft: 10,
      cursor: stackHoverable ? "pointer" : undefined,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      flexShrink: 1e5
    };
  }, [opening, stackHovered, stackHoverable]);
  const titleStyle = useMemo92(() => {
    const hoverEffect = titleHovered && titleHoverable;
    return {
      fontSize: 12,
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      lineHeight: 1,
      color: opening && isCompact ? VERY_LIGHT_TEXT : LIGHT_COLOR,
      userSelect: "none",
      WebkitUserSelect: "none",
      borderBottom: hoverEffect ? "1px solid #fff" : "none",
      cursor: hoverEffect ? "pointer" : undefined
    };
  }, [titleHoverable, isCompact, opening, titleHovered]);
  const text2 = sequence.displayName.length > 1000 ? sequence.displayName.slice(0, 1000) + "..." : sequence.displayName;
  return jsxs84(Fragment26, {
    children: [
      jsx174("div", {
        onPointerEnter: onTitlePointerEnter,
        onPointerLeave: onTitlePointerLeave,
        title: originalLocation ? getOriginalSourceAttribution(originalLocation) : text2 || "<Sequence>",
        style: titleStyle,
        onClick: onClickTitle,
        children: text2 || "<Sequence>"
      }),
      isCompact || !originalLocation ? null : jsx174("div", {
        onPointerEnter: onStackPointerEnter,
        onPointerLeave: onStackPointerLeave,
        onClick: onClickStack,
        style: style11,
        children: getOriginalSourceAttribution(originalLocation)
      }),
      opening ? jsxs84(Fragment26, {
        children: [
          jsx174(Spacing, {
            x: 0.5
          }),
          jsx174(Spinner, {
            duration: 0.5,
            size: 12
          })
        ]
      }) : null
    ]
  });
};

// src/components/Timeline/TimelineListItem.tsx
import {
jsx as jsx175,
jsxs as jsxs85
} from "react/jsx-runtime";
var SPACING = 5;
var outer2 = {
  height: TIMELINE_LAYER_HEIGHT + TIMELINE_ITEM_BORDER_BOTTOM,
  color: "white",
  fontFamily: "Arial, Helvetica, sans-serif",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  wordBreak: "break-all",
  textAlign: "left",
  paddingLeft: SPACING,
  borderBottom: `1px solid ${TIMELINE_TRACK_SEPARATOR}`
};
var space = {
  width: SPACING,
  flexShrink: 0
};
var TimelineListItem = ({ nestedDepth, sequence, isCompact }) => {
  const { hidden, setHidden } = useContext58(Internals45.SequenceVisibilityToggleContext);
  const padder = useMemo93(() => {
    return {
      width: Number(SPACING * 1.5) * nestedDepth,
      flexShrink: 0
    };
  }, [nestedDepth]);
  const isItemHidden = useMemo93(() => {
    return hidden[sequence.id] ?? false;
  }, [hidden, sequence.id]);
  const onToggleVisibility = useCallback89((type) => {
    setHidden((prev) => {
      return {
        ...prev,
        [sequence.id]: type !== "enable"
      };
    });
  }, [sequence.id, setHidden]);
  return jsxs85("div", {
    style: outer2,
    children: [
      jsx175(TimelineLayerEye, {
        type: sequence.type === "audio" ? "speaker" : "eye",
        hidden: isItemHidden,
        onInvoked: onToggleVisibility
      }),
      jsx175("div", {
        style: padder
      }),
      sequence.parent && nestedDepth > 0 ? jsx175("div", {
        style: space
      }) : null,
      jsx175(TimelineStack, {
        sequence,
        isCompact
      })
    ]
  });
};

// src/components/Timeline/TimelineTimeIndicators.tsx
import {useContext as useContext59, useEffect as useEffect58, useMemo as useMemo94, useRef as useRef30} from "react";
import {Internals as Internals46} from "remotion";
import {
jsx as jsx176
} from "react/jsx-runtime";
var TIMELINE_TIME_INDICATOR_HEIGHT = 39;
var container36 = {
  height: TIMELINE_TIME_INDICATOR_HEIGHT - 4,
  boxShadow: `0 0 4px ${TIMELINE_BACKGROUND}`,
  position: "absolute",
  backgroundColor: TIMELINE_BACKGROUND,
  top: 0
};
var tick = {
  width: 1,
  backgroundColor: "rgba(255, 255, 255, 0.15)",
  height: 20,
  position: "absolute"
};
var secondTick = {
  ...tick,
  height: 15
};
var tickLabel = {
  fontSize: 12,
  marginLeft: 8,
  marginTop: 7,
  color: LIGHT_TEXT
};
var timeValue = {
  height: TIMELINE_TIME_INDICATOR_HEIGHT,
  position: "absolute",
  top: 0,
  width: "100%",
  paddingLeft: 10,
  display: "flex",
  alignItems: "center",
  backgroundColor: BACKGROUND,
  borderBottom: `${TIMELINE_ITEM_BORDER_BOTTOM}px solid ${TIMELINE_TRACK_SEPARATOR}`
};
var TimelineTimePlaceholders = () => {
  return jsx176("div", {
    style: timeValue,
    children: jsx176(TimeValue, {})
  });
};
var TimelineTimePadding = () => {
  return jsx176("div", {
    style: {
      height: TIMELINE_TIME_INDICATOR_HEIGHT
    }
  });
};
var TimelineTimeIndicators = () => {
  const sliderTrack = useContext59(TimelineWidthContext);
  const video2 = Internals46.useVideo();
  if (sliderTrack === null) {
    return null;
  }
  if (video2 === null) {
    return null;
  }
  return jsx176(Inner3, {
    durationInFrames: video2.durationInFrames,
    fps: video2.fps,
    windowWidth: sliderTrack
  });
};
var Inner3 = ({ windowWidth, durationInFrames, fps }) => {
  const ref = useRef30(null);
  useEffect58(() => {
    const currentRef = ref.current;
    if (!currentRef) {
      return;
    }
    const { current } = timelineVerticalScroll;
    if (!current) {
      return;
    }
    const onScroll = () => {
      currentRef.style.top = current.scrollTop + "px";
    };
    current.addEventListener("scroll", onScroll);
    return () => {
      current.removeEventListener("scroll", onScroll);
    };
  }, []);
  const style11 = useMemo94(() => {
    return {
      ...container36,
      width: windowWidth - SPLITTER_HANDLE_SIZE / 2,
      overflow: "hidden",
      marginLeft: SPLITTER_HANDLE_SIZE / 2,
      pointerEvents: "none"
    };
  }, [windowWidth]);
  const ticks = useMemo94(() => {
    const frameInterval = getFrameIncrementFromWidth(durationInFrames, windowWidth);
    const MIN_SPACING_BETWEEN_TICKS_PX = 5;
    const seconds = Math.floor(durationInFrames / fps);
    const secondMarkerEveryNth = Math.ceil(MIN_SPACING_BETWEEN_TICKS_PX * fps / (frameInterval * fps));
    const frameMarkerEveryNth = Math.ceil(MIN_SPACING_BETWEEN_TICKS_PX / frameInterval);
    const secondTicks = new Array(seconds).fill(true).map((_, index) => {
      return {
        frame: index * fps,
        style: {
          ...secondTick,
          left: frameInterval * index * fps + TIMELINE_PADDING - SPLITTER_HANDLE_SIZE / 2
        },
        showTime: index > 0
      };
    }).filter((_, idx) => idx % secondMarkerEveryNth === 0);
    const frameTicks = new Array(durationInFrames).fill(true).map((_, index) => {
      return {
        frame: index,
        style: {
          ...tick,
          left: frameInterval * index + TIMELINE_PADDING - SPLITTER_HANDLE_SIZE / 2,
          height: index % fps === 0 ? 10 : index / frameMarkerEveryNth % 2 === 0 ? 5 : 2
        },
        showTime: false
      };
    }).filter((_, idx) => idx % frameMarkerEveryNth === 0);
    const hasTicks = [];
    return [...secondTicks, ...frameTicks].filter((t) => {
      const alreadyUsed = hasTicks.find((ht) => ht === t.frame) !== undefined;
      hasTicks.push(t.frame);
      return !alreadyUsed;
    });
  }, [durationInFrames, fps, windowWidth]);
  return jsx176("div", {
    ref,
    style: style11,
    children: ticks.map((t) => {
      return jsx176("div", {
        style: t.style,
        children: t.showTime ? jsx176("div", {
          style: tickLabel,
          children: renderFrame(t.frame, fps)
        }) : null
      }, t.frame);
    })
  });
};

// src/components/Timeline/TimelineList.tsx
import {
jsx as jsx177,
jsxs as jsxs86
} from "react/jsx-runtime";
var container37 = {
  flex: 1,
  background: BACKGROUND
};
var TimelineList = ({ timeline: timeline2 }) => {
  const ref = useRef31(null);
  const size4 = PlayerInternals16.useElementSize(ref, {
    shouldApplyCssTransforms: false,
    triggerOnWindowResize: false
  });
  const isCompact = size4 ? size4.width < 250 : false;
  return jsxs86("div", {
    ref,
    style: container37,
    children: [
      jsx177(TimelineTimePadding, {}),
      timeline2.map((track) => {
        return jsx177("div", {
          children: jsx177(TimelineListItem, {
            nestedDepth: track.depth,
            sequence: track.sequence,
            isCompact
          }, track.sequence.id)
        }, track.sequence.id);
      })
    ]
  });
};

// src/components/Timeline/TimelinePlayCursorSyncer.tsx
import {useContext as useContext60, useEffect as useEffect59} from "react";
import {Internals as Internals47} from "remotion";
var lastTimelinePositionWhileScrolling = null;
var TimelinePlayCursorSyncer = () => {
  const video2 = Internals47.useVideo();
  const timelineContext = useContext60(Internals47.Timeline.TimelineContext);
  const timelinePosition = Internals47.Timeline.useTimelinePosition();
  const { canvasContent } = useContext60(Internals47.CompositionManager);
  const { zoom: zoomMap } = useContext60(TimelineZoomCtx);
  const compositionId = canvasContent && canvasContent.type === "composition" ? canvasContent.compositionId : null;
  const zoom = compositionId ? zoomMap[compositionId] ?? TIMELINE_MIN_ZOOM : null;
  if (zoom && video2) {
    setCurrentFrame(timelinePosition);
    setCurrentZoom(zoom);
    setCurrentDuration(video2.durationInFrames);
    setCurrentFps(video2.fps);
  }
  const playing = timelineContext.playing ?? false;
  useEffect59(() => {
    if (!video2) {
      return;
    }
    if (!playing) {
      return;
    }
    ensureFrameIsInViewport({
      direction: timelineContext.playbackRate > 0 ? "page-right" : "page-left",
      durationInFrames: video2.durationInFrames,
      frame: timelinePosition
    });
  }, [playing, timelineContext, timelinePosition, video2]);
  useEffect59(() => {
    const { current } = scrollableRef;
    if (!current) {
      return;
    }
    if (playing) {
      lastTimelinePositionWhileScrolling = {
        scrollLeft: current.scrollLeft,
        frame: getCurrentFrame(),
        zoomLevel: getCurrentZoom(),
        durationInFrames: getCurrentDuration()
      };
    } else if (lastTimelinePositionWhileScrolling !== null) {
      if (isCursorInViewport({
        frame: getCurrentFrame(),
        durationInFrames: getCurrentDuration()
      })) {
        return;
      }
      if (lastTimelinePositionWhileScrolling.zoomLevel === getCurrentZoom() && lastTimelinePositionWhileScrolling.durationInFrames === getCurrentDuration()) {
        current.scrollLeft = lastTimelinePositionWhileScrolling.scrollLeft;
      } else {
        ensureFrameIsInViewport({
          direction: "center",
          durationInFrames: getCurrentDuration(),
          frame: lastTimelinePositionWhileScrolling.frame
        });
      }
    }
  }, [playing]);
  return null;
};

// src/components/Timeline/TimelineScrollable.tsx
import {useMemo as useMemo95} from "react";
import {
jsx as jsx178
} from "react/jsx-runtime";
var outer3 = {
  width: "100%",
  height: "100%",
  overflowX: "auto",
  overflowY: "hidden",
  position: "relative",
  backgroundColor: TIMELINE_BACKGROUND
};
var TimelineScrollable = ({ children }) => {
  const containerStyle2 = useMemo95(() => {
    return {
      width: "100%",
      minHeight: "100%"
    };
  }, []);
  return jsx178("div", {
    ref: scrollableRef,
    style: outer3,
    className: HORIZONTAL_SCROLLBAR_CLASSNAME,
    children: jsx178("div", {
      style: containerStyle2,
      children
    })
  });
};

// src/components/Timeline/TimelineTracks.tsx
import {useMemo as useMemo99} from "react";

// src/components/Timeline/TimelineSequence.tsx
import {useContext as useContext61, useMemo as useMemo98, useState as useState59} from "react";
import {Internals as Internals49, useCurrentFrame as useCurrentFrame3} from "remotion";

// src/helpers/get-timeline-sequence-layout.ts
var SEQUENCE_BORDER_WIDTH = 1;
var getWidthOfTrack = ({
  durationInFrames,
  lastFrame,
  windowWidth,
  spatialDuration,
  nonNegativeMarginLeft
}) => {
  const fullWidth9 = windowWidth - TIMELINE_PADDING * 2;
  const base = durationInFrames === Infinity || lastFrame === 0 ? fullWidth9 : spatialDuration / lastFrame * fullWidth9;
  return base - SEQUENCE_BORDER_WIDTH + nonNegativeMarginLeft;
};
var getTimelineSequenceLayout = ({
  durationInFrames,
  startFrom,
  maxMediaDuration,
  startFromMedia,
  video: video2,
  windowWidth,
  premountDisplay
}) => {
  const maxMediaSequenceDuration = (maxMediaDuration ?? Infinity) - startFromMedia;
  const lastFrame = (video2.durationInFrames ?? 1) - 1;
  let spatialDuration = Math.min(maxMediaSequenceDuration, durationInFrames - 1, lastFrame - startFrom);
  const shouldAddHalfAFrameAtEnd = startFrom + durationInFrames < lastFrame;
  const shouldAddHalfAFrameAtStart = startFrom > 0;
  if (shouldAddHalfAFrameAtEnd) {
    spatialDuration += 0.5;
  }
  if (shouldAddHalfAFrameAtStart) {
    spatialDuration += 0.5;
  }
  const startFromWithOffset = shouldAddHalfAFrameAtStart ? startFrom - 0.5 : startFrom;
  const marginLeft = lastFrame === 0 ? 0 : startFromWithOffset / lastFrame * (windowWidth - TIMELINE_PADDING * 2);
  const nonNegativeMarginLeft = Math.min(marginLeft, 0);
  const width = getWidthOfTrack({
    durationInFrames,
    lastFrame,
    nonNegativeMarginLeft,
    spatialDuration,
    windowWidth
  });
  const premountWidth = premountDisplay ? getWidthOfTrack({
    durationInFrames: premountDisplay,
    lastFrame,
    nonNegativeMarginLeft,
    spatialDuration: premountDisplay,
    windowWidth
  }) : null;
  return {
    marginLeft: Math.max(marginLeft, 0) - (premountWidth ?? 0),
    width: width + (premountWidth ?? 0),
    premountWidth
  };
};

// src/components/AudioWaveform.tsx
import {getAudioData, getWaveformPortion} from "@remotion/media-utils";
import {useEffect as useEffect60, useMemo as useMemo97, useRef as useRef32, useState as useState57} from "react";
import {Internals as Internals48} from "remotion";

// src/components/AudioWaveformBar.tsx
import {useMemo as useMemo96} from "react";
import {
jsx as jsx179
} from "react/jsx-runtime";
var WAVEFORM_BAR_LENGTH = 4;
var WAVEFORM_BAR_MARGIN = 2;
var container38 = {
  width: WAVEFORM_BAR_LENGTH,
  backgroundColor: "rgba(255, 255, 255, 0.2)",
  marginLeft: WAVEFORM_BAR_MARGIN,
  borderRadius: 2
};
var AudioWaveformBar = ({ amplitude }) => {
  const style11 = useMemo96(() => {
    return {
      ...container38,
      height: TIMELINE_LAYER_HEIGHT / 2 * amplitude
    };
  }, [amplitude]);
  return jsx179("div", {
    style: style11
  });
};

// src/components/AudioWaveform.tsx
import {
jsx as jsx180,
jsxs as jsxs87
} from "react/jsx-runtime";
var container39 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  position: "absolute",
  height: TIMELINE_LAYER_HEIGHT
};
var errorMessage = {
  fontSize: 13,
  paddingTop: 6,
  paddingBottom: 6,
  paddingLeft: 12,
  paddingRight: 12,
  alignSelf: "flex-start",
  maxWidth: 450,
  opacity: 0.75
};
var canvasStyle = {
  position: "absolute"
};
var AudioWaveform = ({
  src,
  startFrom,
  durationInFrames,
  visualizationWidth,
  setMaxMediaDuration,
  volume,
  doesVolumeChange,
  playbackRate
}) => {
  const [metadata, setMetadata] = useState57(null);
  const [error, setError] = useState57(null);
  const mountState = useRef32({ isMounted: true });
  const vidConf = Internals48.useUnsafeVideoConfig();
  if (vidConf === null) {
    throw new Error("Expected video config");
  }
  const canvas = useRef32(null);
  useEffect60(() => {
    const { current } = mountState;
    current.isMounted = true;
    return () => {
      current.isMounted = false;
    };
  }, []);
  useEffect60(() => {
    if (!canvas.current) {
      return;
    }
    const context5 = canvas.current.getContext("2d");
    if (!context5) {
      return;
    }
    context5.clearRect(0, 0, visualizationWidth, TIMELINE_LAYER_HEIGHT);
    if (!doesVolumeChange || typeof volume === "number") {
      return;
    }
    const volumes = volume.split(",").map((v) => Number(v));
    context5.beginPath();
    context5.moveTo(0, TIMELINE_LAYER_HEIGHT);
    volumes.forEach((v, index) => {
      const x = index / (volumes.length - 1) * visualizationWidth;
      const y = (1 - v) * (TIMELINE_LAYER_HEIGHT - TIMELINE_BORDER * 2) + 1;
      if (index === 0) {
        context5.moveTo(x, y);
      } else {
        context5.lineTo(x, y);
      }
    });
    context5.strokeStyle = LIGHT_TRANSPARENT;
    context5.stroke();
  }, [visualizationWidth, metadata, startFrom, volume, doesVolumeChange]);
  useEffect60(() => {
    setError(null);
    getAudioData(src).then((data) => {
      if (mountState.current.isMounted) {
        setMaxMediaDuration(Math.floor(data.durationInSeconds * vidConf.fps));
        setMetadata(data);
      }
    }).catch((err) => {
      if (mountState.current.isMounted) {
        setError(err);
      }
    });
  }, [setMaxMediaDuration, src, vidConf.fps]);
  const normalized = useMemo97(() => {
    if (!metadata || metadata.numberOfChannels === 0) {
      return [];
    }
    const numberOfSamples = Math.floor(visualizationWidth / (WAVEFORM_BAR_LENGTH + WAVEFORM_BAR_MARGIN));
    return getWaveformPortion({
      audioData: metadata,
      startTimeInSeconds: startFrom / vidConf.fps,
      durationInSeconds: durationInFrames / vidConf.fps * playbackRate,
      numberOfSamples
    });
  }, [
    durationInFrames,
    vidConf.fps,
    metadata,
    playbackRate,
    startFrom,
    visualizationWidth
  ]);
  if (error) {
    return jsx180("div", {
      style: container39,
      children: jsx180("div", {
        style: errorMessage,
        children: "No waveform available. Audio might not support CORS."
      })
    });
  }
  if (!metadata) {
    return null;
  }
  return jsxs87("div", {
    style: container39,
    children: [
      normalized.map((w) => {
        return jsx180(AudioWaveformBar, {
          amplitude: w.amplitude
        }, w.index);
      }),
      jsx180("canvas", {
        ref: canvas,
        style: canvasStyle,
        width: visualizationWidth,
        height: TIMELINE_LAYER_HEIGHT
      })
    ]
  });
};

// src/components/Timeline/LoopedTimelineIndicators.tsx
import React127 from "react";
import {AbsoluteFill as AbsoluteFill3} from "remotion";

// src/components/Timeline/LoopedIndicator.tsx
import {AbsoluteFill as AbsoluteFill2} from "remotion";
import {
jsx as jsx181,
jsxs as jsxs88
} from "react/jsx-runtime";
var width = {
  width: 30,
  flexDirection: "row",
  display: "flex",
  position: "relative"
};
var icon4 = {
  height: 12
};
var Icon = () => jsx181("svg", {
  viewBox: "0 0 512 512",
  style: icon4,
  children: jsx181("path", {
    fill: LIGHT_COLOR,
    d: "M512 256c0 88.224-71.775 160-160 160H170.067l34.512 32.419c9.875 9.276 10.119 24.883.539 34.464l-10.775 10.775c-9.373 9.372-24.568 9.372-33.941 0l-92.686-92.686c-9.373-9.373-9.373-24.568 0-33.941l92.686-92.686c9.373-9.373 24.568-9.373 33.941 0l10.775 10.775c9.581 9.581 9.337 25.187-.539 34.464L170.067 352H352c52.935 0 96-43.065 96-96 0-13.958-2.996-27.228-8.376-39.204-4.061-9.039-2.284-19.626 4.723-26.633l12.183-12.183c11.499-11.499 30.965-8.526 38.312 5.982C505.814 205.624 512 230.103 512 256zM72.376 295.204C66.996 283.228 64 269.958 64 256c0-52.935 43.065-96 96-96h181.933l-34.512 32.419c-9.875 9.276-10.119 24.883-.539 34.464l10.775 10.775c9.373 9.372 24.568 9.372 33.941 0l92.686-92.686c9.373-9.373 9.373-24.568 0-33.941l-92.686-92.686c-9.373-9.373-24.568-9.373-33.941 0L306.882 29.12c-9.581 9.581-9.337 25.187.539 34.464L341.933 96H160C71.775 96 0 167.776 0 256c0 25.897 6.186 50.376 17.157 72.039 7.347 14.508 26.813 17.481 38.312 5.982l12.183-12.183c7.008-7.008 8.786-17.595 4.724-26.634z"
  })
});
var topLine = {
  top: 0,
  height: 2,
  width: 1,
  background: LIGHT_COLOR
};
var bottomLine = {
  top: 0,
  height: 2,
  width: 1,
  background: LIGHT_COLOR
};
var topContainer = {
  justifyContent: "flex-start",
  alignItems: "center"
};
var centerContainer = {
  justifyContent: "center",
  alignItems: "center"
};
var bottomContainer = {
  justifyContent: "flex-end",
  alignItems: "center"
};
var LoopedIndicator = () => {
  return jsxs88("div", {
    style: width,
    children: [
      jsx181(AbsoluteFill2, {
        style: topContainer,
        children: jsx181("div", {
          style: topLine
        })
      }),
      jsx181(AbsoluteFill2, {
        style: bottomContainer,
        children: jsx181("div", {
          style: bottomLine
        })
      }),
      jsx181(AbsoluteFill2, {
        style: centerContainer,
        children: jsx181(Icon, {})
      })
    ]
  });
};

// src/components/Timeline/LoopedTimelineIndicators.tsx
import {
jsx as jsx182,
jsxs as jsxs89
} from "react/jsx-runtime";
var row6 = {
  flexDirection: "row"
};
var LoopedTimelineIndicator = ({ loops }) => {
  return jsx182(AbsoluteFill3, {
    style: row6,
    children: new Array(loops).fill(true).map((_l, i) => {
      return jsxs89(React127.Fragment, {
        children: [
          jsx182(Flex, {}),
          i === loops - 1 ? null : jsx182(LoopedIndicator, {})
        ]
      }, i);
    })
  });
};

// src/components/Timeline/TimelineSequenceFrame.tsx
import {
jsx as jsx183
} from "react/jsx-runtime";
var relativeFrameStyle = {
  fontSize: 11,
  fontFamily: "Arial, Helvetica, sans-serif",
  color: "white",
  opacity: 0.5
};
var TimelineSequenceFrame = ({ roundedFrame, premounted }) => {
  return jsx183("div", {
    style: relativeFrameStyle,
    children: premounted ? "0 (Premounted)" : roundedFrame
  });
};

// src/components/Timeline/TimelineVideoInfo.tsx
import {getVideoMetadata as getVideoMetadata2} from "@remotion/media-utils";
import {useEffect as useEffect61, useRef as useRef33, useState as useState58} from "react";
import {
jsx as jsx184
} from "react/jsx-runtime";
var containerStyle2 = {
  height: TIMELINE_LAYER_HEIGHT - 2,
  width: TIMELINE_LAYER_HEIGHT - 2,
  backgroundColor: "rgba(0, 0, 0, 0.3)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  borderTopLeftRadius: 2,
  borderBottomLeftRadius: 2,
  fontSize: 10,
  fontFamily: "Arial, Helvetica"
};
var svgStyle2 = {
  height: 12
};
var pathStyle = {
  color: "#8e44ad"
};
var TimelineVideoInfo = ({ src }) => {
  const mountState = useRef33({ isMounted: true });
  const [videoMetadata, setVideoMetadata] = useState58(null);
  useEffect61(() => {
    getVideoMetadata2(src).then((data) => {
      setVideoMetadata(data);
    }).catch((err) => {
      console.log("Could not get video metadata", err);
    });
  }, [src]);
  useEffect61(() => {
    const { current } = mountState;
    current.isMounted = true;
    return () => {
      current.isMounted = false;
    };
  }, []);
  if (!videoMetadata) {
    return null;
  }
  return jsx184("div", {
    style: containerStyle2,
    children: jsx184("svg", {
      style: svgStyle2,
      role: "img",
      viewBox: "0 0 576 512",
      children: jsx184("path", {
        style: pathStyle,
        fill: "currentColor",
        d: "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
      })
    })
  });
};

// src/components/Timeline/TimelineSequence.tsx
import {
jsx as jsx185,
jsxs as jsxs90
} from "react/jsx-runtime";
var AUDIO_GRADIENT = "linear-gradient(rgb(16 171 58), rgb(43 165 63) 60%)";
var VIDEO_GRADIENT = "linear-gradient(to top, #8e44ad, #9b59b6)";
var TimelineSequence = ({ s }) => {
  const windowWidth = useContext61(TimelineWidthContext);
  if (windowWidth === null) {
    return null;
  }
  return jsx185(Inner4, {
    windowWidth,
    s
  });
};
var Inner4 = ({ s, windowWidth }) => {
  const [maxMediaDuration, setMaxMediaDuration] = useState59(Infinity);
  const video2 = Internals49.useVideo();
  if (!video2) {
    throw new TypeError("Expected video config");
  }
  const frame2 = useCurrentFrame3();
  const relativeFrame = frame2 - s.from;
  const relativeFrameWithPremount = relativeFrame + (s.premountDisplay ?? 0);
  const roundedFrame = Math.round(relativeFrame * 100) / 100;
  const isInRange = relativeFrame >= 0 && relativeFrame < s.duration;
  const isPremounting = relativeFrameWithPremount >= 0 && relativeFrameWithPremount < s.duration && !isInRange;
  const { marginLeft, width: width2, premountWidth } = useMemo98(() => {
    return getTimelineSequenceLayout({
      durationInFrames: s.loopDisplay ? s.loopDisplay.durationInFrames * s.loopDisplay.numberOfTimes : s.duration,
      startFrom: s.loopDisplay ? s.from + s.loopDisplay.startOffset : s.from,
      startFromMedia: s.type === "sequence" ? 0 : s.startMediaFrom,
      maxMediaDuration,
      video: video2,
      windowWidth,
      premountDisplay: s.premountDisplay
    });
  }, [maxMediaDuration, s, video2, windowWidth]);
  const style11 = useMemo98(() => {
    return {
      background: s.type === "audio" ? AUDIO_GRADIENT : s.type === "video" ? VIDEO_GRADIENT : BLUE,
      border: SEQUENCE_BORDER_WIDTH + "px solid rgba(255, 255, 255, 0.2)",
      borderRadius: 2,
      position: "absolute",
      height: TIMELINE_LAYER_HEIGHT,
      marginLeft,
      width: width2,
      color: "white",
      overflow: "hidden",
      opacity: isInRange ? 1 : 0.5
    };
  }, [isInRange, marginLeft, s.type, width2]);
  return jsxs90("div", {
    style: style11,
    title: s.displayName,
    children: [
      premountWidth ? jsx185("div", {
        style: {
          width: premountWidth,
          height: "100%",
          background: `repeating-linear-gradient(
							-45deg,
							transparent,
							transparent 2px,
							rgba(255, 255, 255, ${isPremounting ? 0.5 : 0.2}) 2px,
							rgba(255, 255, 255, ${isPremounting ? 0.5 : 0.2}) 4px
						)`,
          position: "absolute"
        }
      }) : null,
      s.type === "audio" ? jsx185(AudioWaveform, {
        src: s.src,
        doesVolumeChange: s.doesVolumeChange,
        visualizationWidth: width2,
        startFrom: s.startMediaFrom,
        durationInFrames: s.duration,
        volume: s.volume,
        setMaxMediaDuration,
        playbackRate: s.playbackRate
      }) : null,
      s.type === "video" ? jsx185(TimelineVideoInfo, {
        src: s.src
      }) : null,
      s.loopDisplay === undefined ? null : jsx185(LoopedTimelineIndicator, {
        loops: s.loopDisplay.numberOfTimes
      }),
      s.type !== "audio" && s.type !== "video" && s.loopDisplay === undefined && (isInRange || isPremounting) ? jsx185("div", {
        style: {
          paddingLeft: 5 + (premountWidth ?? 0),
          height: "100%",
          display: "flex",
          alignItems: "center"
        },
        children: jsx185(TimelineSequenceFrame, {
          premounted: isPremounting,
          roundedFrame
        })
      }) : null
    ]
  }, s.id);
};

// src/components/Timeline/is-collapsed.ts
var isTrackHidden = (track) => {
  if (!track.sequence.parent) {
    return false;
  }
  return !track.sequence.showInTimeline;
};

// src/components/Timeline/TimelineTracks.tsx
import {
jsx as jsx186,
jsxs as jsxs91
} from "react/jsx-runtime";
var content = {
  paddingLeft: TIMELINE_PADDING,
  paddingRight: TIMELINE_PADDING,
  paddingTop: 1
};
var timelineContent = {
  minHeight: "100%"
};
var TimelineTracks = ({ timeline: timeline2, hasBeenCut }) => {
  const inner2 = useMemo99(() => {
    return {
      height: TIMELINE_LAYER_HEIGHT,
      marginBottom: TIMELINE_ITEM_BORDER_BOTTOM
    };
  }, []);
  const timelineStyle = useMemo99(() => {
    return {
      ...timelineContent,
      width: 100 + "%"
    };
  }, []);
  return jsxs91("div", {
    style: timelineStyle,
    children: [
      jsxs91("div", {
        style: content,
        children: [
          jsx186(TimelineTimePadding, {}),
          timeline2.map((track) => {
            if (isTrackHidden(track)) {
              return null;
            }
            return jsx186("div", {
              style: inner2,
              children: jsx186(TimelineSequence, {
                s: track.sequence
              })
            }, track.sequence.id);
          })
        ]
      }),
      hasBeenCut ? jsx186(MaxTimelineTracksReached, {}) : null
    ]
  });
};

// src/components/Timeline/Timeline.tsx
import {
jsx as jsx187,
jsxs as jsxs92
} from "react/jsx-runtime";
var container40 = {
  minHeight: "100%",
  flex: 1,
  display: "flex",
  height: 0,
  overflowY: "auto",
  backgroundColor: BACKGROUND
};
var noop7 = () => {
  return;
};
var Timeline = () => {
  const { sequences } = useContext62(Internals50.SequenceManager);
  const videoConfig = Internals50.useUnsafeVideoConfig();
  const timeline2 = useMemo100(() => {
    if (!videoConfig) {
      return [];
    }
    return calculateTimeline({
      sequences,
      sequenceDuration: videoConfig.durationInFrames
    });
  }, [sequences, videoConfig]);
  const durationInFrames = videoConfig?.durationInFrames ?? 0;
  const filtered = useMemo100(() => {
    const withoutHidden = timeline2.filter((t) => !isTrackHidden(t));
    const withoutAfter = withoutHidden.filter((t) => {
      return t.sequence.from <= durationInFrames && t.sequence.duration > 0;
    });
    return withoutAfter.filter((t) => t.sequence.showInTimeline);
  }, [durationInFrames, timeline2]);
  const shown = filtered.slice(0, MAX_TIMELINE_TRACKS);
  const hasBeenCut = filtered.length > shown.length;
  const inner2 = useMemo100(() => {
    return {
      height: shown.length * (TIMELINE_LAYER_HEIGHT + Number(TIMELINE_ITEM_BORDER_BOTTOM)) + TIMELINE_ITEM_BORDER_BOTTOM + (hasBeenCut ? MAX_TIMELINE_TRACKS_NOTICE_HEIGHT : 0) + TIMELINE_TIME_INDICATOR_HEIGHT,
      display: "flex",
      flex: 1,
      minHeight: "100%",
      overflowX: "hidden"
    };
  }, [hasBeenCut, shown.length]);
  return jsx187("div", {
    ref: timelineVerticalScroll,
    style: container40,
    className: "css-reset " + VERTICAL_SCROLLBAR_CLASSNAME,
    children: jsx187(TimelineWidthProvider, {
      children: jsx187("div", {
        style: inner2,
        children: jsxs92(SplitterContainer, {
          orientation: "vertical",
          defaultFlex: 0.2,
          id: "names-to-timeline",
          maxFlex: 0.5,
          minFlex: 0.15,
          children: [
            jsx187(SplitterElement, {
              type: "flexer",
              sticky: jsx187(TimelineTimePlaceholders, {}),
              children: jsx187(TimelineList, {
                timeline: shown
              })
            }),
            jsx187(SplitterHandle, {
              onCollapse: noop7,
              allowToCollapse: "none"
            }),
            jsx187(SplitterElement, {
              type: "anti-flexer",
              sticky: null,
              children: jsxs92(TimelineScrollable, {
                children: [
                  jsx187(TimelineTracks, {
                    timeline: shown,
                    hasBeenCut
                  }),
                  jsx187(TimelineInOutPointer, {}),
                  jsx187(TimelinePlayCursorSyncer, {}),
                  jsx187(TimelineDragHandler, {}),
                  jsx187(TimelineTimeIndicators, {}),
                  jsx187(TimelineSlider, {})
                ]
              })
            })
          ]
        })
      })
    })
  });
};

// src/components/EditorContent.tsx
import {
jsx as jsx188,
jsxs as jsxs93,
Fragment as Fragment27
} from "react/jsx-runtime";
var noop8 = () => {
  return;
};
var container41 = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  height: 0
};
var EditorContent = ({ readOnlyStudio, children }) => {
  const isStill = useIsStill();
  const { canvasContent } = useContext63(Internals51.CompositionManager);
  const onlyTopPanel = canvasContent === null || isStill || canvasContent.type !== "composition";
  return jsxs93("div", {
    style: container41,
    children: [
      jsx188(InitialCompositionLoader2, {}),
      jsx188(MenuToolbar, {
        readOnlyStudio
      }),
      jsxs93(SplitterContainer, {
        orientation: "horizontal",
        id: "top-to-bottom",
        maxFlex: 0.9,
        minFlex: 0.2,
        defaultFlex: 0.75,
        children: [
          jsx188(SplitterElement, {
            sticky: null,
            type: "flexer",
            children
          }),
          onlyTopPanel ? null : jsxs93(Fragment27, {
            children: [
              jsx188(SplitterHandle, {
                allowToCollapse: "none",
                onCollapse: noop8
              }),
              jsx188(SplitterElement, {
                sticky: null,
                type: "anti-flexer",
                children: jsx188(Timeline, {})
              })
            ]
          })
        ]
      })
    ]
  });
};

// src/components/GlobalKeybindings.tsx
import {useContext as useContext64, useEffect as useEffect62} from "react";
var GlobalKeybindings = () => {
  const keybindings2 = useKeybinding();
  const { setSelectedModal } = useContext64(ModalsContext);
  const { setCheckerboard } = useContext64(CheckerboardContext);
  useEffect62(() => {
    const nKey = keybindings2.registerKeybinding({
      event: "keypress",
      key: "n",
      callback: () => {
        showNotification(`To make a new composition, right-click an existing one and select "Duplicate"`, 5000);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const cmdKKey = keybindings2.registerKeybinding({
      event: "keydown",
      key: "k",
      callback: () => {
        setSelectedModal({
          type: "quick-switcher",
          mode: "compositions",
          invocationTimestamp: Date.now()
        });
      },
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false,
      commandCtrlKey: true,
      preventDefault: true
    });
    const cKey = keybindings2.registerKeybinding({
      event: "keypress",
      key: "t",
      callback: () => {
        setCheckerboard((c) => !c);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const questionMark = keybindings2.registerKeybinding({
      event: "keypress",
      key: "?",
      callback: () => {
        setSelectedModal({
          type: "quick-switcher",
          mode: "docs",
          invocationTimestamp: Date.now()
        });
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      nKey.unregister();
      cKey.unregister();
      questionMark.unregister();
      cmdKKey.unregister();
    };
  }, [keybindings2, setCheckerboard, setSelectedModal]);
  return null;
};

// src/components/Modals.tsx
import {useContext as useContext76} from "react";

// src/components/NewComposition/DeleteComposition.tsx
import {useCallback as useCallback93, useContext as useContext69, useMemo as useMemo102} from "react";

// src/components/ModalHeader.tsx
import {useCallback as useCallback90, useContext as useContext65} from "react";
import {
jsx as jsx189,
jsxs as jsxs94
} from "react/jsx-runtime";
var container42 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "12px 16px",
  width: "100%",
  borderBottom: "1px solid black"
};
var titleStyle = {
  fontSize: 14,
  color: "white"
};
var icon5 = {
  height: 20,
  width: 20
};
var NewCompHeader = ({ title: title4 }) => {
  const { setSelectedModal } = useContext65(ModalsContext);
  const onPress = useCallback90(() => {
    setSelectedModal(null);
  }, [setSelectedModal]);
  return jsxs94("div", {
    style: container42,
    children: [
      jsx189("div", {
        style: titleStyle,
        children: title4
      }),
      jsx189(Flex, {}),
      jsx189(CancelButton, {
        style: icon5,
        onPress
      })
    ]
  });
};

// src/components/RenderModal/ResolveCompositionBeforeModal.tsx
import React134, {useContext as useContext66, useEffect as useEffect63, useMemo as useMemo101} from "react";
import {Internals as Internals52} from "remotion";
import {
jsx as jsx190,
jsxs as jsxs95
} from "react/jsx-runtime";
var loaderContainer2 = {
  paddingTop: 40,
  paddingBottom: 40,
  paddingLeft: 100,
  paddingRight: 100,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column"
};
var loaderLabel2 = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var ResolvedCompositionContext = React134.createContext(null);
var ResolveCompositionBeforeModal = ({ compositionId, children }) => {
  const resolved = Internals52.useResolvedVideoConfig(compositionId);
  const unresolvedContext = useContext66(Internals52.CompositionManager);
  const unresolved = unresolvedContext.compositions.find((c) => compositionId === c.id);
  useEffect63(() => {
    const { current } = Internals52.resolveCompositionsRef;
    if (!current) {
      throw new Error("No ref to trigger composition calc");
    }
    current.setCurrentRenderModalComposition(compositionId);
    return () => {
      current.setCurrentRenderModalComposition(null);
    };
  }, [compositionId]);
  if (!unresolved) {
    throw new Error("Composition not found: " + compositionId);
  }
  const value = useMemo101(() => {
    return {
      resolved,
      unresolved
    };
  }, [resolved, unresolved]);
  if (!resolved || resolved.type === "loading") {
    return jsx190(RunningCalculateMetadata, {});
  }
  if (resolved.type === "error") {
    return jsxs95("div", {
      style: loaderContainer2,
      children: [
        jsx190(Spacing, {
          y: 2
        }),
        jsxs95("div", {
          style: loaderLabel2,
          children: [
            "Running ",
            jsx190("code", {
              style: inlineCodeSnippet,
              children: "calculateMetadata()"
            }),
            " ",
            "yielded an error:"
          ]
        }),
        jsx190(Spacing, {
          y: 1
        }),
        jsx190("div", {
          style: loaderLabel2,
          children: resolved.error.message || "Unknown error"
        })
      ]
    });
  }
  return jsx190(ResolvedCompositionContext.Provider, {
    value,
    children
  });
};

// src/components/NewComposition/CodemodFooter.tsx
import {useCallback as useCallback91, useContext as useContext67, useEffect as useEffect64, useState as useState60} from "react";

// src/components/NewComposition/DiffPreview.tsx
import {
jsx as jsx191,
jsxs as jsxs96
} from "react/jsx-runtime";
var CodemodDiffPreview = ({ status }) => {
  if (status.type === "loading") {
    return null;
  }
  if (status.type === "fail") {
    return jsx191("span", {
      style: { color: FAIL_COLOR, fontSize: 13, lineHeight: 1.2 },
      children: status.error
    });
  }
  return jsxs96("div", {
    style: { lineHeight: 1.2 },
    children: [
      jsx191("span", {
        style: { color: LIGHT_TEXT, fontSize: 13, lineHeight: 1.2 },
        children: "This will edit your Root file."
      }),
      jsx191("br", {}),
      jsxs96("span", {
        style: { color: BLUE, fontSize: 13, lineHeight: 1.2 },
        children: [
          status.diff.additions,
          " addition",
          status.diff.additions === 1 ? "" : "s",
          ","
        ]
      }),
      " ",
      jsxs96("span", {
        style: {
          color: SELECTED_GUIDE,
          fontSize: 13,
          lineHeight: 1.2
        },
        children: [
          status.diff.deletions,
          " deletion",
          status.diff.deletions === 1 ? "" : "s"
        ]
      })
    ]
  });
};

// src/components/NewComposition/CodemodFooter.tsx
import {
jsx as jsx192,
jsxs as jsxs97
} from "react/jsx-runtime";
var buttonStyle5 = {
  backgroundColor: BLUE,
  color: "white"
};
var CodemodFooter = ({
  codemod,
  valid,
  loadingNotification,
  succeessNotifcation,
  errorNotification,
  genericSubmitLabel,
  submitLabel
}) => {
  const [submitting, setSubmitting] = useState60(false);
  const { setSelectedModal } = useContext67(ModalsContext);
  const [codemodStatus, setCanApplyCodemod] = useState60({
    type: "loading"
  });
  const [projectInfo, setProjectInfo] = useState60(null);
  useEffect64(() => {
    const controller = new AbortController;
    getProjectInfo(controller.signal).then((info) => {
      setProjectInfo(info.projectInfo);
    }).catch((err) => {
      showNotification(`Could not get project info: ${err.message}. Unable to duplicate composition`, 3000);
    });
    return () => {
      controller.abort();
    };
  }, []);
  const trigger = useCallback91(() => {
    setSubmitting(true);
    setSelectedModal(null);
    const notification2 = showNotification(loadingNotification, null);
    applyCodemod({
      codemod,
      dryRun: false,
      signal: new AbortController().signal
    }).then(() => {
      notification2.replaceContent(succeessNotifcation, 2000);
    }).catch((err) => {
      notification2.replaceContent(`${errorNotification}: ${err.message}`, 2000);
    });
  }, [
    codemod,
    errorNotification,
    loadingNotification,
    setSelectedModal,
    succeessNotifcation
  ]);
  const getCanApplyCodemod = useCallback91(async (signal) => {
    const res = await applyCodemod({
      codemod,
      dryRun: true,
      signal
    });
    if (res.success) {
      setCanApplyCodemod({ type: "success", diff: res.diff });
    } else {
      setCanApplyCodemod({
        type: "fail",
        error: res.reason
      });
    }
  }, [codemod]);
  useEffect64(() => {
    const abortController = new AbortController;
    let aborted = false;
    getCanApplyCodemod(abortController.signal).then(() => {
      return;
    }).catch((err) => {
      if (aborted) {
        return;
      }
      showNotification(`Cannot duplicate composition: ${err.message}`, 3000);
    });
    return () => {
      aborted = true;
      abortController.abort();
    };
  }, [codemodStatus, getCanApplyCodemod, setSelectedModal]);
  const disabled = !valid || submitting || projectInfo === null || codemodStatus.type !== "success";
  const { registerKeybinding } = useKeybinding();
  useEffect64(() => {
    if (disabled) {
      return;
    }
    const enter = registerKeybinding({
      callback() {
        trigger();
      },
      commandCtrlKey: true,
      key: "Enter",
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      enter.unregister();
    };
  }, [disabled, registerKeybinding, trigger, valid]);
  return jsxs97(Row, {
    align: "center",
    children: [
      jsx192(CodemodDiffPreview, {
        status: codemodStatus
      }),
      jsx192(Flex, {}),
      jsx192(Spacing, {
        block: true,
        x: 2
      }),
      jsxs97(Button, {
        onClick: trigger,
        disabled,
        style: {
          ...buttonStyle5,
          backgroundColor: disabled ? BLUE_DISABLED : BLUE
        },
        children: [
          projectInfo && projectInfo.relativeRootFile ? submitLabel({ relativeRootPath: projectInfo.relativeRootFile }) : genericSubmitLabel,
          jsx192(ShortcutHint, {
            keyToPress: "\u21B5",
            cmdOrCtrl: true
          })
        ]
      })
    ]
  });
};

// src/components/NewComposition/DismissableModal.tsx
import {useCallback as useCallback92, useContext as useContext68} from "react";

// src/components/ModalContainer.tsx
import {
jsx as jsx193
} from "react/jsx-runtime";
var padding2 = 20;
var getMaxModalWidth = (width2) => {
  return `min(calc(100vw - ${padding2 * 2}px), calc(${width2}px - ${padding2 * 2}px))`;
};
var getMaxModalHeight = (height) => {
  return `min(calc(100vh - ${padding2 * 2}px), calc(${height}px - ${padding2 * 2}px))`;
};
var backgroundOverlay = {
  backgroundColor: "rgba(255, 255, 255, 0.2)",
  backdropFilter: `blur(1px)`,
  position: "fixed",
  height: "100%",
  width: "100%",
  display: "flex",
  padding: padding2
};
var panel = {
  backgroundColor: BACKGROUND,
  boxShadow: "0 0 4px black",
  color: "white",
  margin: "auto"
};
var ModalContainer = ({ children, onEscape, onOutsideClick }) => {
  return jsx193("div", {
    className: "css-reset",
    style: backgroundOverlay,
    role: "dialog",
    "aria-modal": "true",
    children: jsx193(HigherZIndex, {
      onOutsideClick,
      onEscape,
      children: jsx193("div", {
        style: panel,
        children
      })
    })
  });
};

// src/components/NewComposition/DismissableModal.tsx
import {
jsx as jsx194
} from "react/jsx-runtime";
var DismissableModal = ({ children }) => {
  const { setSelectedModal } = useContext68(ModalsContext);
  const onQuit = useCallback92(() => {
    setSelectedModal(null);
  }, [setSelectedModal]);
  return jsx194(ModalContainer, {
    onOutsideClick: onQuit,
    onEscape: onQuit,
    children
  });
};

// src/components/NewComposition/DeleteComposition.tsx
import {
jsx as jsx195,
jsxs as jsxs98,
Fragment as Fragment28
} from "react/jsx-runtime";
var content2 = {
  padding: 16,
  fontSize: 14,
  flex: 1,
  minWidth: 500
};
var DeleteCompositionLoaded = ({ compositionId }) => {
  const context5 = useContext69(ResolvedCompositionContext);
  if (!context5) {
    throw new Error("Resolved composition context");
  }
  const { unresolved } = context5;
  const codemod = useMemo102(() => {
    return {
      type: "delete-composition",
      idToDelete: compositionId
    };
  }, [compositionId]);
  const onSubmit = useCallback93((e) => {
    e.preventDefault();
  }, []);
  return jsxs98(Fragment28, {
    children: [
      jsx195(NewCompHeader, {
        title: "Delete composition"
      }),
      jsxs98("form", {
        onSubmit,
        children: [
          jsxs98("div", {
            style: content2,
            children: [
              "Do you want to delete the",
              " ",
              jsx195("code", {
                style: inlineCodeSnippet,
                children: unresolved.durationInFrames === 1 ? `<Still>` : "<Composition>"
              }),
              " ",
              "with ID ",
              '"',
              unresolved.id,
              '"',
              "?",
              jsx195("br", {}),
              "The associated ",
              jsx195("code", {
                style: inlineCodeSnippet,
                children: "component"
              }),
              " will remain in your code."
            ]
          }),
          jsx195("div", {
            style: { ...content2, borderTop: "1px solid black" },
            children: jsx195(CodemodFooter, {
              errorNotification: `Could not delete composition`,
              loadingNotification: "Deleting",
              succeessNotifcation: `Deleted ${unresolved.id}`,
              genericSubmitLabel: `Delete`,
              submitLabel: ({ relativeRootPath }) => `Delete from ${relativeRootPath}`,
              codemod,
              valid: true
            })
          })
        ]
      })
    ]
  });
};
var DeleteComposition = ({ compositionId }) => {
  return jsx195(DismissableModal, {
    children: jsx195(ResolveCompositionBeforeModal, {
      compositionId,
      children: jsx195(DeleteCompositionLoaded, {
        compositionId
      })
    })
  });
};

// src/components/NewComposition/DuplicateComposition.tsx
import {useCallback as useCallback95, useContext as useContext70, useMemo as useMemo103, useState as useState61} from "react";
import {Internals as Internals54} from "remotion";

// src/helpers/validate-new-comp-data.ts
import {Internals as Internals53} from "remotion";
var validateCompositionName = (compName, compositions) => {
  if (!Internals53.isCompositionIdValid(compName)) {
    return Internals53.invalidCompositionErrorMessage;
  }
  if (compositions.find((c) => c.id === compName)) {
    return `A composition with that name already exists.`;
  }
  return null;
};
var validateCompositionDimension = (dimension, value) => {
  if (Number(value) % 2 !== 0) {
    return `${dimension} should be divisible by 2, since H264 codec doesn't support odd dimensions.`;
  }
  if (Number.isNaN(Number(value))) {
    return "Invalid number.";
  }
  if (Number(value) === 0) {
    return dimension + " cannot be zero.";
  }
  return null;
};
var validateCompositionDuration = (value) => {
  if (value % 1 !== 0) {
    return `Duration must be an integer.`;
  }
  if (Number.isNaN(value)) {
    return "Invalid number.";
  }
  if (value === 0) {
    return "Duration cannot be zero.";
  }
  return null;
};

// src/components/NewComposition/NewCompDuration.tsx
import {useCallback as useCallback94} from "react";
import {
jsx as jsx196,
jsxs as jsxs99,
Fragment as Fragment29
} from "react/jsx-runtime";
var NewCompDuration = ({ durationInFrames, setDurationInFrames }) => {
  const onDurationInFramesChanged = useCallback94((newValue) => {
    setDurationInFrames(Number(newValue));
  }, [setDurationInFrames]);
  const onDurationChangedDirectly = useCallback94((newVal) => {
    setDurationInFrames(newVal);
  }, [setDurationInFrames]);
  const compDurationErrMessage = validateCompositionDuration(durationInFrames);
  return jsxs99("div", {
    style: optionRow,
    children: [
      jsx196("div", {
        style: label5,
        children: "Duration in frames"
      }),
      jsxs99("div", {
        style: rightRow,
        children: [
          jsx196(InputDragger, {
            type: "number",
            value: durationInFrames,
            onTextChange: onDurationInFramesChanged,
            placeholder: "Duration (frames)",
            name: "durationInFrames",
            min: 1,
            step: 1,
            required: true,
            status: "ok",
            max: 300000,
            onValueChange: onDurationChangedDirectly,
            rightAlign: false
          }),
          compDurationErrMessage ? jsxs99(Fragment29, {
            children: [
              jsx196(Spacing, {
                y: 1,
                block: true
              }),
              jsx196(ValidationMessage, {
                align: "flex-start",
                message: compDurationErrMessage,
                type: "error"
              })
            ]
          }) : null
        ]
      })
    ]
  });
};

// src/components/NewComposition/DuplicateComposition.tsx
import {
jsx as jsx197,
jsxs as jsxs100,
Fragment as Fragment30
} from "react/jsx-runtime";
var content3 = {
  padding: 12,
  paddingRight: 12,
  flex: 1,
  fontSize: 13,
  minWidth: 500
};
var comboBoxStyle = {
  width: 190
};
var DuplicateCompositionLoaded = ({ initialType }) => {
  const context5 = useContext70(ResolvedCompositionContext);
  if (!context5) {
    throw new Error("Resolved composition context");
  }
  const { resolved, unresolved } = context5;
  const [initialCompType] = useState61(initialType);
  const hadDimensionsDefined = unresolved.width && unresolved.height;
  const hadFpsDefined = unresolved.fps !== undefined;
  const hadDurationDefined = unresolved.durationInFrames !== undefined;
  const [selectedFrameRate, setFrameRate] = useState61(resolved.result.fps);
  const { compositions } = useContext70(Internals54.CompositionManager);
  const [type, setType] = useState61(initialCompType);
  const [newId, setName] = useState61(() => {
    const numberAtEnd = resolved.result.id.match(/([0-9]+)$/)?.[0];
    let prefix = numberAtEnd ? Number(numberAtEnd) : 1;
    const initialName = resolved.result.id.replace(/([0-9]+)$/, "");
    let currentName = initialName;
    while (true) {
      currentName = initialName + prefix;
      const err = validateCompositionName(currentName, compositions);
      if (!err) {
        break;
      }
      prefix++;
    }
    return currentName;
  });
  const [size4, setSize] = useState61(() => ({
    width: resolved.result.width,
    height: resolved.result.height
  }));
  const [durationInFrames, setDurationInFrames] = useState61(resolved.result.durationInFrames);
  const onTypeChanged = useCallback95((newType) => {
    setType(newType);
  }, []);
  const onWidthChanged = useCallback95((newValue) => {
    setSize((s) => {
      const { height } = s;
      const newWidth = Number(newValue);
      return {
        height,
        width: newWidth
      };
    });
  }, []);
  const onWidthDirectlyChanged = useCallback95((newWidth) => {
    setSize((s) => {
      const { height } = s;
      return {
        height,
        width: newWidth
      };
    });
  }, []);
  const onHeightDirectlyChanged = useCallback95((newHeight) => {
    setSize((s) => {
      const { width: width2 } = s;
      return {
        width: width2,
        height: newHeight
      };
    });
  }, []);
  const onHeightChanged = useCallback95((newValue) => {
    setSize((s) => {
      const { width: width2 } = s;
      const newHeight = Number(newValue);
      return {
        width: width2,
        height: newHeight
      };
    });
  }, []);
  const onNameChange = useCallback95((e) => {
    setName(e.target.value);
  }, []);
  const onTextFpsChange = useCallback95((newFps) => {
    setFrameRate(Number(newFps));
  }, []);
  const onFpsChange = useCallback95((newFps) => {
    setFrameRate(newFps);
  }, []);
  const compNameErrMessage = validateCompositionName(newId, compositions);
  const compWidthErrMessage = validateCompositionDimension("Width", size4.width);
  const compHeightErrMessage = validateCompositionDimension("Height", size4.height);
  const typeValues = useMemo103(() => {
    return [
      {
        id: "composition",
        keyHint: null,
        label: "<Composition />",
        leftItem: null,
        onClick: () => onTypeChanged("composition"),
        subMenu: null,
        type: "item",
        value: "composition",
        quickSwitcherLabel: null
      },
      {
        id: "still",
        keyHint: null,
        label: "<Still />",
        leftItem: null,
        onClick: () => onTypeChanged("still"),
        subMenu: null,
        type: "item",
        value: "still",
        quickSwitcherLabel: null
      }
    ];
  }, [onTypeChanged]);
  const valid = compNameErrMessage === null && compWidthErrMessage === null && compHeightErrMessage === null;
  const codemod = useMemo103(() => {
    return {
      type: "duplicate-composition",
      idToDuplicate: resolved.result.id,
      newDurationInFrames: hadDurationDefined ? Number(durationInFrames) : null,
      newFps: hadFpsDefined ? Number(selectedFrameRate) : null,
      newHeight: hadDimensionsDefined ? Number(size4.height) : null,
      newWidth: hadDimensionsDefined ? Number(size4.width) : null,
      newId,
      tag: type === "still" ? "Still" : "Composition"
    };
  }, [
    durationInFrames,
    hadDimensionsDefined,
    hadDurationDefined,
    hadFpsDefined,
    newId,
    resolved.result.id,
    selectedFrameRate,
    size4.height,
    size4.width,
    type
  ]);
  const onSubmit = useCallback95((e) => {
    e.preventDefault();
  }, []);
  return jsxs100(Fragment30, {
    children: [
      jsx197(NewCompHeader, {
        title: `Duplicate ${resolved.result.id}`
      }),
      jsxs100("form", {
        onSubmit,
        children: [
          jsxs100("div", {
            style: content3,
            children: [
              initialCompType === "composition" ? jsxs100("div", {
                style: optionRow,
                children: [
                  jsx197("div", {
                    style: label5,
                    children: "Type"
                  }),
                  jsx197("div", {
                    style: rightRow,
                    children: jsx197(Combobox, {
                      title: "Type of composition",
                      style: comboBoxStyle,
                      values: typeValues,
                      selectedId: type
                    })
                  })
                ]
              }) : null,
              jsxs100("div", {
                style: optionRow,
                children: [
                  jsx197("div", {
                    style: label5,
                    children: "ID"
                  }),
                  jsx197("div", {
                    style: rightRow,
                    children: jsxs100("div", {
                      children: [
                        jsx197(RemotionInput, {
                          value: newId,
                          onChange: onNameChange,
                          type: "text",
                          autoFocus: true,
                          placeholder: "Composition ID",
                          status: "ok",
                          rightAlign: true
                        }),
                        compNameErrMessage ? jsxs100(Fragment30, {
                          children: [
                            jsx197(Spacing, {
                              y: 1,
                              block: true
                            }),
                            jsx197(ValidationMessage, {
                              align: "flex-start",
                              message: compNameErrMessage,
                              type: "error"
                            })
                          ]
                        }) : null
                      ]
                    })
                  })
                ]
              }),
              hadDimensionsDefined ? jsxs100(Fragment30, {
                children: [
                  jsxs100("div", {
                    style: optionRow,
                    children: [
                      jsx197("div", {
                        style: label5,
                        children: "Width"
                      }),
                      jsxs100("div", {
                        style: rightRow,
                        children: [
                          jsx197(InputDragger, {
                            type: "number",
                            value: size4.width,
                            placeholder: "Width",
                            onTextChange: onWidthChanged,
                            name: "width",
                            step: 2,
                            min: 2,
                            required: true,
                            status: "ok",
                            formatter: (w) => `${w}px`,
                            max: 1e8,
                            onValueChange: onWidthDirectlyChanged,
                            rightAlign: false
                          }),
                          compWidthErrMessage ? jsxs100(Fragment30, {
                            children: [
                              jsx197(Spacing, {
                                y: 1,
                                block: true
                              }),
                              jsx197(ValidationMessage, {
                                align: "flex-start",
                                message: compWidthErrMessage,
                                type: "error"
                              })
                            ]
                          }) : null
                        ]
                      })
                    ]
                  }),
                  jsxs100("div", {
                    style: optionRow,
                    children: [
                      jsx197("div", {
                        style: label5,
                        children: "Height"
                      }),
                      jsxs100("div", {
                        style: rightRow,
                        children: [
                          jsx197(InputDragger, {
                            type: "number",
                            value: size4.height,
                            onTextChange: onHeightChanged,
                            placeholder: "Height",
                            name: "height",
                            step: 2,
                            required: true,
                            formatter: (h) => `${h}px`,
                            min: 2,
                            status: "ok",
                            max: 1e8,
                            onValueChange: onHeightDirectlyChanged,
                            rightAlign: false
                          }),
                          compHeightErrMessage ? jsxs100(Fragment30, {
                            children: [
                              jsx197(Spacing, {
                                y: 1,
                                block: true
                              }),
                              jsx197(ValidationMessage, {
                                align: "flex-start",
                                message: compHeightErrMessage,
                                type: "error"
                              })
                            ]
                          }) : null
                        ]
                      })
                    ]
                  })
                ]
              }) : null,
              type === "composition" && hadDurationDefined ? jsx197(NewCompDuration, {
                durationInFrames,
                setDurationInFrames
              }) : null,
              type === "composition" && hadFpsDefined ? jsxs100("div", {
                style: optionRow,
                children: [
                  jsx197("div", {
                    style: label5,
                    children: "FPS"
                  }),
                  jsx197("div", {
                    style: rightRow,
                    children: jsx197(InputDragger, {
                      type: "number",
                      value: selectedFrameRate,
                      onTextChange: onTextFpsChange,
                      placeholder: "Frame rate (fps)",
                      name: "fps",
                      min: 1,
                      required: true,
                      status: "ok",
                      max: 240,
                      step: 0.01,
                      onValueChange: onFpsChange,
                      rightAlign: false
                    })
                  })
                ]
              }) : null
            ]
          }),
          jsx197("div", {
            style: { ...content3, borderTop: "1px solid black" },
            children: jsx197(CodemodFooter, {
              loadingNotification: "Duplicating...",
              errorNotification: "Could not duplicate composition",
              succeessNotifcation: `Duplicated ${unresolved.id}`,
              genericSubmitLabel: "Duplicate",
              submitLabel: ({ relativeRootPath }) => `Add to ${relativeRootPath}`,
              codemod,
              valid
            })
          })
        ]
      })
    ]
  });
};
var DuplicateComposition = ({ compositionId, compositionType }) => {
  return jsx197(DismissableModal, {
    children: jsx197(ResolveCompositionBeforeModal, {
      compositionId,
      children: jsx197(DuplicateCompositionLoaded, {
        initialType: compositionType
      })
    })
  });
};

// src/components/NewComposition/RenameComposition.tsx
import {useCallback as useCallback96, useContext as useContext71, useMemo as useMemo104, useState as useState62} from "react";
import {Internals as Internals55} from "remotion";
import {
jsx as jsx198,
jsxs as jsxs101,
Fragment as Fragment31
} from "react/jsx-runtime";
var content4 = {
  padding: 12,
  paddingRight: 12,
  flex: 1,
  fontSize: 13,
  minWidth: 500
};
var RenameCompositionLoaded = () => {
  const context5 = useContext71(ResolvedCompositionContext);
  if (!context5) {
    throw new Error("Resolved composition context");
  }
  const { resolved } = context5;
  const { compositions } = useContext71(Internals55.CompositionManager);
  const [newId, setName] = useState62(() => {
    return resolved.result.id;
  });
  const onNameChange = useCallback96((e) => {
    setName(e.target.value);
  }, []);
  const compNameErrMessage = newId === resolved.result.id ? null : validateCompositionName(newId, compositions);
  const valid = compNameErrMessage === null && resolved.result.id !== newId;
  const codemod = useMemo104(() => {
    return {
      type: "rename-composition",
      idToRename: resolved.result.id,
      newId
    };
  }, [newId, resolved.result.id]);
  const onSubmit = useCallback96((e) => {
    e.preventDefault();
  }, []);
  return jsxs101(Fragment31, {
    children: [
      jsx198(NewCompHeader, {
        title: `Rename ${resolved.result.id}`
      }),
      jsxs101("form", {
        onSubmit,
        children: [
          jsx198("div", {
            style: content4,
            children: jsxs101("div", {
              style: optionRow,
              children: [
                jsx198("div", {
                  style: label5,
                  children: "ID"
                }),
                jsx198("div", {
                  style: rightRow,
                  children: jsxs101("div", {
                    children: [
                      jsx198(RemotionInput, {
                        value: newId,
                        onChange: onNameChange,
                        type: "text",
                        autoFocus: true,
                        placeholder: "Composition ID",
                        status: "ok",
                        rightAlign: true
                      }),
                      compNameErrMessage ? jsxs101(Fragment31, {
                        children: [
                          jsx198(Spacing, {
                            y: 1,
                            block: true
                          }),
                          jsx198(ValidationMessage, {
                            align: "flex-start",
                            message: compNameErrMessage,
                            type: "error"
                          })
                        ]
                      }) : null
                    ]
                  })
                })
              ]
            })
          }),
          jsx198("div", {
            style: { ...content4, borderTop: "1px solid black" },
            children: jsx198(CodemodFooter, {
              loadingNotification: "Renaming...",
              errorNotification: "Could not rename composition",
              succeessNotifcation: `Renamed to ${newId}`,
              genericSubmitLabel: "Rename",
              submitLabel: ({ relativeRootPath }) => `Modify ${relativeRootPath}`,
              codemod,
              valid
            })
          })
        ]
      })
    ]
  });
};
var RenameComposition = ({ compositionId }) => {
  return jsx198(DismissableModal, {
    children: jsx198(ResolveCompositionBeforeModal, {
      compositionId,
      children: jsx198(RenameCompositionLoaded, {})
    })
  });
};

// src/components/QuickSwitcher/QuickSwitcherContent.tsx
import {
useCallback as useCallback97,
useContext as useContext72,
useEffect as useEffect66,
useMemo as useMemo106,
useRef as useRef35,
useState as useState64
} from "react";
import {Internals as Internals56} from "remotion";

// src/icons/keys.tsx
import {
jsx as jsx199
} from "react/jsx-runtime";
var iconStyle5 = {
  width: 10,
  display: "inline"
};
var ShiftIcon = () => {
  return jsx199("svg", {
    style: iconStyle5,
    viewBox: "0 0 448 512",
    children: jsx199("path", {
      fill: "currentColor",
      d: "M48.048 304h73.798v128c0 26.51 21.49 48 48 48h108.308c26.51 0 48-21.49 48-48V304h73.789c42.638 0 64.151-51.731 33.941-81.941l-175.943-176c-18.745-18.745-49.137-18.746-67.882 0l-175.952 176C-16.042 252.208 5.325 304 48.048 304zM224 80l176 176H278.154v176H169.846V256H48L224 80z"
    })
  });
};
var ArrowLeft = () => {
  return jsx199("svg", {
    style: iconStyle5,
    viewBox: "0 0 448 512",
    children: jsx199("path", {
      fill: "currentColor",
      d: "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    })
  });
};
var ArrowRight = () => {
  return jsx199("svg", {
    style: iconStyle5,
    viewBox: "0 0 448 512",
    children: jsx199("path", {
      fill: "currentColor",
      d: "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
    })
  });
};

// src/components/KeyboardShortcutsExplainer.tsx
import {
jsx as jsx200,
jsxs as jsxs102
} from "react/jsx-runtime";
var left3 = {
  width: 85,
  paddingTop: 8,
  paddingBottom: 8
};
var key4 = {
  background: INPUT_BACKGROUND,
  padding: "3px 6px",
  color: "white",
  borderRadius: 3,
  border: "1px solid " + INPUT_BORDER_COLOR_UNHOVERED,
  borderBottomWidth: 3,
  fontSize: 14,
  fontFamily: "monospace"
};
var right2 = {
  fontSize: 14,
  color: "#eee"
};
var container43 = {
  paddingLeft: 20,
  paddingRight: 40,
  paddingTop: 10,
  paddingBottom: 10
};
var title4 = {
  fontWeight: "bold",
  color: "white",
  fontSize: 14,
  marginBottom: 10
};
var keyboardShortcutsDisabled = {
  padding: 12,
  width: "100%",
  fontSize: 14,
  backgroundColor: "rgba(255, 255, 255, 0.1)"
};
var ul = {
  marginTop: 0,
  marginBottom: 0
};
var li = {
  fontSize: 14
};
var KeyboardShortcutsExplainer = () => {
  return jsxs102("div", {
    children: [
      areKeyboardShortcutsDisabled() ? jsxs102("div", {
        style: keyboardShortcutsDisabled,
        children: [
          "Keyboard shortcuts disabled either due to:",
          jsxs102("ul", {
            style: ul,
            children: [
              jsx200("li", {
                style: li,
                children: "a) --disable-keyboard-shortcuts being passed"
              }),
              jsx200("li", {
                style: li,
                children: "b) Config.setKeyboardShortcutsEnabled(false) being set or"
              }),
              jsx200("li", {
                style: li,
                children: " c) a Remotion version mismatch."
              })
            ]
          })
        ]
      }) : null,
      jsxs102(Row, {
        style: container43,
        children: [
          jsxs102(Column, {
            children: [
              jsx200("div", {
                style: title4,
                children: "Playback"
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsxs102("div", {
                    style: left3,
                    children: [
                      jsx200("kbd", {
                        style: key4,
                        children: jsx200(ShiftIcon, {})
                      }),
                      jsx200(Spacing, {
                        x: 0.3
                      }),
                      jsx200("kbd", {
                        style: key4,
                        children: jsx200(ArrowLeft, {})
                      })
                    ]
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "1 second back"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: jsx200(ArrowLeft, {})
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Previous frame"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "Space"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Play / Pause"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: jsx200(ArrowRight, {})
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Next frame"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsxs102("div", {
                    style: left3,
                    children: [
                      jsx200("kbd", {
                        style: key4,
                        children: jsx200(ShiftIcon, {})
                      }),
                      jsx200(Spacing, {
                        x: 0.3
                      }),
                      jsx200("kbd", {
                        style: key4,
                        children: jsx200(ArrowRight, {})
                      })
                    ]
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "1 second forward"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "A"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Jump to beginning"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "E"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Jump to end"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "J"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Reverse playback"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "K"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Pause"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "L"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Play / Speed up"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "G"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Go to frame"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "Enter"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Pause & return to playback start"
                  })
                ]
              }),
              jsx200("br", {}),
              jsx200("div", {
                style: title4,
                children: "Sidebar"
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsxs102("div", {
                    style: left3,
                    children: [
                      jsx200("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      jsx200(Spacing, {
                        x: 0.3
                      }),
                      jsx200("kbd", {
                        style: key4,
                        children: "B"
                      })
                    ]
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Toggle left sidebar"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsxs102("div", {
                    style: left3,
                    children: [
                      jsx200("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      jsx200(Spacing, {
                        x: 0.3
                      }),
                      jsx200("kbd", {
                        style: key4,
                        children: "J"
                      })
                    ]
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Toggle right sidebar"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsxs102("div", {
                    style: left3,
                    children: [
                      jsx200("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      jsx200(Spacing, {
                        x: 0.3
                      }),
                      jsx200("kbd", {
                        style: key4,
                        children: "G"
                      })
                    ]
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Toggle both sidebars"
                  })
                ]
              }),
              jsx200("br", {}),
              jsx200("div", {
                style: title4,
                children: "View"
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "F"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Enter fullscreen"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "Esc"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Exit fullscreen"
                  })
                ]
              })
            ]
          }),
          jsx200(Spacing, {
            x: 8
          }),
          jsxs102(Column, {
            children: [
              jsx200("div", {
                style: title4,
                children: "Navigation"
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "R"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Render composition"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "T"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Toggle checkerboard background"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "?"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Show keyboard shortcuts"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsxs102("div", {
                    style: left3,
                    children: [
                      jsx200("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      jsx200(Spacing, {
                        x: 0.3
                      }),
                      jsx200("kbd", {
                        style: key4,
                        children: "K"
                      })
                    ]
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Quick Switcher"
                  })
                ]
              }),
              jsx200("br", {}),
              jsx200("div", {
                style: title4,
                children: "Playback range"
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "I"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Set In Point"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "O"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Set Out Point"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "X"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Clear In/Out Points"
                  })
                ]
              }),
              jsx200("br", {}),
              jsx200("div", {
                style: title4,
                children: "Zoom"
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "+"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Zoom in"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "-"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Zoom out"
                  })
                ]
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsx200("div", {
                    style: left3,
                    children: jsx200("kbd", {
                      style: key4,
                      children: "0"
                    })
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Reset zoom"
                  })
                ]
              }),
              " ",
              jsx200("br", {}),
              jsx200("div", {
                style: title4,
                children: "Props Editor"
              }),
              jsxs102(Row, {
                align: "center",
                children: [
                  jsxs102("div", {
                    style: left3,
                    children: [
                      jsx200("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      jsx200(Spacing, {
                        x: 0.3
                      }),
                      jsx200("kbd", {
                        style: key4,
                        children: "S"
                      })
                    ]
                  }),
                  jsx200("div", {
                    style: right2,
                    children: "Save"
                  })
                ]
              })
            ]
          })
        ]
      })
    ]
  });
};

// src/components/QuickSwitcher/AlgoliaCredit.tsx
import {
jsx as jsx201
} from "react/jsx-runtime";
var link = {
  display: "inline-flex"
};
var AlgoliaCredit = () => {
  return jsx201("a", {
    style: link,
    href: "https://www.algolia.com/ref/docsearch/?utm_source=www.remotion.dev&utm_medium=referral&utm_content=powered_by&utm_campaign=docsearch",
    target: "_blank",
    rel: "noopener noreferrer",
    children: jsx201("svg", {
      width: "77",
      height: "19",
      "aria-label": "Algolia",
      role: "img",
      children: jsx201("path", {
        d: "M2.5067 0h14.0245c1.384.001 2.5058 1.1205 2.5068 2.5017V16.5c-.0014 1.3808-1.1232 2.4995-2.5068 2.5H2.5067C1.1232 18.9995.0014 17.8808 0 16.5V2.4958A2.495 2.495 0 01.735.7294 2.505 2.505 0 012.5068 0zM37.95 15.0695c-3.7068.0168-3.7068-2.986-3.7068-3.4634L34.2372.3576 36.498 0v11.1794c0 .2715 0 1.9889 1.452 1.994v1.8961zm-9.1666-1.8388c.694 0 1.2086-.0397 1.5678-.1088v-2.2934a5.3639 5.3639 0 00-1.3303-.1679 4.8283 4.8283 0 00-.758.0582 2.2845 2.2845 0 00-.688.2024c-.2029.0979-.371.2362-.4919.4142-.1268.1788-.185.2826-.185.5533 0 .5297.185.8359.5205 1.0375.3355.2016.7928.3053 1.365.3053v-.0008zm-.1969-8.1817c.7463 0 1.3768.092 1.8856.2767.5088.1838.9195.4428 1.2204.7717.3068.334.5147.7777.6423 1.251.1327.4723.196.991.196 1.5603v5.798c-.5235.1036-1.05.192-1.5787.2649-.7048.1037-1.4976.156-2.3774.156-.5832 0-1.1215-.0582-1.6016-.167a3.385 3.385 0 01-1.2432-.5364 2.6034 2.6034 0 01-.8037-.9565c-.191-.3922-.29-.9447-.29-1.5208 0-.5533.11-.905.3246-1.2863a2.7351 2.7351 0 01.8849-.9329c.376-.242.8029-.415 1.2948-.5187a7.4517 7.4517 0 011.5381-.156 7.1162 7.1162 0 011.6667.2024V8.886c0-.259-.0296-.5061-.093-.7372a1.5847 1.5847 0 00-.3245-.6158 1.5079 1.5079 0 00-.6119-.4158 2.6788 2.6788 0 00-.966-.173c-.5206 0-.9948.0634-1.4283.1384a6.5481 6.5481 0 00-1.065.259l-.2712-1.849c.2831-.0986.7048-.1964 1.2491-.2943a9.2979 9.2979 0 011.752-.1501v.0008zm44.6597 8.1193c.6947 0 1.2086-.0405 1.567-.1097v-2.2942a5.3743 5.3743 0 00-1.3303-.1679c-.2485 0-.503.0177-.7573.0582a2.2853 2.2853 0 00-.688.2024 1.2333 1.2333 0 00-.4918.4142c-.1268.1788-.1843.2826-.1843.5533 0 .5297.1843.8359.5198 1.0375.3414.2066.7927.3053 1.365.3053v.0009zm-.191-8.1767c.7463 0 1.3768.0912 1.8856.2759.5087.1847.9195.4436 1.2204.7717.3.329.5147.7786.6414 1.251a5.7248 5.7248 0 01.197 1.562v5.7972c-.3466.0742-.874.1602-1.5788.2648-.7049.1038-1.4976.1552-2.3774.1552-.5832 0-1.1215-.0573-1.6016-.167a3.385 3.385 0 01-1.2432-.5356 2.6034 2.6034 0 01-.8038-.9565c-.191-.3922-.2898-.9447-.2898-1.5216 0-.5533.1098-.905.3245-1.2854a2.7373 2.7373 0 01.8849-.9338c.376-.2412.8029-.4141 1.2947-.5178a7.4545 7.4545 0 012.325-.1097c.2781.0287.5672.081.879.156v-.3686a2.7781 2.7781 0 00-.092-.738 1.5788 1.5788 0 00-.3246-.6166 1.5079 1.5079 0 00-.612-.415 2.6797 2.6797 0 00-.966-.1729c-.5205 0-.9947.0633-1.4282.1384a6.5608 6.5608 0 00-1.065.259l-.2712-1.8498c.283-.0979.7048-.1957 1.2491-.2935a9.8597 9.8597 0 011.752-.1494zm-6.79-1.072c-.7576.001-1.373-.6103-1.3759-1.3664 0-.755.6128-1.3664 1.376-1.3664.764 0 1.3775.6115 1.3775 1.3664s-.6195 1.3664-1.3776 1.3664zm1.1393 11.1507h-2.2726V5.3409l2.2734-.3568v10.0845l-.0008.0017zm-3.984 0c-3.707.0168-3.707-2.986-3.707-3.4642L59.7069.3576 61.9685 0v11.1794c0 .2715 0 1.9889 1.452 1.994V15.0703zm-7.3512-4.979c0-.975-.2138-1.7873-.6305-2.3516-.4167-.571-.9998-.852-1.747-.852-.7454 0-1.3302.281-1.7452.852-.4166.5702-.6195 1.3765-.6195 2.3516 0 .9851.208 1.6473.6254 2.2183.4158.576.9998.8587 1.7461.8587.7454 0 1.3303-.2885 1.747-.8595.4158-.5761.6237-1.2315.6237-2.2184v.0009zm2.3132-.006c0 .7609-.1099 1.3361-.3356 1.9654a4.654 4.654 0 01-.9533 1.6076A4.214 4.214 0 0155.613 14.69c-.579.2412-1.4697.3795-1.9143.3795-.4462-.005-1.3303-.1324-1.9033-.3795a4.307 4.307 0 01-1.474-1.0316c-.4115-.4445-.7293-.9801-.9609-1.6076a5.3423 5.3423 0 01-.3465-1.9653c0-.7608.104-1.493.3356-2.1155a4.683 4.683 0 01.9719-1.5958 4.3383 4.3383 0 011.479-1.0257c.5739-.242 1.2043-.3567 1.8864-.3567.6829 0 1.3125.1197 1.8906.3567a4.1245 4.1245 0 011.4816 1.0257 4.7587 4.7587 0 01.9592 1.5958c.2426.6225.3643 1.3547.3643 2.1155zm-17.0198 0c0 .9448.208 1.9932.6238 2.431.4166.4386.955.6579 1.6142.6579.3584 0 .6998-.0523 1.0176-.1502.3186-.0978.5721-.2134.775-.3517V7.0784a8.8706 8.8706 0 00-1.4926-.1906c-.8206-.0236-1.4452.312-1.8847.8468-.4335.5365-.6533 1.476-.6533 2.3516v-.0008zm6.2863 4.4485c0 1.5385-.3938 2.662-1.1866 3.3773-.791.7136-2.0005 1.0712-3.6308 1.0712-.5958 0-1.834-.1156-2.8228-.334l.3643-1.7865c.8282.173 1.9202.2193 2.4932.2193.9077 0 1.555-.1847 1.943-.5533.388-.3686.578-.916.578-1.643v-.3687a6.8289 6.8289 0 01-.8848.3349c-.3634.1096-.786.167-1.261.167-.6246 0-1.1917-.0979-1.7055-.2944a3.5554 3.5554 0 01-1.3244-.8645c-.3642-.3796-.6541-.8579-.8561-1.4289-.2028-.571-.3068-1.59-.3068-2.339 0-.7034.1099-1.5856.3245-2.1735.2198-.5871.5316-1.0949.9542-1.515.4167-.42.9255-.743 1.5213-.98a5.5923 5.5923 0 012.052-.3855c.7353 0 1.4114.092 2.0707.2024.6592.1088 1.2204.2236 1.6776.35v8.945-.0008zM11.5026 4.2418v-.6511c-.0005-.4553-.3704-.8241-.8266-.8241H8.749c-.4561 0-.826.3688-.8265.824v.669c0 .0742.0693.1264.1445.1096a6.0346 6.0346 0 011.6768-.2362 6.125 6.125 0 011.6202.2185.1116.1116 0 00.1386-.1097zm-5.2806.852l-.3296-.3282a.8266.8266 0 00-1.168 0l-.393.3922a.8199.8199 0 000 1.164l.3237.323c.0524.0515.1268.0397.1733-.0117.191-.259.3989-.507.6305-.7372.2374-.2362.48-.4437.7462-.6335.0575-.0354.0634-.1155.017-.1687zm3.5159 2.069v2.818c0 .081.0879.1392.1622.0987l2.5102-1.2964c.0574-.0287.0752-.0987.0464-.1552a3.1237 3.1237 0 00-2.603-1.574c-.0575 0-.115.0456-.115.1097l-.0008-.0009zm.0008 6.789c-2.0933.0005-3.7915-1.6912-3.7947-3.7804C5.9468 8.0821 7.6452 6.39 9.7387 6.391c2.0932-.0005 3.7911 1.6914 3.794 3.7804a3.7783 3.7783 0 01-1.1124 2.675 3.7936 3.7936 0 01-2.6824 1.1054h.0008zM9.738 4.8002c-1.9218 0-3.6975 1.0232-4.6584 2.6841a5.359 5.359 0 000 5.3683c.9609 1.661 2.7366 2.6841 4.6584 2.6841a5.3891 5.3891 0 003.8073-1.5725 5.3675 5.3675 0 001.578-3.7987 5.3574 5.3574 0 00-1.5771-3.797A5.379 5.379 0 009.7387 4.801l-.0008-.0008z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    })
  });
};

// src/components/QuickSwitcher/NoResults.tsx
import {
jsxs as jsxs103
} from "react/jsx-runtime";
var container44 = {
  padding: 80,
  color: LIGHT_TEXT,
  textAlign: "center",
  fontSize: 14
};
var MODE_TO_STRING = {
  commands: "commands",
  compositions: "compositions",
  docs: "documentation"
};
var QuickSwitcherNoResults = ({ query, mode }) => {
  return jsxs103("div", {
    style: container44,
    children: [
      "No ",
      MODE_TO_STRING[mode],
      " matching ",
      '"',
      query,
      '"'
    ]
  });
};

// src/components/QuickSwitcher/QuickSwitcherResult.tsx
import {useEffect as useEffect65, useMemo as useMemo105, useRef as useRef34, useState as useState63} from "react";
import {
jsx as jsx202,
jsxs as jsxs104,
Fragment as Fragment32
} from "react/jsx-runtime";
var container45 = {
  paddingLeft: 16,
  paddingRight: 16,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  cursor: "pointer"
};
var label8 = {
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
};
var searchLabel = {
  ...label8,
  lineHeight: 1.25
};
var iconStyle6 = {
  width: 14,
  height: 14
};
var labelContainer = {
  overflow: "hidden",
  flex: 1,
  paddingTop: 5,
  paddingBottom: 5
};
var QuickSwitcherResult = ({ result, selected }) => {
  const [hovered, setIsHovered] = useState63(false);
  const ref = useRef34(null);
  const keybindings2 = useKeybinding();
  useEffect65(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    return () => {
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
    };
  }, []);
  useEffect65(() => {
    if (!selected) {
      return;
    }
    const binding = keybindings2.registerKeybinding({
      key: "Enter",
      callback: result.onSelected,
      commandCtrlKey: false,
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      binding.unregister();
    };
  }, [keybindings2, result.onSelected, selected]);
  useEffect65(() => {
    if (selected) {
      ref.current?.scrollIntoView({
        block: "nearest",
        inline: "center"
      });
    }
  }, [selected]);
  const style11 = useMemo105(() => {
    return {
      ...container45,
      backgroundColor: getBackgroundFromHoverState({
        hovered,
        selected
      })
    };
  }, [hovered, selected]);
  const labelStyle5 = useMemo105(() => {
    return {
      ...result.type === "search-result" ? searchLabel : label8,
      color: result.type === "search-result" ? LIGHT_TEXT : selected || hovered ? "white" : LIGHT_TEXT,
      fontSize: 15
    };
  }, [hovered, result.type, selected]);
  return jsxs104("div", {
    ref,
    style: style11,
    onClick: result.onSelected,
    children: [
      result.type === "composition" ? result.compositionType === "still" ? jsx202(StillIcon, {
        color: selected ? "white" : LIGHT_TEXT,
        style: iconStyle6
      }) : jsx202(FilmIcon, {
        color: selected ? "white" : LIGHT_TEXT,
        style: iconStyle6
      }) : null,
      jsx202(Spacing, {
        x: 1
      }),
      jsx202("div", {
        style: labelContainer,
        children: result.type === "search-result" ? jsxs104(Fragment32, {
          children: [
            jsx202("div", {
              dangerouslySetInnerHTML: {
                __html: result.titleLine
              },
              style: labelStyle5
            }),
            jsx202("div", {
              dangerouslySetInnerHTML: {
                __html: result.subtitleLine
              },
              style: labelStyle5
            })
          ]
        }) : jsx202("div", {
          style: labelStyle5,
          children: result.title
        })
      })
    ]
  }, result.id);
};

// src/components/QuickSwitcher/algolia-search.ts
import {NoReactInternals as NoReactInternals14} from "remotion/no-react";
var ALGOLIA_API_KEY = "3e42dbd4f895fe93ff5cf40d860c4a85";
var ALGOLIA_APPLICATION_ID = "PLSDUOL1CA";
var AGOLIA_SEARCH_URL = "https://plsduol1ca-dsn.algolia.net/1/indexes/*/queries";
var algoliaSearch = async (query) => {
  const url = new URL(AGOLIA_SEARCH_URL);
  url.searchParams.set("x-algolia-agen", encodeURIComponent("Remotion Studio DocSearch"));
  url.searchParams.set("x-algolia-api-key", ALGOLIA_API_KEY);
  url.searchParams.set("x-algolia-application-id", ALGOLIA_APPLICATION_ID);
  const { results } = await fetch(url.toString(), {
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    body: JSON.stringify({
      requests: [
        {
          query,
          indexName: "remotion",
          params: 'attributesToRetrieve=["hierarchy.lvl0","hierarchy.lvl1","hierarchy.lvl2","hierarchy.lvl3","hierarchy.lvl4","hierarchy.lvl5","hierarchy.lvl6","content","type","url"]&attributesToSnippet=["hierarchy.lvl1:10","hierarchy.lvl2:10","hierarchy.lvl3:10","hierarchy.lvl4:10","hierarchy.lvl5:10","hierarchy.lvl6:10","content:10"]&hitsPerPage=20'
        }
      ]
    }),
    method: "POST"
  }).then((res) => res.json());
  const { hits } = results[0];
  return hits.map((hit) => {
    const entries = Object.values(hit._highlightResult.hierarchy);
    const result = entries.find((value) => value.matchLevel === "full") ?? entries.find((value) => value.matchLevel === "partial");
    const { subtitle: subtitle3, title: title5 } = splitMatchIntoTitleAndSubtitle(hit);
    if (!result) {
      return null;
    }
    return {
      type: "search-result",
      id: hit.objectID,
      title: "Should not display",
      titleLine: title5,
      subtitleLine: subtitle3,
      onSelected: () => {
        window.open(hit.url);
      }
    };
  }).filter(NoReactInternals14.truthy);
};
var splitMatchIntoTitleAndSubtitle = (match) => {
  const main = match.type === "content" ? match._highlightResult.content : match._highlightResult.hierarchy[match.type];
  const title5 = main.value;
  const subtitle3 = Object.entries(match._highlightResult.hierarchy).filter(([level]) => level !== match.type).map((value) => value[1].value).join(" \u2022 ");
  return { title: title5, subtitle: subtitle3 };
};

// src/components/QuickSwitcher/fuzzy-search.ts
function fuzzySearch(query, dataset) {
  const q = query ? query.trim().toLowerCase() : "";
  const matchingIndices = [];
  if (q.length === 0) {
    for (let i = 0;i < dataset.length; i++) {
      matchingIndices.push(i);
    }
    return dataset.filter((_, i) => matchingIndices.includes(i));
  }
  dataset.forEach((d, index) => {
    const s = d.title.trim().toLowerCase();
    let i = 0;
    let n = -1;
    let l;
    for (;l = q[i++]; )
      if (!~(n = s.indexOf(l, n + 1)))
        return;
    matchingIndices.push(index);
  });
  return dataset.filter((_, i) => matchingIndices.includes(i));
}

// src/components/QuickSwitcher/QuickSwitcherContent.tsx
var waitForElm = function(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      resolve(document.querySelector(selector));
      return;
    }
    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
};
import {
jsx as jsx203,
jsxs as jsxs105,
Fragment as Fragment33
} from "react/jsx-runtime";
var input2 = {
  width: "100%"
};
var modeSelector = {
  paddingLeft: 16,
  paddingRight: 16,
  display: "flex",
  flexDirection: "row",
  paddingTop: 8,
  paddingBottom: 5
};
var modeItem = {
  appearance: "none",
  border: "none",
  fontFamily: "inherit",
  padding: 0,
  fontSize: 13,
  cursor: "pointer"
};
var modeInactive = {
  ...modeItem,
  color: LIGHT_TEXT
};
var modeActive = {
  ...modeItem,
  color: "white",
  fontWeight: "bold"
};
var content5 = {
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 4,
  paddingBottom: 10,
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var loopIndex = (index, length) => {
  if (index < 0) {
    index += length;
  }
  return index % length;
};
var stripQuery = (query) => {
  if (query.startsWith(">") || query.startsWith("?")) {
    return query.substring(1).trim();
  }
  return query.trim();
};
var mapQueryToMode = (query) => {
  return query.startsWith(">") ? "commands" : query.startsWith("?") ? "docs" : "compositions";
};
var mapModeToQuery = (mode) => {
  if (mode === "commands") {
    return "> ";
  }
  if (mode === "compositions") {
    return "";
  }
  if (mode === "docs") {
    return "? ";
  }
  throw new Error("no mode" + mode);
};
var QuickSwitcherContent = ({ initialMode, invocationTimestamp, readOnlyStudio }) => {
  const { compositions } = useContext72(Internals56.CompositionManager);
  const [state, setState] = useState64(() => {
    return {
      query: mapModeToQuery(initialMode),
      selectedIndex: 0
    };
  });
  useEffect66(() => {
    setState({
      query: mapModeToQuery(initialMode),
      selectedIndex: 0
    });
  }, [initialMode, invocationTimestamp]);
  const inputRef = useRef35(null);
  const selectComposition = useSelectComposition();
  const closeMenu = useCallback97(() => {
    return;
  }, []);
  const actions10 = useMenuStructure(closeMenu, readOnlyStudio);
  const [docResults, setDocResults] = useState64({ type: "initial" });
  const { setSelectedModal } = useContext72(ModalsContext);
  const keybindings2 = useKeybinding();
  const mode = mapQueryToMode(state.query);
  const actualQuery = useMemo106(() => {
    return stripQuery(state.query);
  }, [state.query]);
  const menuActions = useMemo106(() => {
    if (mode !== "commands") {
      return [];
    }
    return makeSearchResults(actions10, setSelectedModal);
  }, [actions10, mode, setSelectedModal]);
  const resultsArray = useMemo106(() => {
    if (mode === "commands") {
      return fuzzySearch(actualQuery, menuActions);
    }
    if (mode === "docs" && docResults.type === "results") {
      return docResults.results;
    }
    return fuzzySearch(actualQuery, compositions.map((c) => {
      return {
        id: "composition-" + c.id,
        title: c.id,
        type: "composition",
        onSelected: () => {
          selectComposition(c, true);
          setSelectedModal(null);
          const selector = `.__remotion-composition[data-compname="${c.id}"]`;
          compositionSelectorRef.current?.expandComposition(c.id);
          waitForElm(selector).then(() => {
            document.querySelector(selector)?.scrollIntoView({ block: "center" });
          });
        },
        compositionType: isCompositionStill(c) ? "still" : "composition"
      };
    }));
  }, [
    mode,
    actualQuery,
    compositions,
    menuActions,
    docResults,
    selectComposition,
    setSelectedModal
  ]);
  const onArrowDown = useCallback97(() => {
    setState((s) => {
      return {
        ...s,
        selectedIndex: s.selectedIndex + 1
      };
    });
  }, []);
  const onArrowUp = useCallback97(() => {
    setState((s) => {
      return {
        ...s,
        selectedIndex: s.selectedIndex - 1
      };
    });
  }, []);
  useEffect66(() => {
    const binding = keybindings2.registerKeybinding({
      key: "ArrowUp",
      callback: onArrowUp,
      commandCtrlKey: false,
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      binding.unregister();
    };
  }, [keybindings2, onArrowDown, onArrowUp]);
  useEffect66(() => {
    if (mode !== "docs") {
      return;
    }
    if (actualQuery.trim() === "") {
      setDocResults({ type: "initial" });
      return;
    }
    let cancelled = false;
    setDocResults({ type: "loading" });
    algoliaSearch(actualQuery).then((agoliaResults) => {
      if (cancelled) {
        return;
      }
      setDocResults({ type: "results", results: agoliaResults });
    }).catch((err) => {
      if (cancelled) {
        return;
      }
      setDocResults({ type: "error", error: err });
    });
    return () => {
      cancelled = true;
    };
  }, [actualQuery, mode]);
  useEffect66(() => {
    const binding = keybindings2.registerKeybinding({
      key: "ArrowDown",
      callback: onArrowDown,
      commandCtrlKey: false,
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      binding.unregister();
    };
  }, [keybindings2, onArrowDown]);
  const onTextChange = useCallback97((e) => {
    setState({ query: e.target.value, selectedIndex: 0 });
  }, []);
  const selectedIndexRounded = loopIndex(state.selectedIndex, resultsArray.length);
  const onActionsSelected = useCallback97(() => {
    setState((s) => ({
      query: `> ${stripQuery(s.query)}`,
      selectedIndex: 0
    }));
    inputRef.current?.focus();
  }, []);
  const onCompositionsSelected = useCallback97(() => {
    setState((s) => ({
      query: stripQuery(s.query),
      selectedIndex: 0
    }));
    inputRef.current?.focus();
  }, []);
  const onDocSearchSelected = useCallback97(() => {
    setState((s) => ({
      query: `? ${stripQuery(s.query)}`,
      selectedIndex: 0
    }));
    setDocResults({ type: "initial" });
    inputRef.current?.focus();
  }, []);
  const showKeyboardShortcuts = mode === "docs" && actualQuery.trim() === "";
  const showSearchLoadingState = mode === "docs" && docResults.type === "loading";
  const container46 = useMemo106(() => {
    return {
      width: showKeyboardShortcuts ? 800 : 500
    };
  }, [showKeyboardShortcuts]);
  const results = useMemo106(() => {
    if (showKeyboardShortcuts) {
      return {
        maxHeight: 600,
        overflowY: "auto"
      };
    }
    return {
      overflowY: "auto",
      height: 300
    };
  }, [showKeyboardShortcuts]);
  return jsxs105("div", {
    style: container46,
    children: [
      jsxs105("div", {
        style: modeSelector,
        children: [
          jsx203("button", {
            onClick: onCompositionsSelected,
            style: mode === "compositions" ? modeActive : modeInactive,
            type: "button",
            children: "Compositions"
          }),
          jsx203(Spacing, {
            x: 1
          }),
          jsx203("button", {
            onClick: onActionsSelected,
            style: mode === "commands" ? modeActive : modeInactive,
            type: "button",
            children: "Actions"
          }),
          jsx203(Spacing, {
            x: 1
          }),
          jsx203("button", {
            onClick: onDocSearchSelected,
            style: mode === "docs" ? modeActive : modeInactive,
            type: "button",
            children: "Documentation"
          })
        ]
      }),
      jsxs105("div", {
        style: content5,
        children: [
          jsx203(RemotionInput, {
            ref: inputRef,
            type: "text",
            style: input2,
            autoFocus: true,
            status: "ok",
            value: state.query,
            onChange: onTextChange,
            placeholder: "Search compositions...",
            rightAlign: false
          }),
          showKeyboardShortcuts ? jsxs105(Fragment33, {
            children: [
              jsx203(Spacing, {
                x: 2
              }),
              " ",
              jsx203(AlgoliaCredit, {})
            ]
          }) : null
        ]
      }),
      jsx203("div", {
        style: results,
        className: VERTICAL_SCROLLBAR_CLASSNAME,
        children: showKeyboardShortcuts ? jsx203(KeyboardShortcutsExplainer, {}) : showSearchLoadingState ? null : resultsArray.length === 0 ? jsx203(QuickSwitcherNoResults, {
          mode,
          query: actualQuery
        }) : resultsArray.map((result, i) => {
          return jsx203(QuickSwitcherResult, {
            selected: selectedIndexRounded === i,
            result
          }, result.id);
        })
      })
    ]
  });
};

// src/components/QuickSwitcher/QuickSwitcher.tsx
import {
jsx as jsx204
} from "react/jsx-runtime";
var QuickSwitcher = ({ initialMode, invocationTimestamp, readOnlyStudio }) => {
  return jsx204(DismissableModal, {
    children: jsx204(QuickSwitcherContent, {
      readOnlyStudio,
      invocationTimestamp,
      initialMode
    })
  });
};
var QuickSwitcher_default = QuickSwitcher;

// src/components/RenderModal/RenderModal.tsx
import {BrowserSafeApis as BrowserSafeApis10} from "@remotion/renderer/client.js";
import {getDefaultOutLocation} from "@remotion/studio-shared";
import {
useCallback as useCallback115,
useContext as useContext74,
useEffect as useEffect69,
useMemo as useMemo115,
useReducer as useReducer2,
useRef as useRef37,
useState as useState70
} from "react";

// src/helpers/convert-env-variables.ts
var envVariablesObjectToArray = (envVariables) => {
  return Object.entries(envVariables).map(([key5, one]) => [
    key5.trim().toUpperCase(),
    one.trim()
  ]);
};
var envVariablesArrayToObject = (envVariables) => {
  return envVariables.map(([key5, val]) => [key5.trim(), val.trim()]).filter(([key5, val]) => key5 && val).reduce((acc, [key5, value]) => {
    acc[key5.toUpperCase()] = value;
    return acc;
  }, {});
};

// src/helpers/render-modal-sections.ts
import {useMemo as useMemo107, useState as useState65} from "react";
var useRenderModalSections = (renderMode, codec) => {
  const [selectedTab, setTab] = useState65("general");
  const shownTabs = useMemo107(() => {
    if (renderMode === "audio") {
      return ["general", "data", "audio", "advanced"];
    }
    if (renderMode === "still") {
      return ["general", "data", "picture", "advanced"];
    }
    if (renderMode === "sequence") {
      return ["general", "data", "picture", "advanced"];
    }
    if (renderMode === "video") {
      if (codec === "gif") {
        return ["general", "data", "picture", "gif", "advanced"];
      }
      return ["general", "data", "picture", "audio", "advanced"];
    }
    throw new TypeError("Unknown render mode");
  }, [codec, renderMode]);
  const tab = useMemo107(() => {
    if (!shownTabs.includes(selectedTab)) {
      return shownTabs[0];
    }
    return selectedTab;
  }, [selectedTab, shownTabs]);
  return useMemo107(() => {
    return { tab, setTab, shownTabs };
  }, [tab, shownTabs]);
};

// src/icons/audio.tsx
import {
jsx as jsx205
} from "react/jsx-runtime";
var AudioIcon = (props) => jsx205("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props,
  children: jsx205("path", {
    fill: "currentcolor",
    d: "M243 32.32C105.5 39.15 0 157.8 0 295.5v120.4C0 451.3 28.63 480 64 480h32c17.62 0 32-14.38 32-32V288c0-17.62-14.38-32-32-32H64c-10.79 0-20.8 2.9-29.72 7.7 14.2-106.8 100.5-193.9 210.4-199.4 120.5-5.965 221.7 83.92 234 199.9-9.08-5.1-19.48-8.2-30.68-8.2h-32c-17.62 0-32 14.38-32 32v160c0 17.62 14.38 32 32 32h32c35.38 0 64-28.75 64-64.13V287.9c0-145.4-122-262.88-269-255.58zM64 288h32v160H64c-17.62 0-32-14.5-32-32.13v-95.75C32 302.5 46.38 288 64 288zm416 127.9c0 17.6-14.4 32.1-32 32.1h-32V288h32c17.62 0 32 14.5 32 32.13v95.77z"
  })
});

// src/icons/data.tsx
import {
jsx as jsx206
} from "react/jsx-runtime";
var DataIcon = (props) => {
  return jsx206("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ...props,
    children: jsx206("path", {
      fill: "currentcolor",
      d: "M224 512C100.3 512 0 476.2 0 432V80C0 35.82 100.3 0 224 0C347.7 0 448 35.82 448 80V432C448 476.2 347.7 512 224 512zM416 80.45C415.7 79.69 414.4 77.27 409.8 73.31C402.4 67.11 389.9 60.09 371.6 53.57C335.4 40.62 283.2 32 224 32C164.8 32 112.6 40.62 76.37 53.57C58.1 60.09 45.59 67.11 38.25 73.31C33.55 77.27 32.29 79.69 32 80.45V182.1C46.47 192.7 69.9 202.8 100.9 210.4C135.5 218.9 177.1 224 224 224C270 224 312.5 218.9 347.1 210.4C378.1 202.8 401.5 192.7 416 182.1V80.45zM416 219.5C398.8 228.4 377.9 235.8 354.8 241.5C317.3 250.7 272.2 256 224 256C175.8 256 130.7 250.7 93.22 241.5C70.11 235.8 49.18 228.4 32 219.5V310.1C46.47 320.7 69.9 330.8 100.9 338.4C135.5 346.9 177.1 352 224 352C270 352 312.5 346.9 347.1 338.4C378.1 330.8 401.5 320.7 416 310.1V219.5zM38.25 438.7C45.59 444.9 58.1 451.9 76.37 458.4C112.6 471.4 164.8 480 224 480C283.2 480 335.4 471.4 371.6 458.4C389.9 451.9 402.4 444.9 409.8 438.7C414.4 434.7 415.7 432.3 416 431.6V347.5C398.8 356.4 377.9 363.8 354.8 369.5C317.3 378.7 272.2 384 224 384C175.8 384 130.7 378.7 93.22 369.5C70.11 363.8 49.18 356.4 32 347.5V431.6C32.29 432.3 33.55 434.7 38.25 438.7zM416 431.4C416.1 431.3 416.1 431.3 416.1 431.3L416 431.4zM31.96 431.4C31.94 431.3 31.93 431.3 31.92 431.3L31.96 431.4zM31.96 80.56C31.93 80.65 31.92 80.7 31.92 80.7L31.96 80.56zM416.1 80.7C416.1 80.7 416.1 80.65 416 80.56z"
    })
  });
};

// src/icons/frame.tsx
import {
jsx as jsx207
} from "react/jsx-runtime";
var PicIcon = (props) => jsx207("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props,
  children: jsx207("path", {
    fill: "currentcolor",
    d: "M324.9 157.8c-11.38-17.38-39.89-17.31-51.23-.063L200.5 268.5l-16.4-22.6c-11.4-16.8-38.2-16-49.7 0l-64.52 89.16c-6.797 9.406-7.75 21.72-2.547 32C72.53 377.5 83.05 384 94.75 384h322.5c11.41 0 21.8-6.281 27.14-16.38a30.922 30.922 0 0 0-1.516-31.56L324.9 157.8zM95.8 352l62.39-87.38 29.91 41.34c3.1 4.24 8.3 7.24 13.3 6.64 5.25-.125 10.12-2.781 13.02-7.188l83.83-129.9L415 352H95.8zM447.1 32h-384C28.65 32-.01 60.65-.01 96v320c0 35.35 28.65 64 63.1 64h384c35.35 0 64-28.65 64-64V96c.01-35.35-27.79-64-63.99-64zM480 416c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h384c17.64 0 32 14.36 32 32v320zM144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm0-64c8.822 0 15.1 7.178 15.1 16s-6.3 16-15.1 16-16-7.2-16-16 7.2-16 16-16z"
  })
});

// src/icons/gear.tsx
import {
jsx as jsx208
} from "react/jsx-runtime";
var GearIcon = (props) => jsx208("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props,
  children: jsx208("path", {
    fill: "currentcolor",
    d: "M168 255.1c0-47.7 39.4-88 88-88s88 40.3 88 88c0 49.5-39.4 88.9-88 88.9s-88-39.4-88-88.9zm88-56c-30.9 0-56 26-56 56 0 31.8 25.1 56 56 56s56-24.2 56-56c0-30-25.1-56-56-56zM65.67 230.6l-40.33-36.8c-11.12-10.1-13.68-26.6-6.16-39.6l30.24-52.4c7.52-13.02 23.09-19.05 37.42-14.48l51.96 16.58c13.4-10.34 28.2-18.94 44-25.47l11.7-53.27C197.7 10.47 210.7 0 225.8 0h60.4c15.1 0 28.1 10.47 31.3 25.16l11.7 53.27c14.9 6.53 30.6 15.13 44 25.47l52-16.58c14.3-4.57 29.9 1.46 37.4 14.48l30.2 52.4c7.5 13 5 29.5-6.1 39.6l-40.4 36.8c1.1 8.3 1.7 16.8 1.7 24.5 0 9.5-.6 18-1.7 26.3l40.4 36.8c11.1 10.1 13.6 26.6 6.1 39.6l-30.2 52.4c-7.5 13-23.1 19-37.4 14.5l-52-16.6c-13.4 10.3-29.1 18.9-44 25.5l-11.7 53.2c-3.2 14.7-16.2 25.2-31.3 25.2h-60.4c-15.1 0-28.1-10.5-31.3-25.2l-11.7-53.2c-15.8-6.6-30.6-15.2-44-25.5l-51.96 16.6c-14.33 4.5-29.9-1.5-37.42-14.5l-30.24-52.4c-7.52-13-4.96-29.5 6.16-39.6l40.33-36.8c-1.1-8.3-1.67-16.8-1.67-26.3 0-7.7.57-16.2 1.67-24.5zm92.73-101.4-13.3 10.3-67.97-21.7-30.24 52.4 52.69 48-2.19 16.6c-.92 6.9-1.39 14-1.39 20.3 0 8.1.47 15.2 1.39 22.1l2.19 16.6-52.69 48 30.24 52.4 67.97-21.7 13.3 10.3c11.1 8.6 23.5 15.8 36.6 20.3l15.5 7.3 15.3 69.6h60.4l15.3-69.6 14.6-7.3c14-4.5 26.4-11.7 37.5-20.3l13.3-10.3 68 21.7 30.2-52.4-52.7-48 2.2-16.6c.9-6.9 1.4-14 1.4-21.2 0-7.2-.5-14.3-1.4-21.2l-2.2-16.6 52.7-48-30.2-52.4-68 21.7-13.3-10.3c-11.1-8.6-23.5-15.8-37.5-21.2l-14.6-6.4L286.2 32h-60.4l-15.3 69.6L195 108c-13.1 5.4-25.5 12.6-36.6 21.2z"
  })
});

// src/icons/gif.tsx
import {
jsx as jsx209
} from "react/jsx-runtime";
var GifIcon = (props) => jsx209("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512",
  ...props,
  children: jsx209("path", {
    fill: "currentcolor",
    d: "M512 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96c0-35.35-28.7-64-64-64zm32 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h448c17.64 0 32 14.36 32 32v320zm-80-256h-96c-8.8 0-16 7.2-16 16v160c0 8.844 7.156 16 16 16s16-7.156 16-16v-64h56c8.844 0 16-7.156 16-16s-7.156-16-16-16h-56v-48h80c8.8 0 16-7.2 16-16s-7.2-16-16-16zm-160 0c-8.8 0-16 7.2-16 16v160c0 8.844 7.156 16 16 16s16-7.156 16-16V176c0-8.8-7.2-16-16-16zm-64 80h-64c-8.8 0-16 7.2-16 16s7.156 16 16 16h48v33.45c-24.83 19.91-69.13 18.16-91.48-4.203-24.95-24.95-24.95-65.55 0-90.5 25.03-25 64.19-25 89.22 0 6.25 6.25 16.38 6.25 22.62 0s6.25-16.38 0-22.62c-37.69-37.72-96.78-37.72-134.5 0-37.42 37.42-37.42 98.33 0 135.8C127.8 341.8 153.5 352 180.6 352c27.06 0 52.84-10.25 70.7-28.12 3-2.98 4.7-7.08 4.7-11.28V256c0-8.8-7.2-16-16-16z"
  })
});

// src/components/Tabs/vertical.tsx
import {useCallback as useCallback98, useMemo as useMemo108, useState as useState66} from "react";
import {
jsx as jsx210
} from "react/jsx-runtime";
var selectorButton2 = {
  border: "none",
  flex: 1,
  padding: 8,
  paddingLeft: 16,
  display: "flex",
  flexDirection: "row",
  fontSize: 14,
  color: "inherit",
  alignItems: "center"
};
var VerticalTab = ({ children, onClick, style: style11, selected }) => {
  const [hovered, setHovered] = useState66(false);
  const { tabIndex } = useZIndex();
  const onPointerEnter = useCallback98(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback98(() => {
    setHovered(false);
  }, []);
  const definiteStyle = useMemo108(() => {
    return {
      ...selectorButton2,
      backgroundColor: selected ? SELECTED_BACKGROUND : hovered ? CLEAR_HOVER : "transparent",
      color: selected ? "white" : LIGHT_TEXT,
      boxShadow: selected ? "none" : undefined,
      ...style11
    };
  }, [hovered, selected, style11]);
  return jsx210("button", {
    style: definiteStyle,
    type: "button",
    onClick,
    tabIndex,
    onPointerLeave,
    onPointerEnter,
    children
  });
};

// src/components/RenderModal/CrfSetting.tsx
import {BrowserSafeApis as BrowserSafeApis2} from "@remotion/renderer/client.js";
import {useState as useState68} from "react";

// src/components/RenderModal/NumberSetting.tsx
import {useCallback as useCallback100} from "react";

// src/components/RenderModal/OptionExplainerBubble.tsx
import {BrowserSafeApis} from "@remotion/renderer/client.js";

// src/components/RenderModal/CliCopyButton.tsx
import {useCallback as useCallback99, useEffect as useEffect67, useMemo as useMemo109, useState as useState67} from "react";
import {
jsx as jsx211
} from "react/jsx-runtime";
var svgStyle3 = {
  width: 16,
  height: 16,
  verticalAlign: "sub"
};
var copiedStyle = {
  fontSize: "14px",
  minHeight: "30px",
  minWidth: "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
var buttonStyle6 = {
  width: "30px",
  height: "30px",
  border: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
var CliCopyButton = ({
  valueToCopy
}) => {
  const [copied, setCopied] = useState67(false);
  const [hovered, setHovered] = useState67(false);
  const fillColor = useMemo109(() => {
    return hovered ? "white" : LIGHT_TEXT;
  }, [hovered]);
  const clipboardIcon = jsx211(ClipboardIcon, {
    color: fillColor,
    style: svgStyle3
  });
  const checkSvg = jsx211("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    style: svgStyle3,
    children: jsx211("path", {
      fill: fillColor,
      d: "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
    })
  });
  const onPointerEnter = useCallback99(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback99(() => {
    setHovered(false);
  }, []);
  useEffect67(() => {
    if (!copied) {
      return;
    }
    const handleClear = () => {
      setCopied(false);
      setHovered(false);
    };
    const to = setTimeout(() => handleClear(), 2000);
    return () => clearTimeout(to);
  }, [copied]);
  return copied ? jsx211("span", {
    style: copiedStyle,
    children: checkSvg
  }) : jsx211("button", {
    type: "button",
    onPointerEnter,
    onPointerLeave,
    style: buttonStyle6,
    onClick: () => {
      navigator.clipboard.writeText(valueToCopy);
      setCopied(true);
    },
    children: clipboardIcon
  });
};

// src/components/RenderModal/OptionExplainer.tsx
import {
jsx as jsx212,
jsxs as jsxs106
} from "react/jsx-runtime";
var container46 = {
  fontSize: 14,
  paddingTop: 10,
  paddingBottom: 10,
  backgroundColor: INPUT_BACKGROUND
};
var padding3 = {
  paddingLeft: 20,
  paddingRight: 20
};
var title5 = {
  fontSize: 14
};
var description = {
  fontSize: 14,
  maxWidth: 400
};
var link2 = {
  fontSize: 14,
  maxWidth: 200,
  color: "#0b84f3",
  wordWrap: "break-word",
  textDecoration: "none"
};
var infoRow = {
  ...padding3,
  fontSize: 14,
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var infoRowLabel = {
  width: 150,
  fontSize: 14,
  color: "white"
};
var flexSpacer = {
  display: "flex",
  flex: 1
};
var copyWrapper = {
  display: "flex",
  justifyContent: "flex-end"
};
var OptionExplainer = ({ option }) => {
  return jsxs106("div", {
    style: container46,
    className: "__remotion-info-button-container",
    children: [
      jsxs106("div", {
        style: padding3,
        children: [
          jsxs106("div", {
            children: [
              jsx212("strong", {
                style: title5,
                children: option.name
              }),
              jsx212(Spacing, {
                x: 1
              }),
              jsx212("a", {
                style: link2,
                href: option.docLink,
                target: "_blank",
                children: "Docs"
              })
            ]
          }),
          jsx212("div", {
            style: description,
            children: option.description("ssr")
          })
        ]
      }),
      jsx212(Spacing, {
        y: 0.5,
        block: true
      }),
      jsx212(MenuDivider, {}),
      jsx212(Spacing, {
        y: 0.5,
        block: true
      }),
      jsxs106("div", {
        children: [
          jsxs106("div", {
            style: infoRow,
            children: [
              jsx212("div", {
                style: infoRowLabel,
                children: "CLI flag"
              }),
              jsx212("div", {
                style: flexSpacer
              }),
              jsxs106("code", {
                children: [
                  "--",
                  option.cliFlag
                ]
              }),
              jsx212("div", {
                style: copyWrapper,
                children: jsx212(CliCopyButton, {
                  valueToCopy: option.cliFlag
                })
              })
            ]
          }),
          option.ssrName ? jsxs106("div", {
            style: infoRow,
            children: [
              jsx212("div", {
                style: infoRowLabel,
                children: "Node.JS option"
              }),
              jsx212("div", {
                style: flexSpacer
              }),
              jsx212("code", {
                children: option.ssrName
              }),
              jsx212(Spacing, {
                x: 3.75
              })
            ]
          }) : null,
          jsx212("div", {
            style: infoRow
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/OptionExplainerBubble.tsx
import {
jsx as jsx213
} from "react/jsx-runtime";
var OptionExplainerBubble = ({ id }) => {
  const option = BrowserSafeApis.options[id];
  return jsx213(InfoBubble, {
    title: "Learn more about this option",
    children: jsx213(OptionExplainer, {
      option
    })
  });
};

// src/components/RenderModal/NumberSetting.tsx
import {
jsx as jsx214,
jsxs as jsxs107,
Fragment as Fragment34
} from "react/jsx-runtime";
var NumberSetting = ({ name, value, step, hint, onValueChanged, max, min, formatter }) => {
  const onTextChanged = useCallback100((e) => {
    onValueChanged((q) => {
      const newSetting = step < 1 ? parseFloat(e) : parseInt(e, 10);
      if (Number.isNaN(newSetting)) {
        return q;
      }
      return Math.min(max ?? Infinity, Math.max(newSetting, min));
    });
  }, [max, min, onValueChanged, step]);
  const onValueChange = useCallback100((newConcurrency) => {
    onValueChanged(newConcurrency);
  }, [onValueChanged]);
  return jsxs107("div", {
    style: optionRow,
    children: [
      jsxs107("div", {
        style: label5,
        children: [
          name,
          hint ? jsxs107(Fragment34, {
            children: [
              jsx214(Spacing, {
                x: 0.5
              }),
              jsx214(OptionExplainerBubble, {
                id: hint
              })
            ]
          }) : null
        ]
      }),
      jsx214("div", {
        style: rightRow,
        children: jsx214(RightAlignInput, {
          children: jsx214(InputDragger, {
            value,
            name: name.toLowerCase(),
            onTextChange: onTextChanged,
            onValueChange,
            step,
            placeholder: [min, max].map((f) => f !== null && f !== undefined ? f : "").join("-"),
            min,
            max,
            formatter,
            status: "ok",
            rightAlign: true
          })
        })
      })
    ]
  });
};

// src/components/RenderModal/CrfSetting.tsx
import {
jsx as jsx215
} from "react/jsx-runtime";
var getDefaultCrfState = () => {
  return BrowserSafeApis2.validCodecs.map((c) => {
    return [c, BrowserSafeApis2.getDefaultCrfForCodec(c)];
  }).reduce((acc, [codec, crf]) => {
    return {
      ...acc,
      [codec]: crf
    };
  }, {});
};
var useCrfState = (codec) => {
  const [state, setState] = useState68(() => getDefaultCrfState());
  const range = BrowserSafeApis2.getValidCrfRanges(codec);
  const setCrf = (updater) => {
    setState((q) => {
      return {
        ...q,
        [codec]: typeof updater === "number" ? updater : updater(q[codec])
      };
    });
  };
  return {
    crf: state[codec],
    setCrf,
    minCrf: range[0],
    maxCrf: range[1]
  };
};
var CrfSetting = ({ crf, setCrf, min, max, option }) => {
  return jsx215(NumberSetting, {
    min,
    max,
    name: "CRF",
    onValueChanged: setCrf,
    value: crf,
    step: 1,
    hint: option
  });
};

// src/components/RenderModal/RenderModalAdvanced.tsx
import {BrowserSafeApis as BrowserSafeApis3} from "@remotion/renderer/client.js";
import {useCallback as useCallback104, useMemo as useMemo110} from "react";

// src/helpers/presets-labels.ts
var labelx264Preset = (profile) => {
  if (profile === "ultrafast") {
    return "ultrafast";
  }
  if (profile === "superfast") {
    return "superfast";
  }
  if (profile === "veryfast") {
    return "veryfast";
  }
  if (profile === "faster") {
    return "faster";
  }
  if (profile === "fast") {
    return "fast";
  }
  if (profile === "medium") {
    return "medium";
  }
  if (profile === "slow") {
    return "slow";
  }
  if (profile === "slower") {
    return "slower";
  }
  if (profile === "veryslow") {
    return "veryslow";
  }
  if (profile === "placebo") {
    return "placebo";
  }
  throw new TypeError(`Unknown x264 preset: ${profile}`);
};

// src/components/RenderModal/RenderModalEnvironmentVariables.tsx
import {useCallback as useCallback103} from "react";

// src/components/RenderModal/EnvInput.tsx
import React145, {useCallback as useCallback102} from "react";

// src/components/RenderModal/InlineEyeIcon.tsx
import {useCallback as useCallback101} from "react";
import {
jsx as jsx216
} from "react/jsx-runtime";
var clearIcon2 = {
  height: 14,
  color: "currentColor"
};
var InlineEyeButton = ({ onClick, enabled }) => {
  const renderAction = useCallback101((color) => {
    return enabled ? jsx216("svg", {
      style: clearIcon2,
      viewBox: "0 0 640 512",
      children: jsx216("path", {
        fill: color,
        d: "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM605.5 268.3c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-51.2 0-96 14.8-133.9 36.8l27.3 21.5C244.6 74.2 280.2 64 320 64c70.4 0 127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-9.2 22.1-25.9 52-49.5 81.5l25.1 19.8c25.6-32 43.7-64.4 53.9-89zM88.4 154.7c-25.6 32-43.7 64.4-53.9 89c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c51.2 0 96-14.8 133.9-36.8l-27.3-21.5C395.4 437.8 359.8 448 320 448c-70.4 0-127.7-32-170.8-72C106.1 336 77.3 288 64 256c9.2-22.1 25.9-52 49.5-81.5L88.4 154.7zM320 384c16.7 0 32.7-3.2 47.4-9.1l-30.9-24.4c-5.4 .9-10.9 1.4-16.5 1.4c-51 0-92.8-39.8-95.8-90.1l-30.9-24.4c-.9 6-1.3 12.2-1.3 18.5c0 70.7 57.3 128 128 128zM448 256c0-70.7-57.3-128-128-128c-16.7 0-32.7 3.2-47.4 9.1l30.9 24.4c5.4-.9 10.9-1.4 16.5-1.4c51 0 92.8 39.8 95.8 90.1l30.9 24.4c.9-6 1.3-12.2 1.3-18.5z"
      })
    }) : jsx216("svg", {
      style: clearIcon2,
      viewBox: "0 0 576 512",
      children: jsx216("path", {
        fill: color,
        d: "M117.2 136C160.3 96 217.6 64 288 64s127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-13.3 32-42.1 80-85.2 120c-43.1 40-100.4 72-170.8 72s-127.7-32-170.8-72C74.1 336 45.3 288 32 256c13.3-32 42.1-80 85.2-120zM288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
      })
    });
  }, [enabled]);
  return jsx216(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderModal/EnvInput.tsx
import {
jsx as jsx217,
jsxs as jsxs108,
Fragment as Fragment35
} from "react/jsx-runtime";
var input3 = {
  flex: 1,
  width: "100%"
};
var validationStyle = {
  paddingLeft: optionRow.paddingLeft,
  paddingRight: optionRow.paddingRight
};
var EnvInput = ({
  onEnvKeyChange,
  onEnvValChange,
  envKey,
  envVal,
  onDelete,
  index,
  autoFocus,
  isDuplicate
}) => {
  const [showInPlainText, setShowInPlainText] = React145.useState(false);
  const [initialWarningKeyMissing, setKeyWarningEligible] = React145.useState(() => {
    return envKey.trim() === "" && envVal.trim() !== "";
  });
  const [initialWarningValMissing, setValueWarningEligible] = React145.useState(() => {
    return envKey.trim() !== "" && envVal.trim() === "";
  });
  const isKeyMissing = envKey.trim() === "" && initialWarningKeyMissing && envVal.trim() !== "";
  const isValMissing = envVal.trim() === "" && initialWarningValMissing && envKey.trim() !== "";
  const handleDelete = useCallback102(() => {
    onDelete(index);
  }, [index, onDelete]);
  const togglePlainText = useCallback102(() => {
    setShowInPlainText((prev) => !prev);
  }, []);
  const handleKeyChange = useCallback102((e) => {
    onEnvKeyChange(index, e.target.value);
  }, [index, onEnvKeyChange]);
  const handleValueChange = useCallback102((e) => {
    onEnvValChange(index, e.target.value);
  }, [index, onEnvValChange]);
  const makeKeyWarningEligible = useCallback102(() => {
    setKeyWarningEligible(true);
  }, []);
  const makeValueWarningEligible = useCallback102(() => {
    setValueWarningEligible(true);
  }, []);
  const isNodeEnvKey = envKey.trim() === "NODE_ENV";
  return jsxs108(Fragment35, {
    children: [
      jsxs108(Row, {
        align: "center",
        style: optionRow,
        children: [
          jsx217(RemotionInput, {
            status: isNodeEnvKey || isDuplicate || isKeyMissing ? "warning" : "ok",
            type: "text",
            placeholder: "Key",
            style: input3,
            value: envKey,
            onBlur: makeKeyWarningEligible,
            autoFocus,
            onChange: handleKeyChange,
            rightAlign: false
          }),
          jsx217(Spacing, {
            x: 1
          }),
          jsx217(RemotionInput, {
            status: isValMissing ? "warning" : "ok",
            placeholder: "Value",
            type: showInPlainText ? "text" : "password",
            style: input3,
            value: envVal,
            onBlur: makeValueWarningEligible,
            onChange: handleValueChange,
            rightAlign: false
          }),
          jsx217(Spacing, {
            x: 1.5
          }),
          jsx217(InlineEyeButton, {
            enabled: !showInPlainText,
            onClick: togglePlainText
          }),
          jsx217(InlineRemoveButton, {
            onClick: handleDelete
          })
        ]
      }),
      isNodeEnvKey ? jsx217("div", {
        style: validationStyle,
        children: jsx217(ValidationMessage, {
          align: "flex-start",
          type: "warning",
          message: "NODE_ENV will be overwritten by Remotion during the render process."
        })
      }) : null,
      isDuplicate ? jsx217("div", {
        style: validationStyle,
        children: jsx217(ValidationMessage, {
          align: "flex-start",
          type: "warning",
          message: `${envKey.toUpperCase()} is already defined.`
        })
      }) : null,
      isKeyMissing ? jsx217("div", {
        style: validationStyle,
        children: jsx217(ValidationMessage, {
          align: "flex-start",
          type: "warning",
          message: "Key is missing."
        })
      }) : null,
      isValMissing ? jsx217("div", {
        style: validationStyle,
        children: jsx217(ValidationMessage, {
          align: "flex-start",
          type: "warning",
          message: "Value is missing."
        })
      }) : null
    ]
  });
};

// src/components/RenderModal/RenderModalEnvironmentVariables.tsx
import {
jsx as jsx218,
jsxs as jsxs109
} from "react/jsx-runtime";
var title6 = {
  fontSize: 14,
  fontWeight: "bold",
  color: LIGHT_TEXT,
  marginLeft: 16
};
var container47 = {
  marginTop: 20
};
var button4 = {
  marginLeft: 16
};
var RenderModalEnvironmentVariables = ({ envVariables, setEnvVariables }) => {
  const onEnvValChange = useCallback103((index, value) => {
    setEnvVariables((oldEnv) => {
      const newEnv = [...oldEnv];
      newEnv[index][1] = value;
      return newEnv;
    });
  }, [setEnvVariables]);
  const onEnvKeyChange = useCallback103((index, value) => {
    setEnvVariables((oldEnv) => {
      const newEnv = [...oldEnv];
      newEnv[index][0] = value;
      return newEnv;
    });
  }, [setEnvVariables]);
  const onDelete = useCallback103((index) => {
    setEnvVariables((oldEnv) => oldEnv.filter((_, idx) => idx !== index));
  }, [setEnvVariables]);
  const addField = useCallback103(() => {
    setEnvVariables((oldEnv) => [...oldEnv, ["", ""]]);
  }, [setEnvVariables]);
  const usedKeys = [];
  return jsxs109("div", {
    style: container47,
    children: [
      jsx218("strong", {
        style: title6,
        children: "Environment variables"
      }),
      envVariables.map((env, i) => {
        let isDuplicate = false;
        if (usedKeys.includes(env[0].toUpperCase())) {
          isDuplicate = true;
        }
        usedKeys.push(env[0].toUpperCase());
        return jsx218(EnvInput, {
          onEnvKeyChange,
          onEnvValChange,
          envKey: env[0],
          envVal: env[1],
          onDelete,
          index: i,
          isDuplicate,
          autoFocus: i === envVariables.length - 1 && env[0] === ""
        }, i);
      }),
      jsx218(Spacing, {
        y: 1,
        block: true
      }),
      jsx218(Button, {
        style: button4,
        onClick: addField,
        children: "+ Add env variable"
      }),
      jsx218(Spacing, {
        y: 1,
        block: true
      })
    ]
  });
};

// src/components/RenderModal/RenderModalHr.tsx
import {
jsx as jsx219
} from "react/jsx-runtime";
var hrStyle = {
  margin: "0 0 0 0",
  padding: "0 0 0 0",
  border: "none",
  borderTop: "1px solid #000",
  marginRight: 16,
  marginLeft: 16,
  marginTop: 8,
  marginBottom: 8
};
var RenderModalHr = () => {
  return jsx219("div", {
    style: hrStyle
  });
};

// src/components/RenderModal/RenderModalAdvanced.tsx
import {
jsx as jsx220,
jsxs as jsxs110
} from "react/jsx-runtime";
var container48 = {
  flex: 1,
  overflowY: "auto"
};
var RenderModalAdvanced = ({
  renderMode,
  maxConcurrency,
  minConcurrency,
  setConcurrency,
  concurrency,
  setVerboseLogging,
  logLevel,
  delayRenderTimeout,
  setDelayRenderTimeout,
  disallowParallelEncoding,
  setDisallowParallelEncoding,
  setDisableWebSecurity,
  setIgnoreCertificateErrors,
  setHeadless,
  headless,
  ignoreCertificateErrors,
  disableWebSecurity,
  openGlOption,
  setOpenGlOption,
  setEnvVariables,
  envVariables,
  setx264Preset,
  x264Preset,
  codec,
  offthreadVideoCacheSizeInBytes,
  setOffthreadVideoCacheSizeInBytes,
  enableMultiProcessOnLinux,
  setChromiumMultiProcessOnLinux,
  setUserAgent,
  userAgent,
  beep,
  setBeep,
  repro,
  setRepro
}) => {
  const extendedOpenGlOptions = useMemo110(() => {
    return [
      "angle",
      "egl",
      "swangle",
      "swiftshader",
      "vulkan",
      "angle-egl",
      "default"
    ];
  }, []);
  const onVerboseLoggingChanged = useCallback104((e) => {
    setVerboseLogging(e.target.checked ? "verbose" : "info");
  }, [setVerboseLogging]);
  const toggleCustomOffthreadVideoCacheSizeInBytes = useCallback104(() => {
    setOffthreadVideoCacheSizeInBytes((previous) => {
      if (previous === null) {
        return 536870912;
      }
      return null;
    });
  }, [setOffthreadVideoCacheSizeInBytes]);
  const toggleCustomUserAgent = useCallback104(() => {
    setUserAgent((previous) => {
      if (previous === null) {
        return "Mozilla/5.0 (Remotion)";
      }
      return null;
    });
  }, [setUserAgent]);
  const onDisallowParallelEncodingChanged = useCallback104((e) => {
    setDisallowParallelEncoding(e.target.checked);
  }, [setDisallowParallelEncoding]);
  const onDisableWebSecurityChanged = useCallback104((e) => {
    setDisableWebSecurity(e.target.checked);
  }, [setDisableWebSecurity]);
  const onEnableMultiProcessOnLinux = useCallback104((e) => {
    setChromiumMultiProcessOnLinux(e.target.checked);
  }, [setChromiumMultiProcessOnLinux]);
  const onIgnoreCertificatErrors = useCallback104((e) => {
    setIgnoreCertificateErrors(e.target.checked);
  }, [setIgnoreCertificateErrors]);
  const onHeadless = useCallback104((e) => {
    setHeadless(e.target.checked);
  }, [setHeadless]);
  const onUserAgentChanged = useCallback104((e) => {
    setUserAgent(e.target.value);
  }, [setUserAgent]);
  const onPlayBeepSound = useCallback104((e) => {
    setBeep(e.target.checked);
  }, [setBeep]);
  const onReproToggle = useCallback104((e) => {
    setRepro(e.target.checked);
  }, [setRepro]);
  const openGlOptions = useMemo110(() => {
    return extendedOpenGlOptions.map((option) => {
      return {
        label: option === "default" ? "Default" : option,
        onClick: () => setOpenGlOption(option),
        key: option,
        leftItem: openGlOption === option ? jsx220(Checkmark, {}) : null,
        id: option,
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: option
      };
    });
  }, [extendedOpenGlOptions, openGlOption, setOpenGlOption]);
  const x264PresetOptions = useMemo110(() => {
    return BrowserSafeApis3.x264PresetOptions.map((option) => {
      return {
        label: labelx264Preset(option),
        onClick: () => setx264Preset(option),
        key: option,
        selected: x264Preset === option,
        type: "item",
        id: option,
        keyHint: null,
        leftItem: null,
        quickSwitcherLabel: null,
        subMenu: null,
        value: option
      };
    });
  }, [setx264Preset, x264Preset]);
  const changeOffthreadVideoCacheSizeInBytes = useCallback104((cb) => {
    setOffthreadVideoCacheSizeInBytes((prev) => {
      if (prev === null) {
        throw new TypeError("Expected previous value");
      }
      if (typeof cb === "function") {
        return cb(prev);
      }
      return cb;
    });
  }, [setOffthreadVideoCacheSizeInBytes]);
  return jsxs110("div", {
    style: container48,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: [
      jsxs110("div", {
        style: optionRow,
        children: [
          jsxs110("div", {
            style: label5,
            children: [
              "Verbose logging ",
              jsx220(Spacing, {
                x: 0.5
              }),
              jsx220(OptionExplainerBubble, {
                id: "logLevelOption"
              })
            ]
          }),
          jsx220("div", {
            style: rightRow,
            children: jsx220(Checkbox, {
              checked: logLevel === "verbose",
              onChange: onVerboseLoggingChanged,
              name: "verbose-logging"
            })
          })
        ]
      }),
      renderMode === "still" ? null : jsx220(NumberSetting, {
        min: minConcurrency,
        max: maxConcurrency,
        step: 1,
        name: "Concurrency",
        formatter: (w) => `${w}x`,
        onValueChanged: setConcurrency,
        value: concurrency
      }),
      renderMode === "video" && codec === "h264" ? jsxs110("div", {
        style: optionRow,
        children: [
          jsxs110("div", {
            style: label5,
            children: [
              "x264 Preset",
              jsx220(Spacing, {
                x: 0.5
              }),
              jsx220(OptionExplainerBubble, {
                id: "x264Option"
              })
            ]
          }),
          jsx220("div", {
            style: rightRow,
            children: jsx220(Combobox, {
              title: x264Preset,
              selectedId: x264Preset,
              values: x264PresetOptions
            })
          })
        ]
      }) : null,
      jsx220(NumberSetting, {
        min: 7000,
        max: 900000,
        name: "delayRender() timeout",
        onValueChanged: setDelayRenderTimeout,
        formatter: (w) => `${w}ms`,
        step: 1000,
        hint: "delayRenderTimeoutInMillisecondsOption",
        value: delayRenderTimeout
      }),
      jsxs110("div", {
        style: optionRow,
        children: [
          jsx220("div", {
            style: label5,
            children: "No parallel encoding"
          }),
          jsx220("div", {
            style: rightRow,
            children: jsx220(Checkbox, {
              checked: disallowParallelEncoding,
              onChange: onDisallowParallelEncodingChanged,
              name: "disallow-parallel-encoding"
            })
          })
        ]
      }),
      renderMode === "audio" ? null : jsxs110("div", {
        style: optionRow,
        children: [
          jsx220("div", {
            style: label5,
            children: "Custom OffthreadVideo cache"
          }),
          jsx220(Spacing, {
            x: 0.5
          }),
          jsx220(OptionExplainerBubble, {
            id: "offthreadVideoCacheSizeInBytesOption"
          }),
          jsx220("div", {
            style: rightRow,
            children: jsx220(Checkbox, {
              checked: offthreadVideoCacheSizeInBytes !== null,
              onChange: toggleCustomOffthreadVideoCacheSizeInBytes,
              name: "custom-audio-bitrate"
            })
          })
        ]
      }),
      renderMode === "audio" || offthreadVideoCacheSizeInBytes === null ? null : jsx220(NumberSetting, {
        min: minConcurrency,
        max: 2097152000,
        step: 1024,
        name: "OffthreadVideo cache size",
        formatter: (w) => `${w} bytes`,
        onValueChanged: changeOffthreadVideoCacheSizeInBytes,
        value: offthreadVideoCacheSizeInBytes
      }),
      jsx220(RenderModalHr, {}),
      jsxs110("div", {
        style: optionRow,
        children: [
          jsx220("div", {
            style: label5,
            children: "Disable web security"
          }),
          jsx220("div", {
            style: rightRow,
            children: jsx220(Checkbox, {
              checked: disableWebSecurity,
              onChange: onDisableWebSecurityChanged,
              name: "disable-web-security"
            })
          })
        ]
      }),
      jsxs110("div", {
        style: optionRow,
        children: [
          jsx220("div", {
            style: label5,
            children: "Ignore certificate errors"
          }),
          jsx220("div", {
            style: rightRow,
            children: jsx220(Checkbox, {
              checked: ignoreCertificateErrors,
              onChange: onIgnoreCertificatErrors,
              name: "ignore-certificate-errors"
            })
          })
        ]
      }),
      jsxs110("div", {
        style: optionRow,
        children: [
          jsxs110("div", {
            style: label5,
            children: [
              "Headless mode",
              jsx220(Spacing, {
                x: 0.5
              }),
              jsx220(OptionExplainerBubble, {
                id: "headlessOption"
              })
            ]
          }),
          jsx220("div", {
            style: rightRow,
            children: jsx220(Checkbox, {
              checked: headless,
              onChange: onHeadless,
              name: "headless"
            })
          })
        ]
      }),
      jsxs110("div", {
        style: optionRow,
        children: [
          jsxs110("div", {
            style: label5,
            children: [
              "OpenGL render backend ",
              jsx220(Spacing, {
                x: 0.5
              }),
              jsx220(OptionExplainerBubble, {
                id: "glOption"
              })
            ]
          }),
          jsx220("div", {
            style: rightRow,
            children: jsx220(Combobox, {
              values: openGlOptions,
              selectedId: openGlOption,
              title: "OpenGl option"
            })
          })
        ]
      }),
      jsxs110("div", {
        style: optionRow,
        children: [
          jsx220("div", {
            style: label5,
            children: "Multi-process Chrome on Linux"
          }),
          jsx220(Spacing, {
            x: 0.5
          }),
          jsx220(OptionExplainerBubble, {
            id: "enableMultiprocessOnLinuxOption"
          }),
          jsx220("div", {
            style: rightRow,
            children: jsx220(Checkbox, {
              checked: enableMultiProcessOnLinux,
              onChange: onEnableMultiProcessOnLinux,
              name: "enable-multi-process-on-linux"
            })
          })
        ]
      }),
      jsxs110("div", {
        style: optionRow,
        children: [
          jsx220("div", {
            style: label5,
            children: "Custom User Agent"
          }),
          jsx220("div", {
            style: rightRow,
            children: jsx220(Checkbox, {
              checked: userAgent !== null,
              onChange: toggleCustomUserAgent,
              name: "custom-user-agent"
            })
          })
        ]
      }),
      userAgent === null ? null : jsxs110("div", {
        style: optionRow,
        children: [
          jsx220("div", {
            style: label5,
            children: "User Agent"
          }),
          jsx220("div", {
            style: rightRow,
            children: jsx220("div", {
              children: jsx220(RemotionInput, {
                style: input,
                value: userAgent,
                onChange: onUserAgentChanged,
                status: "ok",
                rightAlign: true
              })
            })
          })
        ]
      }),
      jsxs110("div", {
        style: optionRow,
        children: [
          jsxs110("div", {
            style: label5,
            children: [
              "Create a reproduction ",
              jsx220(OptionExplainerBubble, {
                id: "reproOption"
              })
            ]
          }),
          jsx220("div", {
            style: rightRow,
            children: jsx220(Checkbox, {
              checked: repro,
              onChange: onReproToggle,
              name: "repro"
            })
          })
        ]
      }),
      jsxs110("div", {
        style: optionRow,
        children: [
          jsxs110("div", {
            style: label5,
            children: [
              "Beep when finished ",
              jsx220(OptionExplainerBubble, {
                id: "beepOnFinishOption"
              })
            ]
          }),
          jsx220("div", {
            style: rightRow,
            children: jsx220(Checkbox, {
              checked: beep,
              onChange: onPlayBeepSound,
              name: "beep-when-finished"
            })
          })
        ]
      }),
      jsx220(RenderModalHr, {}),
      jsx220(RenderModalEnvironmentVariables, {
        envVariables,
        setEnvVariables
      })
    ]
  });
};

// src/components/RenderModal/RenderModalAudio.tsx
import {BrowserSafeApis as BrowserSafeApis5} from "@remotion/renderer/client.js";
import {useCallback as useCallback108} from "react";

// src/components/RenderModal/EnforceAudioTrackSetting.tsx
import {useCallback as useCallback105} from "react";
import {
jsx as jsx221,
jsxs as jsxs111
} from "react/jsx-runtime";
var EnforceAudioTrackSetting = ({ enforceAudioTrack, muted, setEnforceAudioTrack }) => {
  const onEnforceAudioTrackChanged = useCallback105((e) => {
    setEnforceAudioTrack(e.target.checked);
  }, [setEnforceAudioTrack]);
  return jsxs111("div", {
    style: optionRow,
    children: [
      jsxs111("div", {
        style: label5,
        children: [
          "Enforce Audio Track",
          jsx221(Spacing, {
            x: 0.5
          }),
          jsx221(OptionExplainerBubble, {
            id: "enforceAudioOption"
          })
        ]
      }),
      jsx221("div", {
        style: rightRow,
        children: jsx221(Checkbox, {
          disabled: muted && !enforceAudioTrack,
          checked: enforceAudioTrack,
          onChange: onEnforceAudioTrackChanged,
          name: "enforce-audio-track"
        })
      })
    ]
  });
};

// src/components/RenderModal/MutedSetting.tsx
import {useCallback as useCallback106} from "react";
import {
jsx as jsx222,
jsxs as jsxs112
} from "react/jsx-runtime";
var MutedSetting = ({ muted, setMuted, enforceAudioTrack }) => {
  const onMutedChanged = useCallback106((e) => {
    setMuted(e.target.checked);
  }, [setMuted]);
  return jsxs112("div", {
    style: optionRow,
    children: [
      jsxs112("div", {
        style: label5,
        children: [
          "Muted",
          jsx222(Spacing, {
            x: 0.5
          }),
          jsx222(OptionExplainerBubble, {
            id: "mutedOption"
          })
        ]
      }),
      jsx222(Spacing, {
        x: 0.25
      }),
      jsx222("div", {
        style: rightRow,
        children: jsx222(Checkbox, {
          checked: muted,
          disabled: enforceAudioTrack && !muted,
          onChange: onMutedChanged,
          name: "muted"
        })
      })
    ]
  });
};

// src/components/RenderModal/SeparateAudioOption.tsx
import {BrowserSafeApis as BrowserSafeApis4} from "@remotion/renderer/client.js";
import {useCallback as useCallback107, useMemo as useMemo111} from "react";

// src/helpers/use-file-existence.ts
import {useContext as useContext73, useEffect as useEffect68, useRef as useRef36, useState as useState69} from "react";
var useFileExistence = (outName) => {
  const [exists, setExists] = useState69(false);
  const { previewServerState: state, subscribeToEvent } = useContext73(StudioServerConnectionCtx);
  const clientId = state.type === "connected" ? state.clientId : undefined;
  const currentOutName = useRef36("");
  currentOutName.current = outName;
  useEffect68(() => {
    if (!clientId) {
      return;
    }
    subscribeToFileExistenceWatcher({
      file: outName,
      clientId
    }).then((_exists) => {
      if (currentOutName.current === outName) {
        setExists(_exists);
      }
    });
    return () => {
      unsubscribeFromFileExistenceWatcher({ file: outName, clientId });
    };
  }, [clientId, outName]);
  useEffect68(() => {
    const listener = (event) => {
      if (event.type !== "watched-file-deleted") {
        return;
      }
      if (event.file !== currentOutName.current) {
        return;
      }
      if (currentOutName.current === outName) {
        setExists(false);
      }
    };
    const unsub = subscribeToEvent("watched-file-deleted", listener);
    return () => {
      unsub();
    };
  }, [outName, subscribeToEvent]);
  useEffect68(() => {
    const listener = (event) => {
      if (event.type !== "watched-file-undeleted") {
        return;
      }
      if (event.file !== outName) {
        return;
      }
      if (currentOutName.current === outName) {
        setExists(true);
      }
    };
    const unsub = subscribeToEvent("watched-file-undeleted", listener);
    return () => {
      unsub();
    };
  }, [outName, subscribeToEvent]);
  return exists;
};

// src/components/RenderModal/RenderModalOutputName.tsx
import {
jsx as jsx223,
jsxs as jsxs113,
Fragment as Fragment36
} from "react/jsx-runtime";
var RenderModalOutputName = ({
  existence,
  inputStyle: inputStyle2,
  outName,
  onValueChange,
  validationMessage,
  label: labelText
}) => {
  return jsxs113("div", {
    style: optionRow,
    children: [
      jsx223(Column, {
        children: jsx223("div", {
          style: label5,
          children: labelText
        })
      }),
      jsx223("div", {
        style: rightRow,
        children: jsxs113("div", {
          children: [
            jsx223(RemotionInput, {
              status: validationMessage ? "error" : existence ? "warning" : "ok",
              style: inputStyle2,
              type: "text",
              value: outName,
              onChange: onValueChange,
              rightAlign: true
            }),
            validationMessage ? jsxs113(Fragment36, {
              children: [
                jsx223(Spacing, {
                  y: 1,
                  block: true
                }),
                jsx223(ValidationMessage, {
                  align: "flex-end",
                  message: validationMessage,
                  type: "error"
                })
              ]
            }) : existence ? jsxs113(Fragment36, {
              children: [
                jsx223(Spacing, {
                  y: 1,
                  block: true
                }),
                jsx223(ValidationMessage, {
                  align: "flex-end",
                  message: "Will be overwritten",
                  type: "warning"
                })
              ]
            }) : null
          ]
        })
      })
    ]
  });
};

// src/components/RenderModal/get-string-before-suffix.ts
var getStringBeforeSuffix = (fileName) => {
  const dotPos = fileName.lastIndexOf(".");
  if (dotPos === -1) {
    return fileName;
  }
  return fileName.substring(0, dotPos);
};

// src/components/RenderModal/SeparateAudioOption.tsx
import {
jsx as jsx224,
jsxs as jsxs114,
Fragment as Fragment37
} from "react/jsx-runtime";
var SeparateAudioOptionInput = ({ separateAudioTo, setSeparateAudioTo, audioCodec }) => {
  const existence = useFileExistence(separateAudioTo);
  const onValueChange = useCallback107((e) => {
    setSeparateAudioTo(e.target.value);
  }, [setSeparateAudioTo]);
  const validationMessage = useMemo111(() => {
    const expectedExtension = BrowserSafeApis4.getExtensionFromAudioCodec(audioCodec);
    const actualExtension = separateAudioTo.split(".").pop();
    if (actualExtension !== expectedExtension) {
      return `Expected extension: .${expectedExtension}`;
    }
    return null;
  }, [audioCodec, separateAudioTo]);
  return jsx224(RenderModalOutputName, {
    existence,
    inputStyle: input,
    onValueChange,
    outName: separateAudioTo,
    label: "Separate audio to",
    validationMessage
  });
};
var SeparateAudioOption = ({ separateAudioTo, setSeparateAudioTo, audioCodec, outName }) => {
  const onSeparateAudioChange = useCallback107((e) => {
    if (e.target.checked) {
      const extension = BrowserSafeApis4.getExtensionFromAudioCodec(audioCodec);
      setSeparateAudioTo(`${getStringBeforeSuffix(outName)}.${extension}`);
    } else {
      setSeparateAudioTo(null);
    }
  }, [audioCodec, outName, setSeparateAudioTo]);
  return jsxs114(Fragment37, {
    children: [
      jsxs114("div", {
        style: optionRow,
        children: [
          jsxs114("div", {
            style: label5,
            children: [
              "Separate audio",
              jsx224(Spacing, {
                x: 0.5
              }),
              jsx224(OptionExplainerBubble, {
                id: "separateAudioOption"
              })
            ]
          }),
          jsx224("div", {
            style: rightRow,
            children: jsx224(Checkbox, {
              disabled: false,
              checked: Boolean(separateAudioTo),
              onChange: onSeparateAudioChange,
              name: "separate-audio-to"
            })
          })
        ]
      }),
      separateAudioTo === null ? null : jsx224(SeparateAudioOptionInput, {
        separateAudioTo,
        setSeparateAudioTo,
        audioCodec
      })
    ]
  });
};

// src/components/RenderModal/human-readable-audio-codecs.ts
var humanReadableAudioCodec = (audioCodec) => {
  if (audioCodec === "aac") {
    return "AAC";
  }
  if (audioCodec === "mp3") {
    return "MP3";
  }
  if (audioCodec === "pcm-16") {
    return "Lossless";
  }
  if (audioCodec === "opus") {
    return "Opus";
  }
};

// src/components/RenderModal/RenderModalAudio.tsx
import {
jsx as jsx225,
jsxs as jsxs115,
Fragment as Fragment38
} from "react/jsx-runtime";
var container49 = {
  flex: 1,
  overflowY: "auto"
};
var RenderModalAudio = ({
  muted,
  setMuted,
  renderMode,
  enforceAudioTrack,
  setEnforceAudioTrackState,
  setShouldHaveCustomTargetAudioBitrate,
  shouldHaveCustomTargetAudioBitrate,
  setCustomTargetAudioBitrateValue,
  customTargetAudioBitrate,
  audioCodec,
  codec,
  setAudioCodec,
  forSeamlessAacConcatenation,
  setForSeamlessAacConcatenation,
  separateAudioTo,
  setSeparateAudioTo,
  outName
}) => {
  const onShouldHaveTargetAudioBitrateChanged = useCallback108((e) => {
    setShouldHaveCustomTargetAudioBitrate(e.target.checked);
  }, [setShouldHaveCustomTargetAudioBitrate]);
  const onTargetAudioBitrateChanged = useCallback108((e) => {
    setCustomTargetAudioBitrateValue(e.target.value);
  }, [setCustomTargetAudioBitrateValue]);
  const onSeamlessAacConcatenationChanges = useCallback108((e) => {
    setForSeamlessAacConcatenation(e.target.checked);
  }, [setForSeamlessAacConcatenation]);
  const audioCodecOptions = useCallback108((currentCodec) => {
    return BrowserSafeApis5.supportedAudioCodecs[currentCodec].map((audioCodecOption) => {
      return {
        label: humanReadableAudioCodec(audioCodecOption),
        onClick: () => setAudioCodec(audioCodecOption),
        key: audioCodecOption,
        leftItem: codec === audioCodecOption ? jsx225(Checkmark, {}) : null,
        id: audioCodecOption,
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: audioCodecOption
      };
    });
  }, [codec, setAudioCodec]);
  return jsxs115("div", {
    style: container49,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: [
      renderMode === "video" ? jsxs115(Fragment38, {
        children: [
          jsx225(MutedSetting, {
            enforceAudioTrack,
            muted,
            setMuted
          }),
          jsx225(RenderModalHr, {})
        ]
      }) : null,
      renderMode === "video" && audioCodecOptions(codec).length >= 2 && !muted ? jsxs115("div", {
        style: optionRow,
        children: [
          jsxs115("div", {
            style: label5,
            children: [
              "Audio Codec ",
              jsx225(Spacing, {
                x: 0.5
              }),
              jsx225(OptionExplainerBubble, {
                id: "audioCodecOption"
              })
            ]
          }),
          jsx225("div", {
            style: rightRow,
            children: jsx225(Combobox, {
              values: audioCodecOptions(codec),
              selectedId: audioCodec,
              title: "AudioCodec"
            })
          })
        ]
      }) : null,
      (renderMode === "video" || renderMode === "audio") && !muted && jsxs115(Fragment38, {
        children: [
          jsx225(EnforceAudioTrackSetting, {
            muted,
            enforceAudioTrack,
            setEnforceAudioTrack: setEnforceAudioTrackState
          }),
          jsx225(RenderModalHr, {})
        ]
      }),
      renderMode === "video" && !muted ? jsx225(SeparateAudioOption, {
        separateAudioTo,
        setSeparateAudioTo,
        audioCodec,
        outName
      }) : null,
      audioCodec === "aac" && !muted ? jsxs115("div", {
        style: optionRow,
        children: [
          jsxs115("div", {
            style: label5,
            children: [
              "For seamless AAC concatenation",
              jsx225(Spacing, {
                x: 0.5
              }),
              jsx225(OptionExplainerBubble, {
                id: "forSeamlessAacConcatenationOption"
              })
            ]
          }),
          jsx225("div", {
            style: rightRow,
            children: jsx225(Checkbox, {
              disabled: false,
              checked: forSeamlessAacConcatenation,
              onChange: onSeamlessAacConcatenationChanges,
              name: "enforce-audio-track"
            })
          })
        ]
      }) : null,
      renderMode === "still" || muted ? null : jsxs115("div", {
        style: optionRow,
        children: [
          jsxs115("div", {
            style: label5,
            children: [
              "Custom audio bitrate",
              " ",
              jsx225(OptionExplainerBubble, {
                id: "audioBitrateOption"
              })
            ]
          }),
          jsx225("div", {
            style: rightRow,
            children: jsx225(Checkbox, {
              checked: shouldHaveCustomTargetAudioBitrate,
              onChange: onShouldHaveTargetAudioBitrateChanged,
              name: "custom-audio-bitrate"
            })
          })
        ]
      }),
      shouldHaveCustomTargetAudioBitrate && renderMode !== "still" && !muted ? jsxs115("div", {
        style: optionRow,
        children: [
          jsx225("div", {
            style: label5,
            children: "Target audio bitrate"
          }),
          jsx225("div", {
            style: rightRow,
            children: jsx225("div", {
              children: jsx225(RemotionInput, {
                style: input,
                value: customTargetAudioBitrate,
                onChange: onTargetAudioBitrateChanged,
                status: "ok",
                rightAlign: true
              })
            })
          })
        ]
      }) : null
    ]
  });
};

// src/components/RenderModal/RenderModalBasic.tsx
import {BrowserSafeApis as BrowserSafeApis6} from "@remotion/renderer/client.js";
import {useCallback as useCallback111, useMemo as useMemo113} from "react";

// src/helpers/prores-labels.ts
var labelProResProfile = (profile) => {
  if (profile === "4444") {
    return "4444";
  }
  if (profile === "4444-xq") {
    return "4444 XQ (Best)";
  }
  if (profile === "hq") {
    return "HQ";
  }
  if (profile === "proxy") {
    return "Proxy (Worst)";
  }
  if (profile === "light") {
    return "Light";
  }
  if (profile === "standard") {
    return "Standard";
  }
  throw new TypeError(`Unknown ProRes profile: ${profile}`);
};

// src/components/RenderModal/FrameRangeSetting.tsx
import {useCallback as useCallback110} from "react";

// src/components/RenderModal/MultiRangeSlider.tsx
import {useCallback as useCallback109, useMemo as useMemo112} from "react";
import {
jsx as jsx226,
jsxs as jsxs116
} from "react/jsx-runtime";
var container50 = {
  borderColor: "black",
  borderStyle: "solid",
  borderWidth: "2px",
  height: 39,
  width: 220,
  position: "relative",
  backgroundColor: INPUT_BACKGROUND,
  marginLeft: 8,
  marginRight: 8,
  borderRadius: 2
};
var sliderRange = {
  position: "absolute",
  top: 0,
  backgroundColor: BLUE,
  height: 35
};
var MultiRangeSlider = ({
  min,
  max,
  start,
  end,
  step,
  onLeftThumbDrag,
  onRightThumbDrag
}) => {
  const getPercent = useCallback109((value) => Math.round((value - min) / (max - min) * 100), [min, max]);
  const rangeStyle = useMemo112(() => {
    const minPercent = getPercent(start);
    const maxPercent = getPercent(end);
    return {
      ...sliderRange,
      left: `${minPercent}%`,
      width: `${maxPercent - minPercent}%`
    };
  }, [end, getPercent, start]);
  const onChangeLeft = useCallback109((event) => {
    const value = Math.min(Number(event.target.value), end - 1);
    onLeftThumbDrag(value);
  }, [end, onLeftThumbDrag]);
  const onChangeRight = useCallback109((event) => {
    const value = Math.max(Number(event.target.value), start + 1);
    onRightThumbDrag(value);
  }, [onRightThumbDrag, start]);
  return jsxs116("div", {
    style: container50,
    children: [
      jsx226("input", {
        type: "range",
        min,
        max,
        value: start,
        step,
        onChange: onChangeLeft,
        className: "__remotion_thumb"
      }),
      jsx226("input", {
        type: "range",
        min,
        max,
        value: end,
        step,
        onChange: onChangeRight,
        className: "__remotion_thumb"
      }),
      jsx226("div", {
        style: rangeStyle
      })
    ]
  });
};

// src/components/RenderModal/FrameRangeSetting.tsx
import {
jsx as jsx227,
jsxs as jsxs117
} from "react/jsx-runtime";
var numberWrapper = {
  minWidth: "39px",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  fontSize: "14px"
};
var FrameRangeSetting = ({ startFrame, endFrame, setEndFrame, durationInFrames, setStartFrame }) => {
  const minStartFrame = 0;
  const maxEndFrame = durationInFrames - 1;
  const onStartFrameChangedDirectly = useCallback110((newStartFrame) => {
    setStartFrame(newStartFrame);
  }, [setStartFrame]);
  const onEndFrameChangedDirectly = useCallback110((newEndFrame) => {
    setEndFrame(newEndFrame);
  }, [setEndFrame]);
  return jsxs117("div", {
    style: optionRow,
    children: [
      jsx227("div", {
        style: label5,
        children: "Frame range"
      }),
      jsxs117("div", {
        style: rightRow,
        children: [
          jsx227("div", {
            style: numberWrapper,
            children: startFrame
          }),
          jsx227(MultiRangeSlider, {
            min: minStartFrame,
            max: maxEndFrame,
            start: startFrame,
            end: endFrame,
            step: 1,
            onLeftThumbDrag: onStartFrameChangedDirectly,
            onRightThumbDrag: onEndFrameChangedDirectly
          }),
          jsx227("div", {
            style: numberWrapper,
            children: endFrame
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/human-readable-codec.ts
var humanReadableCodec = (codec) => {
  if (codec === "aac") {
    return "AAC";
  }
  if (codec === "mp3") {
    return "MP3";
  }
  if (codec === "gif") {
    return "GIF";
  }
  if (codec === "h264") {
    return "H.264";
  }
  if (codec === "h264-mkv") {
    return "H.264 Matroska";
  }
  if (codec === "h264-ts") {
    return "H.264 Transport Stream";
  }
  if (codec === "h265") {
    return "H.265";
  }
  if (codec === "prores") {
    return "ProRes";
  }
  if (codec === "vp8") {
    return "WebM VP8";
  }
  if (codec === "vp9") {
    return "WebM VP9";
  }
  if (codec === "wav") {
    return "Waveform";
  }
  throw new TypeError(`Got unexpected codec "${codec}"`);
};

// src/components/RenderModal/RenderModalBasic.tsx
import {
jsx as jsx228,
jsxs as jsxs118
} from "react/jsx-runtime";
var container51 = {
  flex: 1
};
var RenderModalBasic = ({
  renderMode,
  imageFormatOptions,
  outName,
  codec,
  setVideoCodec: setCodec,
  proResProfile,
  setProResProfile,
  frame: frame2,
  setFrame,
  resolvedComposition,
  setOutName,
  setEndFrame,
  endFrame,
  setStartFrame,
  startFrame,
  validationMessage
}) => {
  const existence = useFileExistence(outName);
  const videoCodecOptions = useMemo113(() => {
    return BrowserSafeApis6.validCodecs.filter((c) => {
      return BrowserSafeApis6.isAudioCodec(c) === (renderMode === "audio");
    }).map((codecOption) => {
      return {
        label: humanReadableCodec(codecOption),
        onClick: () => setCodec(codecOption),
        key: codecOption,
        leftItem: codec === codecOption ? jsx228(Checkmark, {}) : null,
        id: codecOption,
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: codecOption
      };
    });
  }, [renderMode, setCodec, codec]);
  const proResProfileOptions = useMemo113(() => {
    return BrowserSafeApis6.proResProfileOptions.map((option) => {
      return {
        label: labelProResProfile(option),
        onClick: () => setProResProfile(option),
        key: option,
        selected: proResProfile === option,
        type: "item",
        id: option,
        keyHint: null,
        leftItem: null,
        quickSwitcherLabel: null,
        subMenu: null,
        value: option
      };
    });
  }, [proResProfile, setProResProfile]);
  const onFrameSetDirectly = useCallback111((newFrame) => {
    setFrame(newFrame);
  }, [setFrame]);
  const onFrameChanged = useCallback111((e) => {
    setFrame((q) => {
      const newFrame = parseFloat(e);
      if (Number.isNaN(newFrame)) {
        return q;
      }
      return newFrame;
    });
  }, [setFrame]);
  const onValueChange = useCallback111((e) => {
    setOutName(e.target.value);
  }, [setOutName]);
  return jsxs118("div", {
    style: container51,
    children: [
      renderMode === "still" || renderMode === "sequence" ? jsxs118("div", {
        style: optionRow,
        children: [
          jsx228("div", {
            style: label5,
            children: "Format"
          }),
          jsx228("div", {
            style: rightRow,
            children: jsx228(SegmentedControl, {
              items: imageFormatOptions,
              needsWrapping: true
            })
          })
        ]
      }) : jsxs118("div", {
        style: optionRow,
        children: [
          jsxs118("div", {
            style: label5,
            children: [
              "Codec",
              jsx228(Spacing, {
                x: 0.5
              }),
              jsx228(OptionExplainerBubble, {
                id: "videoCodecOption"
              })
            ]
          }),
          jsx228("div", {
            style: rightRow,
            children: jsx228(Combobox, {
              values: videoCodecOptions,
              selectedId: codec,
              title: "Codec"
            })
          })
        ]
      }),
      renderMode === "still" && resolvedComposition.durationInFrames > 1 ? jsxs118("div", {
        style: optionRow,
        children: [
          jsx228("div", {
            style: label5,
            children: "Frame"
          }),
          jsx228("div", {
            style: rightRow,
            children: jsx228(RightAlignInput, {
              children: jsx228(InputDragger, {
                value: frame2,
                onTextChange: onFrameChanged,
                placeholder: `0-${resolvedComposition.durationInFrames - 1}`,
                onValueChange: onFrameSetDirectly,
                name: "frame",
                step: 1,
                min: 0,
                status: "ok",
                max: resolvedComposition.durationInFrames - 1,
                rightAlign: true
              })
            })
          })
        ]
      }) : null,
      renderMode === "video" && codec === "prores" ? jsxs118("div", {
        style: optionRow,
        children: [
          jsx228("div", {
            style: label5,
            children: "ProRes profile"
          }),
          jsx228("div", {
            style: rightRow,
            children: jsx228(Combobox, {
              title: "proResProfile",
              selectedId: proResProfile,
              values: proResProfileOptions
            })
          })
        ]
      }) : null,
      renderMode === "still" ? null : jsx228(FrameRangeSetting, {
        durationInFrames: resolvedComposition.durationInFrames,
        endFrame,
        setEndFrame,
        setStartFrame,
        startFrame
      }),
      jsx228(RenderModalOutputName, {
        existence,
        inputStyle: input,
        outName,
        onValueChange,
        validationMessage,
        label: renderMode === "sequence" ? "Folder name" : "Output name"
      })
    ]
  });
};

// src/components/RenderModal/RenderModalGif.tsx
import {useCallback as useCallback113} from "react";

// src/components/RenderModal/NumberOfLoopsSetting.tsx
import {useCallback as useCallback112} from "react";
import {
jsx as jsx229,
jsxs as jsxs119
} from "react/jsx-runtime";
var min = 0;
var NumberOfLoopsSetting = ({ numberOfGifLoops, setNumberOfGifLoops }) => {
  const onNumberOfGifLoopsChangedDirectly = useCallback112((newConcurrency) => {
    setNumberOfGifLoops(newConcurrency);
  }, [setNumberOfGifLoops]);
  const onNumberOfGifLoopsChanged = useCallback112((e) => {
    setNumberOfGifLoops((q) => {
      const newConcurrency = parseInt(e, 10);
      if (Number.isNaN(newConcurrency)) {
        return q;
      }
      const newConcurrencyClamped = Math.max(newConcurrency, min);
      return newConcurrencyClamped;
    });
  }, [setNumberOfGifLoops]);
  return jsxs119("div", {
    style: optionRow,
    children: [
      jsx229("div", {
        style: label5,
        children: "Number of loops"
      }),
      jsx229("div", {
        style: rightRow,
        children: jsx229(RightAlignInput, {
          children: jsx229(InputDragger, {
            value: numberOfGifLoops,
            onTextChange: onNumberOfGifLoopsChanged,
            placeholder: `${min}-`,
            onValueChange: onNumberOfGifLoopsChangedDirectly,
            name: "number-of-gif-loops",
            step: 1,
            min,
            status: "ok",
            rightAlign: true
          })
        })
      })
    ]
  });
};

// src/components/RenderModal/RenderModalGif.tsx
import {
jsx as jsx230,
jsxs as jsxs120
} from "react/jsx-runtime";
var container52 = {
  flex: 1
};
var RenderModalGif = ({
  everyNthFrame,
  limitNumberOfGifLoops,
  numberOfGifLoopsSetting,
  setEveryNthFrameSetting,
  setLimitNumberOfGifLoops,
  setNumberOfGifLoopsSetting
}) => {
  const onShouldLimitNumberOfGifLoops = useCallback113((e) => {
    setLimitNumberOfGifLoops(e.target.checked);
  }, [setLimitNumberOfGifLoops]);
  return jsxs120("div", {
    style: container52,
    children: [
      jsx230(NumberSetting, {
        name: "Every nth frame",
        min: 1,
        onValueChanged: setEveryNthFrameSetting,
        value: everyNthFrame,
        step: 1
      }),
      jsxs120("div", {
        style: optionRow,
        children: [
          jsxs120("div", {
            style: label5,
            children: [
              "Limit GIF loops ",
              jsx230(Spacing, {
                x: 0.5
              }),
              jsx230(OptionExplainerBubble, {
                id: "numberOfGifLoopsOption"
              })
            ]
          }),
          jsx230("div", {
            style: rightRow,
            children: jsx230(Checkbox, {
              checked: limitNumberOfGifLoops,
              onChange: onShouldLimitNumberOfGifLoops,
              name: "limitNumberOfGifLoops"
            })
          })
        ]
      }),
      limitNumberOfGifLoops ? jsx230(NumberOfLoopsSetting, {
        numberOfGifLoops: numberOfGifLoopsSetting,
        setNumberOfGifLoops: setNumberOfGifLoopsSetting
      }) : null
    ]
  });
};

// src/components/RenderModal/RenderModalPicture.tsx
import {BrowserSafeApis as BrowserSafeApis7} from "@remotion/renderer/client.js";
import {useCallback as useCallback114, useMemo as useMemo114} from "react";

// src/components/RenderModal/JpegQualitySetting.tsx
import {
jsx as jsx231
} from "react/jsx-runtime";
var MIN_JPEG_QUALITY = 1;
var MAX_JPEG_QUALITY = 100;
var JpegQualitySetting = ({ jpegQuality, setJpegQuality }) => {
  return jsx231(NumberSetting, {
    min: MIN_JPEG_QUALITY,
    max: MAX_JPEG_QUALITY,
    step: 1,
    name: "JPEG Quality",
    onValueChanged: setJpegQuality,
    value: jpegQuality,
    hint: "jpegQualityOption"
  });
};

// src/components/RenderModal/ScaleSetting.tsx
import {
jsx as jsx232
} from "react/jsx-runtime";
var MIN_SCALE = 0.1;
var MAX_SCALE = 10;
var ScaleSetting = ({ scale, setScale }) => {
  return jsx232(NumberSetting, {
    min: MIN_SCALE,
    max: MAX_SCALE,
    step: 0.1,
    name: "Scale",
    formatter: (w) => {
      if (typeof w === "number") {
        return `${w.toFixed(1)}x`;
      }
      return `${w}x`;
    },
    onValueChanged: setScale,
    value: scale,
    hint: "scaleOption"
  });
};

// src/components/RenderModal/RenderModalPicture.tsx
import {
jsx as jsx233,
jsxs as jsxs121,
Fragment as Fragment39
} from "react/jsx-runtime";
var qualityControlModes = ["crf", "bitrate"];
var container53 = {
  flex: 1,
  overflowY: "auto"
};
var RenderModalPicture = ({
  renderMode,
  scale,
  setScale,
  pixelFormat,
  imageFormatOptions,
  setQualityControl,
  qualityControlType,
  videoImageFormat,
  setJpegQuality,
  jpegQuality,
  maxCrf,
  minCrf,
  setCrf,
  shouldDisplayQualityControlPicker,
  setCustomTargetVideoBitrateValue,
  crf,
  customTargetVideoBitrate,
  stillImageFormat,
  colorSpace,
  setColorSpace,
  pixelFormatOptions,
  encodingBufferSize,
  encodingMaxRate,
  setEncodingBufferSize,
  setEncodingMaxRate
}) => {
  const colorSpaceOptions = useMemo114(() => {
    return BrowserSafeApis7.validColorSpaces.map((option) => {
      return {
        label: option,
        onClick: () => setColorSpace(option),
        key: option,
        id: option,
        keyHint: null,
        leftItem: colorSpace === option ? jsx233(Checkmark, {}) : null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: option
      };
    });
  }, [colorSpace, setColorSpace]);
  const qualityControlOptions = useMemo114(() => {
    return qualityControlModes.map((option) => {
      return {
        label: option === "crf" ? "CRF" : "Bitrate",
        onClick: () => setQualityControl(option),
        key: option,
        selected: qualityControlType === option
      };
    });
  }, [qualityControlType, setQualityControl]);
  const onTargetVideoBitrateChanged = useCallback114((e) => {
    setCustomTargetVideoBitrateValue(e.target.value);
  }, [setCustomTargetVideoBitrateValue]);
  const onEncodingBufferSizeToggled = useCallback114((e) => {
    setEncodingBufferSize(e.target.checked ? "10000k" : null);
  }, [setEncodingBufferSize]);
  const onEncodingMaxRateToggled = useCallback114((e) => {
    setEncodingMaxRate(e.target.checked ? "5000k" : null);
  }, [setEncodingMaxRate]);
  const onEncodingBufferSizeChanged = useCallback114((e) => {
    setEncodingBufferSize(e.target.value);
  }, [setEncodingBufferSize]);
  const onEncodingMaxRateChanged = useCallback114((e) => {
    setEncodingMaxRate(e.target.value);
  }, [setEncodingMaxRate]);
  return jsxs121("div", {
    style: container53,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: [
      renderMode === "video" ? jsxs121("div", {
        style: optionRow,
        children: [
          jsx233("div", {
            style: label5,
            children: "Image Format"
          }),
          jsx233("div", {
            style: rightRow,
            children: jsx233(SegmentedControl, {
              items: imageFormatOptions,
              needsWrapping: false
            })
          })
        ]
      }) : null,
      renderMode === "video" && videoImageFormat === "jpeg" && jsx233(JpegQualitySetting, {
        jpegQuality,
        setJpegQuality
      }),
      renderMode === "still" && stillImageFormat === "jpeg" && jsx233(JpegQualitySetting, {
        jpegQuality,
        setJpegQuality
      }),
      renderMode === "video" && qualityControlType !== null ? jsx233(RenderModalHr, {}) : null,
      shouldDisplayQualityControlPicker && renderMode === "video" ? jsxs121("div", {
        style: optionRow,
        children: [
          jsx233("div", {
            style: label5,
            children: "Quality control"
          }),
          jsx233("div", {
            style: rightRow,
            children: jsx233(SegmentedControl, {
              items: qualityControlOptions,
              needsWrapping: true
            })
          })
        ]
      }) : null,
      qualityControlType === "crf" && renderMode !== "still" && renderMode !== "sequence" ? jsx233(CrfSetting, {
        crf,
        min: minCrf,
        max: maxCrf,
        setCrf,
        option: "crfOption"
      }) : null,
      qualityControlType === "bitrate" && renderMode === "video" ? jsxs121("div", {
        style: optionRow,
        children: [
          jsxs121("div", {
            style: label5,
            children: [
              "Target video bitrate",
              jsx233(Spacing, {
                x: 0.5
              }),
              jsx233(OptionExplainerBubble, {
                id: "videoBitrateOption"
              })
            ]
          }),
          jsx233("div", {
            style: rightRow,
            children: jsx233("div", {
              children: jsx233(RemotionInput, {
                style: input,
                value: customTargetVideoBitrate,
                onChange: onTargetVideoBitrateChanged,
                status: "ok",
                rightAlign: true
              })
            })
          })
        ]
      }) : null,
      renderMode === "video" ? jsxs121(Fragment39, {
        children: [
          jsxs121("div", {
            style: optionRow,
            children: [
              jsxs121("div", {
                style: label5,
                children: [
                  "Custom FFmpeg -bufsize",
                  jsx233(Spacing, {
                    x: 0.5
                  }),
                  jsx233(OptionExplainerBubble, {
                    id: "encodingBufferSizeOption"
                  })
                ]
              }),
              jsx233("div", {
                style: rightRow,
                children: jsx233(Checkbox, {
                  checked: encodingBufferSize !== null,
                  onChange: onEncodingBufferSizeToggled,
                  name: "encoding-buffer-size"
                })
              })
            ]
          }),
          encodingBufferSize === null ? null : jsxs121("div", {
            style: optionRow,
            children: [
              jsx233("div", {
                style: label5,
                children: "-bufsize value"
              }),
              jsx233("div", {
                style: rightRow,
                children: jsx233("div", {
                  children: jsx233(RemotionInput, {
                    style: input,
                    value: encodingBufferSize,
                    onChange: onEncodingBufferSizeChanged,
                    status: "ok",
                    rightAlign: true
                  })
                })
              })
            ]
          }),
          jsxs121("div", {
            style: optionRow,
            children: [
              jsxs121("div", {
                style: label5,
                children: [
                  "Custom FFmpeg -maxrate",
                  jsx233(Spacing, {
                    x: 0.5
                  }),
                  jsx233(OptionExplainerBubble, {
                    id: "encodingMaxRateOption"
                  })
                ]
              }),
              jsx233("div", {
                style: rightRow,
                children: jsx233(Checkbox, {
                  checked: encodingMaxRate !== null,
                  onChange: onEncodingMaxRateToggled,
                  name: "encoding-max-rate"
                })
              })
            ]
          }),
          encodingMaxRate === null ? null : jsxs121("div", {
            style: optionRow,
            children: [
              jsx233("div", {
                style: label5,
                children: "-maxrate value"
              }),
              jsx233("div", {
                style: rightRow,
                children: jsx233("div", {
                  children: jsx233(RemotionInput, {
                    style: input,
                    value: encodingMaxRate,
                    onChange: onEncodingMaxRateChanged,
                    status: "ok",
                    rightAlign: true
                  })
                })
              })
            ]
          })
        ]
      }) : null,
      renderMode === "video" ? jsx233(RenderModalHr, {}) : null,
      jsx233(ScaleSetting, {
        scale,
        setScale
      }),
      renderMode === "video" ? jsx233(RenderModalHr, {}) : null,
      renderMode === "video" ? jsxs121("div", {
        style: optionRow,
        children: [
          jsx233("div", {
            style: label5,
            children: "Pixel format"
          }),
          jsx233("div", {
            style: rightRow,
            children: jsx233(Combobox, {
              values: pixelFormatOptions,
              selectedId: pixelFormat,
              title: "Pixel Format"
            })
          })
        ]
      }) : null,
      renderMode === "video" ? jsxs121("div", {
        style: optionRow,
        children: [
          jsxs121("div", {
            style: label5,
            children: [
              "Color space",
              jsx233(Spacing, {
                x: 0.5
              }),
              jsx233(OptionExplainerBubble, {
                id: "colorSpaceOption"
              })
            ]
          }),
          jsx233("div", {
            style: rightRow,
            children: jsx233(Combobox, {
              values: colorSpaceOptions,
              selectedId: colorSpace,
              title: "Color Space"
            })
          })
        ]
      }) : null
    ]
  });
};

// src/components/RenderModal/get-default-codecs.ts
import {BrowserSafeApis as BrowserSafeApis8} from "@remotion/renderer/client.js";
var getDefaultCodecs = ({
  defaultConfigurationVideoCodec,
  compositionDefaultVideoCodec,
  renderType,
  defaultConfigurationAudioCodec
}) => {
  const userPreferredVideoCodec = compositionDefaultVideoCodec ?? defaultConfigurationVideoCodec ?? "h264";
  const userPreferredVideoCodecForAudioTab = userPreferredVideoCodec === "aac" ? "aac" : userPreferredVideoCodec === "mp3" ? "mp3" : userPreferredVideoCodec === "wav" ? "wav" : defaultConfigurationAudioCodec === "pcm-16" ? "wav" : defaultConfigurationAudioCodec === "mp3" ? "mp3" : "aac";
  const isVideoCodecAnAudioCodec = BrowserSafeApis8.isAudioCodec(userPreferredVideoCodec);
  if (isVideoCodecAnAudioCodec) {
    return {
      initialAudioCodec: userPreferredVideoCodec,
      initialRenderType: "audio",
      initialVideoCodec: userPreferredVideoCodec,
      initialVideoCodecForAudioTab: userPreferredVideoCodecForAudioTab,
      initialVideoCodecForVideoTab: BrowserSafeApis8.isAudioCodec(defaultConfigurationVideoCodec) ? "h264" : defaultConfigurationVideoCodec
    };
  }
  const suitableAudioCodecForVideoCodec = BrowserSafeApis8.defaultAudioCodecs[userPreferredVideoCodec].compressed;
  return {
    initialAudioCodec: defaultConfigurationAudioCodec ?? suitableAudioCodecForVideoCodec,
    initialVideoCodec: userPreferredVideoCodec,
    initialRenderType: renderType,
    initialVideoCodecForAudioTab: userPreferredVideoCodecForAudioTab,
    initialVideoCodecForVideoTab: userPreferredVideoCodec
  };
};

// src/components/RenderModal/out-name-checker.ts
import {BrowserSafeApis as BrowserSafeApis9} from "@remotion/renderer/client.js";
var invalidCharacters = ["?", "*", "+", ":", "%"];
var isValidStillExtension = (extension, stillImageFormat) => {
  if (stillImageFormat === "jpeg" && extension === "jpg") {
    return true;
  }
  return extension === stillImageFormat;
};
var validateOutnameGui = ({
  outName,
  codec,
  audioCodec,
  renderMode,
  stillImageFormat,
  separateAudioTo
}) => {
  try {
    isValidOutName({
      audioCodec,
      codec,
      outName,
      renderMode,
      stillImageFormat,
      separateAudioTo
    });
    return { valid: true };
  } catch (err) {
    return { valid: false, error: err };
  }
};
var isValidOutName = ({
  outName,
  codec,
  audioCodec,
  renderMode,
  stillImageFormat,
  separateAudioTo
}) => {
  const extension = outName.substring(outName.lastIndexOf(".") + 1);
  const prefix = outName.substring(0, outName.lastIndexOf("."));
  const map = BrowserSafeApis9.defaultFileExtensionMap[codec];
  if (BrowserSafeApis9.supportedAudioCodecs[codec].length > 0 && !(audioCodec in map.forAudioCodec)) {
    throw new Error(`Audio codec ${audioCodec} is not supported for codec ${codec}`);
  }
  const hasDotAfterSlash = () => {
    const substrings = prefix.split("/");
    for (const str of substrings) {
      if (str[0] === ".") {
        return true;
      }
    }
    return false;
  };
  const hasInvalidChar = () => {
    return prefix.split("").some((char) => invalidCharacters.includes(char));
  };
  if (renderMode === "video" || renderMode === "audio") {
    BrowserSafeApis9.validateOutputFilename({
      codec,
      audioCodecSetting: audioCodec ?? null,
      extension,
      preferLossless: false,
      separateAudioTo
    });
  }
  if (prefix.length < 1 && renderMode !== "sequence") {
    throw new Error("The prefix must be at least 1 character long");
  }
  if (prefix[0] === "." || hasDotAfterSlash()) {
    throw new Error("The output name must not start with a dot");
  }
  if (hasInvalidChar()) {
    throw new Error("Filename can't contain the following characters:  ?, *, +, %, :");
  }
  if (renderMode === "still" && stillImageFormat && !isValidStillExtension(extension, stillImageFormat)) {
    throw new Error(`The extension ${extension} is not supported for still image format ${stillImageFormat}`);
  }
  if (renderMode === "sequence") {
    if (outName.includes(".")) {
      throw new Error("Folder names must not contain a dot");
    }
  }
};

// src/components/RenderModal/RenderModal.tsx
import {
jsx as jsx234,
jsxs as jsxs122
} from "react/jsx-runtime";
var initialState2 = { type: "idle" };
var reducer2 = (state, action) => {
  if (action.type === "start") {
    return {
      type: "load"
    };
  }
  if (action.type === "fail") {
    return {
      type: "error"
    };
  }
  if (action.type === "succeed") {
    return {
      type: "success"
    };
  }
  return state;
};
var container54 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "12px 16px",
  borderBottom: "1px solid black"
};
var optionsPanel = {
  display: "flex",
  width: "100%"
};
var horizontalLayout = {
  display: "flex",
  flexDirection: "row",
  overflowY: "auto",
  flex: 1
};
var leftSidebar = {
  padding: 12
};
var horizontalTab = {
  width: 250,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  textAlign: "left",
  fontSize: 16,
  fontWeight: "bold",
  paddingLeft: 15,
  paddingTop: 12,
  paddingBottom: 12
};
var iconContainer = {
  width: 20,
  height: 20,
  marginRight: 15,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center"
};
var icon6 = {
  color: "currentcolor",
  height: 20
};
var buttonStyle7 = {
  backgroundColor: BLUE,
  color: "white"
};
var flexer = {
  flex: 1
};
var outer4 = {
  width: getMaxModalWidth(1000),
  height: getMaxModalHeight(640),
  overflow: "hidden",
  display: "flex",
  flexDirection: "column"
};
var RenderModal = ({
  initialFrame,
  initialVideoImageFormat,
  initialStillImageFormat,
  initialJpegQuality,
  initialScale,
  initialLogLevel,
  initialConcurrency,
  maxConcurrency,
  minConcurrency,
  initialMuted,
  initialEnforceAudioTrack,
  initialProResProfile,
  initialx264Preset,
  initialPixelFormat,
  initialVideoBitrate,
  initialAudioBitrate,
  initialEveryNthFrame,
  initialNumberOfGifLoops,
  initialDelayRenderTimeout,
  initialOffthreadVideoCacheSizeInBytes,
  initialEnvVariables,
  initialDisableWebSecurity,
  initialGl,
  initialHeadless,
  initialIgnoreCertificateErrors,
  initialEncodingBufferSize,
  initialEncodingMaxRate,
  initialUserAgent,
  defaultProps,
  inFrameMark,
  outFrameMark,
  initialColorSpace,
  initialMultiProcessOnLinux,
  defaultConfigurationAudioCodec,
  defaultConfigurationVideoCodec,
  initialBeep,
  initialRepro,
  initialForSeamlessAacConcatenation,
  renderTypeOfLastRender
}) => {
  const { setSelectedModal } = useContext74(ModalsContext);
  const context5 = useContext74(ResolvedCompositionContext);
  if (!context5) {
    throw new Error("Should not be able to render without resolving comp first");
  }
  const {
    resolved: { result: resolvedComposition },
    unresolved: unresolvedComposition
  } = context5;
  const isMounted = useRef37(true);
  const [isVideo] = useState70(() => {
    return typeof resolvedComposition.durationInFrames === "undefined" ? true : resolvedComposition.durationInFrames > 1;
  });
  const [
    {
      initialAudioCodec,
      initialRenderType,
      initialVideoCodec,
      initialVideoCodecForAudioTab,
      initialVideoCodecForVideoTab
    }
  ] = useState70(() => {
    return getDefaultCodecs({
      defaultConfigurationVideoCodec,
      compositionDefaultVideoCodec: resolvedComposition.defaultCodec,
      defaultConfigurationAudioCodec,
      renderType: renderTypeOfLastRender ?? (isVideo ? "video" : "still")
    });
  });
  const [state, dispatch] = useReducer2(reducer2, initialState2);
  const [unclampedFrame, setFrame] = useState70(() => initialFrame);
  const [saving, setSaving] = useState70(false);
  const [stillImageFormat, setStillImageFormat] = useState70(() => initialStillImageFormat);
  const [videoImageFormat, setVideoImageFormat] = useState70(() => initialVideoImageFormat);
  const [sequenceImageFormat, setSequenceImageFormat] = useState70(() => initialStillImageFormat === "jpeg" ? "jpeg" : "png");
  const [concurrency, setConcurrency] = useState70(() => initialConcurrency);
  const [videoCodecForVideoTab, setVideoCodecForVideoTab] = useState70(() => initialVideoCodecForVideoTab);
  const [userSelectedAudioCodec, setUserSelectedAudioCodec] = useState70(() => initialAudioCodec);
  const [separateAudioTo, setSeparateAudioTo] = useState70(null);
  const [envVariables, setEnvVariables] = useState70(() => envVariablesObjectToArray(initialEnvVariables).filter(([key5]) => key5 !== "NODE_ENV"));
  const [initialOutName] = useState70(() => {
    return getDefaultOutLocation({
      compositionName: resolvedComposition.id,
      defaultExtension: initialRenderType === "still" ? initialStillImageFormat : isVideo ? BrowserSafeApis10.getFileExtensionFromCodec(initialVideoCodec, initialAudioCodec) : initialStillImageFormat,
      type: "asset"
    });
  });
  const [videoCodecForAudioTab, setVideoCodecForAudioTab] = useState70(() => initialVideoCodecForAudioTab);
  const [mutedState, setMuted] = useState70(() => initialMuted);
  const [repro, setRepro] = useState70(() => initialRepro);
  const [enforceAudioTrackState, setEnforceAudioTrackState] = useState70(() => initialEnforceAudioTrack);
  const [forSeamlessAacConcatenation, setForSeamlessAacConcatenation] = useState70(() => initialForSeamlessAacConcatenation);
  const [renderMode, setRenderModeState] = useState70(initialRenderType);
  const [jpegQuality, setJpegQuality] = useState70(() => initialJpegQuality);
  const [scale, setScale] = useState70(() => initialScale);
  const [logLevel, setLogLevel] = useState70(() => initialLogLevel);
  const [disallowParallelEncoding, setDisallowParallelEncoding] = useState70(false);
  const [disableWebSecurity, setDisableWebSecurity] = useState70(() => initialDisableWebSecurity);
  const [headless, setHeadless] = useState70(() => initialHeadless);
  const [beepOnFinish, setBeepOnFinish] = useState70(() => initialBeep);
  const [ignoreCertificateErrors, setIgnoreCertificateErrors] = useState70(() => initialIgnoreCertificateErrors);
  const [multiProcessOnLinux, setChromiumMultiProcessOnLinux] = useState70(() => initialMultiProcessOnLinux);
  const [openGlOption, setOpenGlOption] = useState70(() => initialGl ?? "default");
  const [colorSpace, setColorSpace] = useState70(() => initialColorSpace);
  const [userAgent, setUserAgent] = useState70(() => initialUserAgent === null ? null : initialUserAgent.trim() === "" ? null : initialUserAgent);
  const chromiumOptions = useMemo115(() => {
    return {
      headless,
      disableWebSecurity,
      ignoreCertificateErrors,
      gl: openGlOption === "default" ? null : openGlOption,
      userAgent: userAgent === null ? null : userAgent.trim() === "" ? null : userAgent,
      enableMultiProcessOnLinux: multiProcessOnLinux
    };
  }, [
    headless,
    disableWebSecurity,
    ignoreCertificateErrors,
    openGlOption,
    userAgent,
    multiProcessOnLinux
  ]);
  const [outName, setOutName] = useState70(() => initialOutName);
  const [endFrameOrNull, setEndFrame] = useState70(() => outFrameMark ?? null);
  const [startFrameOrNull, setStartFrame] = useState70(() => inFrameMark ?? null);
  const [proResProfileSetting, setProResProfile] = useState70(() => initialProResProfile);
  const [x264PresetSetting, setx264Preset] = useState70(() => initialx264Preset);
  const [userPreferredPixelFormat, setPixelFormat] = useState70(() => initialPixelFormat);
  const [preferredQualityControlType, setQualityControl] = useState70(() => initialVideoBitrate === null ? "crf" : "bitrate");
  const [
    shouldHaveCustomTargetAudioBitrate,
    setShouldHaveCustomTargetAudioBitrate
  ] = useState70(() => initialAudioBitrate !== null);
  const [customTargetAudioBitrate, setCustomTargetAudioBitrateValue] = useState70(() => initialAudioBitrate ?? "320K");
  const [customTargetVideoBitrate, setCustomTargetVideoBitrateValue] = useState70(() => initialVideoBitrate ?? "1M");
  const [encodingMaxRate, setEncodingMaxRate] = useState70(() => initialEncodingMaxRate ?? null);
  const [encodingBufferSize, setEncodingBufferSize] = useState70(() => initialEncodingBufferSize ?? null);
  const [limitNumberOfGifLoops, setLimitNumberOfGifLoops] = useState70(() => initialNumberOfGifLoops !== null);
  const [numberOfGifLoopsSetting, setNumberOfGifLoopsSetting] = useState70(() => initialNumberOfGifLoops ?? 0);
  const [delayRenderTimeout, setDelayRenderTimeout] = useState70(() => initialDelayRenderTimeout);
  const [offthreadVideoCacheSizeInBytes, setOffthreadVideoCacheSizeInBytes] = useState70(initialOffthreadVideoCacheSizeInBytes);
  const codec = useMemo115(() => {
    if (renderMode === "audio") {
      return videoCodecForAudioTab;
    }
    return videoCodecForVideoTab;
  }, [videoCodecForAudioTab, renderMode, videoCodecForVideoTab]);
  const numberOfGifLoops = useMemo115(() => {
    if (codec === "gif" && limitNumberOfGifLoops) {
      return numberOfGifLoopsSetting;
    }
    return null;
  }, [codec, limitNumberOfGifLoops, numberOfGifLoopsSetting]);
  const audioBitrate = useMemo115(() => {
    if (shouldHaveCustomTargetAudioBitrate) {
      return customTargetAudioBitrate;
    }
    return null;
  }, [customTargetAudioBitrate, shouldHaveCustomTargetAudioBitrate]);
  const supportsCrf = BrowserSafeApis10.codecSupportsCrf(codec);
  const supportsVideoBitrate = BrowserSafeApis10.codecSupportsVideoBitrate(codec);
  const supportsBothQualityControls = useMemo115(() => {
    return supportsCrf && supportsVideoBitrate;
  }, [supportsCrf, supportsVideoBitrate]);
  const qualityControlType = useMemo115(() => {
    if (supportsBothQualityControls) {
      return preferredQualityControlType;
    }
    if (supportsCrf) {
      return "crf";
    }
    if (supportsVideoBitrate) {
      return "bitrate";
    }
    return null;
  }, [
    preferredQualityControlType,
    supportsBothQualityControls,
    supportsCrf,
    supportsVideoBitrate
  ]);
  const videoBitrate = useMemo115(() => {
    if (qualityControlType === "bitrate") {
      return customTargetVideoBitrate;
    }
    return null;
  }, [customTargetVideoBitrate, qualityControlType]);
  const { crf, maxCrf, minCrf, setCrf } = useCrfState(codec);
  const dispatchIfMounted = useCallback115((payload) => {
    if (isMounted.current === false)
      return;
    dispatch(payload);
  }, []);
  const muted = useMemo115(() => {
    if (renderMode === "video") {
      return mutedState;
    }
    return false;
  }, [mutedState, renderMode]);
  const enforceAudioTrack = useMemo115(() => {
    if (renderMode === "video") {
      return enforceAudioTrackState;
    }
    if (renderMode === "audio") {
      return enforceAudioTrackState;
    }
    return false;
  }, [enforceAudioTrackState, renderMode]);
  const proResProfile = useMemo115(() => {
    if (renderMode === "video" && codec === "prores") {
      return proResProfileSetting;
    }
    return null;
  }, [codec, proResProfileSetting, renderMode]);
  const x264Preset = useMemo115(() => {
    if (renderMode === "video" && codec === "h264") {
      return x264PresetSetting;
    }
    return null;
  }, [codec, x264PresetSetting, renderMode]);
  const [inputProps, setInputProps] = useState70(() => defaultProps);
  const endFrame = useMemo115(() => {
    if (endFrameOrNull === null) {
      return resolvedComposition.durationInFrames - 1;
    }
    return Math.max(0, Math.min(resolvedComposition.durationInFrames - 1, endFrameOrNull));
  }, [resolvedComposition.durationInFrames, endFrameOrNull]);
  const startFrame = useMemo115(() => {
    if (startFrameOrNull === null) {
      return 0;
    }
    return Math.max(0, Math.min(endFrame - 1, startFrameOrNull));
  }, [endFrame, startFrameOrNull]);
  const frame3 = useMemo115(() => {
    const parsed = Math.floor(unclampedFrame);
    return Math.max(0, Math.min(resolvedComposition.durationInFrames - 1, parsed));
  }, [resolvedComposition.durationInFrames, unclampedFrame]);
  const deriveFinalAudioCodec = useCallback115((passedVideoCodec, passedAudioCodec) => {
    if (passedAudioCodec !== null && BrowserSafeApis10.supportedAudioCodecs[passedVideoCodec].includes(passedAudioCodec)) {
      return passedAudioCodec;
    }
    return BrowserSafeApis10.defaultAudioCodecs[passedVideoCodec].compressed;
  }, []);
  const setDefaultOutName = useCallback115((options) => {
    if (options.type === "still") {
      setOutName((prev) => {
        const newFileName = getStringBeforeSuffix(prev) + "." + options.imageFormat;
        return newFileName;
      });
    } else if (options.type === "sequence") {
      setOutName((prev) => {
        const folderName = getStringBeforeSuffix(prev);
        return folderName;
      });
    } else {
      setOutName((prev) => {
        const codecSuffix = BrowserSafeApis10.getFileExtensionFromCodec(options.codec, deriveFinalAudioCodec(options.codec, options.audioCodec));
        const newFileName = getStringBeforeSuffix(prev) + "." + codecSuffix;
        return newFileName;
      });
    }
  }, [deriveFinalAudioCodec]);
  const setAudioCodec = useCallback115((newAudioCodec) => {
    setUserSelectedAudioCodec(newAudioCodec);
    setDefaultOutName({
      type: "render",
      codec: videoCodecForVideoTab,
      audioCodec: newAudioCodec
    });
    setSeparateAudioTo((prev) => {
      if (prev === null) {
        return null;
      }
      const newExtension = BrowserSafeApis10.getExtensionFromAudioCodec(newAudioCodec);
      const newFileName = getStringBeforeSuffix(prev) + "." + newExtension;
      return newFileName;
    });
  }, [setDefaultOutName, videoCodecForVideoTab]);
  const setCodec = useCallback115((newCodec) => {
    if (renderMode === "audio") {
      setVideoCodecForAudioTab(newCodec);
    } else {
      setVideoCodecForVideoTab(newCodec);
    }
    setDefaultOutName({
      type: "render",
      codec: newCodec,
      audioCodec: deriveFinalAudioCodec(newCodec, userSelectedAudioCodec)
    });
  }, [
    userSelectedAudioCodec,
    deriveFinalAudioCodec,
    renderMode,
    setDefaultOutName
  ]);
  const setStillFormat = useCallback115((format) => {
    setStillImageFormat(format);
    setDefaultOutName({ type: "still", imageFormat: format });
  }, [setDefaultOutName]);
  const { setSidebarCollapsedState } = useContext74(SidebarContext);
  const onClickStill = useCallback115(() => {
    setSidebarCollapsedState({ left: null, right: "expanded" });
    persistSelectedOptionsSidebarPanel2("renders");
    optionsSidebarTabs.current?.selectRendersPanel();
    dispatchIfMounted({ type: "start" });
    addStillRenderJob({
      compositionId: resolvedComposition.id,
      outName,
      imageFormat: stillImageFormat,
      jpegQuality,
      frame: frame3,
      scale,
      logLevel,
      chromiumOptions,
      delayRenderTimeout,
      envVariables: envVariablesArrayToObject(envVariables),
      inputProps,
      offthreadVideoCacheSizeInBytes,
      multiProcessOnLinux,
      beepOnFinish
    }).then(() => {
      dispatchIfMounted({ type: "succeed" });
      setSelectedModal(null);
    }).catch(() => {
      dispatchIfMounted({ type: "fail" });
    });
  }, [
    setSidebarCollapsedState,
    dispatchIfMounted,
    resolvedComposition.id,
    outName,
    stillImageFormat,
    jpegQuality,
    frame3,
    scale,
    logLevel,
    chromiumOptions,
    delayRenderTimeout,
    envVariables,
    inputProps,
    offthreadVideoCacheSizeInBytes,
    multiProcessOnLinux,
    beepOnFinish,
    setSelectedModal
  ]);
  const [everyNthFrameSetting, setEveryNthFrameSetting] = useState70(() => initialEveryNthFrame);
  const everyNthFrame = useMemo115(() => {
    if (codec === "gif") {
      return everyNthFrameSetting;
    }
    return 1;
  }, [codec, everyNthFrameSetting]);
  const audioCodec = deriveFinalAudioCodec(codec, userSelectedAudioCodec);
  const availablePixelFormats = useMemo115(() => {
    return BrowserSafeApis10.validPixelFormatsForCodec(codec);
  }, [codec]);
  const pixelFormat = useMemo115(() => {
    if (availablePixelFormats.includes(userPreferredPixelFormat)) {
      return userPreferredPixelFormat;
    }
    return availablePixelFormats[0];
  }, [availablePixelFormats, userPreferredPixelFormat]);
  const onClickVideo = useCallback115(() => {
    setSidebarCollapsedState({ left: null, right: "expanded" });
    persistSelectedOptionsSidebarPanel2("renders");
    optionsSidebarTabs.current?.selectRendersPanel();
    dispatchIfMounted({ type: "start" });
    addVideoRenderJob({
      compositionId: resolvedComposition.id,
      outName,
      imageFormat: videoImageFormat,
      jpegQuality: stillImageFormat === "jpeg" ? jpegQuality : null,
      scale,
      logLevel,
      codec,
      concurrency,
      crf: qualityControlType === "crf" ? crf : null,
      endFrame,
      startFrame,
      muted,
      enforceAudioTrack,
      proResProfile,
      x264Preset,
      pixelFormat,
      audioBitrate,
      videoBitrate,
      everyNthFrame,
      numberOfGifLoops,
      delayRenderTimeout,
      audioCodec,
      disallowParallelEncoding,
      chromiumOptions,
      envVariables: envVariablesArrayToObject(envVariables),
      inputProps,
      offthreadVideoCacheSizeInBytes,
      colorSpace,
      multiProcessOnLinux,
      encodingBufferSize,
      encodingMaxRate,
      beepOnFinish,
      repro,
      forSeamlessAacConcatenation,
      separateAudioTo
    }).then(() => {
      dispatchIfMounted({ type: "succeed" });
      setSelectedModal(null);
    }).catch(() => {
      dispatchIfMounted({ type: "fail" });
    });
  }, [
    setSidebarCollapsedState,
    dispatchIfMounted,
    resolvedComposition.id,
    outName,
    videoImageFormat,
    stillImageFormat,
    jpegQuality,
    scale,
    logLevel,
    codec,
    concurrency,
    qualityControlType,
    crf,
    endFrame,
    startFrame,
    muted,
    enforceAudioTrack,
    proResProfile,
    x264Preset,
    pixelFormat,
    audioBitrate,
    videoBitrate,
    everyNthFrame,
    numberOfGifLoops,
    delayRenderTimeout,
    audioCodec,
    disallowParallelEncoding,
    chromiumOptions,
    envVariables,
    inputProps,
    offthreadVideoCacheSizeInBytes,
    colorSpace,
    multiProcessOnLinux,
    encodingBufferSize,
    encodingMaxRate,
    beepOnFinish,
    repro,
    forSeamlessAacConcatenation,
    separateAudioTo,
    setSelectedModal
  ]);
  const onClickSequence = useCallback115(() => {
    setSidebarCollapsedState({ left: null, right: "expanded" });
    persistSelectedOptionsSidebarPanel2("renders");
    optionsSidebarTabs.current?.selectRendersPanel();
    dispatchIfMounted({ type: "start" });
    addSequenceRenderJob({
      compositionId: resolvedComposition.id,
      outName,
      imageFormat: sequenceImageFormat,
      scale,
      logLevel,
      concurrency,
      endFrame,
      jpegQuality,
      startFrame,
      delayRenderTimeout,
      chromiumOptions,
      envVariables: envVariablesArrayToObject(envVariables),
      inputProps,
      offthreadVideoCacheSizeInBytes,
      disallowParallelEncoding,
      multiProcessOnLinux,
      beepOnFinish,
      repro
    }).then(() => {
      dispatchIfMounted({ type: "succeed" });
      setSelectedModal(null);
    }).catch(() => {
      dispatchIfMounted({ type: "fail" });
    });
  }, [
    setSidebarCollapsedState,
    dispatchIfMounted,
    resolvedComposition.id,
    outName,
    sequenceImageFormat,
    scale,
    logLevel,
    concurrency,
    endFrame,
    jpegQuality,
    startFrame,
    delayRenderTimeout,
    chromiumOptions,
    envVariables,
    inputProps,
    offthreadVideoCacheSizeInBytes,
    disallowParallelEncoding,
    multiProcessOnLinux,
    beepOnFinish,
    repro,
    setSelectedModal
  ]);
  useEffect69(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const imageFormatOptions = useMemo115(() => {
    if (renderMode === "still") {
      return [
        {
          label: "PNG",
          onClick: () => setStillFormat("png"),
          key: "png",
          selected: stillImageFormat === "png"
        },
        {
          label: "JPEG",
          onClick: () => setStillFormat("jpeg"),
          key: "jpeg",
          selected: stillImageFormat === "jpeg"
        },
        {
          label: "PDF",
          onClick: () => setStillFormat("pdf"),
          key: "pdf",
          selected: stillImageFormat === "pdf"
        },
        {
          label: "WebP",
          onClick: () => setStillFormat("webp"),
          key: "webp",
          selected: stillImageFormat === "webp"
        }
      ];
    }
    if (renderMode === "sequence") {
      return [
        {
          label: "PNG",
          onClick: () => setSequenceImageFormat("png"),
          key: "png",
          selected: sequenceImageFormat === "png"
        },
        {
          label: "JPEG",
          onClick: () => setSequenceImageFormat("jpeg"),
          key: "jpeg",
          selected: sequenceImageFormat === "jpeg"
        }
      ];
    }
    return [
      {
        label: "PNG",
        onClick: () => setVideoImageFormat("png"),
        key: "png",
        selected: videoImageFormat === "png"
      },
      {
        label: "JPEG",
        onClick: () => setVideoImageFormat("jpeg"),
        key: "jpeg",
        selected: videoImageFormat === "jpeg"
      }
    ];
  }, [
    renderMode,
    videoImageFormat,
    stillImageFormat,
    setStillFormat,
    sequenceImageFormat
  ]);
  const setRenderMode = useCallback115((newRenderMode) => {
    setRenderModeState(newRenderMode);
    if (newRenderMode === "audio") {
      setDefaultOutName({
        type: "render",
        codec: videoCodecForAudioTab,
        audioCodec: deriveFinalAudioCodec(videoCodecForAudioTab, userSelectedAudioCodec)
      });
    }
    if (newRenderMode === "video") {
      setDefaultOutName({
        type: "render",
        codec: videoCodecForVideoTab,
        audioCodec: deriveFinalAudioCodec(videoCodecForVideoTab, userSelectedAudioCodec)
      });
    }
    if (newRenderMode === "still") {
      setDefaultOutName({ type: "still", imageFormat: stillImageFormat });
    }
    if (newRenderMode === "sequence") {
      setDefaultOutName({ type: "sequence" });
    }
  }, [
    videoCodecForAudioTab,
    userSelectedAudioCodec,
    deriveFinalAudioCodec,
    setDefaultOutName,
    stillImageFormat,
    videoCodecForVideoTab
  ]);
  const renderTabOptions = useMemo115(() => {
    if (resolvedComposition?.durationInFrames < 2) {
      return [
        {
          label: "Still",
          onClick: () => {
            setRenderMode("still");
          },
          key: "still",
          selected: renderMode === "still"
        }
      ];
    }
    return [
      {
        label: "Still",
        onClick: () => {
          setRenderMode("still");
        },
        key: "still",
        selected: renderMode === "still"
      },
      {
        label: "Video",
        onClick: () => {
          setRenderMode("video");
        },
        key: "video",
        selected: renderMode === "video"
      },
      {
        label: "Audio",
        onClick: () => {
          setRenderMode("audio");
        },
        key: "audio",
        selected: renderMode === "audio"
      },
      {
        label: "Image sequence",
        onClick: () => {
          setRenderMode("sequence");
        },
        key: "sequence",
        selected: renderMode === "sequence"
      }
    ];
  }, [resolvedComposition?.durationInFrames, renderMode, setRenderMode]);
  const outnameValidation = validateOutnameGui({
    outName,
    codec,
    audioCodec,
    renderMode,
    stillImageFormat,
    separateAudioTo
  });
  const { tab, setTab, shownTabs } = useRenderModalSections(renderMode, codec);
  const { registerKeybinding } = useKeybinding();
  const renderDisabled = state.type === "load" || !outnameValidation.valid;
  const trigger = useCallback115(() => {
    if (renderMode === "still") {
      onClickStill();
    } else if (renderMode === "sequence") {
      onClickSequence();
    } else {
      onClickVideo();
    }
  }, [renderMode, onClickStill, onClickSequence, onClickVideo]);
  useEffect69(() => {
    if (renderDisabled) {
      return;
    }
    const enter = registerKeybinding({
      callback() {
        trigger();
      },
      commandCtrlKey: true,
      key: "Enter",
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      enter.unregister();
    };
  }, [registerKeybinding, renderDisabled, trigger]);
  const pixelFormatOptions = useMemo115(() => {
    return availablePixelFormats.map((option) => {
      return {
        label: option,
        onClick: () => setPixelFormat(option),
        key: option,
        id: option,
        keyHint: null,
        leftItem: pixelFormat === option ? jsx234(Checkmark, {}) : null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: option
      };
    });
  }, [availablePixelFormats, pixelFormat]);
  return jsxs122("div", {
    style: outer4,
    children: [
      jsx234(NewCompHeader, {
        title: `Render ${resolvedComposition.id}`
      }),
      jsxs122("div", {
        style: container54,
        children: [
          jsx234(SegmentedControl, {
            items: renderTabOptions,
            needsWrapping: false
          }),
          jsx234("div", {
            style: flexer
          }),
          jsxs122(Button, {
            autoFocus: true,
            onClick: trigger,
            disabled: renderDisabled,
            style: {
              ...buttonStyle7,
              backgroundColor: outnameValidation.valid ? BLUE : BLUE_DISABLED
            },
            children: [
              state.type === "idle" ? `Render ${renderMode}` : "Rendering...",
              jsx234(ShortcutHint, {
                keyToPress: "\u21B5",
                cmdOrCtrl: true
              })
            ]
          })
        ]
      }),
      jsxs122("div", {
        style: horizontalLayout,
        children: [
          jsxs122("div", {
            style: leftSidebar,
            children: [
              shownTabs.includes("general") ? jsxs122(VerticalTab, {
                style: horizontalTab,
                selected: tab === "general",
                onClick: () => setTab("general"),
                children: [
                  jsx234("div", {
                    style: iconContainer,
                    children: jsx234(FileIcon, {
                      style: icon6
                    })
                  }),
                  "General"
                ]
              }) : null,
              shownTabs.includes("data") ? jsxs122(VerticalTab, {
                style: horizontalTab,
                selected: tab === "data",
                onClick: () => setTab("data"),
                children: [
                  jsx234("div", {
                    style: iconContainer,
                    children: jsx234(DataIcon, {
                      style: icon6
                    })
                  }),
                  "Input Props"
                ]
              }) : null,
              shownTabs.includes("picture") ? jsxs122(VerticalTab, {
                style: horizontalTab,
                selected: tab === "picture",
                onClick: () => setTab("picture"),
                children: [
                  jsx234("div", {
                    style: iconContainer,
                    children: jsx234(PicIcon, {
                      style: icon6
                    })
                  }),
                  "Picture"
                ]
              }) : null,
              shownTabs.includes("audio") ? jsxs122(VerticalTab, {
                style: horizontalTab,
                selected: tab === "audio",
                onClick: () => setTab("audio"),
                children: [
                  jsx234("div", {
                    style: iconContainer,
                    children: jsx234(AudioIcon, {
                      style: icon6
                    })
                  }),
                  "Audio"
                ]
              }) : null,
              shownTabs.includes("gif") ? jsxs122(VerticalTab, {
                style: horizontalTab,
                selected: tab === "gif",
                onClick: () => setTab("gif"),
                children: [
                  jsx234("div", {
                    style: iconContainer,
                    children: jsx234(GifIcon, {
                      style: icon6
                    })
                  }),
                  "GIF"
                ]
              }) : null,
              shownTabs.includes("advanced") ? jsxs122(VerticalTab, {
                style: horizontalTab,
                selected: tab === "advanced",
                onClick: () => setTab("advanced"),
                children: [
                  jsx234("div", {
                    style: iconContainer,
                    children: jsx234(GearIcon, {
                      style: icon6
                    })
                  }),
                  "Other"
                ]
              }) : null
            ]
          }),
          jsx234("div", {
            style: optionsPanel,
            className: VERTICAL_SCROLLBAR_CLASSNAME,
            children: tab === "general" ? jsx234(RenderModalBasic, {
              codec,
              resolvedComposition,
              frame: frame3,
              imageFormatOptions,
              outName,
              proResProfile,
              renderMode,
              setVideoCodec: setCodec,
              setFrame,
              setOutName,
              setProResProfile,
              endFrame,
              setEndFrame,
              setStartFrame,
              startFrame,
              validationMessage: outnameValidation.valid ? null : outnameValidation.error.message
            }) : tab === "picture" ? jsx234(RenderModalPicture, {
              renderMode,
              scale,
              setScale,
              pixelFormat,
              pixelFormatOptions,
              imageFormatOptions,
              crf,
              setCrf,
              customTargetVideoBitrate,
              maxCrf,
              minCrf,
              jpegQuality,
              qualityControlType,
              setJpegQuality,
              setColorSpace,
              colorSpace,
              setCustomTargetVideoBitrateValue,
              setQualityControl,
              videoImageFormat,
              stillImageFormat,
              shouldDisplayQualityControlPicker: supportsBothQualityControls,
              encodingBufferSize,
              setEncodingBufferSize,
              encodingMaxRate,
              setEncodingMaxRate
            }) : tab === "audio" ? jsx234(RenderModalAudio, {
              muted,
              renderMode,
              setMuted,
              codec,
              audioCodec,
              setAudioCodec,
              enforceAudioTrack,
              setEnforceAudioTrackState,
              customTargetAudioBitrate,
              setCustomTargetAudioBitrateValue,
              setShouldHaveCustomTargetAudioBitrate,
              shouldHaveCustomTargetAudioBitrate,
              forSeamlessAacConcatenation,
              setForSeamlessAacConcatenation,
              separateAudioTo,
              setSeparateAudioTo,
              outName
            }) : tab === "gif" ? jsx234(RenderModalGif, {
              everyNthFrame,
              limitNumberOfGifLoops,
              numberOfGifLoopsSetting,
              setEveryNthFrameSetting,
              setLimitNumberOfGifLoops,
              setNumberOfGifLoopsSetting
            }) : tab === "data" ? jsx234(DataEditor, {
              defaultProps: inputProps,
              setDefaultProps: setInputProps,
              unresolvedComposition,
              mayShowSaveButton: false,
              propsEditType: "input-props",
              saving,
              setSaving,
              readOnlyStudio: false
            }) : jsx234(RenderModalAdvanced, {
              x264Preset,
              setx264Preset,
              concurrency,
              maxConcurrency,
              minConcurrency,
              renderMode,
              setConcurrency,
              setVerboseLogging: setLogLevel,
              logLevel,
              delayRenderTimeout,
              setDelayRenderTimeout,
              disallowParallelEncoding,
              setDisallowParallelEncoding,
              setDisableWebSecurity,
              setIgnoreCertificateErrors,
              setHeadless,
              headless,
              ignoreCertificateErrors,
              disableWebSecurity,
              openGlOption,
              setOpenGlOption,
              setEnvVariables,
              envVariables,
              offthreadVideoCacheSizeInBytes,
              setOffthreadVideoCacheSizeInBytes,
              enableMultiProcessOnLinux: multiProcessOnLinux,
              setChromiumMultiProcessOnLinux,
              codec,
              userAgent,
              setUserAgent,
              setBeep: setBeepOnFinish,
              beep: beepOnFinish,
              repro,
              setRepro
            })
          })
        ]
      })
    ]
  });
};
var RenderModalWithLoader = (props) => {
  return jsx234(DismissableModal, {
    children: jsx234(ResolveCompositionBeforeModal, {
      compositionId: props.compositionId,
      children: jsx234(RenderModal, {
        ...props
      })
    })
  });
};

// src/components/RenderModal/RenderStatusModal.tsx
import {useCallback as useCallback117, useContext as useContext75} from "react";

// src/components/RenderModal/GuiRenderStatus.tsx
import {useCallback as useCallback116, useMemo as useMemo116} from "react";

// src/components/RenderQueue/SuccessIcon.tsx
import {
jsx as jsx235
} from "react/jsx-runtime";
var iconStyle7 = {
  height: RENDER_STATUS_INDICATOR_SIZE,
  width: RENDER_STATUS_INDICATOR_SIZE
};
var SuccessIcon = () => {
  return jsx235("svg", {
    style: iconStyle7,
    viewBox: "0 0 512 512",
    children: jsx235("path", {
      fill: LIGHT_TEXT,
      d: "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM369 209L241 337l-17 17-17-17-64-64-17-17L160 222.1l17 17 47 47L335 175l17-17L385.9 192l-17 17z"
    })
  });
};

// src/components/RenderModal/GuiRenderStatus.tsx
import {
jsx as jsx236,
jsxs as jsxs123
} from "react/jsx-runtime";
var progressItem = {
  padding: 10,
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var label9 = {
  fontSize: 14,
  width: 400,
  color: "white"
};
var right3 = {
  fontSize: 14,
  color: LIGHT_TEXT,
  textAlign: "right",
  flex: 1
};
var BundlingProgress = ({ progress, doneIn }) => {
  return jsxs123("div", {
    style: progressItem,
    children: [
      progress === 1 ? jsx236(SuccessIcon, {}) : jsx236(CircularProgress, {
        progress
      }),
      jsx236(Spacing, {
        x: 1
      }),
      jsx236("div", {
        style: label9,
        children: progress === 1 ? "Bundled" : `Bundling ${progress * 100}%`
      }),
      doneIn ? jsxs123("div", {
        style: right3,
        children: [
          doneIn,
          "ms"
        ]
      }) : null
    ]
  });
};
var RenderingProgress = ({ progress }) => {
  return jsxs123("div", {
    style: progressItem,
    children: [
      progress.frames === progress.totalFrames ? jsx236(SuccessIcon, {}) : jsx236(CircularProgress, {
        progress: progress.frames / progress.totalFrames
      }),
      jsx236(Spacing, {
        x: 1
      }),
      jsx236("div", {
        style: label9,
        children: progress.doneIn ? `Rendered ${progress.totalFrames} frames` : `Rendering ${progress.frames} / ${progress.totalFrames} frames`
      }),
      progress.doneIn ? jsxs123("div", {
        style: right3,
        children: [
          progress.doneIn,
          "ms"
        ]
      }) : null
    ]
  });
};
var StitchingProgress = ({ progress }) => {
  return jsxs123("div", {
    style: progressItem,
    children: [
      progress.frames === progress.totalFrames ? jsx236(SuccessIcon, {}) : jsx236(CircularProgress, {
        progress: progress.frames / progress.totalFrames
      }),
      jsx236(Spacing, {
        x: 1
      }),
      jsx236("div", {
        style: label9,
        children: progress.doneIn ? `Stitched ${progress.totalFrames} frames` : `Stitching ${progress.frames} / ${progress.totalFrames} frames`
      }),
      progress.doneIn ? jsxs123("div", {
        style: right3,
        children: [
          progress.doneIn,
          "ms"
        ]
      }) : null
    ]
  });
};
var DownloadsProgress = ({ downloads }) => {
  const allHaveProgress = downloads.every((a) => a.totalBytes);
  const totalBytes = allHaveProgress ? downloads.reduce((a, b) => a + b.totalBytes, 0) : null;
  const downloaded = allHaveProgress ? downloads.reduce((a, b) => a + b.downloaded, 0) : null;
  const progress = allHaveProgress ? downloaded / totalBytes : 0.1;
  return jsxs123("div", {
    style: progressItem,
    children: [
      progress === 1 ? jsx236(SuccessIcon, {}) : jsx236(CircularProgress, {
        progress
      }),
      jsx236(Spacing, {
        x: 1
      }),
      jsxs123("div", {
        style: label9,
        children: [
          "Downloading ",
          downloads.length,
          " file",
          downloads.length === 1 ? "" : "s"
        ]
      })
    ]
  });
};
var OpenFile = ({ job }) => {
  const labelStyle5 = useMemo116(() => {
    return {
      ...label9,
      textAlign: "left",
      appearance: "none",
      border: 0,
      paddingLeft: 0,
      cursor: job.deletedOutputLocation ? "inherit" : "pointer",
      textDecoration: job.deletedOutputLocation ? "line-through" : "none"
    };
  }, [job.deletedOutputLocation]);
  const onClick = useCallback116(() => {
    openInFileExplorer({ directory: job.outName });
  }, [job.outName]);
  return jsxs123("div", {
    style: progressItem,
    children: [
      jsx236(SuccessIcon, {}),
      jsx236(Spacing, {
        x: 1
      }),
      jsx236("button", {
        style: labelStyle5,
        type: "button",
        onClick,
        children: job.outName
      }),
      jsx236("div", {
        style: right3,
        children: jsx236(RenderQueueOpenInFinderItem, {
          job
        })
      })
    ]
  });
};
var GuiRenderStatus = ({ job }) => {
  if (job.status === "idle" || job.status === "failed") {
    throw new Error("This component should not be rendered when the job is idle");
  }
  return jsxs123("div", {
    children: [
      jsx236(Spacing, {
        y: 0.5
      }),
      jsx236(BundlingProgress, {
        progress: job.progress.bundling.progress,
        doneIn: job.progress.bundling.doneIn
      }),
      job.progress.rendering ? jsx236(RenderingProgress, {
        progress: job.progress.rendering
      }) : null,
      job.progress.stitching ? jsx236(StitchingProgress, {
        progress: job.progress.stitching
      }) : null,
      job.progress.downloads.length > 0 ? jsx236(DownloadsProgress, {
        downloads: job.progress.downloads
      }) : null,
      job.status === "done" ? jsx236(OpenFile, {
        job
      }) : null,
      jsx236(Spacing, {
        y: 1
      })
    ]
  });
};

// src/components/RenderModal/RenderStatusModal.tsx
import {
jsx as jsx237,
jsxs as jsxs124,
Fragment as Fragment40
} from "react/jsx-runtime";
var container55 = {
  padding: 20,
  maxWidth: 900,
  paddingTop: 0
};
var codeBlock = {
  backgroundColor: "#222",
  whiteSpace: "pre",
  padding: 12,
  borderRadius: 4,
  fontFamily: "monospace",
  overflow: "auto",
  maxHeight: 300
};
var spacer3 = {
  height: SPACING_UNIT,
  width: SPACING_UNIT
};
var buttonRow = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end"
};
var RenderStatusModal = ({ jobId }) => {
  const { setSelectedModal } = useContext75(ModalsContext);
  const { jobs } = useContext75(RenderQueueContext);
  const job = jobs.find((j) => j.id === jobId);
  if (!job) {
    throw new Error("job not found");
  }
  const onQuit = useCallback117(() => {
    setSelectedModal(null);
  }, [setSelectedModal]);
  const onRetry = useCallback117(() => {
    const retryPayload = makeRetryPayload(job);
    setSelectedModal(retryPayload);
  }, [job, setSelectedModal]);
  const onClickOnRemove = useCallback117(() => {
    setSelectedModal(null);
    removeRenderJob(job).catch((err) => {
      showNotification(`Could not remove job: ${err.message}`, 2000);
    });
  }, [job, setSelectedModal]);
  const onClickOnCancel = useCallback117(() => {
    cancelRenderJob(job).catch((err) => {
      showNotification(`Could not cancel job: ${err.message}`, 2000);
    });
  }, [job]);
  if (!job || job.status === "idle") {
    throw new Error("should not have rendered this modal");
  }
  return jsxs124(ModalContainer, {
    onOutsideClick: onQuit,
    onEscape: onQuit,
    children: [
      jsx237(NewCompHeader, {
        title: `Render ${job.compositionId}`
      }),
      jsxs124("div", {
        style: container55,
        children: [
          job.status === "failed" ? jsxs124(Fragment40, {
            children: [
              jsx237("p", {
                children: "The render failed because of the following error:"
              }),
              jsx237("div", {
                className: HORIZONTAL_SCROLLBAR_CLASSNAME,
                style: codeBlock,
                children: job.error.stack
              })
            ]
          }) : null,
          job.status === "done" || job.status === "running" ? jsx237(GuiRenderStatus, {
            job
          }) : null,
          jsx237("div", {
            style: spacer3
          }),
          jsxs124("div", {
            style: buttonRow,
            children: [
              job.status === "running" ? jsx237(Button, {
                onClick: onClickOnCancel,
                children: "Cancel render"
              }) : jsx237(Button, {
                onClick: onClickOnRemove,
                children: "Remove render"
              }),
              jsx237(Flex, {}),
              job.status === "failed" ? jsx237(Button, {
                onClick: onRetry,
                children: "Retry"
              }) : null,
              jsx237("div", {
                style: spacer3
              }),
              jsx237(Button, {
                onClick: onQuit,
                children: "Close"
              })
            ]
          })
        ]
      })
    ]
  });
};

// src/components/UpdateModal/UpdateModal.tsx
import {useCallback as useCallback120, useMemo as useMemo118} from "react";

// src/components/CopyButton.tsx
import {useCallback as useCallback118, useEffect as useEffect70, useState as useState71} from "react";
import {
jsx as jsx238,
jsxs as jsxs125
} from "react/jsx-runtime";
var iconStyle8 = {
  width: 16,
  height: 16,
  color: "white"
};
var buttonContainerStyle = {
  display: "flex",
  minWidth: "114px"
};
var copyIcon = jsx238("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "far",
  "data-icon": "clipboard",
  className: "svg-inline--fa fa-clipboard fa-w-12",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512",
  style: iconStyle8,
  children: jsx238("path", {
    fill: "currentColor",
    d: "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
  })
});
var labelStyle5 = {
  fontSize: 14
};
var CopyButton = ({ textToCopy, label: label10, labelWhenCopied }) => {
  const [copied, setCopied] = useState71(false);
  const onClick = useCallback118(() => {
    copyText(textToCopy).then(() => {
      setCopied(Date.now());
    }).catch((err) => {
      showNotification(`Could not copy: ${err.message}`, 2000);
    });
  }, [textToCopy]);
  useEffect70(() => {
    if (!copied) {
      return;
    }
    const to = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(to);
  }, [copied]);
  return jsxs125(Button, {
    onClick,
    buttonContainerStyle,
    children: [
      copyIcon,
      jsx238(Spacing, {
        x: 1.5
      }),
      " ",
      jsx238("span", {
        style: labelStyle5,
        children: copied ? labelWhenCopied : label10
      })
    ]
  });
};

// src/components/UpdateModal/OpenIssueButton.tsx
import {useCallback as useCallback119, useMemo as useMemo117, useState as useState72} from "react";
import {
jsx as jsx239
} from "react/jsx-runtime";
var svgStyle4 = {
  width: "11px",
  height: "11px"
};
var buttonStyle8 = {
  border: "none",
  width: "24px",
  height: "24px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};
var OpenIssueButton = ({ link: link3 }) => {
  const [hovered, setHovered] = useState72(false);
  const buttonTooltip = `Open GitHub issue in new Tab`;
  const handleClick = useCallback119(() => {
    window.open(link3, "_blank");
  }, [link3]);
  const svgFillColor = useMemo117(() => {
    return hovered ? "white" : LIGHT_TEXT;
  }, [hovered]);
  const openInEditorSvg = jsx239("svg", {
    viewBox: "0 0 512 512",
    style: svgStyle4,
    children: jsx239("path", {
      fill: svgFillColor,
      d: "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    })
  });
  const onPointerEnter = useCallback119(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback119(() => {
    setHovered(false);
  }, []);
  return jsx239("button", {
    title: buttonTooltip,
    type: "button",
    onPointerEnter,
    onPointerLeave,
    style: buttonStyle8,
    onClick: handleClick,
    children: openInEditorSvg
  });
};

// src/components/KnownBugs.tsx
import {
jsx as jsx240,
jsxs as jsxs126
} from "react/jsx-runtime";
var container56 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var text2 = {
  fontSize: 14,
  flex: 1
};
var KnownBugs = ({ bugs }) => {
  const bugElements = bugs.map((bug) => {
    return jsxs126("div", {
      style: container56,
      children: [
        jsxs126("div", {
          style: text2,
          children: [
            "\uD83E\uDEB2 ",
            bug.title
          ]
        }),
        jsx240(OpenIssueButton, {
          link: bug.link
        })
      ]
    }, bug.description + bug.link);
  });
  return jsx240("div", {
    children: bugElements
  });
};

// src/components/UpdateModal/UpdateModal.tsx
import {
jsx as jsx241,
jsxs as jsxs127,
Fragment as Fragment41
} from "react/jsx-runtime";
var container57 = {
  padding: 20,
  paddingTop: 0
};
var text3 = {
  fontSize: 14
};
var title7 = {
  paddingTop: 12,
  paddingBottom: 8,
  ...text3
};
var code = {
  background: SELECTED_BACKGROUND,
  padding: "12px 10px",
  fontSize: 14,
  marginTop: 10,
  marginBottom: 10
};
var link3 = {
  fontWeight: "bold",
  color: BLUE,
  textDecoration: "none",
  ...text3
};
var commands = {
  npm: "npx remotion upgrade",
  yarn: "yarn remotion upgrade",
  pnpm: "pnpm exec remotion upgrade",
  bun: "bun remotion upgrade",
  unknown: "npx remotion upgrade"
};
var UpdateModal = ({ info, knownBugs }) => {
  const hasKnownBugs = useMemo118(() => {
    return knownBugs && knownBugs?.length > 0;
  }, [knownBugs]);
  const command = commands[info.packageManager];
  const onClick = useCallback120(() => {
    copyText(command).catch((err) => {
      showNotification(`Could not copy: ${err.message}`, 2000);
    });
  }, [command]);
  return jsxs127(DismissableModal, {
    children: [
      jsx241(NewCompHeader, {
        title: "Update available"
      }),
      jsxs127("div", {
        style: container57,
        children: [
          hasKnownBugs ? jsxs127(Fragment41, {
            children: [
              jsxs127("div", {
                style: title7,
                children: [
                  "The currently installed version ",
                  info.currentVersion,
                  " has the following known bugs:"
                ]
              }),
              jsx241(KnownBugs, {
                bugs: knownBugs
              }),
              jsx241("div", {
                style: { height: "20px" }
              }),
              jsx241("div", {
                style: text3,
                children: "To upgrade, run the following command:"
              })
            ]
          }) : jsx241("div", {
            style: title7,
            children: "A new update for Remotion is available! Run the following command:"
          }),
          jsxs127(Row, {
            align: "center",
            children: [
              jsx241(Flex, {
                children: jsx241("pre", {
                  onClick,
                  style: code,
                  children: command
                })
              }),
              jsx241(Spacing, {
                x: 1
              }),
              jsx241(CopyButton, {
                textToCopy: command,
                label: "Copy",
                labelWhenCopied: "Copied!"
              })
            ]
          }),
          jsxs127("div", {
            style: text3,
            children: [
              "This will upgrade Remotion from ",
              info.currentVersion,
              " to",
              " ",
              info.latestVersion,
              "."
            ]
          }),
          jsxs127("div", {
            style: text3,
            children: [
              "Read the",
              " ",
              jsx241("a", {
                style: link3,
                target: "_blank",
                href: "https://github.com/remotion-dev/remotion/releases",
                children: "Release notes"
              }),
              " ",
              "to know what",
              "'s",
              " new in Remotion."
            ]
          })
        ]
      })
    ]
  });
};

// src/components/Modals.tsx
import {
jsx as jsx242,
jsxs as jsxs128,
Fragment as Fragment42
} from "react/jsx-runtime";
var Modals = ({ readOnlyStudio }) => {
  const { selectedModal: modalContextType } = useContext76(ModalsContext);
  const canRender = useContext76(StudioServerConnectionCtx).previewServerState.type === "connected";
  return jsxs128(Fragment42, {
    children: [
      modalContextType && modalContextType.type === "duplicate-comp" && jsx242(DuplicateComposition, {
        compositionType: modalContextType.compositionType,
        compositionId: modalContextType.compositionId
      }),
      modalContextType && modalContextType.type === "delete-comp" && jsx242(DeleteComposition, {
        compositionId: modalContextType.compositionId
      }),
      modalContextType && modalContextType.type === "rename-comp" && jsx242(RenameComposition, {
        compositionId: modalContextType.compositionId
      }),
      modalContextType && canRender && modalContextType.type === "render" && jsx242(RenderModalWithLoader, {
        initialFrame: modalContextType.initialFrame,
        compositionId: modalContextType.compositionId,
        initialVideoImageFormat: modalContextType.initialVideoImageFormat,
        initialJpegQuality: modalContextType.initialJpegQuality,
        initialScale: modalContextType.initialScale,
        initialLogLevel: modalContextType.initialLogLevel,
        initialOffthreadVideoCacheSizeInBytes: modalContextType.initialOffthreadVideoCacheSizeInBytes,
        initialConcurrency: modalContextType.initialConcurrency,
        maxConcurrency: modalContextType.maxConcurrency,
        minConcurrency: modalContextType.minConcurrency,
        initialStillImageFormat: modalContextType.initialStillImageFormat,
        initialMuted: modalContextType.initialMuted,
        initialEnforceAudioTrack: modalContextType.initialEnforceAudioTrack,
        initialProResProfile: modalContextType.initialProResProfile,
        initialx264Preset: modalContextType.initialx264Preset,
        initialPixelFormat: modalContextType.initialPixelFormat,
        initialAudioBitrate: modalContextType.initialAudioBitrate,
        initialVideoBitrate: modalContextType.initialVideoBitrate,
        initialEveryNthFrame: modalContextType.initialEveryNthFrame,
        initialNumberOfGifLoops: modalContextType.initialNumberOfGifLoops,
        initialDelayRenderTimeout: modalContextType.initialDelayRenderTimeout,
        initialEnvVariables: modalContextType.initialEnvVariables,
        initialDisableWebSecurity: modalContextType.initialDisableWebSecurity,
        initialGl: modalContextType.initialOpenGlRenderer,
        initialHeadless: modalContextType.initialHeadless,
        initialIgnoreCertificateErrors: modalContextType.initialIgnoreCertificateErrors,
        initialEncodingBufferSize: modalContextType.initialEncodingBufferSize,
        initialEncodingMaxRate: modalContextType.initialEncodingMaxRate,
        initialUserAgent: modalContextType.initialUserAgent,
        initialColorSpace: modalContextType.initialColorSpace,
        initialMultiProcessOnLinux: modalContextType.initialMultiProcessOnLinux,
        initialRepro: modalContextType.initialRepro,
        initialBeep: modalContextType.initialBeep,
        initialForSeamlessAacConcatenation: modalContextType.initialForSeamlessAacConcatenation,
        defaultProps: modalContextType.defaultProps,
        inFrameMark: modalContextType.inFrameMark,
        outFrameMark: modalContextType.outFrameMark,
        defaultConfigurationAudioCodec: modalContextType.defaultConfigurationAudioCodec,
        defaultConfigurationVideoCodec: modalContextType.defaultConfigurationVideoCodec,
        renderTypeOfLastRender: modalContextType.renderTypeOfLastRender
      }),
      modalContextType && canRender && modalContextType.type === "render-progress" && jsx242(RenderStatusModal, {
        jobId: modalContextType.jobId
      }),
      modalContextType && modalContextType.type === "update" && jsx242(UpdateModal, {
        info: modalContextType.info,
        knownBugs: modalContextType.knownBugs
      }),
      modalContextType && modalContextType.type === "quick-switcher" && jsx242(QuickSwitcher_default, {
        readOnlyStudio,
        invocationTimestamp: modalContextType.invocationTimestamp,
        initialMode: modalContextType.mode
      })
    ]
  });
};

// src/components/Editor.tsx
import {
jsx as jsx243,
jsxs as jsxs129
} from "react/jsx-runtime";
var background2 = {
  backgroundColor: BACKGROUND,
  display: "flex",
  width: "100%",
  height: "100%",
  flexDirection: "column",
  position: "absolute"
};
var DEFAULT_BUFFER_STATE_DELAY_IN_MILLISECONDS = 300;
var BUFFER_STATE_DELAY_IN_MILLISECONDS = typeof process.env.BUFFER_STATE_DELAY_IN_MILLISECONDS === "undefined" || process.env.BUFFER_STATE_DELAY_IN_MILLISECONDS === null ? DEFAULT_BUFFER_STATE_DELAY_IN_MILLISECONDS : Number(process.env.BUFFER_STATE_DELAY_IN_MILLISECONDS);
var Editor = ({ Root, readOnlyStudio }) => {
  const size4 = PlayerInternals17.useElementSize(drawRef, {
    triggerOnWindowResize: false,
    shouldApplyCssTransforms: true
  });
  useEffect71(() => {
    if (readOnlyStudio) {
      return;
    }
    const listenToChanges = (e) => {
      if (window.remotion_unsavedProps) {
        e.returnValue = "Are you sure you want to leave?";
      }
    };
    window.addEventListener("beforeunload", listenToChanges);
    return () => {
      window.removeEventListener("beforeunload", listenToChanges);
    };
  }, [readOnlyStudio]);
  const [canvasMounted, setCanvasMounted] = React164.useState(false);
  const onMounted = useCallback121(() => {
    setCanvasMounted(true);
  }, []);
  const value = useMemo119(() => {
    if (!size4) {
      return null;
    }
    return {
      type: "canvas-size",
      canvasSize: size4
    };
  }, [size4]);
  const MemoRoot = useMemo119(() => {
    return React164.memo(Root);
  }, [Root]);
  return jsx243(HigherZIndex, {
    onEscape: noop,
    onOutsideClick: noop,
    children: jsxs129(TimelineZoomContext, {
      children: [
        jsx243(Internals57.CurrentScaleContext.Provider, {
          value,
          children: jsxs129("div", {
            style: background2,
            children: [
              canvasMounted ? jsx243(MemoRoot, {}) : null,
              jsxs129(Internals57.CanUseRemotionHooksProvider, {
                children: [
                  jsx243(EditorContent, {
                    readOnlyStudio,
                    children: jsx243(TopPanel, {
                      size: size4,
                      drawRef,
                      bufferStateDelayInMilliseconds: BUFFER_STATE_DELAY_IN_MILLISECONDS,
                      onMounted,
                      readOnlyStudio
                    })
                  }),
                  jsx243(GlobalKeybindings, {})
                ]
              })
            ]
          })
        }),
        jsx243(Modals, {
          readOnlyStudio
        }),
        jsx243(NotificationCenter, {})
      ]
    })
  });
};

// src/components/EditorContexts.tsx
import {PlayerInternals as PlayerInternals18} from "@remotion/player";

// src/state/preview-size.tsx
import {useCallback as useCallback122, useContext as useContext77, useMemo as useMemo120, useState as useState73} from "react";
import {Internals as Internals58} from "remotion";
import {
jsx as jsx244
} from "react/jsx-runtime";
var key5 = "remotion.previewSize";
var persistPreviewSizeOption = (option) => {
  localStorage.setItem(key5, JSON.stringify(option));
};
var loadPreviewSizeOption = () => {
  const item2 = localStorage.getItem(key5);
  if (item2 === null) {
    return {
      size: "auto",
      translation: {
        x: 0,
        y: 0
      }
    };
  }
  return JSON.parse(item2);
};
var PreviewSizeProvider = ({ children }) => {
  const [size4, setSizeState] = useState73(() => loadPreviewSizeOption());
  const [translation, setTranslation] = useState73(() => {
    return {
      x: 0,
      y: 0
    };
  });
  const { editorZoomGestures } = useContext77(EditorZoomGesturesContext);
  const setSize = useCallback122((newValue) => {
    setSizeState((prevState) => {
      const newVal = newValue(prevState);
      persistPreviewSizeOption(newVal);
      return newVal;
    });
  }, []);
  const previewSizeCtx = useMemo120(() => {
    return {
      size: editorZoomGestures ? size4 : {
        size: size4.size,
        translation: {
          x: 0,
          y: 0
        }
      },
      setSize,
      translation,
      setTranslation
    };
  }, [editorZoomGestures, size4, setSize, translation]);
  return jsx244(Internals58.PreviewSizeContext.Provider, {
    value: previewSizeCtx,
    children
  });
};

// src/components/CheckerboardProvider.tsx
import {useCallback as useCallback123, useMemo as useMemo121, useState as useState74} from "react";
import {
jsx as jsx245
} from "react/jsx-runtime";
var CheckerboardProvider = ({ children }) => {
  const [checkerboard6, setCheckerboardState] = useState74(() => loadCheckerboardOption());
  const setCheckerboard = useCallback123((newValue) => {
    setCheckerboardState((prevState) => {
      const newVal = newValue(prevState);
      persistCheckerboardOption(newVal);
      return newVal;
    });
  }, []);
  const checkerboardCtx = useMemo121(() => {
    return {
      checkerboard: checkerboard6,
      setCheckerboard
    };
  }, [checkerboard6, setCheckerboard]);
  return jsx245(CheckerboardContext.Provider, {
    value: checkerboardCtx,
    children
  });
};

// src/components/MediaVolumeProvider.tsx
import {useMemo as useMemo122, useState as useState75} from "react";
import {Internals as Internals59} from "remotion";
import {
jsx as jsx246
} from "react/jsx-runtime";
var MediaVolumeProvider = ({ children }) => {
  const [mediaMuted, setMediaMuted] = useState75(() => loadMuteOption());
  const [mediaVolume, setMediaVolume] = useState75(1);
  const mediaVolumeContextValue = useMemo122(() => {
    return {
      mediaMuted,
      mediaVolume
    };
  }, [mediaMuted, mediaVolume]);
  const setMediaVolumeContextValue = useMemo122(() => {
    return {
      setMediaMuted,
      setMediaVolume
    };
  }, []);
  return jsx246(Internals59.MediaVolumeContext.Provider, {
    value: mediaVolumeContextValue,
    children: jsx246(Internals59.SetMediaVolumeContext.Provider, {
      value: setMediaVolumeContextValue,
      children
    })
  });
};

// src/components/ModalsProvider.tsx
import {useMemo as useMemo123, useState as useState76} from "react";
import {
jsx as jsx247
} from "react/jsx-runtime";
var ModalsProvider = ({ children }) => {
  const [modalContextType, setModalContextType] = useState76(null);
  const modalsContext = useMemo123(() => {
    return {
      selectedModal: modalContextType,
      setSelectedModal: setModalContextType
    };
  }, [modalContextType]);
  return jsx247(ModalsContext.Provider, {
    value: modalsContext,
    children
  });
};

// src/components/SetTimelineInOutProvider.tsx
import {useEffect as useEffect72, useMemo as useMemo124, useState as useState77} from "react";

// src/state/marks.ts
var localStorageKey5 = () => `remotion.editor.marksv2`;
var persistMarks = (marks) => {
  localStorage.setItem(localStorageKey5(), JSON.stringify(marks));
};
var loadMarks = () => {
  const item2 = localStorage.getItem(localStorageKey5());
  if (item2 === null) {
    return {};
  }
  return JSON.parse(item2);
};

// src/components/SetTimelineInOutProvider.tsx
import {
jsx as jsx248
} from "react/jsx-runtime";
var SetTimelineInOutProvider = ({ children }) => {
  const [inAndOutFrames, setInAndOutFrames] = useState77(() => loadMarks());
  const setTimelineInOutContextValue = useMemo124(() => {
    return {
      setInAndOutFrames
    };
  }, []);
  useEffect72(() => {
    persistMarks(inAndOutFrames);
  }, [inAndOutFrames]);
  return jsx248(TimelineInOutContext.Provider, {
    value: inAndOutFrames,
    children: jsx248(SetTimelineInOutContext.Provider, {
      value: setTimelineInOutContextValue,
      children
    })
  });
};

// src/components/ShowGuidesProvider.tsx
import {useCallback as useCallback124, useMemo as useMemo125, useRef as useRef38, useState as useState78} from "react";
import {
jsx as jsx249
} from "react/jsx-runtime";
var ShowGuidesProvider = ({ children }) => {
  const [guidesList, setGuidesList] = useState78(() => loadGuidesList());
  const [selectedGuideId, setSelectedGuideId] = useState78(null);
  const [hoveredGuideId, setHoveredGuideId] = useState78(null);
  const [editorShowGuides, setEditorShowGuidesState] = useState78(() => loadEditorShowGuidesOption());
  const shouldCreateGuideRef = useRef38(false);
  const shouldDeleteGuideRef = useRef38(false);
  const setEditorShowGuides = useCallback124((newValue) => {
    setEditorShowGuidesState((prevState) => {
      const newVal = newValue(prevState);
      persistEditorShowGuidesOption(newVal);
      return newVal;
    });
  }, []);
  const editorShowGuidesCtx = useMemo125(() => {
    return {
      editorShowGuides,
      setEditorShowGuides,
      guidesList,
      setGuidesList,
      selectedGuideId,
      setSelectedGuideId,
      shouldCreateGuideRef,
      shouldDeleteGuideRef,
      hoveredGuideId,
      setHoveredGuideId
    };
  }, [
    editorShowGuides,
    setEditorShowGuides,
    guidesList,
    selectedGuideId,
    hoveredGuideId
  ]);
  return jsx249(EditorShowGuidesContext.Provider, {
    value: editorShowGuidesCtx,
    children
  });
};

// src/components/ShowRulersProvider.tsx
import {useCallback as useCallback125, useMemo as useMemo126, useState as useState79} from "react";
import {
jsx as jsx250
} from "react/jsx-runtime";
var ShowRulersProvider = ({ children }) => {
  const [editorShowRulers, setEditorShowRulersState] = useState79(() => loadEditorShowRulersOption());
  const setEditorShowRulers = useCallback125((newValue) => {
    setEditorShowRulersState((prevState) => {
      const newVal = newValue(prevState);
      persistEditorShowRulersOption(newVal);
      return newVal;
    });
  }, []);
  const editorShowRulersCtx = useMemo126(() => {
    return {
      editorShowRulers,
      setEditorShowRulers
    };
  }, [editorShowRulers, setEditorShowRulers]);
  return jsx250(EditorShowRulersContext.Provider, {
    value: editorShowRulersCtx,
    children
  });
};

// src/components/ZoomGesturesProvider.tsx
import {useCallback as useCallback126, useMemo as useMemo127, useState as useState80} from "react";
import {
jsx as jsx251
} from "react/jsx-runtime";
var ZoomGesturesProvider = ({ children }) => {
  const [editorZoomGestures, setEditorZoomGesturesState] = useState80(() => loadEditorZoomGesturesOption());
  const setEditorZoomGestures = useCallback126((newValue) => {
    setEditorZoomGesturesState((prevState) => {
      const newVal = newValue(prevState);
      persistEditorZoomGesturesOption(newVal);
      return newVal;
    });
  }, []);
  const editorZoomGesturesCtx = useMemo127(() => {
    return {
      editorZoomGestures,
      setEditorZoomGestures
    };
  }, [editorZoomGestures, setEditorZoomGestures]);
  return jsx251(EditorZoomGesturesContext.Provider, {
    value: editorZoomGesturesCtx,
    children
  });
};

// src/components/EditorContexts.tsx
import {
jsx as jsx252
} from "react/jsx-runtime";
var EditorContexts = ({ children, readOnlyStudio }) => {
  return jsx252(ZodProvider, {
    children: jsx252(PreviewServerConnection, {
      readOnlyStudio,
      children: jsx252(RenderQueueContextProvider, {
        children: jsx252(KeybindingContextProvider, {
          children: jsx252(CheckerboardProvider, {
            children: jsx252(ZoomGesturesProvider, {
              children: jsx252(ShowRulersProvider, {
                children: jsx252(ShowGuidesProvider, {
                  children: jsx252(PreviewSizeProvider, {
                    children: jsx252(ModalsProvider, {
                      children: jsx252(MediaVolumeProvider, {
                        children: jsx252(PlayerInternals18.PlayerEmitterProvider, {
                          currentPlaybackRate: null,
                          children: jsx252(SidebarContextProvider, {
                            children: jsx252(FolderContextProvider, {
                              children: jsx252(HighestZIndexProvider, {
                                children: jsx252(SetTimelineInOutProvider, {
                                  children
                                })
                              })
                            })
                          })
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};

// src/components/Notifications/ServerDisconnected.tsx
import {useContext as useContext78} from "react";
import {
jsx as jsx253,
jsxs as jsxs130
} from "react/jsx-runtime";
var container58 = {
  position: "fixed",
  justifyContent: "flex-end",
  alignItems: "flex-start",
  display: "flex",
  width: "100%",
  height: "100%",
  flexDirection: "column",
  padding: 30,
  pointerEvents: "none",
  backgroundColor: "transparent",
  fontFamily: "SF Pro, Arial, Helvetica, sans-serif"
};
var message = {
  backgroundColor: "#e74c3c",
  color: "white",
  paddingLeft: 20,
  paddingRight: 20,
  paddingTop: 12,
  paddingBottom: 12,
  borderRadius: 4,
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.4)",
  lineHeight: 1.5
};
var inlineCode = {
  fontSize: 16,
  fontFamily: "monospace"
};
var pageIsGoingToReload = false;
window.addEventListener("beforeunload", () => {
  pageIsGoingToReload = true;
});
var ServerDisconnected = () => {
  const { previewServerState: ctx } = useContext78(StudioServerConnectionCtx);
  const fav = document.getElementById("__remotion_favicon");
  if (ctx.type !== "disconnected") {
    fav.setAttribute("href", "/favicon.ico");
    return null;
  }
  if (pageIsGoingToReload) {
    return null;
  }
  const base64Favicon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARiSURBVHgB7d1NThRBFAfw/2tGgru5gXMD8QZ4AmVjAi6kN0TiAm8gnkBcGARNumcx4E48Ae0JaE9gewLHlQSZelaNgyHGL/RVd1X3+y10RQL58+rVx1QBKKWUUkoppZRSSimllFJKKVUjQs32stEiJcktZiwxzKL9Fvqzb6S0/44JVBKbtwa9aj29U6JjagtkJzsYzBEyBi9d5utsQIULCcxvelgo03R5jBarJZCXw/17E+bt82r4Hy4gtuEQekUbK8h7IHvDV5vMZht+VAlRfmYw3EhXKrSA10Ce2X7RIzpGDVzlgM1wPb2bI2JeA9nN99/b/waoV+XCmTAex1g13gLZyUZrdjjJ0CAbTB5bMN4C2ctHxwxaRABiCsZLIG6KmxC/R2BiCCaBBwn4NgJk10B2GOWj3Wz/IQLlpUL28oOjyy4AG1AZppuhVYt4hWRZ1o8gDGc6rL4YHjxCQMQDOcNCEI38bxnmLTc9d30PARAPZAITZP/4A1ctx3bjcw0NEw8koeQ64tRnu25qeggTb+q2/BmRcyv9K7yw3MTOsmiFuLMOtICblJzS5+Mm+opoIBOgFYHMuL5yVHcoooFQuwJxag9FNJCIG/rv1BqKaCDfzshbqbZQxAJxK3SJI9qATUPJstdef0axQGJbof+jwRc6eQ2PxAIx4DZXx3duSrybv3oCTyR7yACdYR762sIXDKQbFfId4ZGPJi8YCA3QLf05YvF+IhYIEV1Dx9hNu8XdbLQFQV6OcDuFaFNyKiwWiJ19DNBN/VN8XoMQrRABDFqCEJ32CiBisT08rRAZAwjRQAKjgcgQO+rVQARMb3gJ0UAkML+DEA1EwAQkdkNMcnOx1Zcxf8V9ol7y88GSm4tdDKRy1xsgSIes/0BM4ndN5HZ7OzZkMePperqSQ5jkkFWhO6r76WrYJ4b2N+YTumF60QeeSG6/d2DI4rHvW1eCPaT9Q9YZw/sVOMlZVoUWM8zpg/Su97dVJGdZFVrKhbFR05MdYoFcwWmF1rF9kbG8UeP7KaI3qBp628QTHrueUccwdZHw/ZDWNHY7tU1u1B2GIxqIYSO2Dd0Ud79wnq/eaOpBgR4EMVDW/oijINu87d7U6hYaJBrInA0k0iu4bvVtZ1KrBRrm4Vr06GNkF3cO7RCVhvK4pmiFOISkjOStk1lVrBQIiPh5SAyN3fWKWeMuEBjxCmEkh3bVvokAzd5idL2iQqDEA1nASXmK+XFIfeTCo5gFAudllvo8G20TUeNVElMQ58QrxLHD1jbB3GumSnhsz7qHE9BhTEGc87aOm16KJHi7rfqj8yfI53E1j/l9eK8L651stJUQeXx/iuzU1QztZLGIsRp+xvtOh3Qo3/qCedumEC6qZetpJztwz7O6UAa4FNsP7ELTfXbWbskUdjgq9M9VCJoFcwvTlfyPDd9t3XNJjA+2IZcGpmxi+7tpjW3OupurJziZhtKWPzWhlFJKKaWUUkoppZRSSiml/uwrgZ/Bfwo/wccAAAAASUVORK5CYII=";
  fav.setAttribute("href", base64Favicon);
  return jsx253("div", {
    style: container58,
    className: "css-reset",
    children: jsxs130("div", {
      style: message,
      children: [
        "The studio server has disconnected. ",
        jsx253("br", {}),
        window.remotion_studioServerCommand ? jsxs130("span", {
          children: [
            "Run",
            " ",
            jsx253("code", {
              style: inlineCode,
              children: window.remotion_studioServerCommand
            }),
            " ",
            "to run it again."
          ]
        }) : jsx253("span", {
          children: "Fast refresh will not work."
        })
      ]
    })
  });
};

// src/helpers/inject-css.ts
import {Internals as Internals60} from "remotion";
var makeDefaultGlobalCSS = () => {
  return `
  html {
    --remotion-cli-internals-blue: #0b84f3;
  }
  
  body {
    overscroll-behavior-y: none;
    overscroll-behavior-x: none;
    /* Override Chakra UI position: relative on body */
    position: static !important;
  }
  
  .remotion-splitter {
    user-select: none;
  }
  
  .remotion-splitter-horizontal {
    transform: scaleY(2);
    background: linear-gradient(
      to bottom,
      transparent 25%,
      black 25%,
      black 75%,
      transparent
    );
  }
  
  .remotion-splitter-horizontal:hover,
  .remotion-splitter-horizontal.remotion-splitter-active {
    background: linear-gradient(
      to bottom,
      var(--remotion-cli-internals-blue),
      var(--remotion-cli-internals-blue)
    );
  }
  
  .remotion-splitter-vertical {
    transform: scaleX(2);
    background: linear-gradient(
      to right,
      transparent 25%,
      black 25%,
      black 75%,
      transparent
    );
  }
  
  .remotion-splitter-vertical:hover,
  .remotion-splitter-vertical.remotion-splitter-active {
    background: linear-gradient(
      to right,
      var(--remotion-cli-internals-blue),
      var(--remotion-cli-internals-blue)
    );
  }
  
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  input:focus,
  textarea:focus,
  button:focus,
  a:focus {
    outline: none;
    box-shadow:
      inset 1px 1px #555,
      inset -1px -1px #555,
      inset 1px -1px #555,
      inset -1px 1px #555;
    border-radius: 0 !important;
  }
  
  input[type='color'].__remotion_color_picker::-webkit-color-swatch-wrapper {
    padding: 0;
  }
  input[type='color'].__remotion_color_picker::-webkit-color-swatch {
    border: none;
  }
  
  .__remotion_thumb,
  .__remotion_thumb::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
  }
  
  .__remotion_thumb {
    pointer-events: none;
    position: absolute;
    height: 0;
    outline: none;
    top: 15.5px;
    width: 221px;
    margin-left: -2px;
    z-index: 2;
  }
  
  /* For Firefox browsers */
  .__remotion_thumb::-moz-range-thumb {
    border: 1px solid black;
    border-radius: 2px;
    cursor: pointer;
    height: 37px;
    width: 10px;
    pointer-events: all;
    border-color: black;
    background-color: white;
    position: relative;
  }
  
  /* For Chrome browsers */
  .__remotion_thumb::-webkit-slider-thumb {
    border: 1px solid black;
    border-radius: 2px;
    cursor: pointer;
    height: 39px;
    width: 10px;
    pointer-events: all;
    border-color: black;
    background-color: white;
    position: relative;
  }  

  .${DEFAULT_PROPS_PATH_ACTIVE_CLASSNAME} span {
    color: var(--remotion-cli-internals-blue) !important;
    transition: color 0.2s ease-in-out;
  }
  `.trim();
};
var injected = false;
var injectCSS = () => {
  if (injected) {
    return;
  }
  Internals60.CSSUtils.injectCSS(makeDefaultGlobalCSS());
  injected = true;
};

// src/Studio.tsx
import {
jsx as jsx254,
jsxs as jsxs131
} from "react/jsx-runtime";
var getServerDisconnectedDomElement = () => {
  return document.getElementById("server-disconnected-overlay");
};
var Studio = ({ rootComponent, readOnly }) => {
  useLayoutEffect2(() => {
    window.remotion_isStudio = true;
    Internals61.enableSequenceStackTraces();
    return () => {
      window.remotion_isStudio = false;
    };
  }, []);
  useLayoutEffect2(() => {
    injectCSS();
  }, []);
  return jsx254(Internals61.RemotionRoot, {
    numberOfAudioTags: window.remotion_numberOfAudioTags,
    children: jsxs131(EditorContexts, {
      readOnlyStudio: readOnly,
      children: [
        jsx254(Editor, {
          readOnlyStudio: readOnly,
          Root: rootComponent
        }),
        readOnly ? null : createPortal(jsx254(ServerDisconnected, {}), getServerDisconnectedDomElement())
      ]
    })
  });
};

// src/internals.ts
var StudioInternals = {
  Studio
};
export {
  StudioInternals
};
